webpackJsonp([0],{

/***/ "+AC5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _scroller = __webpack_require__("+geU");

var _scroller2 = _interopRequireDefault(_scroller);

var _flexbox = __webpack_require__("F3HL");

var _chain = __webpack_require__("zDi5");

var _chain2 = _interopRequireDefault(_chain);

var _value2name = __webpack_require__("NE4E");

var _value2name2 = _interopRequireDefault(_value2name);

var _isArray = __webpack_require__("cEdU");

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'picker',
  components: {
    Flexbox: _flexbox.Flexbox,
    FlexboxItem: _flexbox.FlexboxItem
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new _chain2.default(this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return (0, _value2name2.default)(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new _scroller2.default(_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new _scroller2.default(ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if ((0, _stringify2.default)(_this3.getValue()) !== (0, _stringify2.default)(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new _chain2.default(newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "+EOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPictureList_vue__ = __webpack_require__("CJuu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPictureList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPictureList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPictureList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPictureList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPictureList_vue__ = __webpack_require__("fA0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPictureList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPictureList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e38d197_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ViewPictureList_vue__ = __webpack_require__("2taz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("t5ke")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e38d197"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPictureList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e38d197_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ViewPictureList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e38d197_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ViewPictureList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+PSE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"reportNoList"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":item.otherservice === '拆箱' ? _vm.src2 : _vm.src1,"alt":""}})]),_vm._v(" "),(item.otherservice === '拆箱')?_c('div',{staticClass:"list-devanning"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(item.ladingId))])]),_vm._v(" "),(item.mBlNo)?_c('div',{staticClass:"list-item-row"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.mBlNo))])])]):_vm._e(),_vm._v(" "),(item.preCarriage)?_c('div',{staticClass:"list-item-row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.preCarriage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"consignee-linkman"},[_vm._v(_vm._s(item.consigneeLinkman))]),_vm._v(" "),(item.consigneeMp)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeMp))]):_vm._e(),_vm._v(" "),(item.consigneeMp && item.consigneeTel)?_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e(),_vm._v(" "),(!item.consigneeMp && item.consigneeTel)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.loadDate)))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.consigneePlace))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(5,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark9))])])])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_vm._m(6,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.shipCompany))])])]),_vm._v(" "),(item.vessel && item.voyage)?_c('div',{staticClass:"list-item-row"},[_vm._m(7,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.vessel)+_vm._s(item.vessel && item.voyage ? ' / ' : '')+_vm._s(item.voyage))])])]):_vm._e(),_vm._v(" "),(item.portDelivery)?_c('div',{staticClass:"list-item-row"},[_vm._m(8,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.portDelivery))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(9,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.cont))])])])])]):_vm._e(),_vm._v(" "),(item.otherservice !== '拆箱')?_c('div',{staticClass:"list-binning"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(item.ladingId))])]),_vm._v(" "),(item.mBlNo)?_c('div',{staticClass:"list-item-row"},[_vm._m(10,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.mBlNo))])])]):_vm._e(),_vm._v(" "),(item.preCarriage)?_c('div',{staticClass:"list-item-row"},[_vm._m(11,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.preCarriage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(12,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"consignee-linkman"},[_vm._v(_vm._s(item.companyLxr))]),_vm._v(" "),(item.shipperMp)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.shipperMp)+" ")]):_vm._e(),_vm._v(" "),(item.shipperMp && item.shipperTel)?_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.shipperTel))]):_vm._e(),_vm._v(" "),(!item.shipperMp && item.shipperTel)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.shipperTel))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(13,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.loadDate)))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(14,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.jhr))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(15,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark3))])])])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_vm._m(16,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.shipCompany))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(17,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.vessel)+_vm._s(item.vessel && item.voyage ? ' / ' : '')+_vm._s(item.voyage))])])]),_vm._v(" "),(item.portLoading)?_c('div',{staticClass:"list-item-row"},[_vm._m(18,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.portLoading))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(19,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.cont))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search btn-report",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goReportContNo(item.ladingId, item.otherservice)}}},[_vm._v("报柜号\n                ")])],1)])}),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],2),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("运单号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("车牌号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货联系人：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货时间：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货地点：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货说明：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船公司：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船名/航次：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("目的港：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜型：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("运单号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("车牌号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货联系人：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货时间：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货地点：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货说明：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船公司：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船名/航次：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("起运港：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜型：")])])}]


/***/ }),

/***/ "+RXR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VoyageResult_vue__ = __webpack_require__("Loy+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VoyageResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VoyageResult_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VoyageResult_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VoyageResult_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VoyageResult_vue__ = __webpack_require__("Efi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VoyageResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VoyageResult_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bbba166_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_VoyageResult_vue__ = __webpack_require__("4JgS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("3f23")
  __webpack_require__("8ABI")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bbba166"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VoyageResult_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bbba166_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_VoyageResult_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bbba166_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_VoyageResult_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+YWw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+kMp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
};

/***/ }),

/***/ "+qj0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAMAAAAPkIrYAAAAjVBMVEUAAAARvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgYBtqcAAAALnRSTlMABvppEcTyze3pp+TZj1b2tx0LY4d7rk8xI97TnoF2cRYPvl4sJ8hHOrKVPjZDOTWI8QAAA59JREFUWMOlWFmiqjAMLTKICIIKyKiIAz5E97+8d9OggLYINF9Qyml6MrQJ6ZXLyjOu5kKb6VGcJ/tCIdNE2fr681Ni6yGNBZJ2zuzJloV1GYO0OSyffeI8BuskL5rf7LlhpXvZc0snaqHl1SCoe/zejbENO+reU/W980T5rVT5UsgoWCxnh/lrpd0PqLCeqXv8ZSu/RrN6TbrSUCdvQ/rk7CDYNePP2eOUf2vyS3Zo6CjkTXBRqe0gT/aRtKAPyjyTYXKgJtXO/A3mw0PuQcldrhkMIFVjoq2iPh1/rR5q46DQnhTM/3RR6lfqhoyTyobf5O6gRWk/jsFpmJl1+A/AJnYwDqdR4toeuaKqPEk1g7d7if7acskt9QZuNvPBWiEvjQNlC+WNHcGmedlyjeGu3znfPfjqvd5O8OZypt7A7hosJnPUXsJKLw5MeOHY8ARWcZQUliuZ3ocMHfC5gOeUG6OYp1Y2L8CQogifDdhAxlT/H3xCIwWwFTPkRvKD/gAr+kzW4zbnmQpvD1beBh4SmksBdcdkvesLUsKzgAOrwEMJDxKP9WM3ZTGzPKoT1FY0GKl//ifux3/FFQa/NwlY+z9SMAbEZA75qo70iyCWBXFECHihLQiFkbOm3hV3vzwHScfkMHAnKlAviqXAwInEYGZRLKLRkIwgGIWxIMA8RBTGMmnWwuwsigVMlf16Letb6xxz68xZ9uhlEb2HL13BUDMwMT1XRNH5fLmIyMFSwdrIgYzeSNQeO6J/8bGOg7DQv9DvRbEqGKgwHgWxMB5rckMRrCZPhLhVMSxwGac2pyGGpdR5lSSY7wV8osn3eA4N9dWmVGKcQ3g+GiIx1JyPxMdze3Js47ldNPcJdzqWBMpGrSDXlMlYMlqxff+aiiVFjSrNvXAaloeadG5jzjSs0Ebnect18kVAUvHXj/u9NuUmkHbv9+J1R8Coh3JpJFRgN/dewTrtwqrTMMRhfAxYQKFMhVvXHkXrWuR/XL0t1/W2kqiexOsDnMb0ASpSAs8bRpmEpA3vT1wIyamHfZMGlQooPrBvMl9jmmBXJIGJsxZ7hW8+49VqQppSXtdjk9QTteTO7vypr8Ng9WGF2/fswuT1v6Sbl7/7X0bWYs+mO2aF/qHVl9PVxN3L24Nn+fGsGc67Stx0UIxdqso/+oVf27lEcPNii7Ti9jF168xafncnfMm2vvYFZJaFRKbJeZUa8+UfpLY01cTbZb2z/wNp30ljqPwNjAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "/0UN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_vue__ = __webpack_require__("KinT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_vue__ = __webpack_require__("9807");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_be506736_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_checker_vue__ = __webpack_require__("tub4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("LIP2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_be506736_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_checker_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_be506736_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_checker_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/HK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(_vm.direction === 'rtl' ? one.value + '‎' : one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var staticRenderFns = []


/***/ }),

/***/ "/g1U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DeliveImgList',
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      src1: __webpack_require__("w2ig"), // 装箱的icon图片
      src2: __webpack_require__("fy9M"), // 送货的icon图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      isNoData: false
    };
  },
  created: function created() {
    document.title = '位置上传';
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code
      };
      this.isShowLoading = true;
      this.requestApi({
        url: _const.apiUrl.locationNoticeList,
        data: data
      }, function (resultData) {
        var list = resultData.data.list || [];
        if (list.length === 0) {
          _this.isNoData = true;
          _this.isShowLoading = false;
          _this.isShowTable = false;
          return;
        }
        _this.tableData = list;
      }, function (error) {
        _this.isShowLoading = false;
        if (error) {
          console.error(error);
        }
      });
    },
    goNextPage: function goNextPage(bookingId, ladingId, servicetype) {

      this.$router.push({
        name: 'LocationUpload',
        query: {
          bookingId: bookingId,
          ladingId: ladingId,
          servicetype: servicetype
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "/hKF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABaCAMAAAB5TAO7AAAAYFBMVEUAAAD/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/////hDz/+PX/mWX/6N//v6L/tpT/0Lz/o3b/4NT/8Or/j1L/yK//2Mj/rYY29LWkAAAAEHRSTlMA8+jczKWNc1tGMyQXDbq5t8q2lAAAA1NJREFUaN60ltmu6yAMRXPn+YptMwfS///LE0jgnKoPjh+ypaZCVbME9gKWH+b+LMvPT0YbPWT5dTtl2fP7s7k3S8ufL+bWLD1/v5o7sxz599/cmGXkm7kvy8x3xb9CpP2ZYtFCFFoSw+2UiKiFaLS0jNUS8NBCVFpaB96wGi1EpSUx9gQ1RKMl9YnAqyEKLRvDmgp94aeWFxnGBMBRr1BSQmQt7TrKkbj3l8dKKoisZeJej9h51RjaAFc0EFlLDzjbnhsNJioplkvWsmQgU6sHw5ljGgiawstaeh59a4F6jAG2CoikZViBNY19JZ5jcuCHGjK1fEWg0mC43mQrHUsWLkIkLTcgWzMZZDDXbjSbDJG0DDlNGbuEwQLlZALhIkTW0tshfB/BmVN8Xy/ORNaS2JGxPNop99WqgFN4ImpJKzhjMAiwxrqh5Uh5JAEiaGkZ73tIAqgC8KNm3vucGdgEiKRlqdnPAoF5iNMX78zqRYisZfE+Je9zt93T7L6aHeBSEWpyTcuEkbWW13Omx5IAkbRMByC/XFa2xqCjQ1YrQC6elsBzG8VmZGFPY0oyRD4tny0vxPDdTA4RaAwZIp+WT7eVgGDr2EfHLyJEPi0Z9UmgMdoaJQrLJWo5xchzrRiOEXvRH8DmADhfBIioZYfwh94l6449jBs7RW6cKkBkLUv6gLMd5WyDxA4OGwAFRLjExmFMbLDHe9clL0AELSeg7J/51toAAajCtqLTkvqxbweDAuBNOHd/EiBXtSwO4GjHTcOZxIj9DpAoRgFyTcspH+ec25fvN+VMO7ulCBCFlmFDD8cyrhmlVYeDMBOdlvRWex2kIAwDARTNJnSpCTbaVur9b2ktync3kPDnAg9KfyZZWmvL3ym9frZwvXYg4SW2/srcat/fFV9i6164MAVIf5b793F/WL1I/LY8F8qZYz8Sb8sjwtt8QCNIvC3XMtf7dQiJt+XCtwqQ/izPY7gGyHiWz1JahIxn+dheATKSJdGHyHiWAkKWEkKWFxFhsouQpY+kSUXI0kTI0kTI0kTI0kTI0kTIUkSY7CJk6SNpUhGyNBGyNBGyNBGyNBGyDBAhy2RNdhGy9JE0qQhZmghZmghZmghZmghZughZJn+yiZDlGxfAJa0kIfgtAAAAAElFTkSuQmCC"

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("cvA0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("92Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_e4154764_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("d1G5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("TmiF")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_e4154764_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_e4154764_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/ulZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0TpV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "Vehicletracking",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            loadDate: '',
            unloadingDate: '',
            truck_no: '',
            is_self: null, // 这个就是类型
            is_selfOps: [{
                key: '自有车',
                value: '自有车'
            }, {
                key: '挂靠车',
                value: '挂靠车'
            }, {
                key: '临时车',
                value: '临时车'
            }]

        };
    },
    created: function created() {
        document.title = '车辆跟踪';
    },

    methods: {
        search: function search() {
            this.$router.push({
                name: 'VehicletrackingResult',
                query: {
                    begin: this.loadDate || '',
                    end: this.unloadingDate || '',
                    truck_no: this.truck_no || '',
                    is_self: this.is_self || ''
                }
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "0pea":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
};

/***/ }),

/***/ "0vWR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _objectAssign = __webpack_require__("BEQ0");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _xscroll = __webpack_require__("WTNC");

var _xscroll2 = _interopRequireDefault(_xscroll);

var _pulldown = __webpack_require__("ypEt");

var _pulldown2 = _interopRequireDefault(_pulldown);

var _pullup = __webpack_require__("qbvd");

var _pullup2 = _interopRequireDefault(_pullup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//

var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

exports.default = {
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new _xscroll2.default({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = (0, _objectAssign2.default)(pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new _pulldown2.default(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = (0, _objectAssign2.default)(pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new _pullup2.default(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
};


function pure(obj) {
  return JSON.parse((0, _stringify2.default)(obj));
}

/***/ }),

/***/ "0wEq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABLCAMAAADzhaESAAAAilBMVEUAAAARvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJgRvJhXEtAlAAAALXRSTlMApXeZ3UTDZku70vpx9CEU6a9iK4h+QDIH2smUjlPVtYNcHA/vSTklDalX9uI/MXp0AAACFElEQVRYw+2Y6W6rMBBGHZoECPu+hyVr0/r9X+/KTINritNBqFJ0lfMjIV/gCGZsWYbIqHYGHTDyDfmFq2aGbz1hAElLRYy4j4P+tKJRE1HgFBYdsMCxpyNqll74iVlLOIkrnBv1IcsEcpZG35NVejfYRyqg9ulqrGhY6guRd1fUVMzB7eRirF9ZmopmHwwBVKCMLzbDIXdOpjJgxkPdbDvQyiMoMshCduwGZBaOBw5o9ZYdarMEvFbhUPqMzOb6yQvKxuA7mY/KFFvC6DtM5uMsVxB3uWK/XLF7Kf5acVDeEJipXJGyDEEtVyQUiSNVdEiDlcpr0aAMhvqoI128+ZXYef5x8VI8m+K0xwzOPJErDhZFkckVZ4qk46tqMbqL47y7cDx3dRjVItHXCOoLEeEKPP+TIr0uVagWLZcpbHbNaZFCY9eYyxXKXykqZQozwCs82fy+YRUJlbHDKgKpYo9+kHfZg1T4csbqFL6knE88Ll4KvGITaWPFOarwCtjnFqLCZFs8vAL2kiVXgIG6SAWfySFXqF8ziKJ3iAms281d4cMM0gjLtwRFDI4IFF+GlpA1+3aQLfmgDJ195Maw89ehSDhOBhXx+VuNFjuqjIl3HRf4UXQ4R/XdYQ69AjJ9ilqROMAAdC59yNhxM37+cT5SKVMdb8ERCcus/khRTE4W2ozCc5l/gnvMh3cgP7itXZMM/ANs6/pf0u08kgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "133T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1DHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("seJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("U36D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_b64b5042_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Pd9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("HXHJ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_b64b5042_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_b64b5042_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1Q5S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-group-tip",style:({'text-align':_vm.align})},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "1jKx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if ((0, _typeof3.default)(this.value) === 'object' && isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return (0, _stringify2.default)(one);
          }).indexOf((0, _stringify2.default)(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
};


function isEqual(obj1, obj2) {
  return (0, _stringify2.default)(obj1) === (0, _stringify2.default)(obj2);
}

/***/ }),

/***/ "1pHq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAWBAMAAAD6A0vjAAAAGFBMVEVMksRMksRMksRMksRMksRMksRMksRMksRCsggqAAAAB3RSTlO79B6/uvMfGYQZbwAAAB9JREFUCNdjUAlRYGAvN2AQLy9gKKcMg8wAm6UgkAAAiZQaYThFypwAAAAASUVORK5CYII="

/***/ }),

/***/ "2A0z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cleanStyle = __webpack_require__("wmxo");

var _cleanStyle2 = _interopRequireDefault(_cleanStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'group',
  methods: {
    cleanStyle: _cleanStyle2.default
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "2DUM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAARVBMVEUAAADd3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d1j2hCcAAAAFnRSTlMA9T96p5f36i8S+Rfrvq6FXVFFLgwHndeqDQAAAHZJREFUKM/F0rsSgzAMRNFVogA2SXj7/z+VGYrdAWNK2PbMrSQEr9LpKg/wVNwf6vIW6WK3Yjf3RXwDqIm5jSxzexnRfpYZcULzPRgxLkBT703lB5vKiFKZUEojSlsaUUoTUmVCaTvYY8cW2tVrehkdweM5RQ8rNMo5v9mAzfoAAAAASUVORK5CYII="

/***/ }),

/***/ "2PkL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2RPQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("/kga");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'alert',
  components: {
    XDialog: _xDialog2.default
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "2euu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2nGA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"myFooter"}},[_c('a',{staticClass:"tel",attrs:{"href":'tel:' + _vm.tel},on:{"click":_vm.handleToast}},[_vm._v("联系我们")])])}
var staticRenderFns = []


/***/ }),

/***/ "2sLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("vjYW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("TCOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_4b3d2bd8_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("gIQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("YeBf")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_4b3d2bd8_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_4b3d2bd8_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2taz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ViewPictureList"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":item.otherservice === '拆箱' ? _vm.src2 : _vm.src1,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-binning"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(item.ladingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(item.bookingId))])]),_vm._v(" "),(item.mBlNo)?_c('div',{staticClass:"list-item-row"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.mBlNo))])])]):_vm._e(),_vm._v(" "),(item.preCarriage)?_c('div',{staticClass:"list-item-row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.preCarriage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"consignee-linkman"},[_vm._v(_vm._s(item.consigneeLinkman))]),_vm._v(" "),(item.consigneeMp)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeMp))]):_vm._e(),_vm._v(" "),(item.consigneeMp && item.consigneeTel)?_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e(),_vm._v(" "),(!item.consigneeMp && item.consigneeTel)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[(item.servicetype === '拖车')?_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.loadDate)))]):_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.releasePlanDate)))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.consigneePlace))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(5,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark9))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(6,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.shipCompany))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(7,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.portDelivery))])])]),_vm._v(" "),(item.remark18)?_c('div',{staticClass:"list-item-row"},[_vm._m(8,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark18))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("1pHq"),"alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#333"}},[_vm._v("柜号/封号")])]),_vm._v(" "),_vm._m(9,true)]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v(_vm._s(item.contSealNo))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.cont))])])])])]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search btn-loading-img",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage(item.bookingId,item.ladingId, item.servicetype)}}},[_vm._v("查看图片\n                ")])],1)])}),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],2),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("运单号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("车牌号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货联系人：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货时间：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货地点：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货说明：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船公司：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("目的港：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("备注18：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"cont",staticStyle:{"color":"#333"}},[_vm._v("柜型")])])}]


/***/ }),

/***/ "39Im":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DeliveImgList',
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      src1: __webpack_require__("w2ig"), // 装箱的icon图片
      src2: __webpack_require__("fy9M"), // 送货的icon图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      isNoData: false
    };
  },
  created: function created() {
    document.title = '位置上传';
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code
      };
      this.isShowLoading = true;
      this.requestApi({
        url: _const.apiUrl.locationNoticeList,
        data: data
      }, function (resultData) {
        var list = resultData.data.list || [];
        if (list.length === 0) {
          _this.isNoData = true;
          _this.isShowLoading = false;
          _this.isShowTable = false;
          return;
        }
        _this.tableData = list;
      }, function (error) {
        _this.isShowLoading = false;
        if (error) {
          console.error(error);
        }
      });
    },
    goNextPage: function goNextPage(bookingId, ladingId, servicetype) {

      this.$router.push({
        name: 'LocationUpload',
        query: {
          bookingId: bookingId,
          ladingId: ladingId,
          servicetype: servicetype
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__ = __webpack_require__("ykmb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__ = __webpack_require__("4rCc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_46ce9210_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_flexbox_item_vue__ = __webpack_require__("uEpA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_46ce9210_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_flexbox_item_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_46ce9210_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_flexbox_item_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3c9e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

exports.default = {
    name: "MyFooter",
    // props: ['tel'],
    props: [],
    data: function data() {
        return {
            tel: ''
        };
    },
    created: function created() {
        this.getKehuTel();
    },

    methods: {
        getKehuTel: function getKehuTel() {
            var _this = this;

            // 获取“联系我们”的号码
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.requestApi({
                url: _const.apiUrl.getKehuTel,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this.tel = dataObj.tel || '';
            });
        },
        handleToast: function handleToast(e) {
            // 如果没有获取到联系方式，要提示用户刷新页面
            if (this.tel) {} else {
                e.preventDefault();
                this.showToast('获取不到联系方式，请刷新页面！', 1500, 'warn');
            }
        }
    }
}; //
//
//
//
//
//

/***/ }),

/***/ "3d+v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'divider'
};

/***/ }),

/***/ "3f23":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3lov":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_amapLocation_vue__ = __webpack_require__("8yea");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_amapLocation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_amapLocation_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_amapLocation_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_amapLocation_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_amapLocation_vue__ = __webpack_require__("X2rc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_amapLocation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_amapLocation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7701be80_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_amapLocation_vue__ = __webpack_require__("oSJp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("CHHn")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7701be80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_amapLocation_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7701be80_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_amapLocation_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7701be80_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_amapLocation_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3mKF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3sFM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4FCr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("xxDG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("pmSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_adb1491a_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Uq6G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("4r6v")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_adb1491a_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_adb1491a_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4JgS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"voyageResult"}},[(_vm.isShowTable)?_c('div',[_c('scroller',{ref:"scrollerBottom",attrs:{"lock-x":"","scroll-bottom-offset":50},on:{"on-scroll-bottom":_vm.onScrollBottom}},[_c('div',{staticClass:"box2"},[_c('div',{staticClass:"voyage-table-box"},[_c('table',{staticClass:"voyage-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("船名/航次")]),_vm._v(" "),_c('th',[_vm._v("开船日期")]),_vm._v(" "),_c('th',[_vm._v("船到日期")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.tableData),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(item.vesselName)+"/"+_vm._s(item.voyage))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.onboardDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.arrival))])])}),0)])]),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}}),_vm._v(" "),_c('divider',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMore && !_vm.isShowLoading),expression:"isShowMore && !isShowLoading"}]},[_vm._v("请上拉加载更多数据")])],1)])],1):_vm._e(),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "4jQ+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4lZo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUploadList_vue__ = __webpack_require__("/g1U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUploadList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUploadList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUploadList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUploadList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUploadList_vue__ = __webpack_require__("39Im");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUploadList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUploadList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa3a9dc4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LocationUploadList_vue__ = __webpack_require__("Q/LH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("UBv9")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa3a9dc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUploadList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa3a9dc4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LocationUploadList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa3a9dc4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LocationUploadList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4lrv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VehicletrackingResult_vue__ = __webpack_require__("Zspb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VehicletrackingResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VehicletrackingResult_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VehicletrackingResult_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VehicletrackingResult_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VehicletrackingResult_vue__ = __webpack_require__("TfX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VehicletrackingResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VehicletrackingResult_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de67988_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_VehicletrackingResult_vue__ = __webpack_require__("ym7X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("IxoN")
  __webpack_require__("TW3/")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3de67988"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_VehicletrackingResult_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de67988_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_VehicletrackingResult_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de67988_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_VehicletrackingResult_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4r6v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4rCc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

exports.default = {
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
};

/***/ }),

/***/ "52S5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"order"}},[_c('group',{attrs:{"gutter":10}},[_c('selector',{ref:"shipperSelector",staticClass:"select-box",attrs:{"title":"托运人","options":_vm.shipperOps,"placeholder":"请选择托运人","readonly":_vm.isDisabledList.shipperSelector},on:{"on-change":function (value) {_vm.changeShipper(value,'shipperSelector')}},model:{value:(_vm.shipper),callback:function ($$v) {_vm.shipper=$$v},expression:"shipper"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"装货日期","value-text-align":"right","placeholder":"请选择日期","required":""},model:{value:(_vm.load_date),callback:function ($$v) {_vm.load_date=$$v},expression:"load_date"}}),_vm._v(" "),_c('selector',{ref:"consigSelector",attrs:{"title":"货主","options":_vm.consigneeOps,"placeholder":"请选择货主","direction":"rtl","readonly":_vm.isDisabledList.consigSelector},on:{"on-change":function (value) {_vm.getArea(value,'consigSelector')}},model:{value:(_vm.consignee_id),callback:function ($$v) {_vm.consignee_id=$$v},expression:"consignee_id"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"货名","text-align":"right","placeholder":"请输入货物名称","required":""},model:{value:(_vm.goods_name),callback:function ($$v) {_vm.goods_name=$$v},expression:"goods_name"}}),_vm._v(" "),_c('selector',{ref:"dockOfLoadingSelector",attrs:{"title":"起运地","options":_vm.dockOfLoadingOps,"placeholder":"请选择起运地","direction":"rtl","readonly":_vm.isDisabledList.dockOfLoadingSelector},on:{"on-change":function (value) {_vm.getLoadJhr(value,'dockOfLoadingSelector')}},model:{value:(_vm.dockOfLoading),callback:function ($$v) {_vm.dockOfLoading=$$v},expression:"dockOfLoading"}}),_vm._v(" "),_c('selector',{ref:"finalDestinationSelector",attrs:{"title":"目的地","options":_vm.finalDestinationOps,"placeholder":"请选择目的地","direction":"rtl","readonly":_vm.isDisabledList.finalDestinationSelector},on:{"on-change":function (value) {_vm.getConsigPlace(value,'finalDestinationSelector')}},model:{value:(_vm.finalDestination),callback:function ($$v) {_vm.finalDestination=$$v},expression:"finalDestination"}}),_vm._v(" "),_c('selector',{ref:"jhrSelector",attrs:{"title":"装货地址","options":_vm.jhrOps,"placeholder":"请选择装货地址","direction":"rtl","readonly":_vm.isDisabledList.jhrSelector},on:{"on-change":function (value) {_vm.getLoadLink(value,'jhrSelector')}},model:{value:(_vm.jhr),callback:function ($$v) {_vm.jhr=$$v},expression:"jhr"}}),_vm._v(" "),_c('selector',{ref:"companyLxrSelector",attrs:{"title":"装货联系人","options":_vm.company_lxrOps,"placeholder":"请选择装货联系人","direction":"rtl","readonly":_vm.isDisabledList.companyLxrSelector},on:{"on-change":function (value) {_vm.getLoadTelMp(value,'companyLxrSelector')}},model:{value:(_vm.company_lxr),callback:function ($$v) {_vm.company_lxr=$$v},expression:"company_lxr"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"装货电话","text-align":"right","max":13,"placeholder":"请输入装货电话"},model:{value:(_vm.shipper_tel),callback:function ($$v) {_vm.shipper_tel=$$v},expression:"shipper_tel"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"装货手机","text-align":"right","max":11,"placeholder":"请输入装货手机"},model:{value:(_vm.shipper_mp),callback:function ($$v) {_vm.shipper_mp=$$v},expression:"shipper_mp"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"装货说明","text-align":"right","placeholder":"请输入装货说明"},model:{value:(_vm.remark3),callback:function ($$v) {_vm.remark3=$$v},expression:"remark3"}}),_vm._v(" "),_c('selector',{ref:"consigneePlaceSelector",attrs:{"title":"卸货地址","options":_vm.consignee_placeOps,"placeholder":"请选择卸货地址","direction":"rtl","readonly":_vm.isDisabledList.consigneePlaceSelector},on:{"on-change":function (value) {_vm.getXHLink(value,'consigneePlaceSelector')}},model:{value:(_vm.consignee_place),callback:function ($$v) {_vm.consignee_place=$$v},expression:"consignee_place"}}),_vm._v(" "),_c('selector',{ref:"consigneeLinkmanSelector",attrs:{"title":"卸货联系人","options":_vm.consignee_linkmanOps,"placeholder":"请选择卸货联系人","direction":"rtl","readonly":_vm.isDisabledList.consigneeLinkmanSelector},on:{"on-change":function (value) {_vm.getXhTelMp(value,'consigneeLinkmanSelector')}},model:{value:(_vm.consignee_linkman),callback:function ($$v) {_vm.consignee_linkman=$$v},expression:"consignee_linkman"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"卸货电话","text-align":"right","max":13,"placeholder":"请输入卸货电话"},model:{value:(_vm.consignee_tel),callback:function ($$v) {_vm.consignee_tel=$$v},expression:"consignee_tel"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"卸货手机","text-align":"right","max":11,"placeholder":"请输入卸货手机"},model:{value:(_vm.consignee_mp),callback:function ($$v) {_vm.consignee_mp=$$v},expression:"consignee_mp"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"卸货说明","text-align":"right","placeholder":"请输入卸货说明"},model:{value:(_vm.remark9),callback:function ($$v) {_vm.remark9=$$v},expression:"remark9"}}),_vm._v(" "),_c('selector',{ref:"carriageSelector",attrs:{"title":"操作条款","options":_vm.carriageOps,"direction":"rtl","placeholder":"请选择操作条款"},model:{value:(_vm.carriage),callback:function ($$v) {_vm.carriage=$$v},expression:"carriage"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"柜量","text-align":"right","placeholder":"请输入柜量"},model:{value:(_vm.contQty),callback:function ($$v) {_vm.contQty=$$v},expression:"contQty"}}),_vm._v(" "),_c('selector',{ref:"contTypeSelector",attrs:{"title":"柜型","options":_vm.contTypeOps,"direction":"rtl","placeholder":"请选择柜型"},model:{value:(_vm.contType),callback:function ($$v) {_vm.contType=$$v},expression:"contType"}}),_vm._v(" "),_c('selector',{ref:"insuranceStatusSelector",attrs:{"title":"是否保险","options":_vm.insurance_statusOps,"direction":"rtl","placeholder":"请选择"},model:{value:(_vm.insurance_status),callback:function ($$v) {_vm.insurance_status=$$v},expression:"insurance_status"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"费用说明","text-align":"right","placeholder":"请输入费用说明"},model:{value:(_vm.fees_remark2),callback:function ($$v) {_vm.fees_remark2=$$v},expression:"fees_remark2"}})],1),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("下单")])],1),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "5Xmy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5l0J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "QuoteResult",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            tableData: [],
            newData: [{
                sPlace: '广州',
                sPort: '黄埔港',
                ePlace: '天津',
                ePort: '天津港',
                // ship_company: '',
                truck_delivery: '远集拖车',
                tf_loading1_t: 10,
                // tf_loading2_t: 0,
                // oceanfee: 0,
                cont_fee: 10,
                // order_fee: 0,
                // baf: 0,
                port_fee: 20
                // tf_delivery1: 0,
                // tf_delivery2_t: 0,
                // totalup1: 0,
                // totalup2: 0,
            }], // 假数据，后续要注释
            canFetch: true, // false为阻止继续获取数据
            isShowLoading: false,
            isShowTable: true,
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回
            totalPages: 2, // 总页数，初始化必须比pageNo大；发现后台也有返回
            isNoData: false // false代表还有数据
        };
    },
    created: function created() {
        document.title = '报价查询';
        this.onScrollBottom(); // 组件被创建时，就先获取一次数据
    },

    methods: {
        getData: function getData(url, data) {
            var _this = this;

            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.isShowLoading = false;
                this.canFetch = true;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle'
                });
                return;
            }
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 调用接口获取数据
            this.$http({
                method: 'post',
                url: url,
                data: data
            }).then(function (res) {
                var resultData = res.data; // 后台返回结果
                var code = resultData.code;
                var info = resultData.info; // 412或500的提示语
                if (code === 412) {
                    _this.$vux.toast.show({
                        // text: '状态出错，请重新操作！',
                        text: info,
                        time: 1000,
                        type: 'warn'
                    });
                    _this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                    _this.isShowLoading = false;
                    _this.$vux.loading.hide();
                    return;
                }
                if (code === 500) {
                    _this.$vux.toast.show({
                        // text: '系统繁忙！',
                        text: info,
                        time: 1000,
                        type: 'warn'
                    });
                    _this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                    _this.isShowLoading = false;
                    _this.$vux.loading.hide();
                    return;
                }
                // 如果一切正常，那就渲染数据
                _this.$vux.loading.hide();
                var dataObj = resultData.data.page;
                if (dataObj.result.length === 0) {
                    // 如果没有数据了，要告知用户
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    // 如果第一页就没数据，那隐藏scroller
                    if (_this.pageNo === 1) {
                        _this.isShowTable = false;
                    }
                    return;
                }
                dataObj.result.forEach(function (item) {
                    _this.tableData.push(item);
                }); // 表格数据是放在result中
                _this.totalCount = dataObj.totalCount;
                _this.totalPages = Math.ceil(_this.totalCount / _this.pageSize);
                _this.pageNo++;
                _this.$nextTick(function () {
                    _this.$refs.scrollerBottom.reset();
                }); // 要重置scroller组件
                _this.isShowLoading = false;
                _this.canFetch = true;
            }).catch(function (error) {
                _this.canFetch = true;
                _this.$vux.loading.hide();
                console.error(error.response);
            });
        },
        onScrollBottom: function onScrollBottom() {
            this.isShowLoading = true;
            var query = this.$route.query;
            var data = {
                splace: query.splace,
                sport: query.sport,
                eport: query.eport,
                eplace: query.eplace,
                cont: query.cont,
                pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                pageNo: this.pageNo, // 当前为第几页数据，要累加
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            if (!this.canFetch) {} else {
                this.canFetch = false;
                this.getData(_const.apiUrl.quoteTemplate, data);
            }
        }
    }
};

/***/ }),

/***/ "61LD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("7uin");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("DxUy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_37c27a69_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("rPN7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("V7l1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_37c27a69_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_37c27a69_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6Q4U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _popup = __webpack_require__("+v63");

var _popup2 = _interopRequireDefault(_popup);

var _dom = __webpack_require__("te2A");

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new _popup2.default({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && (0, _keys2.default)(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && _dom2.default.removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && _dom2.default.addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
};

/***/ }),

/***/ "6e8/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "DeliveImgLook",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src2: __webpack_require__("fy9M"), // 送货的icon图片
            iconClose: __webpack_require__("VrRN"), // 关闭图标
            goBackQuery: {}, // 回退时要带的参数
            displayUrl: '',
            imgSrcList: [
                // require('@/assets/images/plan/wx_zhuang_blue.png'),
                // require('@/assets/images/wx_sc_oringe.png')
            ], // 图片路径列表
            isNoData: false,
            isShowLoading: false,
            step: -1
        };
    },
    created: function created() {
        document.title = '送货图片';
        var query = this.$route.query;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常，原因：页面先被刷新一次，再进入该组件，导致数据丢失，而且用go回退时要两次！
        if (!_const.apiParams.companyId) {
            _const.apiParams.companyId = query.companyId2;
            _const.apiParams.openId = query.openId2;
            this.step = -2;
        }
        if (query.type === 'delive') {
            this.displayUrl = _const.apiUrl.deliveImgDisplay; // 送货图片的接口
        } else if (query.type === 'open') {
            this.displayUrl = _const.apiUrl.lookopenimg; // 开箱图片的接口
        } else {
            this.displayUrl = _const.apiUrl.lookDelivedoc; // 送货单证图片的接口
        }
        this.getDisplayImg();
    },

    methods: {
        getDisplayImg: function getDisplayImg() {
            var _this = this;

            // 获取可展示的图片
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                id: this.id,
                servicetype: this.servicetype,
                referenceno: this.referenceno
            };
            this.isShowLoading = true;
            this.requestApi({
                url: this.displayUrl,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                var imgSrcList = dataObj.paths || [];
                if (imgSrcList.length === 0) {
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    _this.imgSrcList = imgSrcList;
                    return;
                }
                _this.imgSrcList = imgSrcList;
                _this.$previewRefresh();
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error);
                }
            });
        }
    }
};

/***/ }),

/***/ "6gNV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MyFooter = __webpack_require__("m+mo");

var _MyFooter2 = _interopRequireDefault(_MyFooter);

var _GoHome = __webpack_require__("ZWVd");

var _GoHome2 = _interopRequireDefault(_GoHome);

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "Business",
    components: {
        MyFooter: _MyFooter2.default,
        MyBtnReturn: _MyBtnReturn2.default,
        GoHome: _GoHome2.default
    },
    data: function data() {
        return {
            datediff: 0,
            dateDiffOptions: [{
                key: '7',
                value: '一周内'
            }, {
                key: '30',
                value: '一个月内'
            }, {
                key: '90',
                value: '三个月内'
            }, {
                key: '180',
                value: '六个月内'
            }, {
                key: '365',
                value: '一年内'
            }],
            cont_no: '',
            m_bl_no: '',
            lading_id: '',
            consignee_id: ''
        };
    },
    created: function created() {
        document.title = '货物跟踪';
    },

    methods: {
        goResultPage: function goResultPage() {
            var route = {
                name: 'BusinessResult',
                query: {
                    cont_no: this.cont_no,
                    m_bl_no: this.m_bl_no,
                    lading_id: this.lading_id,
                    consignee_id: this.consignee_id,
                    datediff: this.datediff
                }
            };
            this.$router.push(route);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "6liP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "Vehicletracking",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            loadDate: '',
            unloadingDate: '',
            truck_no: '',
            is_self: null, // 这个就是类型
            is_selfOps: [{
                key: '自有车',
                value: '自有车'
            }, {
                key: '挂靠车',
                value: '挂靠车'
            }, {
                key: '临时车',
                value: '临时车'
            }]

        };
    },
    created: function created() {
        document.title = '车辆跟踪';
    },

    methods: {
        search: function search() {
            this.$router.push({
                name: 'VehicletrackingResult',
                query: {
                    begin: this.loadDate || '',
                    end: this.unloadingDate || '',
                    truck_no: this.truck_no || '',
                    is_self: this.is_self || ''
                }
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "6td+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7/ee":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'demurrageQueryList',
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      shipper: null,
      companyId: null,

      listData: []
    };
  },
  created: function created() {
    document.title = '滞期天数查询';
    this.shipper = this.$route.query.shipper;
    this.companyId = this.$route.query.companyId;
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        shipper: this.shipper,
        companyId: this.companyId
      };

      this.$http.post(_const.apiUrl.getContainerDemurrageDaysList, data).then(function (response) {
        if (response.data.code == 200) {
          _this.listData = response.data.data;
        }
      }).catch(function (error) {});
    }
  }
};

/***/ }),

/***/ "71I8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"LocationUpload"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_c('div',{staticClass:"lading-id"},[_c('div',{staticClass:"list-item__first"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(_vm.bookingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.bookingId))])])]),_vm._v(" "),_c('amapLocation',{staticStyle:{"padding":"03px 0.16rem","background-color":"#FFFFFF","color":"#333333","margin-top":"10px"},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}},[_vm._v("\n            当前位置："+_vm._s(_vm.address || '正在获取当前位置...')+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"list-item",on:{"click":function($event){return _vm.checkItem(index)}}},[_c('div',{staticClass:"top"},[_c('img',{staticStyle:{"width":"20px","margin-right":"10px"},attrs:{"src":item.check ? _vm.check : _vm.unCheck}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","width":"100%"}},[_c('div',{staticClass:"list-item-row-left"},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("柜号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.contNo && item.contNo.toUpperCase() || '/'))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("柜型：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.contId && item.contId.toUpperCase() || '/'))])])])]),_vm._v(" "),(item.locationNotice)?_c('div',{staticClass:"list-item-row-left",staticStyle:{"margin-left":"30px","font-size":"0.15rem"}},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v(_vm._s(item.otherService == '装箱' ? '装货位置' : '卸货位置')+"：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.locationNotice))])]):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"bottom-handel",class:{'bottom-handel-visible' : _vm.showBottomHandel}},[_c('x-button',{class:{'upload-disabled' : !_vm.address},attrs:{"disabled":!_vm.address},on:{"click":_vm.upload}},[_vm._v("上传")])],1),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],1),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "7Ah8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("JqR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("oWvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_72b9f796_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("AIJJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("xLid")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_72b9f796_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_72b9f796_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7GQS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAQlBMVEUAAABixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn0RUMYnAAAAFXRSTlMA9T96p5f46i8S+lcX676uhUUuDAcsypu2AAAAdUlEQVQoz8XSuxKDMAxE0VWiADaEt///V5mh2B0wpoRtz9xKQvAqXa7yAE/FDVCXt0g3exTHpS3iF0BNzG1imdvHiNZbZsQZzf9kxLgCTX00lT/sKiNKZUIpjSjtaEQpTUiVCaVda68dW2h3r+lldASP1xQ9bBqfNyyywBgmAAAAAElFTkSuQmCC"

/***/ }),

/***/ "7TQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("kW1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("CZUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_04768dae_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Uelq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("OAXP")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_04768dae_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_04768dae_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7sNH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7uin":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("/kga");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'confirm',
  components: {
    XDialog: _xDialog2.default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "8ABI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8LKC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8OYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"goHome"}},[_c('div',{staticClass:"btn-go-home",on:{"click":_vm.handleGoHome}},[_c('i',{staticClass:"iconfont icon-home"},[_vm._v("")])])])}
var staticRenderFns = []


/***/ }),

/***/ "8tGI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'DeliveImgLading',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src2: __webpack_require__("fy9M"), // 送货的icon图片
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'zzzz',
                //   deliveimgisload: 0,
                //   openimgisupload: 1,
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'aaaaa',
                //   deliveimgisload: 1,
                //   openimgisupload: 0,
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            isNoData: false
        };
    },
    created: function created() {
        document.title = '送货图片';
        this.bookingId = this.$route.query.bookingId;
        this.ladingId = this.$route.query.ladingId;
        this.servicetype = this.$route.query.servicetype;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            // 获取工作单下要上传图片的柜，一个工作单可能有多个柜号id
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                servicetype: this.servicetype
            };
            this.isShowLoading = true;
            // 调用接口获取数据
            this.requestApi({
                url: _const.apiUrl.deliveImgLading,
                data: data
            }, function (resultData) {
                _this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况
                _this.tableData = resultData.data.sonos || [];
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        goNextPage: function goNextPage(routerName, id, referenceno, contNo, contId, type) {
            // 按钮的方法，跳转查看页面，并且带些参数过去
            this.$router.push({
                name: routerName,
                query: {
                    bookingId: this.bookingId,
                    ladingId: this.ladingId,
                    servicetype: this.servicetype,
                    id: id,
                    referenceno: referenceno,
                    contNo: contNo,
                    contId: contId,
                    type: type, // 为了区分装箱与封箱，load为装箱，seal为封箱,delivedoc为送货单证图片
                    companyId2: _const.apiParams.companyId,
                    openId2: _const.apiParams.openId
                }
            });
        }
    }
};

/***/ }),

/***/ "8yea":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _asyncLoadJs = __webpack_require__("W9EI");

var _asyncLoadJs2 = _interopRequireDefault(_asyncLoadJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'amapLocation',
    data: function data() {
        return {
            map: null,
            edit: false, // 是否可编辑
            placeSearch: null,
            poiList: [],
            selectIndex: -1, // 选中位置
            show: false,
            currLocation: null
        };
    },

    watch: {
        selectIndex: function selectIndex(newValue, oldValue) {
            if (newValue != oldValue && newValue != -1 && this.poiList.length > newValue) {
                var poi = this.poiList[newValue];
                this.map.setCenter([poi.location.lng, poi.location.lat]);

                this.map.clearMap();
                var marker = new AMap.Marker({
                    position: new AMap.LngLat(poi.location.lng, poi.location.lat)
                });
                this.map.add(marker);
            }
        },
        show: function show(newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                if (this.selectIndex != -1 && this.poiList.length > this.selectIndex) {
                    var poi = this.poiList[this.selectIndex];
                    this.map.setCenter([poi.location.lng, poi.location.lat]);

                    if (this.map.getZoom() < 10) {
                        this.map.setZoom(16);
                    }
                }
            }
        }
    },
    props: {
        value: {
            type: Object,
            default: null
        }
    },
    methods: {
        /**
         * 加载地图
         */
        loadMap: function loadMap() {
            var that = this;
            (0, _asyncLoadJs2.default)().then(function (AMap) {
                that.map = new AMap.Map('amapContainer', {
                    zoom: 17,
                    resizeEnable: true
                });
                that.getLocation();
                that.initAutocomplete();
                that.initPlaceSearch();
            }, function (e) {
                console.error('地图加载失败', e);
            });
        },

        /**
         * 获取去当前位置
         */
        getLocation: function getLocation() {
            var that = this;
            this.map.plugin('AMap.Geolocation', function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 10000, //超过10秒后停止定位，默认：无穷大
                    maximumAge: 0, //定位结果缓存0毫秒，默认：0
                    convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                    showButton: true, //显示定位按钮，默认：true
                    buttonPosition: 'RB', //定位按钮停靠位置，默认：'LB'，左下角
                    buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
                    showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
                    panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
                    zoomToAccuracy: true //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                });

                that.map.addControl(geolocation);
                geolocation.getCurrentPosition();
                AMap.event.addListener(geolocation, 'complete', onComplete);
                AMap.event.addListener(geolocation, 'error', onError);

                function onComplete(data) {
                    // data是具体的定位信息
                    that.edit = true;
                    that.selectIndex = -1;
                    that.placeSearch.search(data.formattedAddress);
                }

                function onError(data) {
                    // 定位出错
                    console.error(data);
                }
            });
        },

        /**
         * 初始化自动匹配输入
         */
        initAutocomplete: function initAutocomplete() {
            var that = this;
            AMap.plugin('AMap.Autocomplete', function () {

                // 实例化Autocomplete
                var autoComplete = new AMap.Autocomplete({
                    city: '全国',
                    input: 'Autocomplete'
                });

                AMap.event.addListener(autoComplete, 'complete', onComplete);
                AMap.event.addListener(autoComplete, 'error', onError);
                AMap.event.addListener(autoComplete, 'select', onSelect);

                function onComplete(data) {}

                function onError(data) {}

                function onSelect(data) {
                    // 选择输入
                    that.selectIndex = -1;
                    that.placeSearch.search(data.poi.name);
                }
            });
        },

        /**
         * 初始化搜索服务
         */
        initPlaceSearch: function initPlaceSearch() {
            var that = this;
            AMap.plugin('AMap.PlaceSearch', function () {

                that.placeSearch = new AMap.PlaceSearch({
                    pageSize: 30,
                    renderStyle: 'default',
                    extensions: 'all'
                });

                AMap.event.addListener(that.placeSearch, 'complete', onComplete);
                AMap.event.addListener(that.placeSearch, 'error', onError);

                function onComplete(data) {
                    that.selectIndex = 0;
                    that.poiList = data.poiList.pois;

                    if (!that.value || !that.value.address) {
                        // 第一次获取到位置，回传回去，能减少打开页面频率
                        var poi = that.poiList[that.selectIndex];
                        var address = {
                            address: (poi.pname || '') + (poi.cityname || '') + (poi.adname || '') + (poi.address || '') + (poi.name || ''),
                            lng: poi.location.lng,
                            lat: poi.location.lat
                        };
                        that.$emit('input', address);
                    }
                }

                function onError(err) {
                    console.error(err);
                }
            });
        },

        /**
         * 确定选择
         */
        enter: function enter() {
            var poi = this.poiList[this.selectIndex];
            var address = {
                address: (poi.pname || '') + (poi.cityname || '') + (poi.adname || '') + (poi.address || '') + (poi.name || ''),
                lng: poi.location.lng,
                lat: poi.location.lat
            };
            this.$emit('input', address);
            this.show = false;
        }
    },
    created: function created() {
        this.loadMap();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "92Bb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preventBodyScroll = __webpack_require__("JkZY");

var _preventBodyScroll2 = _interopRequireDefault(_preventBodyScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_preventBodyScroll2.default],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "9807":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
};

/***/ }),

/***/ "9ADW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

exports.default = {
    data: function data() {
        return {
            msg: 'Hello World!',
            isShowLoading: false,
            groupData: [],
            companyId: '',
            isToast: false,
            canFetch: true
        };
    },
    created: function created() {
        document.title = '货物跟踪';
        // 如果参数为undefined，axios不会传该参数到服务器！
        // 现在后台将companyId/openId等存到session，但验证权限接口menuPermission还是需要前端传递companyId参数的，因此保留这里的代码
        _const.apiParams.companyId = this.getUrlParams('companyId') || _const.apiParams.companyId || '';
        _const.apiParams.code = this.getUrlParams('code') || _const.apiParams.code || '';
        this.getMenu();
    },

    methods: {
        getMenu: function getMenu() {
            var _this = this;

            var data = {
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                openId: _const.apiParams.openId
            };
            this.isShowLoading = true;
            this.$http.post(_const.apiUrl.getAvailableMenu, data).then(function (response) {
                _this.isShowLoading = false;
                if (response.data.code !== 200) {
                    _this.showToast(response.data.info);
                    return;
                }
                var availableMenu = response.data.data || [];
                if (availableMenu.length === 0) {
                    _this.groupData = [_const.homeMenu.kehu, _const.homeMenu.yewu, _const.homeMenu.siji];
                    return;
                }
                debugger;
                availableMenu.forEach(function (item) {
                    var menuItem = {};
                    if (item.menuType === '0') {
                        menuItem = _const.homeMenu.kehu;
                    } else if (item.menuType === '1') {
                        menuItem = _const.homeMenu.yewu;
                    } else if (item.menuType === '2') {
                        menuItem = _const.homeMenu.siji;
                    }
                    if (item.menuTitle) {
                        var menuTitle = item.menuTitle.split(',');
                        for (var j = 0; j < menuItem.contentData.length; j++) {
                            var label = menuItem.contentData[j].label;
                            if (!menuTitle.includes(label)) {
                                menuItem.contentData.splice(j, 1);
                                j--;
                            }
                        }
                    }

                    _this.groupData.push(menuItem);
                });
            }).catch(function (error) {
                console.error(error);
                _this.isShowLoading = false;
            });
        },
        goMenu: function goMenu(menuType, path) {
            var _this2 = this;

            if (!this.canFetch) return;
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.canFetch = false;
            var data = {
                companyId: _const.apiParams.companyId,
                menuType: menuType,
                code: _const.apiParams.code,
                openId: _const.apiParams.openId // 第二次调用开始会使用，代替code
            };
            this.$http.post(_const.apiUrl.menuPermission, data).then(function (response) {
                _this2.$vux.loading.hide();
                // 判断响应状态
                var resultData = response.data;
                var code = resultData.code;
                var info = resultData.info; // 412或500的提示语
                if (code === 412) {
                    _this2.showToast(info, 2000, 'warn');
                } else if (code === 500) {
                    _this2.showToast(info, 2000, 'warn');
                } else {
                    // 判断是否有权限
                    var hasPermission = resultData.data.hasPermission || '';
                    var openId = resultData.data.openId || '';
                    var unPermissionInfo = resultData.data.unPermissionInfo;
                    _const.apiParams.openId = _const.apiParams.openId || openId;
                    if (hasPermission) {
                        _this2.$router.push({
                            path: path
                            // query: {
                            //   openId: openId
                            // }
                        });
                    } else {
                        _this2.showToast(unPermissionInfo, 2000, 'warn');
                    }
                }
                _this2.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
            }).catch(function (error) {
                _this2.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                _this2.$vux.loading.hide();
                console.error(error.config);
                console.error('Error', error.message);
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "9HL0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9O+z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9mub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgList_vue__ = __webpack_require__("wRSE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgList_vue__ = __webpack_require__("NYe3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_910c8b9a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgList_vue__ = __webpack_require__("TyqU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("9HL0")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-910c8b9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_910c8b9a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_910c8b9a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9xmH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A+vQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAeFBMVEUAAABz3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K5z3K6luReNAAAAJ3RSTlMABukQkon67OKAWJZLDPE1e8nFdmGtn21TKRna0qYiFPbAubRDJDvZ/OJeAAABZElEQVQoz4WT63KDIBSEl6toRI2aeNdcmvL+b1gBMZO2M34/5IwLzLJwsENSfqZS0jNPCX7D4sjsRDHDBwk1H9AEb8jJ/OFEdvVi/uES9LA2yuz3MRgPhyOxtVRGst7qwLTpifPsXFU6ygA10Bsggj/rP3ZlgyZba++lf+VuSrzW/rxZ0g9A0VYF0AghSrecIDUbGQez/oCzCaTg3jRvNQEb9UKsnTl/bOZLN34B/RP6kaMWDmUsJXyaLWmorIvVDP/IFtKNtyz77vJuAfS8MBaSkqvsuWJORAEynSt9vUdBpiFRamgN8OtQI35vXoZyrAnQFtC6VeFf6a2oZ9UB6NGoewpWBJ27WHJYXpfIXk/xApBX02hjcaFWABYhzYgvw5k6waFsqNaHyvPTbZ0sQDryXE9BgHWmif2FBmqAXG0xaXTUXyiSXRaYt4PQ+5pHEh5TQEnzhh88xYOHfNAGx0100II/LJFJSibLT0AAAAAASUVORK5CYII="

/***/ }),

/***/ "A5j2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('amapLocation',{model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}},[_c('div',{staticStyle:{"background-color":"#FFFFFF","height":"100px","border-radius":"5px"}},[_vm._v(_vm._s(_vm.location.address || ''))])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "AD3X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _safariFix = __webpack_require__("xNvf");

var _safariFix2 = _interopRequireDefault(_safariFix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'toast',
  mixins: [_safariFix2.default],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "AIJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()],{"labelClass":"weui-label","labelStyle":_vm.labelStyles,"labelTitle":_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){return _vm.onHide(false)},"on-click-right":function($event){return _vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var staticRenderFns = []


/***/ }),

/***/ "ALGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("TZ+T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("H57j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_38c5ac93_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("w1RL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("uDI8")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_38c5ac93_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_38c5ac93_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AlWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"goBackBtn"}},[_c('div',{staticClass:"btn-return",on:{"click":_vm.handleReturn}},[_c('img',{attrs:{"src":__webpack_require__("sW9f"),"alt":""}})])])}
var staticRenderFns = []


/***/ }),

/***/ "BDJl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"quote"}},[_c('group',[_c('selector',{ref:"sPlaceSelector",attrs:{"title":"起始地","options":_vm.sPlaceOps,"direction":"rtl","placeholder":"请选择起始地"},on:{"on-change":_vm.sPlaceChange},model:{value:(_vm.splace),callback:function ($$v) {_vm.splace=$$v},expression:"splace"}}),_vm._v(" "),_c('selector',{ref:"sPortSelector",attrs:{"title":"起始港","options":_vm.sPortOps,"direction":"rtl","placeholder":"请选择起始港"},on:{"on-change":_vm.sPortChange},model:{value:(_vm.sport),callback:function ($$v) {_vm.sport=$$v},expression:"sport"}}),_vm._v(" "),_c('selector',{ref:"ePortSelector",attrs:{"title":"目的港","options":_vm.ePortOps,"direction":"rtl","placeholder":"请选择目的港"},on:{"on-change":_vm.ePortChange},model:{value:(_vm.eport),callback:function ($$v) {_vm.eport=$$v},expression:"eport"}}),_vm._v(" "),_c('selector',{ref:"ePlaceSelector",attrs:{"title":"目的地","options":_vm.ePlaceOps,"direction":"rtl","placeholder":"请选择目的地"},on:{"on-change":_vm.ePlaceChange},model:{value:(_vm.eplace),callback:function ($$v) {_vm.eplace=$$v},expression:"eplace"}}),_vm._v(" "),_c('selector',{ref:"contSelector",attrs:{"title":"柜型","options":_vm.contTypeOps,"direction":"rtl","placeholder":"请选择柜型"},on:{"on-change":_vm.contChange},model:{value:(_vm.cont),callback:function ($$v) {_vm.cont=$$v},expression:"cont"}})],1),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('button',{staticClass:"btn-search",on:{"click":_vm.goResultPage}},[_vm._v("查询")])]),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "BG2Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "ReportContNo",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            ladingId: '',
            src1: __webpack_require__("w2ig"), // 装箱的图片
            src2: __webpack_require__("qDaJ"), // 拆箱的图片
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   sealNo: 'ajdfkadfjakl',
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   sealNo: '',
                // },
            ],
            isTodayEnd: false, // true就代表今日计划的数据获取完了
            isShowTable: true,
            isShowLoading: false,
            isShowConfirm: false,
            canUpdate: true, // true代表能继续发送请求，控制onConfirm方法的
            isNoData: false,
            isDisabledList: [], // 控制btn-report按钮的是否禁用属性，有多个按钮，因此有多个元素
            content: {
                id: '',
                contNo: '',
                sealNo: '',
                shipperW: '',
                index: 0 // 存放该数据的索引，onConfirm中可以找到isDisabledList对应的元素
            }
        };
    },
    created: function created() {
        document.title = '报柜号';
        this.ladingId = this.$route.query.ladingId;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            // 获取工作单下要报柜号的柜，一个工作单可能有多个柜号id，对应第二个页面
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId
            };
            this.isShowLoading = true;
            // 先获取今日计划的数据
            // 调用接口获取数据
            this.requestApi({
                url: _const.apiUrl.getReportContNoSono,
                data: data
            }, function (resultData) {
                _this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                var list = resultData.data.sonos || [];
                if (list.length === 0) {
                    // 如果没有数据，要告知用户
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    _this.tableData = list;
                    return;
                }
                // todo:前端添加两个属性，分别代表是否已报柜号、是否已报封条号
                list.forEach(function (item) {
                    // this.tableData.forEach((item) => { // 要注释
                    item.isReportContNo = item.contNo; // 真值就代表已报柜号了
                    item.isReportSealNo = item.sealNo; // 真值就代表已报封条号了
                    // 添加对应数量的禁用属性，如果contNo与sealNo都为真值，那就直接添加true，禁用按钮
                    if (item.contNo && item.sealNo) {
                        _this.isDisabledList.push(true);
                    } else {
                        _this.isDisabledList.push(false);
                    }
                });
                _this.tableData = list;
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        btnReportFn: function btnReportFn(index, id) {
            // todo: 现在写的逻辑：只要报过了，就不给修改
            // 按钮btn-report的方法，先检验是否有输入柜号或者封号(至少有一个)，然后弹窗询问用户是否确认报柜号
            var tableData = this.tableData[index];
            var contNo = tableData.contNo && tableData.contNo.toUpperCase();
            var sealNo = tableData.sealNo && tableData.sealNo.toUpperCase();
            var shipperW = tableData.shipperW;
            var isReportContNo = tableData.isReportContNo;
            var isReportSealNo = tableData.isReportSealNo;
            if (!shipperW) {
                this.showToast('货重必填！', 2000, 'warn');
                return;
            }
            if (contNo || sealNo || shipperW) {
                if (isReportContNo && contNo && !sealNo && !shipperW) {
                    // 已经报过柜号了，但这次又不填写封条号，不给继续报
                    this.showToast('已经报过柜号了！', 2000, 'warn');
                    return;
                }
                if (isReportSealNo && sealNo && !contNo && !shipperW) {
                    // 已经报过封条号了，但这次又不填写柜号，不给继续报
                    this.showToast('已经报过封条号了！', 2000, 'warn');
                    return;
                }
                this.isShowConfirm = true;
                this.content = {
                    id: id,
                    contNo: contNo || '',
                    sealNo: sealNo || '',
                    shipperW: shipperW,
                    index: index // 该索引可对应tableData与isDisabledList的数据
                };
            } else {
                this.showToast('请输入柜号或封条号', 2000, 'warn');
            }
        },
        onConfirm: function onConfirm() {
            var _this2 = this;

            // 更新对应 的柜号、封号
            if (!this.canUpdate) return;
            this.canUpdate = false;
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                id: this.content.id,
                contNos: this.content.contNo,
                sealNos: this.content.sealNo,
                shipperW: this.content.shipperW
            };
            var index = this.content.index;
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: _const.apiUrl.reportContNo,
                data: data
            }, function (resultData) {
                _this2.$vux.loading.hide();
                // 到这一步，那就是更新成功了：判断是报了哪个，如果都报了，那就禁用对应的按钮，连柜号的input也要禁用！
                var successInfo = resultData.data.info || '操作成功！';
                // this.showToast('操作成功！', 2000)
                _this2.showToast(successInfo, 2000);
                if (data.sealNos && data.contNos) {
                    _this2.isDisabledList[index] = true;
                    _this2.tableData[index].isReportContNo = true;
                    _this2.tableData[index].isReportSealNo = true;
                } else if (data.contNos) {
                    _this2.tableData[index].isReportContNo = true;
                } else if (data.sealNos) {
                    _this2.tableData[index].isReportSealNo = true;
                }
            }, function (error) {
                _this2.canUpdate = true;
                _this2.$vux.loading.hide();
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        changeToUpperCase: function changeToUpperCase(item, index) {
            this.tableData[index][item] = this.tableData[index][item] && this.tableData[index][item].toUpperCase(); // 防止数据为null
        }
    }
};

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("uCgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Z5JB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_0178dc7c_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("pPRd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("G86e")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_0178dc7c_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_0178dc7c_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Bse7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABLCAYAAAArmToeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlEMkY5RjhDQkUzNTExRTk4REMyQzg5OUY1N0UyMjA0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlEMkY5RjhEQkUzNTExRTk4REMyQzg5OUY1N0UyMjA0Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUQyRjlGOEFCRTM1MTFFOThEQzJDODk5RjU3RTIyMDQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUQyRjlGOEJCRTM1MTFFOThEQzJDODk5RjU3RTIyMDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6AEtReAAAHw0lEQVR42uxca2wVRRSee8FqRMGqRVsMSA1FiUZMy0sTxQpVgQSj5RGNiBBbg8REg1pS+wOfrfGXqYQSMYoE7dWEGIVIe4ngD0VLA1GpSaHFFxJbpaGCD+zD83XPhrnTmXt3u7f37q17ki/tzszO3flm5pwzM2c3NLauXwyzLCFUEa4lnOfwnn8IhwiVhD3D9WCnymKvRxvKjSHMJRQQcgiXGcqdJLxDaDHkP0jYOoTnPJ8wi7CbMI+wV1PmesIKwjglvZfQSThB+JJw0OmPqmRcTthAWEm40GEdjxNmGAhZ77HzRhGe0pBRwA118oythOcI2wlxp0FY+r+I8A1hjQsiBJctNeTlJGE0j9ekLXPxjCBuG+FtQpYTMvIJjYQrh/jAJwzpnySBjN2atJ+GUA+mbD0hlIiM1wmXDPFhP4yjF54kNHkgooHwkib9XdZVbrX/PawCtBIiazKN/n6rYew0oY7wEeEXVkyq/MHKKtHou5OtSZbDhz7Lim9fggZjGl4sKf1JhDsIqwhjDfccJUwl9KnWBGTU0N+nlRs6CMWEwyIzBYbgDcJiQ34J1IJKBnrtZk3hhzOYCMhvhHsJ7xnyi01DeIpmGO0SmS99hNWEHzR500xkZCtph8TIkT8JL2vSLzWRkaVRXiNJdji1OmEx8qXDgcX735AhAjIGK9OADDcSkBGQEZARkOFGRrsoi1XgWl4Z+k2wy7ZJWHunw04Gyn1GuNHHHYuV6MJUTJObfE4EZAHhilSQcUK431VKx6KsKxVk/Ex40ceE9BCe8LrIdKNAq1hJTfWZFQIRh52uP5JFBuQ4I/AzAqcrICMgIyAjoCAgIyAjmWTczc5NL3uiqQA8ygOE6X4iA9Ex7wvrJCqVowlhT4WEiJ/IuE5Yp9zpEhyB5nq4/1CCa1fueAuvCLPTRAbOf3/1cD/iRBDpc4uwgnKe9UJGt7A2T14Rqd/pauHG9HmoA6fypclcqEGRFQfWJDCtARmZ8syYrtXCig9FvFkP+yV/CWu/BUryBcJtIk5037jNQ9cZ6RYcVSBGFccVEwxlLiDkMRBZjHDr74UVqPeasPZJM35kIIbziLCicCa4vPdqvq+N8FAmkwFHD0FqiDMd77EuBPy+xZ70RV5Na6oFMZ47hRWXrgp0xC7OR9AtgthO87LhKsJMwiLCXZo2lvJowTlLZyaQMcZABBaJ2KHHsYUuRLuTcZD1RB57m48obS1iMm9nEl2TgQj/xWJwqKRT+ZvwKeFrB2W3aIg4RljaXR46MEiz1vUXssLsonzZRsDSrKF8hFZv5xEhE/Im6rQTECGsHgzhpgeUNJinHcIccetUerjuSAJluVWzsCqhhnbS82bR37MKEY3Sumkz5ZdL+WG67qO/mHYf8xSSZeWpsoE3DhyTMV24eIklgSBO/YY45vOIoiwxImaBCMOIaNQsIGMIkcqDkK+UEYJ6pxAhp8IuejRZEoqTt0Yhopenho6IMoWICnHurLWM8iOEGJK4nvtF7EsBIOgxN6YVvVmfBCLwEBvimPm1StomXiDKJGQTqllB2o0tp4bihYD5EiF4N66Nyi5RCPlCWEH2MZ1A3mjY6TSxe/RWYZ21DlVf4EG+M+TDxd6jlJ8Iq0ENkEdDtTItmnk3DCRgakR5xBRKZZBWQ/VEuZ5cNsfyC4TFbqwJSNvHGA4pUa532eaTexck5Ev5duPzueHZrJgxSop49DzDZWFp5lFaO4+edq5fNgglfvJAZyvXO6X/IwoR6OEiajS8yc3sVdpSB8VKeRVSw23J5+kj2LLIMsdPZBQo101K4wU3DD0/n9DOOgC+xVJWoPKoQV6UcI00faIScaq/UuBGZwy39LBjZwvepT3JjbJ1htyzOrF1R7uS3mzrC64Hf/Caxe+ycveTOz5Kue7WlKlOQIZ5/V/XX8EWx1T/KD9Nk16NA6ZKs4f6CxPU76uRgfdC5LORSfY0kXwE9GyNi9FwUjLDUSVb3eXv8NPIaFWuZ3jaFqvrl52yqLKA09Xf6icy9ivXCz0SUSZZoKWaYmr9+/1ERoNyvUCZNmhkKAEJcNUbJSK6eG2jxofmcv0xvx92oNVTJXtFbCQh9FmlojP64xABL7ONvU2bCPgjOqVbqezl4Hf3gowzSsG8NJGB48NaJe1R3oRJNC2qlRVsu4kIKlvE9cpSS0v4vrAYHEw6U5g/HjLcspGtijxKI7wPYSIiX1qDyK56s2E/I6KM/g7+3YFl81HlHnzVpCpNZMARWqekTcZ8NhHCbnkNk1DBrnqXgYgGrk+WdTQquu2dLmyYPq9ZoeITLtvSRAqOB5YpacfYKhww7IXEO6Uv4hGhElFPRCyXK4loKgrxPuRG3lNItawWg7+7MZnNb60YHLhiIiKXy+/XENHEv3Ou0bxo+YBwX5x9jFbWuH1JbvS/vD/yqsYdd3tu0s0u9iS+ZyGbT52X3cT5nfJnI2wyJvLwy0nTtKgwuNk4P9mimTJepJ5HxIAVlcmw/YwfhfUJlq40kbHIkI4HXs76qyMJa58VXN8ZYVA8tnzOK7toGshIdAyBQyAcXq0X7l/xOM73TeF6jBIyfMFtFg/NOcI6u8xhk5tswSkbvti0ysWoRAfOFdae6WzeIRvPvkMvj4BWVpoN7NkadZ08Tf4TYAB/7ToR6J5eBwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "ByWV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAMAAAAPkIrYAAAAh1BMVEUAAAD2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCqbSCnsAAAALHRSTlMAMy1mzJYOu5n8HsPzE+/sv1sI+Ww6+OjXyIR/drCMV08/0amQexngtyonI6+KAm4AAAG7SURBVFjD7dbbkppAFIXhhQjYKKCEw6B41jnu93++bDpOOqV7qqChktQU/w3rwvouoAsEkG9j6lO8zXErU9Q35UKXM9Ufc7S1pSE6aysexCq1pefesW+vBWNNYN9ktL6zFQaLIBzICnguB7J+8FT9LbNH699Z5qT1t8xJ62+Zk9bfMuvvW+/ExbLV+SlU/NOLbLV+CqtpcTrwNfLmm1S2Wj6F1RM1vb5BJ1vykiVOeb6lZSRTktlaRjKdjpZWTULbDyvro5Kw4mBhcW7yaC0srPXaB6LZnRSvI3S3iMoVX/ITmZINS2m26Wxxc4dHtviUrj7g1yUp8ZsmL505n89n4sq6ka76DkrfWnkZi0tc3sfZOUuBaBOTTvoPIC9j6SoHumjNkmC1iH6nduBcvm29Lc4FcqJhrFdgN5Q1B7zvaKkBrfnXlkJB3NO0VVWN95cvrSmm1KUr/IuSrThH3cmqAEyWglV4IZAGXawATavyziouz2hKPdWaSm4Pyd+pP6zFjqVb0cFt1z7CZ2/Lm6Xfz33bv3hA1ryfx36Vzh5KbS2fHvJHa7T+Ayt07jo+WkfnrlC2PLLIGy1r6yc9rWkcCb2fKgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "CE5r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _const = __webpack_require__("ZLd3");

var _GoHome = __webpack_require__("ZWVd");

var _GoHome2 = _interopRequireDefault(_GoHome);

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "Order",
    components: {
        GoHome: _GoHome2.default,
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            // todo:逻辑应该是：上层中某个选项变化了，下面所有select与受影响的input都要变为null
            shipper: null,
            shipperOps: [],
            employeeId: '',
            load_date: '',
            consignee_id: null, // 囧，selector组件要设置默认值为null时，placeholder才有效果！
            consigneeOps: [
                // {
                //   key: 'lsh',
                //   value: '李四'
                // },
                // {
                //   key: 'zhs',
                //   value: '张三'
                // }
            ],
            goods_name: '',
            dockOfLoading: null,
            dockOfLoadingOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            finalDestination: null,
            finalDestinationOps: [],
            jhr: null,
            jhrOps: [],
            company_lxr: null,
            company_lxrOps: [],
            shipper_tel: '',
            shipper_mp: '',
            remark3: '', // 装货说明
            consignee_place: null,
            consignee_placeOps: [],
            consignee_linkman: null,
            consignee_linkmanOps: [],
            consignee_tel: '',
            consignee_mp: '',
            remark9: '', // 卸货说明
            carriage: null,
            carriageOps: [{
                key: 'DR-DR',
                value: '门/门'
            }, {
                key: 'DR-CY',
                value: '门/堆场'
            }, {
                key: 'CY-DR',
                value: '堆场/门'
            }, {
                key: 'CY-CY',
                value: '堆场/堆场'
            }],
            contQty: '', // todo:柜量还要进行处理？
            contType: null,
            contTypeOps: [
                // {
                //   key: '20',
                //   value: '20GP'
                // },
                // {
                //   key: '40',
                //   value: '20GP'
                // },
                // {
                //   key: '4',
                //   value: '4GP'
                // },
            ], // todo:后台传递来
            insurance_status: null,
            insurance_statusOps: [{
                key: '1',
                value: '是'
            }, {
                key: '0',
                value: '否'
            }],
            fees_remark2: '',
            isDisabledList: {
                shipperSelector: false,
                consigSelector: false,
                dockOfLoadingSelector: false,
                finalDestinationSelector: false,
                jhrSelector: false,
                companyLxrSelector: false,
                consigneePlaceSelector: false,
                consigneeLinkmanSelector: false
            }, // 这个对象存放控制各个selector组件的readonly属性的值
            canSubmit: true
        };
    },
    created: function created() {
        document.title = '业务下单';
        this.getInitialSelectData();
    },

    methods: {
        getInitialSelectData: function getInitialSelectData() {
            var _this = this;

            // 可获取到shippers(托运人列表)、employeeId(对应业务员？)、conts(柜型柜量)
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: _const.apiUrl.getShippersAndConts,
                data: data
            }, function (resultData) {
                _this.$vux.loading.hide();
                var dataObj = resultData.data;
                _this.shipperOps = dataObj.shippers;
                _this.employeeId = dataObj.employeeId;
                _this.contTypeOps = dataObj.conts;
            }, function (error) {
                _this.$vux.loading.hide();
                if (error) {
                    // todo:如果请求失败，2秒后可重新获取，或者提示用户刷新页面？
                    setTimeout(function () {
                        _this.getInitialSelectData();
                    }, 2000);
                    console.error(error);
                }
            });
        },

        // 所有selector的on-change方法都换成原生的change,记得要.native；（这是为了避免初始化selector时自动运行一次on-change）
        changeShipper: function changeShipper(value, ref) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (value) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                // 由于on-change会立即调用一次，因此如果value为null，要中止函数
                                _this2.isDisabled(ref);
                                // 与getStartArea获取起运地
                                _context.next = 5;
                                return _this2.getConsignee();

                            case 5:
                                _context.next = 7;
                                return _this2.getStartArea();

                            case 7:
                                _this2.isDisabled(ref);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        getConsignee: function getConsignee(value, ref) {
            var _this3 = this;

            // 获取货主：根据托运人查询
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper
            };
            this.requestApi({
                url: _const.apiUrl.getConsignee,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this3.consigneeOps = dataObj.consignee;
            }, function (error) {
                if (error) {
                    // todo:除了getInitialSelectData可以自动重新请求外，其他change事件触发的接口不可自动重新获取，不然万一用户修改选项，请求数据会混乱了！
                    // 处理上述bug：因此如果请求失败了，那就重置select的默认值为null
                    _this3.shipper = null;
                    console.error(error);
                }
            });
        },
        getStartArea: function getStartArea(value, ref) {
            var _this4 = this;

            // 获取起运地：根据托运人查询
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || ''
            };
            this.requestApi({
                url: _const.apiUrl.getStartArea,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this4.dockOfLoadingOps = dataObj.startArea;
            }, function (error) {
                if (error) {
                    _this4.shipper = null;
                    console.error(error);
                }
            });
        },
        getArea: function getArea(value, ref) {
            var _this5 = this;

            // 获取目的地：通过托运人与货主去查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取目的地：通过托运人与货主去查询
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id || ''
            };
            this.requestApi({
                url: _const.apiUrl.getArea,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this5.finalDestinationOps = dataObj.area;
            }, function (error) {
                _this5.isDisabled(ref);
                if (error) {
                    _this5.consignee_id = null;
                    console.error(error);
                }
            });
        },
        getLoadJhr: function getLoadJhr(value, ref) {
            var _this6 = this;

            // 获取装货地址：根据起运地查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.dockOfLoading || '' // 也可以直接使用参数value
            };
            this.requestApi({
                url: _const.apiUrl.getPlace,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this6.jhrOps = dataObj.places;
            }, function (error) {
                _this6.isDisabled(ref);
                if (error) {
                    _this6.dockOfLoading = null;
                    console.error(error);
                }
            });
        },
        getConsigPlace: function getConsigPlace(value, ref) {
            var _this7 = this;

            // 获取卸货地址：根据目的地去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.finalDestination || ''
            };
            this.requestApi({
                url: _const.apiUrl.getPlace,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this7.consignee_placeOps = dataObj.places;
            }, function (error) {
                _this7.isDisabled(ref);
                if (error) {
                    _this7.finalDestination = null;
                    console.error(error);
                }
            });
        },
        getLoadLink: function getLoadLink(value, ref) {
            var _this8 = this;

            // 获取装货联系人：根据起运地+装货地址去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.dockOfLoading || '',
                place: this.jhr || ''
            };
            this.requestApi({
                url: _const.apiUrl.getLinkman,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this8.company_lxrOps = dataObj.linkmans;
            }, function (error) {
                _this8.isDisabled(ref);
                if (error) {
                    _this8.jhr = null;
                    console.error(error);
                }
            });
        },
        getLoadTelMp: function getLoadTelMp(value, ref) {
            var _this9 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取装货人手机电话：根据起运地+装货地址+装货联系人获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.dockOfLoading || '',
                place: this.jhr || '',
                linkman: this.company_lxr || ''
            };
            this.requestApi({
                url: _const.apiUrl.getOtherloadInfo,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                // 手机与电话好像是放在loadInfo数组里面
                _this9.shipper_tel = dataObj.loadInfo[1];
                _this9.shipper_mp = dataObj.loadInfo[0];
            }, function (error) {
                _this9.isDisabled(ref);
                if (error) {
                    _this9.company_lxr = null;
                    console.error(error);
                }
            });
        },
        getXHLink: function getXHLink(value, ref) {
            var _this10 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货联系人：根据目的地+卸货地址获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.finalDestination || '',
                place: this.consignee_place || ''
            };
            this.requestApi({
                url: _const.apiUrl.getLinkman,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this10.consignee_linkmanOps = dataObj.linkmans;
            }, function (error) {
                _this10.isDisabled(ref);
                if (error) {
                    _this10.consignee_place = null;
                    console.error(error);
                }
            });
        },
        getXhTelMp: function getXhTelMp(value, ref) {
            var _this11 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货人手机电话：根据目的地+卸货地址+卸货联系人获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.finalDestination || '',
                place: this.consignee_place || '',
                linkman: this.consignee_linkman || ''
            };
            this.requestApi({
                url: _const.apiUrl.getOtherloadInfo,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this11.consignee_tel = dataObj.loadInfo[0];
                _this11.consignee_mp = dataObj.loadInfo[1];
            }, function (error) {
                _this11.isDisabled(ref);
                if (error) {
                    _this11.consignee_linkman = null;
                    console.error(error);
                }
            });
        },
        submit: function submit(e) {
            var _this12 = this;

            // 对表单各项进行检测
            if (!this.shipper) {
                this.showToastWarn('请输入托运人');
                return;
            }
            if (!this.load_date) {
                this.showToastWarn('请选择装货时间');
                return;
            }
            if (!this.consignee_id) {
                this.showToastWarn('请输入货主');
                return;
            }
            if (!this.goods_name) {
                this.showToastWarn('请输入货名');
                return;
            }
            if (!this.dockOfLoading) {
                this.showToastWarn('请输入起运地');
                return;
            }
            if (!this.finalDestination) {
                this.showToastWarn('请输入目的地');
                return;
            }
            if (!this.jhr) {
                this.showToastWarn('请输入装货地址');
                return;
            }
            if (!this.company_lxr) {
                this.showToastWarn('请输入装货联系人');
                return;
            }
            if (!(this.shipper_mp || this.shipper_tel)) {
                this.showToastWarn('装货联系人手机,电话至少输入一个');
                return;
            }
            if (!this.consignee_place) {
                this.showToastWarn('请输入卸货地址');
                return;
            }
            if (!this.consignee_linkman) {
                this.showToastWarn('请输入卸货联系人');
                return;
            }
            if (!(this.consignee_tel || this.consignee_mp)) {
                this.showToastWarn('卸货联系人手机,电话至少输入一个');
                return;
            }
            if (!this.contQty) {
                this.showToastWarn('请输入柜量');
                return;
            } else if (isNaN(Number(this.contQty))) {
                // 柜量必须是数字，而且是整数
                this.showToastWarn('柜量必须为数字');
                return;
            }
            if (!this.fees_remark2) {
                this.showToastWarn('请输入费用说明');
                return;
            }
            // 防止连续调用接口
            if (!this.canSubmit) {
                console.error('不可点击');
                return;
            }
            this.canSubmit = false;
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 提交下单信息
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                employeeId: this.employeeId || '',
                load_date: this.load_date,
                consignee_id: this.consignee_id,
                goods_name: this.goods_name,
                dockOfLoading: this.dockOfLoading,
                finalDestination: this.finalDestination,
                jhr: this.jhr,
                company_lxr: this.company_lxr,
                shipper_tel: this.shipper_tel || '',
                shipper_mp: this.shipper_mp || '',
                remark3: this.remark3,
                consignee_place: this.consignee_place,
                consignee_linkman: this.consignee_linkman,
                consignee_tel: this.consignee_tel || '',
                consignee_mp: this.consignee_mp || '',
                remark9: this.remark9,
                carriage_item: this.carriage,
                contQty: parseInt(this.contQty), // 柜量必须为整数
                contType: this.contType,
                insurance_status: this.insurance_status || 0,
                fees_remark2: this.fees_remark2,
                group: this.group
            };
            this.requestApi({
                url: _const.apiUrl.addOrder,
                data: data
            }, function (resultData) {
                _this12.$vux.loading.hide();
                // 最后判断下单是否成功，给toast，状态码为200就是成功
                var dataObj = resultData.data;
                _this12.showToast(dataObj.info, 1500, 'success', {
                    onHide: function onHide() {
                        _this12.$router.push('/home');
                    }
                });
            }, function (error) {
                _this12.canSubmit = true;
                _this12.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            });
        },
        showToastWarn: function showToastWarn(text) {
            var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

            // 专门给submit函数里的验证使用
            this.showToast(text, time, 'warn');
        },
        isDisabled: function isDisabled(ref) {
            // 在触发select的change事件后，要先禁用select，等到请求完毕后，再重启select功能
            // 两种实现方式：1、第一种是通过ref获取到对应dom元素，然后禁用：
            // this.$refs[ref].$el.querySelector('select').disabled = !this.$refs[ref].$el.querySelector('select').disabled

            // 2、第二种是控制对应数据去设置selector组件的readonly属性
            this.isDisabledList[ref] = !this.isDisabledList[ref];
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "CHHn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CJuu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DeliveImgList',
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      src1: __webpack_require__("w2ig"), // 装箱的icon图片
      src2: __webpack_require__("fy9M"), // 送货的icon图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      isNoData: false
    };
  },
  created: function created() {
    document.title = '查看图片';
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code
      };
      this.isShowLoading = true;

      this.requestApi({
        url: _const.apiUrl.viewPicturesOrderList,
        data: data
      }, function (resultData) {
        var list = resultData.data.list || [];
        if (list.length === 0) {

          _this.isNoData = true;
          _this.isShowLoading = false;
          _this.isShowTable = false;
          return;
        }
        _this.tableData = list;
      }, function (error) {
        _this.isShowLoading = false;
        if (error) {
          console.error(error);
        }
      });
    },
    goNextPage: function goNextPage(bookingId, ladingId, servicetype) {

      this.$router.push({
        name: 'ViewPicture',
        query: {
          bookingId: bookingId,
          ladingId: ladingId,
          servicetype: servicetype
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "CMqz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _icon = __webpack_require__("oWtu");

var _icon2 = _interopRequireDefault(_icon);

var _datetimepicker = __webpack_require__("zV4+");

var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

var _group = __webpack_require__("rHil");

var _group2 = _interopRequireDefault(_group);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _uuid = __webpack_require__("KRg4");

var _uuid2 = _interopRequireDefault(_uuid);

var _format2 = __webpack_require__("ODCk");

var _format3 = _interopRequireDefault(_format2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'datetime',
  mixins: [_uuid2.default],
  components: {
    Group: _group2.default,
    InlineDesc: _inlineDesc2.default,
    Icon: _icon2.default
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = (0, _keys2.default)(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new _datetimepicker2.default(_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = (0, _format3.default)(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
};

/***/ }),

/***/ "CPjU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "CZUS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _cell = __webpack_require__("1DHf");

var _cell2 = _interopRequireDefault(_cell);

var _popup = __webpack_require__("HD9R");

var _popup2 = _interopRequireDefault(_popup);

var _radio = __webpack_require__("QHDY");

var _radio2 = _interopRequireDefault(_radio);

var _props = __webpack_require__("Zor0");

var _props2 = _interopRequireDefault(_props);

var _props3 = __webpack_require__("2IIR");

var _props4 = _interopRequireDefault(_props3);

var _transferDom = __webpack_require__("63CM");

var _transferDom2 = _interopRequireDefault(_transferDom);

var _arrayFind = __webpack_require__("NXHL");

var _arrayFind2 = _interopRequireDefault(_arrayFind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _cellProps = (0, _props4.default)(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

delete _cellProps.value;

exports.default = {
  name: 'popup-radio',
  components: {
    Popup: _popup2.default,
    Radio: _radio2.default,
    Cell: _cell2.default
  },
  directives: {
    TransferDom: _transferDom2.default
  },
  props: (0, _extends3.default)({
    placeholder: String,
    readonly: Boolean
  }, _cellProps, (0, _props2.default)()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if ((0, _typeof3.default)(this.options[0]) === 'object') {
        var match = (0, _arrayFind2.default)(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
};

/***/ }),

/***/ "Cwtp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__("mw3O");

var _qs2 = _interopRequireDefault(_qs);

var _const = __webpack_require__("ZLd3");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "feeMaintain",
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {

      ladingId: null,

      bookingId: null,
      feeType: [],

      feeList: [],

      isShowTable: false,
      isShowLoading: false
    };
  },
  created: function created() {
    document.title = '费用维护';
    this.ladingId = this.$route.query.ladingId;
    this.bookingId = this.$route.query.bookingId;
    this.loadFeeType();
    this.loadFeeList();
  },

  methods: {
    /**
     * 获取费用名称
     */
    loadFeeType: function loadFeeType() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId
      };
      this.$http.post(_const.apiUrl.getFeeIdList, data).then(function (response) {
        if (response.data.code == 200) {
          _this.feeType = [response.data.data];
        }
      }).catch(function (error) {
        console.error(error);
      });
    },

    /**
     * 获取费用列表
     */
    loadFeeList: function loadFeeList() {
      var _this2 = this;

      this.isShowLoading = true;
      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        bookingId: this.bookingId
      };
      this.$http.post(_const.apiUrl.getFeeDetail, data).then(function (response) {
        _this2.isShowLoading = false;
        if (response.data.code == 200) {
          var list = response.data.data;
          _this2.feeList = list.map(function (item) {
            return {
              key: [item.feeId],
              value: item.price,
              id: item.id
            };
          });
        }
      }).catch(function (error) {
        _this2.isShowLoading = false;
        console.error(error);
      });
    },

    /**
     * 添加费用名称
     */
    addFee: function addFee() {
      if (this.feeType.length == 0 && this.feeType[0].length == 0) {
        this.loadFeeType();
        return;
      }

      var index = 0;
      if (this.feeList.length != 0) {
        var lastIndex = this.feeType[0].indexOf(this.feeList[this.feeList.length - 1].key[0]);
        index = lastIndex >= 0 && lastIndex < this.feeType[0].length - 1 ? lastIndex + 1 : 0;
      }
      var item = {
        key: [this.feeType[0][index]],
        value: null
      };
      this.feeList.push(item);
    },

    /**
     * 费用维护
     */
    feeSave: function feeSave() {
      var _this3 = this;

      var par = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId
      };
      var url = _const.apiUrl.saveFee + '?' + _qs2.default.stringify(par);
      var data = this.feeList.map(function (item) {
        return {
          feeId: item.key[0],
          totalup: item.value,
          id: item.id || null,
          orderId: _this3.bookingId
        };
      });

      this.$vux.loading.show({
        text: 'Loading'
      });
      /**
       * requestbody 传递参数未封装
       */
      _axios2.default.post(url, data, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(function (res) {
        _this3.msg = res.data;
        _this3.$vux.loading.hide();
        _this3.showToast(res.data.data);
        if (res.data.code == 200) {
          _this3.loadFeeList();
        }
      }).catch(function (err) {
        _this3.$vux.loading.hide();
      });
    }
  }
};

/***/ }),

/***/ "CzA5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

var _util = __webpack_require__("LOkV");

var _uploadImg = __webpack_require__("vwcn");

var _uploadImg2 = _interopRequireDefault(_uploadImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'DeliveImgUpload',
    components: {
        MyBtnReturn: _MyBtnReturn2.default,
        uploadImg: _uploadImg2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src2: __webpack_require__("fy9M"), // 送货的icon图片
            uploadOpenSrc: __webpack_require__("itOs"), // 开箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: __webpack_require__("ujfB"), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadDelivedocSrc: __webpack_require__("CPjU"), // 送货单证图片，上传图片的那个图标，如果用户上传了，就替代下
            imgSrc: '', // 一开始为uploadLoadSrc或uploadSealSrc，之后为用户上传的图片
            // base64Img: '', // 用户上传的图片转换为base64；废弃吧，直接用imgSrc也一样
            //iconClose: require('@/assets/images/wx_sc_oringe.png'), // 关闭图标
            iconClose2: __webpack_require__("VrRN"), // 关闭图标
            isShowLoading: false,
            canUpload: true,
            isUploaded: false, // 是否已经上传成功，true代表已经上传成了
            goBackQuery: {}, // 回退时要带的参数
            uploadUrl: '',
            file: '', // 保存e.target.files[0]
            fileUrl: '', // 上传成功后返回的图片路径
            fileUrl2: '', // 上传成功后返回的图片路径
            step: -1,
            inputFiles: []
        };
    },
    created: function created() {
        document.title = '送货图片';
        var query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype || '';
        this.id = query.id;
        this.referenceno = query.referenceno || '';
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常，原因：页面先被刷新一次，再进入该组件，导致数据丢失，而且用go回退时要两次！
        if (!_const.apiParams.companyId) {
            // 如果apiParams.companyId变回空字符串了，证明页面被刷新了
            _const.apiParams.companyId = query.companyId2;
            _const.apiParams.openId = query.openId2;
            this.step = -2;
        }
        // 判断是开箱的，还是封箱的
        if (query.type === 'delive') {
            var imgSrc = {
                imgSrc: this.uploadSealSrc, //封箱图片
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(imgSrc);
            this.uploadUrl = _const.apiUrl.uploadDelive;
        } else if (query.type === 'open') {
            //this.imgSrc = this.uploadOpenSrc

            var _imgSrc = {
                imgSrc: this.uploadOpenSrc, //开箱图片
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(_imgSrc);
            this.uploadUrl = _const.apiUrl.uploadOpenController;
        } else {

            var _imgSrc2 = {
                imgSrc: this.uploadDelivedocSrc, //送货单证图片
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(_imgSrc2);
            this.uploadUrl = _const.apiUrl.uploadDelivedoc;
        }
    },

    methods: {
        uploadImg: function uploadImg() {
            var _this = this;

            // 如果已经上传成功了，不给继续上传
            //一次可以传多张，但只能传一次
            if (this.isUploaded) {
                this.showToast('已上传图片了，请返回上一页面继续操作！');
                return;
            }
            var imgs = [];
            var loadComplete = true;
            this.inputFiles.forEach(function (item, index) {
                if (item.flag === '1') {
                    if (item.progress === 100) {
                        imgs.push({ img: item.imgSrc });
                    } else {
                        loadComplete = false;
                    }
                }
            });
            if (!loadComplete) {
                this.showToast('请等待照片上传完成！');
                return;
            }
            if (imgs.length === 0) {
                this.showToast('请选择照片再上传！');
                return;
            }

            this.$vux.loading.show({
                text: 'Loading'
            });
            var param = {
                base64Imgs: (0, _stringify2.default)(imgs), //多张图片
                companyId: _const.apiParams.companyId,
                openId: _const.apiParams.openId,
                bookingId: this.bookingId,
                ladingId: this.ladingId,
                id: this.id,
                referenceno: this.referenceno,
                cont_no: this.contNo
            };
            var url = this.uploadUrl;
            this.requestApi({
                url: url,
                data: param
            }, function (res) {
                //let resultData = res.data // 后台返回结果
                var code = res.code;
                var info = res.data.info;

                if (code === 412) {
                    //let info = resultData.info // 412或500的提示语
                    _this.showToast(info, 1500, 'warn');
                } else if (code === 500) {
                    //let info = resultData.info // 412或500的提示语
                    _this.showToast(info, 1500, 'warn');
                } else {
                    _this.isUploaded = true; //上传后改标识
                    if (info === "上传成功") {
                        var mes = "上传成功" + res.data.num.toString() + "张图片";
                        _this.showToast(mes, 2000, 'success', {
                            onHide: function onHide() {
                                _this.showToast('请返回上一页面继续操作。', 2000);
                            }
                        });
                    } else {

                        if (res.data.num > 0) {

                            var _mes = "只上传成功" + res.data.num.toString() + "张(受总共最多上传30张的限制)";
                            _this.showToast(_mes, 5000, 'success', {
                                onHide: function onHide() {
                                    _this.showToast('请返回上一页面继续操作。', 2000);
                                }
                            });
                        } else {
                            _this.showToast(info, 1500, 'warn');
                        }
                    }
                }
                _this.canUpload = true;
                _this.$vux.loading.hide();
            }, function (error) {
                _this.canUpload = true;
                _this.$vux.loading.hide();
                if (error) {
                    console.error(error);
                    _this.showToast('上传失败！', 2000, 'cancel');
                }
            });
        }
    }
};

/***/ }),

/***/ "D0fX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLook_vue__ = __webpack_require__("6e8/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLook_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLook_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLook_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLook_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLook_vue__ = __webpack_require__("vOLE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLook_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLook_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fea1e6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgLook_vue__ = __webpack_require__("Mcxb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("7sNH")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fea1e6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLook_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fea1e6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgLook_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fea1e6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgLook_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DW2Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'demurrageQueryList',
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      shipper: null,
      companyId: null,

      listData: []
    };
  },
  created: function created() {
    document.title = '滞期天数查询';
    this.shipper = this.$route.query.shipper;
    this.companyId = this.$route.query.companyId;
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        shipper: this.shipper,
        companyId: this.companyId
      };

      this.$http.post(_const.apiUrl.getContainerDemurrageDaysList, data).then(function (response) {
        if (response.data.code == 200) {
          _this.listData = response.data.data;
        }
      }).catch(function (error) {});
    }
  }
};

/***/ }),

/***/ "DY9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"deliveImgUpload"}},[_c('div',[_c('div',{staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src2,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-item__first"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(_vm.ladingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.bookingId))])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contNo))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v("柜型：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contId))])])]),_vm._v(" "),_c('p',{staticStyle:{"color":"#333"}},[_vm._v(_vm._s(_vm.type === 'delive' ? '封箱图片：' : (_vm.type === 'open' ? '开箱图片：':'单证图片：')))]),_vm._v(" "),_c('uploadImg',{model:{value:(_vm.inputFiles),callback:function ($$v) {_vm.inputFiles=$$v},expression:"inputFiles"}})],1)]),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}}),_vm._v(" "),_c('div',{staticClass:"btn-box",staticStyle:{"margin-top":"0.2rem","padding":"0 0.16rem"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.uploadImg}},[_vm._v("确认上传")])])],1),_vm._v(" "),_c('MyBtnReturn',{attrs:{"step":_vm.step}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "Dk6r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if ((0, _typeof3.default)(this.value) === 'object' && isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return (0, _stringify2.default)(one);
          }).indexOf((0, _stringify2.default)(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
};


function isEqual(obj1, obj2) {
  return (0, _stringify2.default)(obj1) === (0, _stringify2.default)(obj2);
}

/***/ }),

/***/ "DxUy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("/kga");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'confirm',
  components: {
    XDialog: _xDialog2.default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "E2vU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'divider'
};

/***/ }),

/***/ "E6Re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"LoadImgLook"}},[_c('div',[_c('div',{staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src1,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-item__first"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(_vm.ladingId))])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contNo))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v("柜型：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contId))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('span',[_vm._v(_vm._s(_vm.type === 'load' ? '装箱图片：' : (_vm.type==='seal'?'封箱图片：':'单证图片：')))])]),_vm._v(" "),_vm._l((_vm.imgSrcList),function(item,index){return _c('div',{key:index,staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left-upload"},[_c('img',{attrs:{"src":item,"preview":"0","alt":""}})])])})],2)]),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],1),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无图片")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn',{attrs:{"step":_vm.step}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "EVI3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _big = __webpack_require__("gaXx");

var _big2 = _interopRequireDefault(_big);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new _big2.default(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new _big2.default(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "EXDq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__ = __webpack_require__("jp8c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__ = __webpack_require__("wkjy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5729c4a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_test_vue__ = __webpack_require__("A5j2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("P4mZ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5729c4a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_test_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5729c4a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_test_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EfW6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Efi/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'VoyageResult',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            tableData: [
                // {
                //   vesselName: '新海秀',
                //   voyage: '1001S',
                //   onboardDate: '2014-11-10', // 开船日期
                //   arrival: '2014-11-29' // 船到日期
                // },
                // {
                //   vesselName: '新海秀',
                //   voyage: '1001S',
                //   onboardDate: '2014-11-10', // 开船日期
                //   arrival: '2014-11-29' // 船到日期
                // },
            ],
            isShowTable: true, // 没有数据时才注释掉这个滚动组件
            isShowLoading: false,
            isShowMore: true,
            canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
            pageSize: 15, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false,
            tableDataUrl: '', // 查询表单数据API，voyageTemplate或voyageTemplateYw
            routeName: ''
        };
    },
    created: function created() {
        document.title = '船期查询';
        var query = this.$route.query;
        this.routeName = query.routeName;
        if (this.routeName === 'VoyageKehu') {
            this.tableDataUrl = _const.apiUrl.voyageTemplate;
        } else {
            this.tableDataUrl = _const.apiUrl.voyageTemplateYw;
        }
        this.onScrollBottom();
    },

    methods: {
        getMoreData: function getMoreData(url, data) {
            var _this = this;

            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.isShowMore = false;
                this.showToast('暂无更多数据！', 2000);
                return;
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data.page;
                var resultArr = dataObj.result || []; // 防止后台返回null
                if (_this.pageNo === 1 && resultArr.length === 0) {
                    // 如果根本没有数据
                    _this.isShowTable = false;
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    _this.isShowMore = false;
                    return;
                }
                resultArr.forEach(function (item) {
                    _this.tableData.push(item);
                }); // 表格数据是放在result中
                _this.totalCount = dataObj.totalCount;
                _this.totalPages = dataObj.totalPages;
                _this.pageNo++;
                _this.$nextTick(function () {
                    _this.$refs.scrollerBottom.reset();
                }); // 要重置scroller组件
            }, function (error) {
                _this.isShowLoading = false;
                _this.canFetch = true;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        onScrollBottom: function onScrollBottom() {
            if (!this.canFetch) {} else {
                this.isShowLoading = true;
                // this.isShowMore = false
                this.canFetch = false;
                var query = this.$route.query;
                var data = {
                    place_loading: query.place_loading || '',
                    place_delivery: query.place_delivery || '',
                    pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                    pageNo: this.pageNo, // 当前为第几页数据，要累加
                    openId: _const.apiParams.openId,
                    companyId: _const.apiParams.companyId,
                    code: _const.apiParams.code
                };
                this.getMoreData(this.tableDataUrl, data);
            }
        }
    }
};

/***/ }),

/***/ "EmH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ik+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("SOtS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_5e492186_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("YmXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("vofn")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_5e492186_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_5e492186_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Eta7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("/kga");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'alert',
  components: {
    XDialog: _xDialog2.default
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "EyCA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _GoHome = __webpack_require__("ZWVd");

var _GoHome2 = _interopRequireDefault(_GoHome);

var _MyFooter = __webpack_require__("m+mo");

var _MyFooter2 = _interopRequireDefault(_MyFooter);

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "FreightPrice",
    components: {
        MyFooter: _MyFooter2.default,
        MyBtnReturn: _MyBtnReturn2.default,
        GoHome: _GoHome2.default
    },
    data: function data() {
        return {
            place_loading: null,
            place_loadingOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            place_delivery: null,
            place_deliveryOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ], // 目的港要根据起始港调用接口查询
            group: '', // 后台返回的
            shipper: '', // 后台返回的
            areaUrl: '' // 查询地点API，freightPrice，该接口还会拿到shipper与group，后续调用表格数据接口时也要传给后台
            // tableDataUrl: '', // 查询表单数据API，freightPriceTemplate
        };
    },
    created: function created() {
        document.title = '全程运输报价查询';
        this.areaUrl = _const.apiUrl.freightPrice;
        this.searchArea();
    },

    methods: {
        searchArea: function searchArea() {
            var _this = this;

            // 获取起始与目的等地点:如果没获取到，要提示用户重新打开页面吗？
            // 该接口还会拿到shipper与group，后续调用表格数据接口时也要传给后台
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.requestApi({
                url: this.areaUrl,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                // 囧，结果后台返回了数组里一个null，[null]，selector组件直接崩溃
                _this.place_loadingOps = dataObj.starts || []; // 防止后台返回null
                _this.place_deliveryOps = dataObj.ends || []; // 防止后台返回null
                _this.group = dataObj.group || ''; // 防止后台返回null
                _this.shipper = dataObj.shipper || ''; // 防止后台返回null
            }, function (error) {
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        goResultPage: function goResultPage() {
            var route = {
                name: 'FreightPriceResult',
                query: {
                    place_loading: this.place_loading || '',
                    place_delivery: this.place_delivery || '',
                    group: this.group,
                    shipper: this.shipper,
                    openId: _const.apiParams.openId,
                    companyId: _const.apiParams.companyId,
                    code: _const.apiParams.code
                }
            };
            this.$router.push(route);
        },
        startChange: function startChange(value) {
            var _this2 = this;

            if (!value) return;
            // 去获取目的地的数据：这是根据起运地获取的，数量应该没startAreaUrl接口的多吧？
            // 加一个loading，顺便可以不让用户又去选择另一个起运地
            this.$vux.loading.show({
                text: 'Loading'
            });
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                start: this.place_loading || ''
            };
            this.requestApi({
                url: _const.apiUrl.changePlace,
                data: data
            }, function (resultData) {
                _this2.$vux.loading.hide();
                var dataObj = resultData.data;
                _this2.place_deliveryOps = dataObj.findEndPlace || []; // 防止后台返回null
                _this2.place_delivery = null; // 目的地被选中项变为null，不然查询时会记忆回来选择的
            }, function (error) {
                _this2.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            });
        },
        targetChange: function targetChange(value) {}
    }
};

/***/ }),

/***/ "FHMP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FWhd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

var _amapLocation = __webpack_require__("3lov");

var _amapLocation2 = _interopRequireDefault(_amapLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'DeliveImgLading',
    components: {
        MyBtnReturn: _MyBtnReturn2.default,
        amapLocation: _amapLocation2.default
    },
    data: function data() {
        return {
            src1: __webpack_require__("w2ig"), // 装箱的icon图片
            src2: __webpack_require__("fy9M"), // 送货的icon图片

            check: __webpack_require__("jWrU"),
            unCheck: __webpack_require__("ZfQA"),

            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            // src2: require('@/assets/images/wx_song_green.png'), // 送货的icon图片
            tableData: [],
            address: null,

            isShowTable: true,
            isShowLoading: false,
            isNoData: false,

            showBottomHandel: false,
            location: null
        };
    },

    watch: {
        location: function location(newValue, oldValue) {
            this.address = newValue.address;
        }
    },
    created: function created() {
        document.title = '更新位置';
        this.bookingId = this.$route.query.bookingId;
        this.ladingId = this.$route.query.ladingId;
        this.servicetype = this.$route.query.servicetype;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                bookingId: this.bookingId
            };
            this.showBottomHandel = false;
            this.address = null;
            this.isShowLoading = true;
            this.requestApi({
                url: _const.apiUrl.getLocationNoticeDetail,
                data: data
            }, function (resultData) {
                _this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况

                var sonos = resultData.data || [];

                _this.tableData = sonos.map(function (item) {
                    return (0, _extends3.default)({}, item, {
                        check: false
                    });
                });
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        checkItem: function checkItem(index) {
            var _this2 = this;

            this.tableData[index].check = !this.tableData[index].check;
            this.showBottomHandel = false;
            this.tableData.forEach(function (item) {
                if (item.check) {
                    _this2.showBottomHandel = true;
                }
            });
        },
        upload: function upload() {
            var _this3 = this;

            if (!this.address) {
                this.showToast('请输入位置');
                return;
            }
            var ids = this.tableData.map(function (item) {
                if (item.check) {
                    return item.id;
                }
            });
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                ids: ids.join(','),
                location: this.address
            };
            this.$http.post(_const.apiUrl.locationNoticeSave, data).then(function (response) {
                if (response.data.code == 200) {
                    _this3.getData();
                }
            }).catch(function (error) {
                console.error(error);
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "G6kY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G86e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G8OR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "FreightPriceResult",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            tableData: [
                // {
                //   priceType: '20GP',
                //   pricePortLoading: '广州',
                //   priceDockLoading: '上海',
                //   totalup: '￥3000.23',
                //   priceGoodsName: '石油',
                //   priceCarriageItem: 'DR-DR(门-门)',
                //   priceConsigneeJhr: '广州市海珠区建南1',
                //   priceConsigneePlace: '广州市海珠区江南西',
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false,
            tableDataUrl: '' // 查询表单数据API，freightPriceTemplate
        };
    },
    created: function created() {
        document.title = '全程运输报价查询';
        this.tableDataUrl = _const.apiUrl.freightPriceTemplate;
    },
    mounted: function mounted() {
        // 要在这个钩子函数中才能一开始操作到scrollBottom标签
        this.onScrollBottom();
    },

    methods: {
        getMoreData: function getMoreData(url, data) {
            var _this = this;

            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle',
                    type: 'text'
                });
                return;
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data.page;
                var resultArr = dataObj.result || []; // 防止后台返回null
                if (resultArr.length === 0) {
                    // 如果没有数据，要告知用户（不在第一个if加上this.pageNo === 1，是怕后台莫名其妙传完[]）
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    // 如果是第一页就没有数据，那隐藏scroller吧
                    if (_this.pageNo === 1) {
                        _this.isShowTable = false;
                    }
                    return;
                }
                resultArr.forEach(function (item) {
                    _this.tableData.push(item);
                }); // 表格数据是放在result中
                _this.totalCount = dataObj.totalCount;
                _this.totalPages = dataObj.totalPages;
                _this.pageNo++;
                _this.$nextTick(function () {
                    _this.$refs.scrollerBottom.reset(); // 一开始不能v-if隐藏scrollBottom标签，否则这里获取不到scrollBottom标签
                }); // 要重置scroller组件
            }, function (error) {
                _this.isShowLoading = false;
                _this.canFetch = true;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        onScrollBottom: function onScrollBottom() {
            if (!this.canFetch) {} else {
                this.isShowLoading = true;
                this.canFetch = false;
                var query = this.$route.query;
                var data = {
                    place_loading: query.place_loading,
                    place_delivery: query.place_delivery,
                    group: query.group,
                    shipper: query.shipper,
                    pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                    pageNo: this.pageNo, // 当前为第几页数据，要累加
                    openId: _const.apiParams.openId,
                    companyId: _const.apiParams.companyId,
                    code: _const.apiParams.code
                };
                this.getMoreData(this.tableDataUrl, data);
            }
        }
    }
};

/***/ }),

/***/ "GK7v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "ReportContNo",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            ladingId: '',
            src1: __webpack_require__("w2ig"), // 装箱的图片
            src2: __webpack_require__("qDaJ"), // 拆箱的图片
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   sealNo: 'ajdfkadfjakl',
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   sealNo: '',
                // },
            ],
            isTodayEnd: false, // true就代表今日计划的数据获取完了
            isShowTable: true,
            isShowLoading: false,
            isShowConfirm: false,
            canUpdate: true, // true代表能继续发送请求，控制onConfirm方法的
            isNoData: false,
            isDisabledList: [], // 控制btn-report按钮的是否禁用属性，有多个按钮，因此有多个元素
            content: {
                id: '',
                contNo: '',
                sealNo: '',
                shipperW: '',
                index: 0 // 存放该数据的索引，onConfirm中可以找到isDisabledList对应的元素
            }
        };
    },
    created: function created() {
        document.title = '报柜号';
        this.ladingId = this.$route.query.ladingId;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            // 获取工作单下要报柜号的柜，一个工作单可能有多个柜号id，对应第二个页面
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId
            };
            this.isShowLoading = true;
            // 先获取今日计划的数据
            // 调用接口获取数据
            this.requestApi({
                url: _const.apiUrl.getReportContNoSono,
                data: data
            }, function (resultData) {
                _this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                var list = resultData.data.sonos || [];
                if (list.length === 0) {
                    // 如果没有数据，要告知用户
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    _this.tableData = list;
                    return;
                }
                // todo:前端添加两个属性，分别代表是否已报柜号、是否已报封条号
                list.forEach(function (item) {
                    // this.tableData.forEach((item) => { // 要注释
                    item.isReportContNo = item.contNo; // 真值就代表已报柜号了
                    item.isReportSealNo = item.sealNo; // 真值就代表已报封条号了
                    // 添加对应数量的禁用属性，如果contNo与sealNo都为真值，那就直接添加true，禁用按钮
                    if (item.contNo && item.sealNo) {
                        _this.isDisabledList.push(true);
                    } else {
                        _this.isDisabledList.push(false);
                    }
                });
                _this.tableData = list;
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        btnReportFn: function btnReportFn(index, id) {
            // todo: 现在写的逻辑：只要报过了，就不给修改
            // 按钮btn-report的方法，先检验是否有输入柜号或者封号(至少有一个)，然后弹窗询问用户是否确认报柜号
            var tableData = this.tableData[index];
            var contNo = tableData.contNo && tableData.contNo.toUpperCase();
            var sealNo = tableData.sealNo && tableData.sealNo.toUpperCase();
            var shipperW = tableData.shipperW;
            var isReportContNo = tableData.isReportContNo;
            var isReportSealNo = tableData.isReportSealNo;
            if (!shipperW) {
                this.showToast('货重必填！', 2000, 'warn');
                return;
            }
            if (contNo || sealNo || shipperW) {
                if (isReportContNo && contNo && !sealNo && !shipperW) {
                    // 已经报过柜号了，但这次又不填写封条号，不给继续报
                    this.showToast('已经报过柜号了！', 2000, 'warn');
                    return;
                }
                if (isReportSealNo && sealNo && !contNo && !shipperW) {
                    // 已经报过封条号了，但这次又不填写柜号，不给继续报
                    this.showToast('已经报过封条号了！', 2000, 'warn');
                    return;
                }
                this.isShowConfirm = true;
                this.content = {
                    id: id,
                    contNo: contNo || '',
                    sealNo: sealNo || '',
                    shipperW: shipperW,
                    index: index // 该索引可对应tableData与isDisabledList的数据
                };
            } else {
                this.showToast('请输入柜号或封条号', 2000, 'warn');
            }
        },
        onConfirm: function onConfirm() {
            var _this2 = this;

            // 更新对应 的柜号、封号
            if (!this.canUpdate) return;
            this.canUpdate = false;
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                id: this.content.id,
                contNos: this.content.contNo,
                sealNos: this.content.sealNo,
                shipperW: this.content.shipperW
            };
            var index = this.content.index;
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: _const.apiUrl.reportContNo,
                data: data
            }, function (resultData) {
                _this2.$vux.loading.hide();
                // 到这一步，那就是更新成功了：判断是报了哪个，如果都报了，那就禁用对应的按钮，连柜号的input也要禁用！
                var successInfo = resultData.data.info || '操作成功！';
                // this.showToast('操作成功！', 2000)
                _this2.showToast(successInfo, 2000);
                if (data.sealNos && data.contNos) {
                    _this2.isDisabledList[index] = true;
                    _this2.tableData[index].isReportContNo = true;
                    _this2.tableData[index].isReportSealNo = true;
                } else if (data.contNos) {
                    _this2.tableData[index].isReportContNo = true;
                } else if (data.sealNos) {
                    _this2.tableData[index].isReportSealNo = true;
                }
            }, function (error) {
                _this2.canUpdate = true;
                _this2.$vux.loading.hide();
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        changeToUpperCase: function changeToUpperCase(item, index) {
            this.tableData[index][item] = this.tableData[index][item] && this.tableData[index][item].toUpperCase(); // 防止数据为null
        }
    }
};

/***/ }),

/***/ "GKgO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUpload_vue__ = __webpack_require__("FWhd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUpload_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUpload_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUpload_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUpload_vue__ = __webpack_require__("wALF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f663662_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LocationUpload_vue__ = __webpack_require__("71I8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fZUZ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f663662"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LocationUpload_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f663662_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LocationUpload_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f663662_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LocationUpload_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Gkm1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H0qR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H3Xw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "FeeMaintainList",
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  mounted: function mounted() {
    this.$refs.scrollerBottom.reset();
  },
  data: function data() {
    var pulldownDefaultConfig = {
      content: '下拉刷新',
      height: 60,
      autoRefresh: true,
      downContent: '下拉刷新',
      upContent: '释放后刷新',
      loadingContent: '正在刷新...',
      clsPrefix: 'xs-plugin-pulldown-'
    };
    var pullupDefaultConfig = {
      content: '上拉加载更多',
      pullUpHeight: 60,
      height: 40,
      autoRefresh: true,
      downContent: '释放后加载',
      upContent: '上拉加载更多',
      loadingContent: '加载中...',
      clsPrefix: 'xs-plugin-pullup-'
    };
    return {
      src1: __webpack_require__("w2ig"), // 装箱的图片
      src2: __webpack_require__("qDaJ"), // 拆箱的图片
      tableData: [],
      scrollerStatus: {
        pulldownStatus: 'default',
        pullupStatus: 'enabled'
      },
      pageNo: 1, // 页码
      pullupDefaultConfig: pullupDefaultConfig,
      pulldownDefaultConfig: pulldownDefaultConfig
    };
  },
  created: function created() {
    document.title = '费用维护';
    this.onPulldownLoading();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code,
        pageNo: this.pageNo,
        pageSize: 10
      };
      this.requestApi({
        url: _const.apiUrl.feeMaintainPageList,
        data: data
      }, function (resultData) {
        var list = resultData.data.page.result || [];

        _this.tableData.push.apply(_this.tableData, list);

        _this.scrollerStatus.pulldownStatus = 'default';
        var totalPages = resultData.data.page.totalPages;
        if (_this.pageNo >= totalPages) {
          _this.scrollerStatus.pullupStatus = 'disabled';
        } else {
          _this.scrollerStatus.pullupStatus = 'default';
        }

        _this.$refs.scrollerBottom.reset();
      }, function (error) {
        if (error) {
          _this.scrollerStatus.pulldownStatus = 'default';
          _this.scrollerStatus.pullupStatus = 'default';
        }
      });
    },
    goReportContNo: function goReportContNo(ladingId, otherservice, bookingId) {
      this.$router.push({
        name: 'FeeMaintain',
        query: {
          ladingId: ladingId,
          otherservice: otherservice,
          bookingId: bookingId
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    },

    /**
    * 下拉刷新
    */
    onPulldownLoading: function onPulldownLoading() {
      this.pageNo = 1;
      this.tableData = [];
      this.getData();
    },

    /**
    * 上拉加载更多
    */
    onPullupLoading: function onPullupLoading() {
      this.pageNo++;
      this.getData();
    }
  }
};

/***/ }),

/***/ "H57j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = __webpack_require__("f6Hi");

var _base2 = _interopRequireDefault(_base);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _autosize = __webpack_require__("JnrT");

var _autosize2 = _interopRequireDefault(_autosize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// prop.autosize

exports.default = {
  name: 'x-textarea',
  minxins: [_base2.default],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: _inlineDesc2.default
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      _autosize2.default.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      (0, _autosize2.default)(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      _autosize2.default.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "HBHn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__("mw3O");

var _qs2 = _interopRequireDefault(_qs);

var _const = __webpack_require__("ZLd3");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "feeMaintain",
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {

      ladingId: null,

      bookingId: null,
      feeType: [],

      feeList: [],

      isShowTable: false,
      isShowLoading: false
    };
  },
  created: function created() {
    document.title = '费用维护';
    this.ladingId = this.$route.query.ladingId;
    this.bookingId = this.$route.query.bookingId;
    this.loadFeeType();
    this.loadFeeList();
  },

  methods: {
    /**
     * 获取费用名称
     */
    loadFeeType: function loadFeeType() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId
      };
      this.$http.post(_const.apiUrl.getFeeIdList, data).then(function (response) {
        if (response.data.code == 200) {
          _this.feeType = [response.data.data];
        }
      }).catch(function (error) {
        console.error(error);
      });
    },

    /**
     * 获取费用列表
     */
    loadFeeList: function loadFeeList() {
      var _this2 = this;

      this.isShowLoading = true;
      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        bookingId: this.bookingId
      };
      this.$http.post(_const.apiUrl.getFeeDetail, data).then(function (response) {
        _this2.isShowLoading = false;
        if (response.data.code == 200) {
          var list = response.data.data;
          _this2.feeList = list.map(function (item) {
            return {
              key: [item.feeId],
              value: item.price,
              id: item.id
            };
          });
        }
      }).catch(function (error) {
        _this2.isShowLoading = false;
        console.error(error);
      });
    },

    /**
     * 添加费用名称
     */
    addFee: function addFee() {
      if (this.feeType.length == 0 && this.feeType[0].length == 0) {
        this.loadFeeType();
        return;
      }

      var index = 0;
      if (this.feeList.length != 0) {
        var lastIndex = this.feeType[0].indexOf(this.feeList[this.feeList.length - 1].key[0]);
        index = lastIndex >= 0 && lastIndex < this.feeType[0].length - 1 ? lastIndex + 1 : 0;
      }
      var item = {
        key: [this.feeType[0][index]],
        value: null
      };
      this.feeList.push(item);
    },

    /**
     * 费用维护
     */
    feeSave: function feeSave() {
      var _this3 = this;

      var par = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId
      };
      var url = _const.apiUrl.saveFee + '?' + _qs2.default.stringify(par);
      var data = this.feeList.map(function (item) {
        return {
          feeId: item.key[0],
          totalup: item.value,
          id: item.id || null,
          orderId: _this3.bookingId
        };
      });

      this.$vux.loading.show({
        text: 'Loading'
      });
      /**
       * requestbody 传递参数未封装
       */
      _axios2.default.post(url, data, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(function (res) {
        _this3.msg = res.data;
        _this3.$vux.loading.hide();
        _this3.showToast(res.data.data);
        if (res.data.code == 200) {
          _this3.loadFeeList();
        }
      }).catch(function (err) {
        _this3.$vux.loading.hide();
      });
    }
  }
};

/***/ }),

/***/ "HD9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("6Q4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Tqs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_aaf175b0_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Uexn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("orOp")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_aaf175b0_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_aaf175b0_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HH+o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var staticRenderFns = []


/***/ }),

/***/ "HXHJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HaVW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUploadZJDLD_vue__ = __webpack_require__("oory");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUploadZJDLD_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUploadZJDLD_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUploadZJDLD_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUploadZJDLD_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUploadZJDLD_vue__ = __webpack_require__("u9s0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUploadZJDLD_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUploadZJDLD_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94da134e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgUploadZJDLD_vue__ = __webpack_require__("f2xR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("3mKF")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94da134e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUploadZJDLD_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94da134e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgUploadZJDLD_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94da134e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgUploadZJDLD_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HsZO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'LoadImgLading',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: __webpack_require__("w2ig"), // 装箱的图片，右上角的icon
            // src2: require('@/assets/images/plan/wx_chai_oringe.png'), // 拆箱的图片
            uploadLoadSrc: __webpack_require__("wVEz"), // 装箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: __webpack_require__("ujfB"), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            iconClose: __webpack_require__("VrRN"), // 关闭图标
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'zzzz',
                //   loadimgisupload: 0,
                //   sealimgisupload: 1,
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'aaaaa',
                //   loadimgisupload: 1,
                //   sealimgisupload: 0,
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            isNoData: false
        };
    },
    created: function created() {
        document.title = '装货图片';
        var query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            // 获取工作单下要上传图片的柜，一个工作单可能有多个柜号id
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                servicetype: this.servicetype
            };
            this.isShowLoading = true;
            // 调用接口获取数据
            this.requestApi({
                url: _const.apiUrl.loadImgLading,
                data: data
            }, function (resultData) {
                _this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况
                _this.tableData = resultData.data.sonos || [];
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        goNextPage: function goNextPage(routerName, id, referenceno, contNo, contId, type) {
            // 按钮的方法，跳转上传或查看页面，并且带些参数过去
            // todo 有个bug，在这层跳转到下一个页面时，会感觉到先关闭当前窗口，然后重新打开一个窗口？导致数据丢失，而且用go回退时要两次！
            // 但有时候又是直接一次跳转成功，奇怪！

            this.$router.push({
                name: routerName,
                // path: '/load-img-upload',
                query: {
                    bookingId: this.bookingId,
                    ladingId: this.ladingId,
                    servicetype: this.servicetype,
                    id: id,
                    referenceno: referenceno,
                    contNo: contNo,
                    contId: contId,
                    type: type, // 为了区分装箱与封箱，load为装箱，seal为封箱,loaddoc为单证图片
                    companyId2: _const.apiParams.companyId,
                    openId2: _const.apiParams.openId
                }
            });
        }
    }
};

/***/ }),

/***/ "I+8Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"FeeMaintainList"}},[_c('div',[_c('scroller',{ref:"scrollerBottom",staticClass:"scroller",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":""},on:{"on-pullup-loading":_vm.onPullupLoading,"on-pulldown-loading":_vm.onPulldownLoading},model:{value:(_vm.scrollerStatus),callback:function ($$v) {_vm.scrollerStatus=$$v},expression:"scrollerStatus"}},[_c('div',_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":item.otherservice === '拆箱' ? _vm.src2 : _vm.src1,"alt":""}})]),_vm._v(" "),(item.otherservice === '拆箱')?_c('div',{staticClass:"list-devanning"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row lading"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(item.ladingId))])]),_vm._v(" "),(item.mBlNo)?_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("运单号：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.mBlNo))])])]):_vm._e(),_vm._v(" "),(item.preCarriage)?_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("车牌号：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.preCarriage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货联系人：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"consignee-linkman"},[_vm._v(_vm._s(item.consigneeLinkman))]),_vm._v(" "),(item.consigneeMp)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeMp))]):_vm._e(),_vm._v(" "),(item.consigneeMp && item.consigneeTel)?_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e(),_vm._v(" "),(!item.consigneeMp && item.consigneeTel)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货时间：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.loadDate)))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货地点：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.consigneePlace))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货说明：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark9))])])])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船公司：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.shipCompany))])])]),_vm._v(" "),(item.vessel && item.voyage)?_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船名/航次：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.vessel)+_vm._s(item.vessel && item.voyage ? ' / ' : '')+_vm._s(item.voyage))])])]):_vm._e(),_vm._v(" "),(item.portDelivery)?_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("目的港：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.portDelivery))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜型：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.cont))])])])])]):_vm._e(),_vm._v(" "),(item.otherservice !== '拆箱')?_c('div',{staticClass:"list-binning"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(item.ladingId))])]),_vm._v(" "),(item.mBlNo)?_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("运单号：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.mBlNo))])])]):_vm._e(),_vm._v(" "),(item.preCarriage)?_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("车牌号：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.preCarriage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货联系人：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"consignee-linkman"},[_vm._v(_vm._s(item.companyLxr))]),_vm._v(" "),(item.shipperMp)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.shipperMp)+" ")]):_vm._e(),_vm._v(" "),(item.shipperMp && item.shipperTel)?_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.shipperTel))]):_vm._e(),_vm._v(" "),(!item.shipperMp && item.shipperTel)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.shipperTel))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货时间：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.loadDate)))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货地点：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.jhr))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货说明：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark3))])])])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船公司：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.shipCompany))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船名/航次：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.vessel)+_vm._s(item.vessel && item.voyage ? ' / ' : '')+_vm._s(item.voyage))])])]),_vm._v(" "),(item.portLoading)?_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("起运港：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.portLoading))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜型：")])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.cont))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('button',{staticClass:"btn-search btn-report",attrs:{"type":"primary"},on:{"click":function($event){return _vm.goReportContNo(item.ladingId, item.otherservice, item.bookingId)}}},[_vm._v("费用维护")])])])}),0)])],1),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "I3VT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAhFBMVEUAAAD/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH3/vH04sozTAAAAK3RSTlMA6gf5f8UQ5pHZI92LWEs4GvTurnfAuJNcDfvTlmpQzqiFcmBWQjEpFcuc8ws5RwAAAWZJREFUKM+Nk2lzgyAQhpdLBbyjVmNi7qv7//9fBcTEtJPp82Fnh3eAPWGGppEIGQtFlFJ4J+AEZwgPlmoS4oLw/Kpu8BdfT3WFf7D36hd6mDRWFq/3E+PX9Xq0sX1IJWix/wcm5B1AWhh5QNTQTvGZ+LnxCgVwlVicc0Qe+DQ4ACXu1+YQ9xif2vjYXaqqdvlTSJ3TlKM9wES3R0sKERoUUEWjvnnoO9W6xIkIhA0C8qwDXkrEHJqH1MTJApwznreBvIOHMvcnMF+RPA6vl1MFtNdah9PhLNfAp1JucYaB7+M6z0ZbKghgy7xMQHjvfkFsFGxJC5lEh3CJbbLh1q2EGl9eI65y+u0TG2wnPHnUj3rZKicPtqhdUAnGBL/anLLkyKtjmtmimoDrAh3ycANPhch9Q5+IE7XqrUASuHFYUsYKIAsREz9M7+x2Zpg+juLq4yBvFmtAlmKY/HuJnitIGCOLFfwBwQxTeZXy4WAAAAAASUVORK5CYII="

/***/ }),

/***/ "IUs4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vehicletracking"}},[_c('group',[_c('datetime',{attrs:{"title":"装货日期","value-text-align":"right","placeholder":"请选择装货日期"},model:{value:(_vm.loadDate),callback:function ($$v) {_vm.loadDate=$$v},expression:"loadDate"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"卸货日期","value-text-align":"right","placeholder":"请选择卸货日期"},model:{value:(_vm.unloadingDate),callback:function ($$v) {_vm.unloadingDate=$$v},expression:"unloadingDate"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"车牌号","text-align":"right","placeholder":"请输入车牌号码"},model:{value:(_vm.truck_no),callback:function ($$v) {_vm.truck_no=$$v},expression:"truck_no"}}),_vm._v(" "),_c('selector',{ref:"typeSelector",attrs:{"title":"类型","options":_vm.is_selfOps,"direction":"rtl","placeholder":"请选择类型"},model:{value:(_vm.is_self),callback:function ($$v) {_vm.is_self=$$v},expression:"is_self"}})],1),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.search()}}},[_vm._v("查询")])],1),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "IYP8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABaCAMAAAB5TAO7AAAAYFBMVEUAAABQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+X////2+v1hrud+u+rF3vXj7/qkzfCw0/G72fNwtOna6viYx+6Mwezt9PzQ5Pd89/AwAAAAEHRSTlMA+fPo3My6pY1zW0YzJBcNBikDSgAAA19JREFUaN60lslyrDAMRf3m+cWyjScw/P9fRsIBVSqLW1pwK9VReuETmntEu1/++Tj3+5N/Os65P5/9w3Gcv1/8s3GSf1/9o3Fn/n/zT8bNvHz3D8Zd+eGfi7vz0xuSvGTdrBCLlguV85W6EWLQUo5vvhKjjBCLlgJYBWSF2LQsRLR4M8SmZQpEOZkhJi3jTnmnkHiKVgjWsk9GZoC88JSTDYK17LRKow4iuYiWpGchmSBYy0ZEe1nu8vK08x8WCNYy1p0k7e5YjQyqNgjWcqxCybV7v80aN/5lgmAtU6CcGVNlWq8LWqMBArXszIg+lhbndGbjsRsgQEvpbbyn++BDOwYgQMu6yHa/TtOJo3UDEKhloEVO27xEJ07RfgEI1FIcuf9j3fNXya4kAAFaVt28Rc+9S9bHGPUI1AEEaDnqNoc0GVq3CT4TKoBALVWV+KFunW1ZpQ4AArTUc/eLoSXTMg8MwVpO37VkH25cQRCspZSJf96XbBFqrPJOJmoIgrUsxReSu6IlGzLETI0hNYXQAQRrKRmBctKSyfY6Frk9iRuYEr+xVATBT8u0U5gl028WNCtQ1jVLlzuAAC3fOkZasljD/SDe6Ay4EqylJGt5ewvESAobV2CLtZbUiAqCYC0H0SlE2lomySF97vdCZkpFEKzlViaLE9r8eGqpdC24JgOGYC0n5Cg9U2DI7HThokVZBXWnNQII1lIS09wtVSCJz79W20ojZloABGmpEUEE0sP8hHqmPfkefWzoSrCWuq42+XRkIedTHZkGMN6mZTn7tB9DOh0Xykmf+gCCtVTVF+/13MaouUUBxKJl0YUsMsobr7XXuwrFIBQF0ZQpzVNMcf//M2+CyJSHg0wVUq3GceNe+yQHSCbLc4xve53aL8/vfAVILkvu+vImcvWfHSNE4iy5g1v/XgeTHCDJLNt2/0YiN5M8g5AlynmMRBj5EMln+SXy9BNQEkgqy54Ik5xAcmtZmeQIyWeJwiTHSD5L3vclQKazrBtGgExk+ZQYmc9SQMhSQsjSRcjSR5bVRMhSRcjSRMjSRMjSRMjSRMjSRMjSRcjSR5bVRMhSRcjSRMjSRMjSRMjSRMjSRMjSRcjSR5bVRMhSRcjSRMjSRMjSRMjSRMjSRMjSRMjSRMjyD8sjJqSqvFOrAAAAAElFTkSuQmCC"

/***/ }),

/***/ "IoGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuoteResult_vue__ = __webpack_require__("jK9e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuoteResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuoteResult_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuoteResult_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuoteResult_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuoteResult_vue__ = __webpack_require__("5l0J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuoteResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuoteResult_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b61adc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_QuoteResult_vue__ = __webpack_require__("bMC4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("m9C4")
  __webpack_require__("Gkm1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54b61adc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuoteResult_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b61adc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_QuoteResult_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b61adc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_QuoteResult_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IxoN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JU7c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = __webpack_require__("f6Hi");

var _base2 = _interopRequireDefault(_base);

var _objectFilter = __webpack_require__("q5lo");

var _props = __webpack_require__("Zor0");

var _props2 = _interopRequireDefault(_props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'radio',
  mixins: [_base2.default],
  filters: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey
  },
  props: (0, _props2.default)(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey,
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, (0, _objectFilter.getLabel)(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}

/***/ }),

/***/ "Ji7B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Business_vue__ = __webpack_require__("6gNV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Business_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Business_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Business_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Business_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Business_vue__ = __webpack_require__("Qk6u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Business_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Business_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c77d5a20_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Business_vue__ = __webpack_require__("KR+S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("N4Z8")
  __webpack_require__("TbnC")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c77d5a20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Business_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c77d5a20_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Business_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c77d5a20_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Business_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JqR+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _picker = __webpack_require__("taJy");

var _picker2 = _interopRequireDefault(_picker);

var _cell = __webpack_require__("1DHf");

var _cell2 = _interopRequireDefault(_cell);

var _popup = __webpack_require__("HD9R");

var _popup2 = _interopRequireDefault(_popup);

var _popupHeader = __webpack_require__("WZtS");

var _popupHeader2 = _interopRequireDefault(_popupHeader);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _flexbox = __webpack_require__("F3HL");

var _array2String = __webpack_require__("LsKW");

var _array2String2 = _interopRequireDefault(_array2String);

var _value2name = __webpack_require__("NE4E");

var _value2name2 = _interopRequireDefault(_value2name);

var _mixin_uuid = __webpack_require__("OFgA");

var _mixin_uuid2 = _interopRequireDefault(_mixin_uuid);

var _transferDom = __webpack_require__("63CM");

var _transferDom2 = _interopRequireDefault(_transferDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var getObject = function getObject(obj) {
  return JSON.parse((0, _stringify2.default)(obj));
};

exports.default = {
  name: 'popup-picker',
  directives: {
    TransferDom: _transferDom2.default
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [_mixin_uuid2.default],
  components: {
    Picker: _picker2.default,
    Cell: _cell2.default,
    Popup: _popup2.default,
    PopupHeader: _popupHeader2.default,
    Flexbox: _flexbox.Flexbox,
    FlexboxItem: _flexbox.FlexboxItem,
    InlineDesc: _inlineDesc2.default
  },
  filters: {
    array2string: _array2String2.default,
    value2name: _value2name2.default
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: _value2name2.default,
    getNameValues: function getNameValues() {
      return (0, _value2name2.default)(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if ((0, _stringify2.default)(this.currentValue) !== (0, _stringify2.default)(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = (0, _stringify2.default)(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = getObject(val);
      this.$emit('on-shadow-change', _val, (0, _value2name2.default)(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.tempValue)) {
        this.tempValue = getObject(val);
        this.currentValue = getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', getObject(val));
      this.$emit('on-change', getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: getObject(this.value),
      closeType: false,
      currentData: (0, _stringify2.default)(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
};

/***/ }),

/***/ "KJbd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "FeeMaintainList",
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  mounted: function mounted() {
    this.$refs.scrollerBottom.reset();
  },
  data: function data() {
    var pulldownDefaultConfig = {
      content: '下拉刷新',
      height: 60,
      autoRefresh: true,
      downContent: '下拉刷新',
      upContent: '释放后刷新',
      loadingContent: '正在刷新...',
      clsPrefix: 'xs-plugin-pulldown-'
    };
    var pullupDefaultConfig = {
      content: '上拉加载更多',
      pullUpHeight: 60,
      height: 40,
      autoRefresh: true,
      downContent: '释放后加载',
      upContent: '上拉加载更多',
      loadingContent: '加载中...',
      clsPrefix: 'xs-plugin-pullup-'
    };
    return {
      src1: __webpack_require__("w2ig"), // 装箱的图片
      src2: __webpack_require__("qDaJ"), // 拆箱的图片
      tableData: [],
      scrollerStatus: {
        pulldownStatus: 'default',
        pullupStatus: 'enabled'
      },
      pageNo: 1, // 页码
      pullupDefaultConfig: pullupDefaultConfig,
      pulldownDefaultConfig: pulldownDefaultConfig
    };
  },
  created: function created() {
    document.title = '费用维护';
    this.onPulldownLoading();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code,
        pageNo: this.pageNo,
        pageSize: 10
      };
      this.requestApi({
        url: _const.apiUrl.feeMaintainPageList,
        data: data
      }, function (resultData) {
        var list = resultData.data.page.result || [];

        _this.tableData.push.apply(_this.tableData, list);

        _this.scrollerStatus.pulldownStatus = 'default';
        var totalPages = resultData.data.page.totalPages;
        if (_this.pageNo >= totalPages) {
          _this.scrollerStatus.pullupStatus = 'disabled';
        } else {
          _this.scrollerStatus.pullupStatus = 'default';
        }

        _this.$refs.scrollerBottom.reset();
      }, function (error) {
        if (error) {
          _this.scrollerStatus.pulldownStatus = 'default';
          _this.scrollerStatus.pullupStatus = 'default';
        }
      });
    },
    goReportContNo: function goReportContNo(ladingId, otherservice, bookingId) {
      this.$router.push({
        name: 'FeeMaintain',
        query: {
          ladingId: ladingId,
          otherservice: otherservice,
          bookingId: bookingId
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    },

    /**
    * 下拉刷新
    */
    onPulldownLoading: function onPulldownLoading() {
      this.pageNo = 1;
      this.tableData = [];
      this.getData();
    },

    /**
    * 上拉加载更多
    */
    onPullupLoading: function onPullupLoading() {
      this.pageNo++;
      this.getData();
    }
  }
};

/***/ }),

/***/ "KR+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"business"}},[_c('group',{attrs:{"gutter":15}},[_c('x-input',{staticClass:"business-input",attrs:{"title":"柜号","placeholder":"请输入柜号","novalidate":"","placeholder-align":"right","text-align":"right"},model:{value:(_vm.cont_no),callback:function ($$v) {_vm.cont_no=$$v},expression:"cont_no"}}),_vm._v(" "),_c('x-input',{staticClass:"business-input",attrs:{"title":"运单号","placeholder":"请输入运单号","novalidate":"","placeholder-align":"right","text-align":"right"},model:{value:(_vm.m_bl_no),callback:function ($$v) {_vm.m_bl_no=$$v},expression:"m_bl_no"}}),_vm._v(" "),_c('x-input',{staticClass:"business-input",attrs:{"title":"工作单号","placeholder":"请输入工作单号","novalidate":"","placeholder-align":"right","text-align":"right"},model:{value:(_vm.lading_id),callback:function ($$v) {_vm.lading_id=$$v},expression:"lading_id"}}),_vm._v(" "),_c('x-input',{staticClass:"business-input",attrs:{"title":"货主","placeholder":"请输入货主","novalidate":"","placeholder-align":"right","text-align":"right"},model:{value:(_vm.consignee_id),callback:function ($$v) {_vm.consignee_id=$$v},expression:"consignee_id"}}),_vm._v(" "),_c('popup-radio',{staticClass:"business-input",attrs:{"title":"时间","options":_vm.dateDiffOptions,"placeholder":"请选择时间"},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticClass:"each-item-content"},[_vm._v("\n                    "+_vm._s(props.label)+"\n                ")])]}}]),model:{value:(_vm.datediff),callback:function ($$v) {_vm.datediff=$$v},expression:"datediff"}})],1),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goResultPage($event)}}},[_vm._v("查询")])],1),_vm._v(" "),_c('MyFooter',{staticStyle:{"margin-top":"0.2rem"}}),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "KZl4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "KdaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgList_vue__ = __webpack_require__("YeHI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgList_vue__ = __webpack_require__("elS0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ea429e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgList_vue__ = __webpack_require__("sJY8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("FHMP")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65ea429e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ea429e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ea429e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KinT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
};

/***/ }),

/***/ "Kl/K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'DeliveImgLading',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src2: __webpack_require__("fy9M"), // 送货的icon图片
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'zzzz',
                //   deliveimgisload: 0,
                //   openimgisupload: 1,
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'aaaaa',
                //   deliveimgisload: 1,
                //   openimgisupload: 0,
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            isNoData: false
        };
    },
    created: function created() {
        document.title = '送货图片';
        this.bookingId = this.$route.query.bookingId;
        this.ladingId = this.$route.query.ladingId;
        this.servicetype = this.$route.query.servicetype;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            // 获取工作单下要上传图片的柜，一个工作单可能有多个柜号id
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                servicetype: this.servicetype
            };
            this.isShowLoading = true;
            // 调用接口获取数据
            this.requestApi({
                url: _const.apiUrl.deliveImgLading,
                data: data
            }, function (resultData) {
                _this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况
                _this.tableData = resultData.data.sonos || [];
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        goNextPage: function goNextPage(routerName, id, referenceno, contNo, contId, type) {
            // 按钮的方法，跳转查看页面，并且带些参数过去
            this.$router.push({
                name: routerName,
                query: {
                    bookingId: this.bookingId,
                    ladingId: this.ladingId,
                    servicetype: this.servicetype,
                    id: id,
                    referenceno: referenceno,
                    contNo: contNo,
                    contId: contId,
                    type: type, // 为了区分装箱与封箱，load为装箱，seal为封箱,delivedoc为送货单证图片
                    companyId2: _const.apiParams.companyId,
                    openId2: _const.apiParams.openId
                }
            });
        }
    }
};

/***/ }),

/***/ "KuUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"businessResult"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}]},[_c('scroller',{ref:"scrollerBottom",attrs:{"lock-x":"","scroll-bottom-offset":100},on:{"on-scroll-bottom":_vm.onScrollBottom}},[_c('div',{staticClass:"box2"},[_vm._l((_vm.tableData),function(item,index){return _c('ul',{key:index,staticClass:"list"},[_c('li',{staticClass:"list-item"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"list-item-text1"},[_vm._v("运单号：")]),_vm._v(" "),_c('i',{staticClass:"list-item-text2"},[_vm._v(_vm._s(item.mblNo))])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("1pHq"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"list-item-text1"},[_vm._v("柜号：")]),_vm._v(" "),_c('i',{staticClass:"list-item-text2"},[_vm._v(_vm._s(item.contNo))])]),_vm._v(" "),_c('li',{staticClass:"list-item list-item__checker clear"},[_c('checker',{attrs:{"default-item-class":"default-item"},model:{value:(item.truckStatus),callback:function ($$v) {_vm.$set(item, "truckStatus", $$v)},expression:"item.truckStatus"}},[_c('checker-item',{attrs:{"value":"1","disabled":""}},[_c('img',{attrs:{"src":item.truckStatus !== '×' ? _vm.radioIconGreen : _vm.radioIconGrey,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.truckStatus !== '×' ? '已派车' : '未派车'))]),_vm._v(" "),(item.truckStatus !== '×')?_c('b',{staticClass:"list-item-date"},[_vm._v(_vm._s(_vm.editDate(item.truckStatus)))]):_vm._e()])],1),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"default-item"},model:{value:(item.loadOverStatus),callback:function ($$v) {_vm.$set(item, "loadOverStatus", $$v)},expression:"item.loadOverStatus"}},[_c('checker-item',{attrs:{"value":"1","disabled":""}},[_c('img',{attrs:{"src":item.loadOverStatus !== '×' ? _vm.radioIconGreen : _vm.radioIconGrey,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.loadOverStatus !== '×' ? '已装货' : '未装货'))]),_vm._v(" "),(item.loadOverStatus !== '×')?_c('b',{staticClass:"list-item-date"},[_vm._v(_vm._s(_vm.editDate(item.loadOverStatus)))]):_vm._e()])],1),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"default-item"},model:{value:(item.inVesselStatus),callback:function ($$v) {_vm.$set(item, "inVesselStatus", $$v)},expression:"item.inVesselStatus"}},[_c('checker-item',{attrs:{"value":"1","disabled":""}},[_c('img',{attrs:{"src":item.inVesselStatus !== '×' ? _vm.radioIconGreen : _vm.radioIconGrey,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.inVesselStatus !== '×' ? '已上船' : '未上船'))]),_vm._v(" "),(item.inVesselStatus !== '×')?_c('b',{staticClass:"list-item-date"},[_vm._v(_vm._s(_vm.editDate(item.inVesselStatus)))]):_vm._e()])],1),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"default-item"},model:{value:(item.isArrived),callback:function ($$v) {_vm.$set(item, "isArrived", $$v)},expression:"item.isArrived"}},[_c('checker-item',{attrs:{"value":"1","disabled":""}},[_c('img',{attrs:{"src":item.isArrived !== '×' ? _vm.radioIconGreen : _vm.radioIconGrey,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.isArrived !== '×' ? '船已到' : '船未到'))]),_vm._v(" "),(item.isArrived !== '×')?_c('b',{staticClass:"list-item-date"},[_vm._v(_vm._s(_vm.editDate(item.isArrived)))]):_vm._e()])],1),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"default-item"},model:{value:(item.goodsReliveStatus),callback:function ($$v) {_vm.$set(item, "goodsReliveStatus", $$v)},expression:"item.goodsReliveStatus"}},[_c('checker-item',{attrs:{"value":"1","disabled":""}},[_c('img',{attrs:{"src":item.goodsReliveStatus !== '×' ? _vm.radioIconGreen : _vm.radioIconGrey,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.goodsReliveStatus !== '×' ? '已送货' : '未送货'))]),_vm._v(" "),(item.goodsReliveStatus !== '×')?_c('b',{staticClass:"list-item-date"},[_vm._v(_vm._s(_vm.editDate(item.goodsReliveStatus)))]):_vm._e()])],1)],1),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('img',{attrs:{"src":item.isGoodskeep === '扣箱' ? _vm.goodsKeepIcon0 : _vm.goodsKeepIcon1,"alt":""}})])])}),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}}),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e()],2)])],1),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "LAxo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _arrayFind = __webpack_require__("NXHL");

var _arrayFind2 = _interopRequireDefault(_arrayFind);

var _uuid = __webpack_require__("KRg4");

var _uuid2 = _interopRequireDefault(_uuid);

var _cleanStyle = __webpack_require__("wmxo");

var _cleanStyle2 = _interopRequireDefault(_cleanStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findByKey = function findByKey(key, options) {
  var _rs = (0, _arrayFind2.default)(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'selector',
  mixins: [_uuid2.default],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = (0, _typeof3.default)(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: _cleanStyle2.default,
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if ((0, _typeof3.default)(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
};

/***/ }),

/***/ "LBXa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _GoHome = __webpack_require__("ZWVd");

var _GoHome2 = _interopRequireDefault(_GoHome);

var _MyFooter = __webpack_require__("m+mo");

var _MyFooter2 = _interopRequireDefault(_MyFooter);

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "FreightPrice",
    components: {
        MyFooter: _MyFooter2.default,
        MyBtnReturn: _MyBtnReturn2.default,
        GoHome: _GoHome2.default
    },
    data: function data() {
        return {
            place_loading: null,
            place_loadingOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            place_delivery: null,
            place_deliveryOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ], // 目的港要根据起始港调用接口查询
            group: '', // 后台返回的
            shipper: '', // 后台返回的
            areaUrl: '' // 查询地点API，freightPrice，该接口还会拿到shipper与group，后续调用表格数据接口时也要传给后台
            // tableDataUrl: '', // 查询表单数据API，freightPriceTemplate
        };
    },
    created: function created() {
        document.title = '全程运输报价查询';
        this.areaUrl = _const.apiUrl.freightPrice;
        this.searchArea();
    },

    methods: {
        searchArea: function searchArea() {
            var _this = this;

            // 获取起始与目的等地点:如果没获取到，要提示用户重新打开页面吗？
            // 该接口还会拿到shipper与group，后续调用表格数据接口时也要传给后台
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.requestApi({
                url: this.areaUrl,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                // 囧，结果后台返回了数组里一个null，[null]，selector组件直接崩溃
                _this.place_loadingOps = dataObj.starts || []; // 防止后台返回null
                _this.place_deliveryOps = dataObj.ends || []; // 防止后台返回null
                _this.group = dataObj.group || ''; // 防止后台返回null
                _this.shipper = dataObj.shipper || ''; // 防止后台返回null
            }, function (error) {
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        goResultPage: function goResultPage() {
            var route = {
                name: 'FreightPriceResult',
                query: {
                    place_loading: this.place_loading || '',
                    place_delivery: this.place_delivery || '',
                    group: this.group,
                    shipper: this.shipper,
                    openId: _const.apiParams.openId,
                    companyId: _const.apiParams.companyId,
                    code: _const.apiParams.code
                }
            };
            this.$router.push(route);
        },
        startChange: function startChange(value) {
            var _this2 = this;

            if (!value) return;
            // 去获取目的地的数据：这是根据起运地获取的，数量应该没startAreaUrl接口的多吧？
            // 加一个loading，顺便可以不让用户又去选择另一个起运地
            this.$vux.loading.show({
                text: 'Loading'
            });
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                start: this.place_loading || ''
            };
            this.requestApi({
                url: _const.apiUrl.changePlace,
                data: data
            }, function (resultData) {
                _this2.$vux.loading.hide();
                var dataObj = resultData.data;
                _this2.place_deliveryOps = dataObj.findEndPlace || []; // 防止后台返回null
                _this2.place_delivery = null; // 目的地被选中项变为null，不然查询时会记忆回来选择的
            }, function (error) {
                _this2.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            });
        },
        targetChange: function targetChange(value) {}
    }
};

/***/ }),

/***/ "LIP2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LOkV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * cutImg不能能压缩图片，只是裁剪了图片
 * @param fileObj [type: object] [比如e.target.files[0]]
 * @param callback [type: fn] [回调函数，比如调用上传接口]
 */
var cutImg = exports.cutImg = function cutImg(fileObj, callback) {
    if (typeof FileReader === 'undefined') {
        console.error('当前浏览器内核不支持base64图标压缩');
        //调用上传方式不压缩
        directTurnIntoBase64(fileObj, callback);
    } else {
        try {
            var reader = new FileReader();
            reader.onload = function (e) {
                var image = document.createElement('img');
                image.onload = function () {
                    var square = 700; //定义画布的大小，也就是图片压缩之后的像素
                    var canvas = document.createElement('canvas');
                    var context = canvas.getContext('2d');
                    var imageWidth = 0; //压缩图片的大小
                    var imageHeight = 0;
                    var offsetX = 0;
                    var offsetY = 0;

                    canvas.width = square;
                    canvas.height = square;
                    context.clearRect(0, 0, square, square);

                    if (this.width > this.height) {
                        imageWidth = Math.round(square * this.width / this.height);
                        imageHeight = square;
                        offsetX = -Math.round((imageWidth - square) / 2);
                    } else {
                        imageHeight = Math.round(square * this.height / this.width);
                        imageWidth = square;
                        offsetY = -Math.round((imageHeight - square) / 2);
                    }
                    context.drawImage(this, offsetX, offsetY, imageWidth, imageHeight);
                    var data = canvas.toDataURL('image/jpeg');
                    //压缩完成执行回调
                    callback(data);
                };
                image.src = e.target.result; // 必须赋值给src属性，比如img的onload都不执行
            };
            reader.readAsDataURL(fileObj);
        } catch (e) {
            console.error('压缩失败');
            //调用直接上传方式  不压缩
            directTurnIntoBase64(fileObj, callback);
        }
    }
};

/**
 * directTurnIntoBase64不对图片进行压缩，直接转成base64
 * @param fileObj
 * @param callback
 */
var directTurnIntoBase64 = exports.directTurnIntoBase64 = function directTurnIntoBase64(fileObj, callback) {
    var r = new FileReader();
    // 转成base64
    r.onload = function () {
        //变成字符串
        var base64 = this.result;
        callback(base64);
    };
    r.readAsDataURL(fileObj); //转成Base64格式
};

/**
 * compress能压缩图片
 * @param fileObj [type: object] [比如e.target.files[0]]
 * @param obj [type: object] [比如传入{quality:0.7}，设置压缩后的质量]
 * @param callback [type: fn] [回调函数，比如调用上传接口]
 */
var compress = exports.compress = function compress(fileObj, obj, callback) {
    if (!fileObj) return;
    if (fileObj.size / 1024 > 1025) {
        // 大于1M，进行压缩上传
        try {
            var reader = new FileReader();
            reader.onload = function (e) {
                var image = document.createElement('img');
                image.onload = function () {
                    var that = this;
                    // 默认按比例压缩
                    var w = that.width,
                        h = that.height,
                        scale = w / h;
                    w = obj.width || w;
                    h = obj.height || w / scale;
                    var quality = 0.7; // 默认图片质量为0.7
                    //生成canvas
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    // 创建属性节点
                    var anw = document.createAttribute("width");
                    anw.nodeValue = w;
                    var anh = document.createAttribute("height");
                    anh.nodeValue = h;
                    canvas.setAttributeNode(anw);
                    canvas.setAttributeNode(anh);
                    ctx.drawImage(that, 0, 0, w, h);
                    // 图像质量：小于0.3的话，可能就开始失真严重了
                    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
                        quality = obj.quality;
                    }
                    // quality = obj.quality;
                    // quality值越小，所绘制出的图像越模糊
                    var base64 = canvas.toDataURL('image/jpeg', quality);
                    //压缩完成执行回调
                    callback(base64);
                };
                image.src = e.target.result; // 必须赋值给src属性，比如img的onload都不执行
            };
            reader.readAsDataURL(fileObj);
        } catch (e) {
            console.error('压缩失败');
            // 不压缩
            directTurnIntoBase64(fileObj, callback);
        }
    } else {
        // 小于1M不压缩
        directTurnIntoBase64(fileObj, callback);
    }
};

/**
 * photoCompress会获取到图片的base64，然后去调用canvasDataURL对图片进行压缩
 * @param file [type: object] [文件(类型是图片格式)]
 * @param w  [type: object] [文件压缩的后宽度，宽度越小，字节越小，这里其实是对象，比如{quality:0.7}，设置压缩后的质量]
 * @param callback [type: fn] [回调函数，比如调用上传接口]
 * 注：quality被限制最小为0.3了，因为小于0.3的话，图片就开始失真了！
 */
var photoCompress = exports.photoCompress = function photoCompress(file, w, callback) {
    if (!file) {
        console.error('file有问题，不是对象吧？');
        return;
    }
    var ready = new FileReader();
    /*开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
    ready.readAsDataURL(file);
    ready.onload = function () {
        var path = this.result;
        canvasDataURL(path, w, callback);
    };
};

/**
 * 压缩图片至文件
 * @param {Object} file
 * @param {Object} obj
 * @param {Object} callback
 */
var photoCompressToFile = exports.photoCompressToFile = function photoCompressToFile(file, obj, callback) {
    if (!file) {
        console.error('file有问题，不是对象吧？');
        return;
    }
    if (file.size / 1024 > obj.minSize) {
        // 超过大小
        photoCompress(file, obj, function (base64Img) {
            var newFile = dataURLtoFile(base64Img, file.name);
            callback(newFile);
        }, function () {
            // 图片经过多次压缩，还是太大了，提示用户
            console.error('抱歉，图片太大');
        });
    } else {
        callback(file);
    }
};

/**
 * canvasDataURL会去压缩图片
 * @param path [type: string] [是一个base64的字符串，这里一般会由photoCompress函数传入]
 * @param obj [type: object] [比如传入{quality:0.7, minSize: 1000, minQuality: 0.1}，分别设置压缩后的质量、图片大小的最小值、图片质量的最小值]
 * @param callback  [type: fn] [回调函数，比如调用上传接口]
 * @param errorCallback  [type: fn] [回调函数，因图片太大而获取图片失败的情况]
 * 注：现在最小限制以minQuality为准，minSize只是辅助，如果需求修改为必须小于限制值minSize，就在第二个判断里调用errorCallback；
 * 注：如果直接使用base64格式上传，content-length会比使用File对象格式上传大一些；
 */
var canvasDataURL = function canvasDataURL(path, obj, callback, errorCallback) {
    var img = new Image();
    var minSize = obj.minSize; // 图片大小限制，不传就没限制
    var minQuality = obj.minQuality || 0.1; // 限制最小的图片质量quality
    img.src = path;
    img.onload = function () {
        if (obj.quality < minQuality) {
            // todo:quality小于minQuality了，证明图片太大，可以在这里告知用户图片太大了！
            // 由于下面代码有判断了，这里不会被执行的
            errorCallback && errorCallback();
            return;
        }
        var quality = 0.7; // 默认图片质量为0.7，而且必须大于0，否则强制为默认值
        // 图像质量：quality值越小，所绘制出的图像越模糊，小于0.3的话，可能就开始失真严重了
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
            quality = obj.quality;
        }
        var that = this;
        // 默认按比例压缩
        var w = that.width,
            h = that.height,
            scale = w / h;
        w = obj.width || w;
        h = obj.height || w / scale;
        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // 创建属性节点
        var anw = document.createAttribute("width");
        anw.nodeValue = w;
        var anh = document.createAttribute("height");
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);

        var base64 = canvas.toDataURL('image/jpeg', quality);
        // 回调函数返回base64的值
        // callback(base64);

        // 判断压缩后的图片是否超过限制值minSize，但quality不要小于minQuality，不然失真非常严重
        var size = convertBase64UrlToBlob(base64).size;
        if (size / 1024 > minSize && quality > minQuality) {
            // 如果压缩后还是大于限制值minSize，且quality还大于minQuality，那就再压缩：发现不能使用之前压缩后获得的base64去压缩，没效果，所以要重新传入quality
            var newQuality = (quality * 10 - 2) / 10; // js还是不要使用浮点数计算了
            canvasDataURL(path, {
                quality: newQuality,
                minSize: minSize,
                minQuality: minQuality
            }, callback);
        } else if (size / 1024 > minSize && quality === minQuality) {
            // 如果压缩后还是大于限制值minSize，但quality刚好等于minQuality，那就返回压缩后的base64吧
            // 但需求如果修改为必须小于限制值minSize，那这里就告知用户，调用errorCallback
            // errorCallback && errorCallback()
            callback(base64);
        } else {
            // 到这一步，证明图片大小不超过限制值minSize
            // 回调函数返回base64的值
            callback(base64);
        }
    };
};

/**
 * convertBase64UrlToBlob将base64的图片url数据转换为Blob
 * @param dataUrl [用url方式表示的base64图片数据]
 */
var convertBase64UrlToBlob = exports.convertBase64UrlToBlob = function convertBase64UrlToBlob(dataUrl) {
    var arr = dataUrl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
};

/**
 * dataURLtoFile将base64的图片url数据转换为原来的File对象
 * @param dataUrl [用url方式表示的base64图片数据]
 */
var dataURLtoFile = exports.dataURLtoFile = function dataURLtoFile(dataUrl) {
    var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';

    var arr = dataUrl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
};

exports.default = {
    cutImg: cutImg,
    directTurnIntoBase64: directTurnIntoBase64,
    compress: compress,
    convertBase64UrlToBlob: convertBase64UrlToBlob,
    photoCompress: photoCompress,
    canvasDataURL: canvasDataURL,
    dataURLtoFile: dataURLtoFile,
    photoCompressToFile: photoCompressToFile
};

/***/ }),

/***/ "LTgZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell"},[_c('div',[_c('p',{class:_vm.labelClass,style:({width: _vm.$parent.labelWidth, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readonly),expression:"!readonly"}],staticClass:"weui-cell__ft vux-cell-primary",class:{'vux-number-round': _vm.buttonStyle === 'round'},staticStyle:{"font-size":"0"}},[_c('div',{style:({float:_vm.align})},[_c('a',{staticClass:"vux-number-selector vux-number-selector-sub",class:{'vux-number-disabled':_vm.disabledMin},on:{"click":_vm.sub}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}},[_c('defs'),_c('path',{attrs:{"d":"M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-number-input",style:({width: _vm.width}),attrs:{"name":_vm.name,"readonly":!_vm.fillable,"pattern":"[0-9]*","type":"number"},domProps:{"value":(_vm.currentValue)},on:{"blur":[_vm.blur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"vux-number-selector vux-number-selector-plus",class:{'vux-number-disabled':_vm.disabledMax},on:{"click":_vm.add}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20"}},[_c('defs'),_c('path',{attrs:{"d":"M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readonly),expression:"readonly"}],staticClass:"weui-cell__ft vux-cell-primary"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var staticRenderFns = []


/***/ }),

/***/ "LeAj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("QNoK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("EVI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_87e1f61c_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("LTgZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("G6kY")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_87e1f61c_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_87e1f61c_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LkYy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLading_vue__ = __webpack_require__("HsZO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLading_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLading_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLading_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLading_vue__ = __webpack_require__("frZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0169a8e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgLading_vue__ = __webpack_require__("qwxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("j/5W")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0169a8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLading_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0169a8e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgLading_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0169a8e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgLading_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Loy+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'VoyageResult',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            tableData: [
                // {
                //   vesselName: '新海秀',
                //   voyage: '1001S',
                //   onboardDate: '2014-11-10', // 开船日期
                //   arrival: '2014-11-29' // 船到日期
                // },
                // {
                //   vesselName: '新海秀',
                //   voyage: '1001S',
                //   onboardDate: '2014-11-10', // 开船日期
                //   arrival: '2014-11-29' // 船到日期
                // },
            ],
            isShowTable: true, // 没有数据时才注释掉这个滚动组件
            isShowLoading: false,
            isShowMore: true,
            canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
            pageSize: 15, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false,
            tableDataUrl: '', // 查询表单数据API，voyageTemplate或voyageTemplateYw
            routeName: ''
        };
    },
    created: function created() {
        document.title = '船期查询';
        var query = this.$route.query;
        this.routeName = query.routeName;
        if (this.routeName === 'VoyageKehu') {
            this.tableDataUrl = _const.apiUrl.voyageTemplate;
        } else {
            this.tableDataUrl = _const.apiUrl.voyageTemplateYw;
        }
        this.onScrollBottom();
    },

    methods: {
        getMoreData: function getMoreData(url, data) {
            var _this = this;

            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.isShowMore = false;
                this.showToast('暂无更多数据！', 2000);
                return;
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data.page;
                var resultArr = dataObj.result || []; // 防止后台返回null
                if (_this.pageNo === 1 && resultArr.length === 0) {
                    // 如果根本没有数据
                    _this.isShowTable = false;
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    _this.isShowMore = false;
                    return;
                }
                resultArr.forEach(function (item) {
                    _this.tableData.push(item);
                }); // 表格数据是放在result中
                _this.totalCount = dataObj.totalCount;
                _this.totalPages = dataObj.totalPages;
                _this.pageNo++;
                _this.$nextTick(function () {
                    _this.$refs.scrollerBottom.reset();
                }); // 要重置scroller组件
            }, function (error) {
                _this.isShowLoading = false;
                _this.canFetch = true;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        onScrollBottom: function onScrollBottom() {
            if (!this.canFetch) {} else {
                this.isShowLoading = true;
                // this.isShowMore = false
                this.canFetch = false;
                var query = this.$route.query;
                var data = {
                    place_loading: query.place_loading || '',
                    place_delivery: query.place_delivery || '',
                    pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                    pageNo: this.pageNo, // 当前为第几页数据，要累加
                    openId: _const.apiParams.openId,
                    companyId: _const.apiParams.companyId,
                    code: _const.apiParams.code
                };
                this.getMoreData(this.tableDataUrl, data);
            }
        }
    }
};

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("bwrR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xzd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb497582_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("rtyr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("2euu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb497582_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb497582_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MCPu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mcxb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"deliveImgLook"}},[_c('div',[_c('div',{staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src2,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-item__first"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(_vm.ladingId))])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contNo))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v("柜型：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contId))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('span',[_vm._v(_vm._s(_vm.type === 'delive' ? '封箱图片：' : (_vm.type === 'open' ? '开箱图片：':'单证图片：')))])]),_vm._v(" "),_vm._l((_vm.imgSrcList),function(item,index){return _c('div',{key:index,staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left-upload"},[_c('img',{attrs:{"src":item,"alt":"","preview":"0"}})])])})],2)]),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],1),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无图片")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn',{attrs:{"step":_vm.step}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "MkQx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ml40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__ = __webpack_require__("CE5r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__ = __webpack_require__("yzPM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a845f1c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__ = __webpack_require__("52S5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("QWK6")
  __webpack_require__("Na6W")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a845f1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a845f1c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a845f1c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "N4Z8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _fastclick = __webpack_require__("v5o6");

var _fastclick2 = _interopRequireDefault(_fastclick);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__("mw3O");

var _qs2 = _interopRequireDefault(_qs);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _vuePhotoPreview = __webpack_require__("ibnl");

var _vuePhotoPreview2 = _interopRequireDefault(_vuePhotoPreview);

__webpack_require__("tOCg");

var _index = __webpack_require__("Peep");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("Y+qm");

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__("3BeM");

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__("NXWw");

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__("rHil");

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__("1DHf");

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__("pDNl");

var _index14 = _interopRequireDefault(_index13);

var _index15 = __webpack_require__("wwIJ");

var _index16 = _interopRequireDefault(_index15);

var _index17 = __webpack_require__("7TQh");

var _index18 = _interopRequireDefault(_index17);

var _index19 = __webpack_require__("2sLL");

var _index20 = _interopRequireDefault(_index19);

var _checker = __webpack_require__("/0UN");

var _checker2 = _interopRequireDefault(_checker);

var _checkerItem = __webpack_require__("hGvq");

var _checkerItem2 = _interopRequireDefault(_checkerItem);

var _index21 = __webpack_require__("UNGY");

var _index22 = _interopRequireDefault(_index21);

var _index23 = __webpack_require__("ALGc");

var _index24 = _interopRequireDefault(_index23);

var _index25 = __webpack_require__("LeAj");

var _index26 = _interopRequireDefault(_index25);

var _flexbox = __webpack_require__("YxJB");

var _flexbox2 = _interopRequireDefault(_flexbox);

var _flexboxItem = __webpack_require__("3Lt7");

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

var _index27 = __webpack_require__("S8Wg");

var _index28 = _interopRequireDefault(_index27);

var _index29 = __webpack_require__("4FCr");

var _index30 = _interopRequireDefault(_index29);

var _index31 = __webpack_require__("rLAy");

var _index32 = _interopRequireDefault(_index31);

var _index33 = __webpack_require__("62KO");

var _index34 = _interopRequireDefault(_index33);

var _index35 = __webpack_require__("rGqP");

var _index36 = _interopRequireDefault(_index35);

var _index37 = __webpack_require__("EmH9");

var _index38 = _interopRequireDefault(_index37);

var _index39 = __webpack_require__("etVR");

var _index40 = _interopRequireDefault(_index39);

var _index41 = __webpack_require__("7Ah8");

var _index42 = _interopRequireDefault(_index41);

var _index43 = __webpack_require__("HD9R");

var _index44 = _interopRequireDefault(_index43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vuxComponents = {
  Group: _index10.default,
  Cell: _index12.default,
  Selector: _index16.default,
  XInput: _index14.default,
  PopupRadio: _index18.default,
  XButton: _index20.default,
  Checker: _checker2.default,
  CheckerItem: _checkerItem2.default,
  Datetime: _index22.default,
  XTextarea: _index24.default,
  XNumber: _index26.default,
  Flexbox: _flexbox2.default,
  FlexboxItem: _flexboxItem2.default,
  Scroller: _index28.default,
  LoadMore: _index30.default,
  Toast: _index32.default,
  Confirm: _index34.default,
  Divider: _index36.default,
  CheckIcon: _index38.default,
  Checklist: _index40.default,
  PopupPicker: _index42.default,
  Popup: _index44.default
};

var vuxPlugins = [_index2.default, _index4.default, _index6.default, _index8.default];

(0, _keys2.default)(vuxComponents).forEach(function (k) {
  _vue2.default.component(k, vuxComponents[k]);
});

vuxPlugins.forEach(function (plugin) {
  _vue2.default.use(plugin);
});

var options = {
  fullscreenEl: false, //控制是否显示右上角全屏按钮
  closeEl: false, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: false, //控制是否显示放大缩小按钮
  counterEl: false, //控制是否显示左上角图片数量按钮
  arrowEl: false, //控制如图的左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: true, //点击应切换控件的可见性
  clickToCloseNonZoomable: true
};
_vue2.default.use(_vuePhotoPreview2.default, options);

_fastclick2.default.attach(document.body);

/**
* showToast对vux的toast插件进行封装
* @param text [内容]
* @param time [持续显示时间]
* @param type [类型，可选值 success, warn, cancel, text]
* @param options [type: object] [可传入toast插件支持的其他属性]
*/
_vue2.default.prototype.showToast = function (text) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  this.$vux.toast.show({
    text: text,
    type: type,
    time: time,
    position: options.position || 'default',
    width: options.width || '7.6em',
    isShowMask: options.isShowMask || false,
    onHide: options.onHide
  });
};

/**
* $http是配置axios，只要调用$http，那请求的参数都会被序列化为Form data
* @type {AxiosInstance}
* 使用到qs插件来序列化；
* 写入Vue.prototype，可全局使用该函数；
* 注：如果请求参数不需要序列化，可直接在组件内引入axios
*/
_vue2.default.prototype.$http = _axios2.default.create({
  transformRequest: [function (data) {

    data = _qs2.default.stringify(data);
    return data;
  }]
}); // 将axios添加到Vue原型中


/**
* requestApi是对$http进行多一层封装，处理下后台返回code为412或500的情况
* option [type:object] [传递请求需要的类型、url、参数等] [url必须传！];
* okCallback [type:fn] [后台返回的code为不为412或500时，运行该函数，对数据进行处理];
* statusCallback [type:fn] [在该函数中可控制各种状态，比如是否显示、可继续请求等状态];
* 注：statusCallback是请求成功或失败都可以执行的，如果需要只有在请求失败时才执行，可在该函数中用if(error){ 只有请求失败才执行 }；
*/
_vue2.default.prototype.requestApi = function (option, okCallback, statusCallback) {
  var _this = this;

  if (!option.url) {
    console.error("没传url啊");
  }
  this.$http({
    method: option.method || 'post',
    url: option.url, // url必须有
    data: option.data || {}
  }).then(function (res) {
    var resultData = res.data;
    var code = resultData.code;
    var info = resultData.info;
    if (code === 412) {
      _this.$vux.toast.show({

        text: info,
        time: 1500,
        type: 'warn'
      });
    } else if (code === 500) {
      _this.$vux.toast.show({

        text: info,
        time: 1500,
        type: 'warn'
      });
    } else {
      okCallback && okCallback(resultData);
    }

    statusCallback && statusCallback();
  }).catch(function (error) {
    statusCallback && statusCallback(error);
    console.error(error);

    _this.$vux.toast.show({
      text: '网络超时！',
      time: 1500,
      type: 'warn'
    });
  });
};

_vue2.default.config.productionTip = false;

/**
* getUrlParams获取url里拼接的参数
* USAGE:
* let paramName = getUrlParams('paramName');
* let { param1, param2 } = getUrlParams('param1', 'params2');
* @returns {Object, Array}
*/
_vue2.default.prototype.getUrlParams = function () {
  function getByName(name) {
    var reg = new RegExp('(^|&|\\?)' + name + '=([^&]*)(&|$)', 'i');
    var param = window.location.href.substring(1).match(reg);
    if (param !== null) {
      if (param[2].indexOf('#') !== -1) {

        var reg2 = /([^&]*)#/;
        var param2 = param[2].match(reg2);
        return param2[1];
      }
      return param[2];
    }
    return undefined;
  }

  if (arguments.length === 1) {
    return getByName(arguments[0]) || {};
  }
  var result = {};
  [].concat(Array.prototype.slice.call(arguments)).forEach(function (name) {
    result[name] = getByName(name);
  });
  return result;
};

Date.prototype.Format = function (fmt) {
  //
  if (!this.getDate()) return;

  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

/* eslint-disable no-new */
new _vue2.default({
  router: _router2.default,
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app-box');

/***/ }),

/***/ "NYe3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__("ZLd3");

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'LoadImgList',
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      src1: __webpack_require__("w2ig"), // 装箱的图片
      src2: __webpack_require__("qDaJ"), // 拆箱的图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      isNoData: false
    };
  },
  created: function created() {
    document.title = '装货图片';
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code
      };
      this.isShowLoading = true;

      this.requestApi({
        url: _const.apiUrl.loadImgListController,
        data: data
      }, function (resultData) {
        var list = resultData.data.list || [];
        if (list.length === 0) {

          _this.isNoData = true;
          _this.isShowLoading = false;
          _this.isShowTable = false;
          return;
        }
        _this.tableData = list;
      }, function (error) {
        _this.isShowLoading = false;
        if (error) {
          console.error(error);
        }
      });
    },
    goNextPage: function goNextPage(bookingId, ladingId, servicetype) {

      this.$router.push({
        name: 'LoadImgLading',
        query: {
          bookingId: bookingId,
          ladingId: ladingId,
          servicetype: servicetype
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "Na6W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nf+F":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAARCAMAAAASeod7AAAAXVBMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzQDM+LAAAAHnRSTlMAA+0V9+bRxp2Saj8xurd1WTghqoiBD6h3XU5LJBhdSjlSAAAAdUlEQVQoz53RRw6AMAwEQCcQamiht/3/M2kSCAg+MNfVyolNb1VMLB+Bw+URoHImd7BKDX1KsXIzYevGUZhI7LyCLsKMWeBL3ITNlui8bj0XNkqTVmCUR7/86hfn/Gmwzn+Yb+9n/98Jbn+J4fYv+3/3e99/AQjPEymf/McLAAAAAElFTkSuQmCC"

/***/ }),

/***/ "NobU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NxxP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABLCAMAAAD+m9FVAAAAkFBMVEUAAAD2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCqFzcMjAAAAL3RSTlMApZlDw97Td7sF8+lm7w/8Siohhq0MyKEU99pcCM44NE8vs34l4qqQcWphVhyKbyXohUwAAALfSURBVFjD7ZjZtqowDIYVZSgoMwrihPO4+/5vd0gLlIJUqjdnr7X/Kwldn20S2qSDLt01B1dKZqPBW0XuJVCIAo9aUszLoRTvqYD216yJiBWTjTYpRcMN7cB6YAMXKcfYWNzoPTFaTcgMrPu6ZY4Yw59iThNiHTYhAVhvnClkkB3m3yzpEme82YjAupxzxlvJ8KgnnqODD4oruHvRK12q4MS+n7lns/BLaX3Ck+UNpBSHlFKyx/DgDmQ1rBwFssi0pBWpNO5USf77NJDXBCDj4gF+Dz+AxN9BmB++h2h/kF8HsXWlh36WIgha4V7aiSAb3FOxAPLoyTCRyCdBL4YzEUfnMeqh+LfkyR/kf4a4miNI1FXWB2KbWKhFH8gav9GDh0CVcW7NZCo3kzi05nbLJxtDFWh3GHRKPjrfQ5ZpqCbmIkyXn0PSIy50TD+EoDlfgUpDWIllahrNqOEnkCsMXbkon5JLjperPMSe0jWwlU1taYgOaY4q/0DVqUtDoMTO2GMG9X4bgrY6p5+MW42TO6RuyN3iRC1I2Pr878TOynelDlFyg9eEZLglrd7Q1Aro6sDcNCGeGOLDuGbW+K3lnITLQSbGFqo9W3C2t6MzmnC68a3HiTU4Zf90kg7xFtKr2lQOkHpbGQhLlOO6cPORpIk8xDPBT+F9s7mHDutbJb/ibYJrSrafbUpbpxY6YMhD7IA7D6aBLQ9JW/22lcpBWEc8nRnGrJzSfCkDicb0v4M1Ium6Dui8xlF/CDLI7nqJatiLCTYDEUifblQh26vPG/0VLrcH4I3fMNxy5rwio2zMVcibWOxUGKPZL4IO5YWaO5fQzm/PisTr/BKu5b1KKoIsyquZtva05jjQVFYenYw1OWIEh9Ga7c8Lg9dOR+xyRBHEDbbeh4U7pLPLEVcUuDFM92WdxSIPr+3OVIa1kqwxXkPO1c2CJixnrcJ359kxaSCS0C5mbKmjbshItdx/DToFNM3zzvUAAAAASUVORK5CYII="

/***/ }),

/***/ "O4d1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_vm._l((_vm.groupData),function(item,index){return _c('group',{key:index,attrs:{"gutter":10}},[_c('cell',[_c('h2',{staticClass:"cell-title",attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('img',{staticStyle:{"display":"block","margin-right":"0.16rem"},attrs:{"slot":"icon","width":"5","src":item.iconTitleUrl},slot:"icon"})]),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0,"wrap":"wrap"}},_vm._l((item.contentData),function(subItem,subIndex){return _c('flexbox-item',{key:subIndex,attrs:{"span":1/4}},[_c('div',{staticClass:"flex-demo",on:{"click":function($event){return _vm.goMenu(subItem.menuType, subItem.path)}}},[_c('img',{attrs:{"src":subItem.iconUrl,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"flex-demo-text"},[_vm._v(_vm._s(subItem.label))])])])}),1)],1)}),_vm._v(" "),_c('div',[_c('toast',{attrs:{"type":"warn","time":1000,"is-show-mask":"","position":"middle"},model:{value:(_vm.isToast),callback:function ($$v) {_vm.isToast=$$v},expression:"isToast"}},[_vm._v("抱歉，您没有操作权限！")])],1),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"正在加载..."}})],2)}
var staticRenderFns = []


/***/ }),

/***/ "OAXP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OGWE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

var _util = __webpack_require__("LOkV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "LoadImgUpload",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: __webpack_require__("w2ig"), // 装箱的图片，右上角的icon
            uploadLoadSrc: __webpack_require__("wVEz"), // 装箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: __webpack_require__("ujfB"), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            imgSrc: '', // 一开始为uploadLoadSrc或uploadSealSrc，之后为用户上传的图片
            fileUrl: '', // 上传成功后返回的图片路径
            iconClose: __webpack_require__("VrRN"), // 关闭图标
            isShowLoading: false,
            canUpload: true,
            isUploaded: false, // 是否已经上传成功，true代表已经上传成了
            goBackQuery: {}, // 回退时要带的参数
            uploadUrl: '',
            step: -2,
            inputFiles: [{ imgSrc: null }]
        };
    },
    created: function created() {
        document.title = '装货图片';
        var query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常
        // 出现上述bug的原因：页面的url被拼接了一个问号，变成/?#/这种情况，然后刷新一次页面，再进入这个组件，导致数据丢失，而且用go回退时要两次！
        // 上述Bug后，如果使用go回退，那apiParams里的属性在这里设置也没用，还是初始化为空字符串了，可能要保存在sessionStorage了，
        // 或者后台去将companyId与openId保存在session里
        // =>最新进展：后台保存在session里了
        if (!_const.apiParams.companyId) {
            // 如果apiParams.companyId变回空字符串了，证明页面被刷新了
            console.error('companyId被弄没了');
            _const.apiParams.companyId = query.companyId2;
            _const.apiParams.openId = query.openId2;
            this.step = -2;
        }
        // 判断是装箱的，还是封箱的
        // 可以异步上传图片了，不用麻烦后台重定向了
        // let resultUrl = `#/load-upload-result?companyId=${apiParams.companyId}&openId=${apiParams.openId}&ladingId=${query.ladingId}&id=${query.id}&referenceno=${query.referenceno}&cont_no=${query.contNo}&type=${query.type}`
        if (query.type === 'load') {
            this.imgSrc = this.uploadLoadSrc;

            // this.uploadUrl = `${apiUrl.loadImgUpload}?companyId=${apiParams.companyId}&openId=${apiParams.openId}&ladingId=${query.ladingId}&id=${query.id}&referenceno=${query.referenceno}&cont_no=${query.contNo}&resultUrl=${resultUrl}`
            this.uploadUrl = _const.apiUrl.loadImgUpload;
        } else {
            this.imgSrc = this.uploadSealSrc;
            // this.uploadUrl = `${apiUrl.uploadSealController}?companyId=${apiParams.companyId}&openId=${apiParams.openId}&ladingId=${query.ladingId}&id=${query.id}&referenceno=${query.referenceno}&cont_no=${query.contNo}&resultUrl=${resultUrl}`
            this.uploadUrl = _const.apiUrl.uploadSealController;
        }
    },

    methods: {
        getImg: function getImg(e) {
            var _this = this;

            // 如果用户选择图片时，按了取消/撤销，那e.target.files[0]会变为undefined，此时要阻止后续操作
            if (!e.target.files[0]) return;
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.file = e.target.files[0];
            // 如果图片超过2M，才进行压缩：因为现在限制10M内，但还是尽量别上传太大图片，所以大于2M还是压缩一次吧
            // 新需求：大于512K的，都进行压缩
            if (this.file.size / 1024 > 513) {
                // 压缩图片
                (0, _util.photoCompress)(this.file, {
                    quality: 0.5,
                    minSize: 513
                }, function (base64Img) {
                    _this.$vux.loading.hide();
                    _this.imgSrc = base64Img;
                }, function () {
                    // 图片经过多次压缩，还是太大了，提示用户
                    _this.$vux.loading.hide();
                    _this.showToast('抱歉，图片太大', 2000);
                });
            } else {
                // 小于512K的，直接用，不压缩了
                (0, _util.directTurnIntoBase64)(this.file, function (base64Img) {
                    _this.$vux.loading.hide();
                    _this.imgSrc = base64Img;
                });
            }
        },
        resetImg: function resetImg() {
            // 这个方法是.icon-close的方法，只是删除下已加载的图片
            if (this.type === 'load') {
                this.imgSrc = this.uploadLoadSrc;
            } else {
                this.imgSrc = this.uploadSealSrc;
            }
            // bug:如果resetImg了，在resetImg中没有将input获取到的file清空的话，那用户紧接着又选同一张图片，是无法触发change事件的！
            // 处理上述bug：因此要将其value变为空字符串
            this.$refs.inputFile.value = '';
            this.file = '';
        },
        uploadImg: function uploadImg() {
            var _this2 = this;

            // 如果已经上传成功了，不给继续上传
            if (this.isUploaded) {
                this.showToast('已上传图片了，请返回上一页面继续操作！');
                return;
            }
            // 提交前先验证下有没选择图片了
            if (!this.canUpload) return;
            this.canUpload = false;
            if (this.file) {} else {
                this.showToast('请先选择图片');
                this.canUpload = true;
                return;
            }
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 上传图片：该接口需要'Content-Type': 'multipart/form-data'；因此要将图片文件与其他参数都放进FormData实例中
            var param = {
                base64Img: this.imgSrc, // 现在上传图片的格式为base64的
                companyId: _const.apiParams.companyId,
                openId: _const.apiParams.openId,
                bookingId: this.bookingId,
                ladingId: this.ladingId,
                id: this.id,
                referenceno: this.referenceno,
                cont_no: this.contNo
            };
            var config = { // 如果已经使用FormData对象作为参数了，那不用设置这个请求头了，会自动修改为这个content-type的
                headers: { 'Content-Type': 'multipart/form-data' }
            }; //添加请求头
            var url = this.uploadUrl;
            // this.$http.post(apiUrl.uploadDelive, param, config) // 用已序列化数据的方式会直接报500
            this.requestApi({
                url: url,
                data: param
            }, function (res) {
                //{"code":200,"data":{"fileUrl":"/api/upload/aohy/a4266e1e31f942ba89246656dd3ffce7.png"}}
                var resultData = res.data; // 后台返回结果data数据
                var code = res.code;
                var info = resultData.info; // 412或500的提示语
                if (code === 412) {
                    _this2.showToast(info, 1500, 'warn');
                } else if (code === 500) {
                    _this2.showToast(info, 1500, 'warn');
                } else {
                    _this2.isUploaded = true;
                    _this2.showToast('上传成功！', 2000, 'success', {
                        onHide: function onHide() {
                            _this2.showToast('请返回上一页面继续操作。', 2000);
                        }
                    });
                }
                _this2.canUpload = true;
                _this2.$vux.loading.hide();
            }, function (error) {
                _this2.canUpload = true;
                _this2.$vux.loading.hide();
                // if (error.response) {
                //   // 请求已发出，但服务器响应的状态码不在 2xx 范围内
                //   if (error.response.status === 413) {
                //     this.showToast('图片太大，上传失败！', 2000,'cancel')
                //   } else {
                //     this.showToast('上传失败！', 2000,'cancel')
                //   }
                // } else {
                if (error) {
                    console.error(error);
                    _this2.showToast('上传失败！', 2000, 'cancel');
                }
                // }
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "ONI/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//

exports.default = {
    name: 'MyBtnReturn',
    props: {
        routerName: String,
        query: Object,
        step: Number
        // step: {
        //   type: Number,
        //   default: -1
        // },
    },
    data: function data() {
        return {};
    },

    methods: {
        handleReturn: function handleReturn() {
            // this.$router.push({
            //   name: this.routerName,
            //   query: this.query || {}
            // })

            // 回退按钮要弄成类似浏览器的回退按钮，不然IOS端的微信自带回退按钮会乱
            if (this.step) {
                // history.go(this.step)
                this.$router.go(this.step);
            } else {
                // history.go(-1)
                this.$router.go(-1);
            }
        }
    }
};

/***/ }),

/***/ "OSCf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ViewPicture"}},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_c('div',{staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src2,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-item__first"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(_vm.ladingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.bookingId))])]),_vm._v(" "),_vm._l((_vm.tableData),function(item,index){return [_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.contNo && item.contNo.toUpperCase()))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v("柜型：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.contId && item.contId.toUpperCase()))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn btn-look",class:{'btn-disabled' : item.deliveimgisload == 0},attrs:{"disabled":item.deliveimgisload == 0,"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('DeliveImgLook', item.id, item.referenceno, item.contNo, item.contId, 'delive')}}},[_vm._v("\n                                    查看\n                                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn btn-look",class:{'btn-disabled' : item.openimgisupload == 0},attrs:{"disabled":item.openimgisupload == 0,"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('DeliveImgLook', item.id, item.referenceno, item.contNo, item.contId, 'open')}}},[_vm._v("\n                                    查看\n                                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn btn-look",class:{'btn-disabled' : item.delivedocisupload == 0},attrs:{"disabled":item.delivedocisupload == 0,"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('DeliveImgLook', item.id, item.referenceno, item.contNo, item.contId, 'delivedoc')}}},[_vm._v("\n                                    查看\n                                ")])],1)])])])]})],2),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],1),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货图片：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("开箱图片：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("单证图片：")])])}]


/***/ }),

/***/ "Oe89":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OrxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "P+D6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

exports.default = {
    name: "MyFooter",
    // props: ['tel'],
    props: [],
    data: function data() {
        return {
            tel: ''
        };
    },
    created: function created() {
        this.getKehuTel();
    },

    methods: {
        getKehuTel: function getKehuTel() {
            var _this = this;

            // 获取“联系我们”的号码
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.requestApi({
                url: _const.apiUrl.getKehuTel,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this.tel = dataObj.tel || '';
            });
        },
        handleToast: function handleToast(e) {
            // 如果没有获取到联系方式，要提示用户刷新页面
            if (this.tel) {} else {
                e.preventDefault();
                this.showToast('获取不到联系方式，请刷新页面！', 1500, 'warn');
            }
        }
    }
}; //
//
//
//
//
//

/***/ }),

/***/ "P2Kv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _objectAssign = __webpack_require__("BEQ0");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _xscroll = __webpack_require__("WTNC");

var _xscroll2 = _interopRequireDefault(_xscroll);

var _pulldown = __webpack_require__("ypEt");

var _pulldown2 = _interopRequireDefault(_pulldown);

var _pullup = __webpack_require__("qbvd");

var _pullup2 = _interopRequireDefault(_pullup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//

var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

exports.default = {
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new _xscroll2.default({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = (0, _objectAssign2.default)(pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new _pulldown2.default(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = (0, _objectAssign2.default)(pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new _pullup2.default(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
};


function pure(obj) {
  return JSON.parse((0, _stringify2.default)(obj));
}

/***/ }),

/***/ "P4mZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5Kq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _scroller = __webpack_require__("+geU");

var _scroller2 = _interopRequireDefault(_scroller);

var _flexbox = __webpack_require__("F3HL");

var _chain = __webpack_require__("zDi5");

var _chain2 = _interopRequireDefault(_chain);

var _value2name = __webpack_require__("NE4E");

var _value2name2 = _interopRequireDefault(_value2name);

var _isArray = __webpack_require__("cEdU");

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'picker',
  components: {
    Flexbox: _flexbox.Flexbox,
    FlexboxItem: _flexbox.FlexboxItem
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new _chain2.default(this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return (0, _value2name2.default)(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new _scroller2.default(_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new _scroller2.default(ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if ((0, _stringify2.default)(_this3.getValue()) !== (0, _stringify2.default)(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new _chain2.default(newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "P8n1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintain_vue__ = __webpack_require__("Cwtp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintain_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintain_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintain_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintain_vue__ = __webpack_require__("HBHn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintain_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd1e245_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FeeMaintain_vue__ = __webpack_require__("mqin");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("zxca")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fd1e245"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintain_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd1e245_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FeeMaintain_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd1e245_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FeeMaintain_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Pd9i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var staticRenderFns = []


/***/ }),

/***/ "PqHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLook_vue__ = __webpack_require__("eSwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLook_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLook_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLook_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLook_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLook_vue__ = __webpack_require__("yj1K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLook_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLook_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb7b740e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgLook_vue__ = __webpack_require__("E6Re");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("EfW6")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb7b740e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgLook_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb7b740e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgLook_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb7b740e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgLook_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Q/LH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"LocationUploadList"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":item.otherservice === '拆箱' ? _vm.src2 : _vm.src1,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-binning"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(item.ladingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(item.bookingId))])]),_vm._v(" "),(item.mBlNo)?_c('div',{staticClass:"list-item-row"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.mBlNo))])])]):_vm._e(),_vm._v(" "),(item.preCarriage)?_c('div',{staticClass:"list-item-row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.preCarriage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"consignee-linkman"},[_vm._v(_vm._s(item.consigneeLinkman))]),_vm._v(" "),(item.consigneeMp)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeMp))]):_vm._e(),_vm._v(" "),(item.consigneeMp && item.consigneeTel)?_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e(),_vm._v(" "),(!item.consigneeMp && item.consigneeTel)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[(item.servicetype === '拖车')?_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.loadDate)))]):_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.releasePlanDate)))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.consigneePlace))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(5,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark9))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(6,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.shipCompany))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(7,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.portDelivery))])])]),_vm._v(" "),(item.remark18)?_c('div',{staticClass:"list-item-row"},[_vm._m(8,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark18))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("1pHq"),"alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#333"}},[_vm._v("柜号/封号")])]),_vm._v(" "),_vm._m(9,true)]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v(_vm._s(item.contSealNo || '/'))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.cont))])])])])]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search btn-loading-img",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage(item.bookingId,item.ladingId, item.servicetype)}}},[_vm._v("更新位置")])],1)])}),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],2),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("运单号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("车牌号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货联系人：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货时间：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货地点：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货说明：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船公司：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("目的港：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("备注18：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"cont",staticStyle:{"color":"#333"}},[_vm._v("柜型")])])}]


/***/ }),

/***/ "Q0lW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QHDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ZWmw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("JU7c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6e55c14a_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("cW8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("8LKC")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6e55c14a_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6e55c14a_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QNoK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _big = __webpack_require__("gaXx");

var _big2 = _interopRequireDefault(_big);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new _big2.default(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new _big2.default(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "QQnc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"deliveImgLading"}},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_c('div',{staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src2,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-item__first"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(_vm.ladingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.bookingId))])]),_vm._v(" "),_vm._l((_vm.tableData),function(item,index){return [_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.contNo && item.contNo.toUpperCase()))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v("柜型：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.contId && item.contId.toUpperCase()))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('div',{staticClass:"btn-box"},[(item.deliveimgisload)?_c('x-button',{staticClass:"btn btn-look",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('DeliveImgLook', item.id, item.referenceno, item.contNo, item.contId, 'delive')}}},[_vm._v("查看\n                                ")]):_c('x-button',{staticClass:"btn btn-upload",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('DeliveImgUpload', item.id, item.referenceno, item.contNo, item.contId, 'delive')}}},[_vm._v("上传\n                                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('div',{staticClass:"btn-box"},[(item.openimgisupload)?_c('x-button',{staticClass:"btn btn-look",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('DeliveImgLook', item.id, item.referenceno, item.contNo, item.contId, 'open')}}},[_vm._v("查看\n                                ")]):_c('x-button',{staticClass:"btn btn-upload",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('DeliveImgUpload', item.id, item.referenceno, item.contNo, item.contId, 'open')}}},[_vm._v("上传\n                                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('div',{staticClass:"btn-box"},[(item.delivedocisupload)?_c('x-button',{staticClass:"btn btn-look",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('DeliveImgLook', item.id, item.referenceno, item.contNo, item.contId, 'delivedoc')}}},[_vm._v("查看\n                                ")]):_c('x-button',{staticClass:"btn btn-upload",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('DeliveImgUpload', item.id, item.referenceno, item.contNo, item.contId, 'delivedoc')}}},[_vm._v("上传\n                                ")])],1)])])])]})],2),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],1),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货图片：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("开箱图片：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("单证图片：")])])}]


/***/ }),

/***/ "QSTa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "QWK6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qk6u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MyFooter = __webpack_require__("m+mo");

var _MyFooter2 = _interopRequireDefault(_MyFooter);

var _GoHome = __webpack_require__("ZWVd");

var _GoHome2 = _interopRequireDefault(_GoHome);

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "Business",
    components: {
        MyFooter: _MyFooter2.default,
        MyBtnReturn: _MyBtnReturn2.default,
        GoHome: _GoHome2.default
    },
    data: function data() {
        return {
            datediff: 0,
            dateDiffOptions: [{
                key: '7',
                value: '一周内'
            }, {
                key: '30',
                value: '一个月内'
            }, {
                key: '90',
                value: '三个月内'
            }, {
                key: '180',
                value: '六个月内'
            }, {
                key: '365',
                value: '一年内'
            }],
            cont_no: '',
            m_bl_no: '',
            lading_id: '',
            consignee_id: ''
        };
    },
    created: function created() {
        document.title = '货物跟踪';
    },

    methods: {
        goResultPage: function goResultPage() {
            var route = {
                name: 'BusinessResult',
                query: {
                    cont_no: this.cont_no,
                    m_bl_no: this.m_bl_no,
                    lading_id: this.lading_id,
                    consignee_id: this.consignee_id,
                    datediff: this.datediff
                }
            };
            this.$router.push(route);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "RIvw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABLCAMAAADtTJGhAAAAllBMVEUAAADxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0KXmQMfAAAAMXRSTlMA+QQP8+7SudwaCuB3cDwkWyoHpZJrSBWATOazoDYxH9bFm4xQrOLNvYdmVZfqQmHI4DmvzQAABLpJREFUWMOlWOe6ojAQTehVBUEQsPcu7/9yS4pZSEHcPT/u5yXJcTJz5pgAepHNwrtt+SY0Hs77cJksNfBv0GbJuuZh2MH4d6rl3awVOKXZT1T7Td0H4z48vJnVWujb90sQBvlu+m7FCrfuIKqxzVacg5HXHnL3icOiCwYUI4R09kaemmXyoBOs6AtVVtKgKvVMbWLR4K69XAufTJv2J1i7OXSe15N5A09Zj8A3xDkkudBVM15kQhKDAYiIoi1FVa941NyDYfAqPN+Rsk2IrH7olpAkRVL0EWRRD8YErzkLaXEL3HY6+AlzzLbli33G+88UitltZwCoczPpPgxw7seKKqPBUHzOFhqrTp1xuIpv13D/QEUGDmjQbj/Bm7wAOdwaYyEf1XHT3ADDDZc4VugpJWS5p2gbrCi2WMON+5Tn/q/jGtVIvdGU+SruWZmHhBZ1auq868CVpMFoh3ZC+V0JeZ8fIGmwJGpKtCM2Bsu9YIoXNPCi2pcJD4QFCca+xZR8T72uePE1QKFZ5PMUzeAlFpEuzjsBu8EaR8fHlrBqe4j3LLRqs2b6/KzydPYceYUu++aE6WIiIfNZ8mxY23NKrEvIwBvtHn3YYnkryfSQWrQT6oxMakbL5oOP20FBFiVGzWAkYwXZGA0HAKxYFwtk2syuOdgzKRlA0ZdUsQsZmeHUEvhSsookLUczxLbb1z1Yyp0owyrzheYt616UM95y0dMR2Aj599J1/RXr1BMqMAFrvpfGRT0IRbtpYuIcx+bvTrT1fojOD7E2TOR7nV0eh3H5nX2a2Kqx3LhkDsK8s8jH3WmgyHjrHIADAEJk+O9OsM6vMDnLhTgmR+KMaT8R83yumiHWWck79vsb15vzxxUp7xQpUDi4wn4uyDfUk3RAjsZi8TeiFxepoWUK1/CcPi7Hk7qG0s9mfWQzlZ+Bo9RpwVTNNQUqpwWV/IiTmUqJZUDxG8B+nQRcVWTiVQLrq2C/mzYQsSvYHaqqzvCT/AuQ7zLhf9F59ZzQrogN6qmJvlR6StsRlTHB3eWHxnvr/D22mL2ozxpgLZ6C4tA+TZECorhRT/LeJM14nKEUH04ll+EcN2vbW6uObzT7Y24yxyZiPPGXEHsqPd5kHp8nmkP2zBB9zHarAbCHtAyzhsumAyeXU2TQPdNazAhGJirO/o3viteGy7xem0fwukRc5R5F50edHj96XZ3UeeviA18AeGcaxqOR48L8yF8jNmBG7dP2RLgHPNnRzZhjBZJNFXjZkhxDKxw/Cjfg7gFcQR5EbIvCoWrSQgsety7N8903N6+PDxT+WHVDAdqG3p3UGH53Ai7ehfUftzrxvnn6KbYbXrOJVRE74+FcaU12ox4z5wOpvDu9o6+m51TpYDttCFdkEa4VsJFiYkUO6vXze1g5ZG3lY6XpYhWOVOarYW9cDh5yM9ULjox2MpwOeBcEU/J/hf87SlYEH3+2J7o0V/nHUqxlp39qcyExdHY4hmXYfWOZzXcWu2GEGv/ix5Lq2qoZoHVI8vQaBpetfWw9rlzxlZShaJP+d44wEQq0PCJjVmCxNVVUVijrOX0/AmrE87sjxnQOIvCPcOfB9uwURg1N3yp3r0XcO/0PC6Vv0JQWdEEAAAAASUVORK5CYII="

/***/ }),

/***/ "RJTy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
};

/***/ }),

/***/ "ROt2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyFooter = __webpack_require__("m+mo");

var _MyFooter2 = _interopRequireDefault(_MyFooter);

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Voyage',
    components: {
        MyFooter: _MyFooter2.default,
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            place_loading: null,
            place_loadingOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            place_delivery: null,
            place_deliveryOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            title: [],
            canCall: true, // true代表能继续发送请求，控制search方法的
            startAreaUrl: '', // 查询起运地API，voyageSearch或voyageSearchYeWu
            endAreaUrl: '', // 查询目的地API，changePlace目的地或changePort目的港
            routeName: ''
        };
    },
    created: function created() {
        document.title = '船期查询';
        // this.test()
        // 判断是哪个路由路径，然后获取相应数据
        this.routeName = this.$route.name;
        if (this.routeName === 'VoyageKehu') {
            // 如果是客户应用的
            this.title = ['起始地', '目的地'];
            this.startAreaUrl = _const.apiUrl.voyageSearch;
            this.endAreaUrl = _const.apiUrl.changePlace;
            this.tableDataUrl = _const.apiUrl.voyageTemplate;
        } else {
            // 如果是业务应用的
            this.title = ['起始港', '目的港'];
            this.startAreaUrl = _const.apiUrl.voyageSearchYeWu;
            this.endAreaUrl = _const.apiUrl.changePort;
            this.tableDataUrl = _const.apiUrl.voyageTemplateYw;
        }

        this.searchArea();
    },

    methods: {
        searchArea: function searchArea() {
            var _this = this;

            // 获取起始与目的等地点:如果没获取到，要提示用户重新打开页面吗？
            // 这里获取的目的地应该是总数量，可随用户选
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.requestApi({
                url: this.startAreaUrl,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                // todo:囧，结果后台返回了数组里一个null，[null]，selector组件直接崩溃
                if (_this.routeName === 'VoyageKehu') {
                    _this.place_loadingOps = dataObj.startPlaces || []; // 防止后台返回null
                    _this.place_deliveryOps = dataObj.endPlaces || []; // 防止后台返回null
                } else {
                    _this.place_loadingOps = dataObj.startPorts || []; // 防止后台返回null
                    _this.place_deliveryOps = dataObj.endPorts || []; // 防止后台返回null
                }
            }, function (error) {
                if (error) {
                    console.error(error);
                }
            });
        },
        startChange: function startChange(value) {
            var _this2 = this;

            if (!value) return;
            // 去获取目的地的数据：这是根据起运地获取的，数量应该没startAreaUrl接口的多吧？
            // 加一个loading吧，顺便可以不让用户又去选择另一个起运地
            this.$vux.loading.show({
                text: 'Loading'
            });
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                start: this.place_loading || ''
            };
            this.requestApi({
                url: this.endAreaUrl,
                data: data
            }, function (resultData) {
                _this2.$vux.loading.hide();
                var dataObj = resultData.data;
                // 囧，结果后台返回了数组里一个null，[null]，selector组件直接崩溃
                if (_this2.routeName === 'VoyageKehu') {
                    _this2.place_deliveryOps = dataObj.findEndPlace || []; // 防止后台返回null
                } else {
                    _this2.place_deliveryOps = dataObj.findEndPort || []; // 防止后台返回null
                }
                _this2.place_delivery = null; // 目的地被选中项变为null，不然查询时会记忆回来选择的
            }, function (error) {
                _this2.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            });
        },
        search: function search() {
            this.$router.push({
                name: 'VoyageResult',
                query: {
                    place_loading: this.place_loading || '',
                    place_delivery: this.place_delivery || '',
                    routeName: this.routeName // 传递路由name给结果页面，可以判断是客户还是业务应用
                }
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "S8Wg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0vWR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("P2Kv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_49b594dd_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("dQrX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("MkQx")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_49b594dd_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_49b594dd_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SFNY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-item",class:_vm.classNames,on:{"click":_vm.select}},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "SOtS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__("oWtu");

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'check-icon',
  components: {
    Icon: _icon2.default
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),

/***/ "SSHx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sd/X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"reportContNo"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_c('div',{staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src1,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-item__first"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(_vm.ladingId))])]),_vm._v(" "),_vm._l((_vm.tableData),function(item,index){return [_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.id))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[(!item.isReportContNo)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.contNo),expression:"item.contNo"}],class:{ disabled: _vm.isDisabledList[index] },attrs:{"placeholder":"请输入柜号","disabled":_vm.isDisabledList[index]},domProps:{"value":(item.contNo)},on:{"change":function($event){return _vm.changeToUpperCase('contNo', index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "contNo", $event.target.value)}}}):_c('span',[_vm._v(_vm._s(item.contNo && item.contNo.toUpperCase()))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[(!item.isReportSealNo)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.sealNo),expression:"item.sealNo"}],attrs:{"placeholder":"请输入封条号"},domProps:{"value":(item.sealNo)},on:{"change":function($event){return _vm.changeToUpperCase('sealNo', index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "sealNo", $event.target.value)}}}):_c('span',[_vm._v(_vm._s(item.sealNo && item.sealNo.toUpperCase()))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.shipperW),expression:"item.shipperW"}],attrs:{"placeholder":"请输入货重"},domProps:{"value":(item.shipperW)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "shipperW", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search btn-report",class:{ disabled: _vm.isDisabledList[index] },attrs:{"type":"primary","disabled":_vm.isDisabledList[index]},nativeOn:{"click":function($event){return _vm.btnReportFn(index, item.id)}}},[_vm._v("报柜号/封号\n                    ")])],1)]})],2),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],1),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('confirm',{attrs:{"title":"报柜号/封号"},on:{"on-confirm":_vm.onConfirm},model:{value:(_vm.isShowConfirm),callback:function ($$v) {_vm.isShowConfirm=$$v},expression:"isShowConfirm"}},[_c('ul',{staticClass:"confirm-list"},[_c('li',{staticClass:"confirm-list-item"},[_c('span',{staticClass:"confirm-list-item-left"},[_vm._v("工作单号：")]),_vm._v(" "),_c('b',{staticClass:"confirm-list-item-right"},[_vm._v(_vm._s(_vm.ladingId))])]),_vm._v(" "),_c('li',{staticClass:"confirm-list-item"},[_c('span',{staticClass:"confirm-list-item-left"},[_vm._v("柜号ID：")]),_vm._v(" "),_c('b',{staticClass:"confirm-list-item-right"},[_vm._v(_vm._s(_vm.content.id))])]),_vm._v(" "),_c('li',{staticClass:"confirm-list-item"},[_c('span',{staticClass:"confirm-list-item-left"},[_vm._v("柜号：")]),_vm._v(" "),_c('b',{staticClass:"confirm-list-item-right"},[_vm._v(_vm._s(_vm.content.contNo))])]),_vm._v(" "),_c('li',{staticClass:"confirm-list-item"},[_c('span',{staticClass:"confirm-list-item-left"},[_vm._v("封条号：")]),_vm._v(" "),_c('b',{staticClass:"confirm-list-item-right"},[_vm._v(_vm._s(_vm.content.sealNo))])]),_vm._v(" "),_c('li',{staticClass:"confirm-list-item"},[_c('span',{staticClass:"confirm-list-item-left"},[_vm._v("货重：")]),_vm._v(" "),_c('b',{staticClass:"confirm-list-item-right"},[_vm._v(_vm._s(_vm.content.shipperW))])])])]),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("柜号ID：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("封条号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("货重：")])])}]


/***/ }),

/***/ "Sf51":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TCOM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__("0FxO");

exports.default = {
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && (0, _router.go)(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "TNdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyBtnReturn_vue__ = __webpack_require__("slyI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyBtnReturn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyBtnReturn_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyBtnReturn_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyBtnReturn_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyBtnReturn_vue__ = __webpack_require__("ONI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyBtnReturn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyBtnReturn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07bbb7d3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_MyBtnReturn_vue__ = __webpack_require__("AlWE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("9xmH")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07bbb7d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyBtnReturn_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07bbb7d3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_MyBtnReturn_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07bbb7d3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_MyBtnReturn_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TW3/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TZ+T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = __webpack_require__("f6Hi");

var _base2 = _interopRequireDefault(_base);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _autosize = __webpack_require__("JnrT");

var _autosize2 = _interopRequireDefault(_autosize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// prop.autosize

exports.default = {
  name: 'x-textarea',
  minxins: [_base2.default],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: _inlineDesc2.default
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      _autosize2.default.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      (0, _autosize2.default)(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      _autosize2.default.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "TbnC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TcVl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPicture_vue__ = __webpack_require__("jOOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPicture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPicture_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPicture_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPicture_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPicture_vue__ = __webpack_require__("8tGI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPicture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPicture_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b847319a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ViewPicture_vue__ = __webpack_require__("OSCf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Z06H")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b847319a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ViewPicture_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b847319a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ViewPicture_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b847319a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ViewPicture_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TfX0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'VehicletrackingResult',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            tableData: [],
            // newData: [
            //   {
            //     c_drive_num_hk: '090',
            //     truck_no: '粤Ajk232',
            //     truck_company: '远集拖车',
            //     c_phone: '13515646848',
            //     zxhdz: '',
            //     time: '0',
            //     truck_status: 0,
            //     c_truck_tracing_status: 0, // 车辆状态
            //     // isShowBtn: false, // 这个不是后台传的，而是前端添加
            //   },
            // ],// 假数据，后续要注释
            tracingStatusList: [{
                key: 0,
                value: '营运'
            }, {
                key: 1,
                value: '待安排'
            }, {
                key: 2,
                value: '维修'
            }, {
                key: 3,
                value: '交通事故'
            }, {
                key: 4,
                value: '违章'
            }],
            isShowTable: true,
            isShowLoading: false,
            originSelectedStatus: [],
            canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
            canUpdate: true, // true代表能继续发送请求，控制updateState方法的
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false, // false代表有数据
            url: _const.apiUrl.vehicleTemplate,
            updateUrl: _const.apiUrl.updateVehicle
        };
    },
    created: function created() {
        document.title = '车辆跟踪';
        this.onScrollBottom();
    },

    methods: {
        getMoreData: function getMoreData(url, data) {
            var _this = this;

            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle',
                    type: 'text'
                });
                return;
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data.page;
                var resultArr = dataObj.result || []; // 防止后台返回null
                if (_this.pageNo === 1 && resultArr.length === 0) {
                    // 如果根本没有数据
                    _this.isShowTable = false;
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    return;
                }
                resultArr.forEach(function (item) {
                    // 为了控制保存按钮，要先给返回的数据添加一个属性isShowBtn
                    item.isShowBtn = false;
                    _this.tableData.push(item);
                    // 为了让selector的value恢复到初始值，要先保存刚请求回来的
                    _this.originSelectedStatus.push(item.c_truck_tracing_status);
                }); // 表格数据是放在result中
                _this.totalCount = dataObj.totalCount;
                _this.totalPages = dataObj.totalPages;
                _this.pageNo++;
                _this.$nextTick(function () {
                    _this.$refs.scrollerBottom.reset();
                }); // 要重置scroller组件
            }, function (error) {
                _this.isShowLoading = false;
                _this.canFetch = true;
                if (error) {
                    console.error(error);
                }
            });
        },
        onScrollBottom: function onScrollBottom() {
            this.isShowLoading = true;
            var query = this.$route.query;
            var data = {
                begin: query.loadDate,
                end: query.unloadingDate,
                truck_no: query.truck_no,
                is_self: query.is_self,
                pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                pageNo: this.pageNo, // 当前为第几页数据，要累加
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            if (!this.canFetch) {} else {
                this.canFetch = false;
                this.getMoreData(this.url, data);
            }
        },
        changeNative: function changeNative(e, index) {
            // 不用vux的on-change，使用原生的change事件就不会首次渲染触发，而且后台可能会传默认选项，因此也无法判断用户有没选择；
            // 不过原生的change事件中无法正常获取到v-model绑定的值，因此只能使用e.target.value获取了
            // 现在要控制对应的保存按钮，两种方式：
            // 1、为tableData加一个控制按钮属性，每次修改都找到对应数据，修改这个控制的属性；
            // 2、直接获取到该按钮的dom，然后控制显示状态
            this.tableData[index].isShowBtn = true;
        },
        updateState: function updateState(index) {
            var _this2 = this;

            // 点击保存按钮后，调用接口保存，参数有：c_drive_num_hk、truck_no、被选中的c_truck_tracing_status
            var data = {
                c_drive_num_hk: this.tableData[index].c_drive_num_hk,
                truck_no: this.tableData[index].truck_no,
                state: this.tableData[index].c_truck_tracing_status,
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            // 调用接口进行修改
            this.canUpdate = false;
            this.requestApi({
                url: this.updateUrl,
                data: data
            }, function (resultData) {
                // 没看懂后台会返回什么，先当做到这一步就是更新成功吧
                // 接口调用成功后，要隐藏按钮，还可以给个成功toast
                _this2.$vux.toast.show({
                    text: '更新成功',
                    type: 'success'
                });
                _this2.tableData[index].isShowBtn = false;
                // this.$set(this.tableData[index],'isShowBtn',false)
                // 保存成功的话，要重置下originSelectedStatus里的数据
                _this2.originSelectedStatus[index] = _this2.tableData[index].c_truck_tracing_status;
            }, function (error) {
                _this2.canUpdate = true;
                console.error(error);
            });
        },
        handleCancel: function handleCancel(index) {
            // 点击取消按钮后，要重置selector的默认值
            this.tableData[index].c_truck_tracing_status = this.originSelectedStatus[index];
            this.tableData[index].isShowBtn = false; // 隐藏按钮
        }
    }
};

/***/ }),

/***/ "TmiF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tqs5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _popup = __webpack_require__("+v63");

var _popup2 = _interopRequireDefault(_popup);

var _dom = __webpack_require__("te2A");

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new _popup2.default({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && (0, _keys2.default)(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && _dom2.default.removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && _dom2.default.addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
};

/***/ }),

/***/ "TyqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loadImgList"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src1,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-binning"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(item.ladingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(item.bookingId))])]),_vm._v(" "),(item.mBlNo)?_c('div',{staticClass:"list-item-row"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.mBlNo))])])]):_vm._e(),_vm._v(" "),(item.preCarriage)?_c('div',{staticClass:"list-item-row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.preCarriage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"consignee-linkman"},[_vm._v(_vm._s(item.companyLxr))]),_vm._v(" "),(item.shipperMp)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.shipperMp)+" ")]):_vm._e(),_vm._v(" "),(item.shipperMp && item.shipperTel)?_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.shipperTel))]):_vm._e(),_vm._v(" "),(!item.shipperMp && item.shipperTel)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.shipperTel))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.loadDate)))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.jhr))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(5,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark3))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(6,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.shipCompany))])])]),_vm._v(" "),(item.vessel && item.voyage)?_c('div',{staticClass:"list-item-row"},[_vm._m(7,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.vessel)+_vm._s(item.vessel && item.voyage ? ' / ' : '')+_vm._s(item.voyage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(8,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.portLoading))])])]),_vm._v(" "),(item.remark18)?_c('div',{staticClass:"list-item-row"},[_vm._m(9,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark18))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("1pHq"),"alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#333"}},[_vm._v("柜号/封号")])]),_vm._v(" "),_vm._m(10,true)]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v(_vm._s(item.contSealNo))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.cont))])])])])]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search btn-loading-img",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage(item.bookingId,item.ladingId, item.servicetype)}}},[_vm._v("上传/查看图片\n                ")])],1)])}),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],2),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("运单号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("车牌号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货联系人：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货时间：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货地点：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货说明：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船公司：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船名/航次：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("起运港：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("备注18：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"cont",staticStyle:{"color":"#333"}},[_vm._v("柜型")])])}]


/***/ }),

/***/ "U36D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _router = __webpack_require__("0FxO");

var _props = __webpack_require__("2IIR");

var _props2 = _interopRequireDefault(_props);

var _cleanStyle = __webpack_require__("wmxo");

var _cleanStyle2 = _interopRequireDefault(_cleanStyle);

var _getParentProp = __webpack_require__("vLYD");

var _getParentProp2 = _interopRequireDefault(_getParentProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'cell',
  components: {
    InlineDesc: _inlineDesc2.default
  },
  props: (0, _props2.default)(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return (0, _cleanStyle2.default)({
        width: (0, _getParentProp2.default)(this, 'labelWidth'),
        textAlign: (0, _getParentProp2.default)(this, 'labelAlign'),
        marginRight: (0, _getParentProp2.default)(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && (0, _router.go)(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "UBv9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UMYo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "GoHome",
    data: function data() {
        return {};
    },

    methods: {
        handleGoHome: function handleGoHome() {
            this.$router.push({
                name: 'Home'
            });
        }
    }
};

/***/ }),

/***/ "UNGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("CMqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("d6cP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_0f2db92d_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("HH+o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("+YWw")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_0f2db92d_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_0f2db92d_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UbqI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicletracking_vue__ = __webpack_require__("0TpV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicletracking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicletracking_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicletracking_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicletracking_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicletracking_vue__ = __webpack_require__("6liP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicletracking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicletracking_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa23f04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Vehicletracking_vue__ = __webpack_require__("IUs4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("vQGC")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fa23f04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicletracking_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa23f04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Vehicletracking_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa23f04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Vehicletracking_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Uc0O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"freightPrice"}},[_c('group',{attrs:{"gutter":10}},[_c('selector',{ref:"placeLoadingSelector",attrs:{"title":"起运地","options":_vm.place_loadingOps,"direction":"rtl","placeholder":"请选择起运地"},on:{"on-change":_vm.startChange},model:{value:(_vm.place_loading),callback:function ($$v) {_vm.place_loading=$$v},expression:"place_loading"}}),_vm._v(" "),_c('selector',{ref:"placeDeliverySelector",attrs:{"title":"目的地","options":_vm.place_deliveryOps,"direction":"rtl","placeholder":"请选择目的地"},on:{"on-change":_vm.targetChange},model:{value:(_vm.place_delivery),callback:function ($$v) {_vm.place_delivery=$$v},expression:"place_delivery"}})],1),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goResultPage($event)}}},[_vm._v("查询")])],1),_vm._v(" "),_c('MyFooter',{staticStyle:{"margin-top":"0.2rem"}}),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "Uelq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{attrs:{"title":_vm.title,"value":_vm.currentValue,"is-link":!_vm.readonly,"value-align":_vm.valueAlign,"border-intent":_vm.borderIntent},nativeOn:{"click":function($event){return _vm.show($event)}}},[(!_vm.displayValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.displayValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayValue))]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticStyle:{"background-color":"#fff"},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_vm._t("popup-header",null,{"options":_vm.options,"value":_vm.currentValue}),_vm._v(" "),_c('radio',{attrs:{"options":_vm.options,"fill-mode":false},on:{"on-change":_vm.onValueChange},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(props.icon),expression:"props.icon"}],staticClass:"vux-radio-icon",attrs:{"src":props.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label"},[_vm._v(_vm._s(props.label))])])],{"icon":props.icon,"label":props.label,"index":props.index})]}}],null,true),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],2)],1)])}
var staticRenderFns = []


/***/ }),

/***/ "Uexn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []


/***/ }),

/***/ "Uq6G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-loadmore weui-loadmore",class:{'weui-loadmore_line':!_vm.showLoading, 'weui-loadmore_dot': !_vm.showLoading && !_vm.tip}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tip || !_vm.showLoading),expression:"tip || !showLoading"}],staticClass:"weui-loadmore__tips"},[_vm._v(_vm._s(_vm.tip))])])}
var staticRenderFns = []


/***/ }),

/***/ "V3cc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABLCAMAAAAcR8osAAAAnFBMVEUAAAAOmf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf8Omf/Ia0SjAAAAM3RSTlMApZlD3sN3+2YVu9IwXhEZsdTKlPXPCurn5KmIDj8GNCLbjStLrTmicO+3hHtUJR1/bQzSs+IHAAAC80lEQVRYw+2XaXeqMBCGUxcglk3ZRVABrVVrl/z//3Y7CcYECg09Pffc29P3i8mIj5OZySSgLj3d64TLX4zRZwqrw2lElZbMYhFZekbNZQoPeS+G2SBgzxf+kkHmpKEjWC+3B7eWiFjHRNQLNUZNxgKsZ9HykHPE5pFIMqj1ock4tVe444wjkeQyOl7I5lkI1lxGX5dTsigU2WUDwpxdHTSuQ8Zjt9mUVVG7vq2NKUyiEg0SdhmkzvgUxhUaqjvKSNkkpj4NVjihwWMTqMYlGi4DGFM2huEdGi78DQwUfQNj/g2M+1/G32GsziMVHfJuRh4QNR27GWuiKtzJeFZF+Hl3PE5qCN3oy4szVlCG/4f6+GX8m4xq3ledC1OBsfJJr7YKjD35RI7MgGuE1/TjcZgfeBc/rJrxWM8mPXIvqFPqeflhjHE6jXXiJ7NT9jXGSkvITRMtHM6wIiIrtgYywiVpa/mmzuBXXt01TDvHpuHqdL7A6oyQInTP4RbH0ynkrcF40iQdbjt1SaO4lrj7CV2OzHBb+/0JCS8zAUZOYdQWo3Dq9VkiwyQtzeukRuAFRmhHyIhaRvSlAYMn0UpglJ0MDXxa1xfsESDq3+whJmdxLcuutSTXToHnFDICPEY1LJFimhmyyrrAAecgDplzBHLAkbFCblN2ueeQGsHzkCowpvwFLbOs1wTcf7WsjN/8pwoMeDsx2Q9EGddkxgoMWLMNg0JiFGCyIVYKDHgipxF0gyCgEX3/dGmUc/hS3Y9admumD4kHckzTzN5n2fung3g8huSl0sUCrHhehtSHR0R5ivUh16m5FY89U67TZS+D75d2TD22X3y6oh7xfdtmrMENDSHoAb7dh+D9Q2YI/WPGaq5PvI9RBSSoEcG1j50JG/VI7qfhPmQLufXTS52p56/1dcbbXZM1+0hHrX2+2M3zBT1HpFdazzkX8oOi/xI17TpvIzGIm1kfw/v43E+0FZK0LxaJ/yHB39mt+4ceT9OxYP0D/KY9upNomxoAAAAASUVORK5CYII="

/***/ }),

/***/ "V7l1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V8Pl":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAWBAMAAAD6A0vjAAAAGFBMVEVXs3BXs3BXs3BXs3BXs3BXs3BXs3BXs3C7ELBBAAAAB3RSTlO79B6/uvMfGYQZbwAAAB9JREFUCNdjUAlRYGAvN2AQLy9gKKcMg8wAm6UgkAAAiZQaYThFypwAAAAASUVORK5CYII="

/***/ }),

/***/ "VIaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgUpload_vue__ = __webpack_require__("X4+V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgUpload_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgUpload_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgUpload_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgUpload_vue__ = __webpack_require__("CzA5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_544bc0de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgUpload_vue__ = __webpack_require__("DY9B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("z9ug")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-544bc0de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgUpload_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_544bc0de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgUpload_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_544bc0de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgUpload_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VQkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"plan"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":item.otherservice === '拆箱' ? _vm.src2 : _vm.src1,"alt":""}})]),_vm._v(" "),(item.otherservice === '拆箱')?_c('div',{staticClass:"list-devanning"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(item.ladingId))])]),_vm._v(" "),(item.mBlNo)?_c('div',{staticClass:"list-item-row"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.mBlNo))])])]):_vm._e(),_vm._v(" "),(item.preCarriage)?_c('div',{staticClass:"list-item-row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.preCarriage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"consignee-linkman"},[_vm._v(_vm._s(item.consigneeLinkman))]),_vm._v(" "),(item.consigneeMp)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeMp)+" ")]):_vm._e(),_vm._v(" "),(item.consigneeMp && item.consigneeTel)?_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e(),_vm._v(" "),(!item.consigneeMp && item.consigneeTel)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[(item.servicetype === '拖车')?_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.loadDate)))]):_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.releasePlanDate)))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.consigneePlace))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(5,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark9))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(6,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.shipCompany))])])]),_vm._v(" "),(item.vessel && item.voyage)?_c('div',{staticClass:"list-item-row"},[_vm._m(7,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.vessel)+_vm._s(item.vessel && item.voyage ? ' / ' : '')+_vm._s(item.voyage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(8,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.portDelivery))])])]),_vm._v(" "),(item.remark18)?_c('div',{staticClass:"list-item-row"},[_vm._m(9,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark18))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("1pHq"),"alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#333"}},[_vm._v("柜号/封号")])]),_vm._v(" "),_vm._m(10,true)]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v(_vm._s(item.contSealNo))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.cont))])])])])]):_vm._e(),_vm._v(" "),(item.otherservice !== '拆箱')?_c('div',{staticClass:"list-binning"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(item.ladingId))])]),_vm._v(" "),(item.mBlNo)?_c('div',{staticClass:"list-item-row"},[_vm._m(11,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.mBlNo))])])]):_vm._e(),_vm._v(" "),(item.preCarriage)?_c('div',{staticClass:"list-item-row"},[_vm._m(12,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.preCarriage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(13,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"consignee-linkman"},[_vm._v(_vm._s(item.companyLxr))]),_vm._v(" "),(item.shipperMp)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.shipperMp)+" ")]):_vm._e(),_vm._v(" "),(item.shipperMp && item.shipperTel)?_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.shipperTel))]):_vm._e(),_vm._v(" "),(!item.shipperMp && item.shipperTel)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.shipperTel))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(14,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.loadDate)))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(15,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.jhr))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(16,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark3))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(17,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.shipCompany))])])]),_vm._v(" "),(item.vessel && item.voyage)?_c('div',{staticClass:"list-item-row"},[_vm._m(18,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.vessel)+_vm._s(item.vessel && item.voyage ? ' / ' : '')+_vm._s(item.voyage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(19,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.portLoading))])])]),_vm._v(" "),(item.remark18)?_c('div',{staticClass:"list-item-row"},[_vm._m(20,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark18))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("1pHq"),"alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#333"}},[_vm._v("柜号/封号")])]),_vm._v(" "),_vm._m(21,true)]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v(_vm._s(item.contSealNo))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.cont))])])])])]):_vm._e()])}),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],2),_vm._v(" "),(_vm.isNoData)?_c('div',{staticClass:"no-data"},[_c('divider',[_vm._v(_vm._s(_vm.noDataText))])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("运单号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("车牌号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货联系人：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货时间：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货地点：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货说明：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船公司：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船名/航次：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("目的港：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("备注18：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"cont",staticStyle:{"color":"#333"}},[_vm._v("柜型")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("运单号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("车牌号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货联系人：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货时间：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货地点：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装货说明：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船公司：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船名/航次：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("起运港：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("备注18：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"cont",staticStyle:{"color":"#333"}},[_vm._v("柜型")])])}]


/***/ }),

/***/ "Vike":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VrRN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAh1BMVEUAAAD/////////////////////////////////////////////////////////////////////////////////////////////////////////ZQD/////chT/5NP/aAX/fir/4s//nl7/9/L/8Ob/6dr/1br/z6//j0X/hjb/eyT/xqD/xqHKkrsGAAAAG3RSTlMA8/kZFI/22s/Md2dYBO6VcU63KSVwULi2BpMNNjg9AAAB3ElEQVRIx6VW2ZaCMAwNS0ER13GdFEHcl///viFBKRpReuY+FOi5t2nTLICAH6tJOHDdQThRsQ9f4I+6+gnd0SeNpxwtEPx6DfR+xHQJJ+q/4087mrG75eckxTQ557fdXdL5kfxxufzxhHWcjncj81d+z6X5Q4avyA6scHsvfJrc5vgO+ZYlT4oxrb+/4Htc9mxjbPg/tP9Ngk1INnyO6uT9Dq1P/EYF2+g8vBvR/i/4CRc+RwQMjzaU42fkvKnyzofkT/wG9u6Q4y0o3ir/p1lKD/mVcVxRJM7ofivGpu6tpPiqFHznMwCgeD7V11knD/66bvvE0Q7gU7yhscAKwzcWkCPRg7gYr9UksVhh3ipcSRCDYp8KheSXnlUwKcYzCkUm+HgmwRLCYkxQKLTgY0JzIdA1pygUko8pXzbQKJKGBSKZeBa0nQUXHLszDCC081IIE7t7WIKyu2kFsV0sxeBpm2jVHkDXJh+6nEDtM06POEXb53Tgl0WgbdXQQ1NmWtUlxzOFrE3l05EplW1qqymVMHX09+qtnWm93H/vD+5YNJTGDsToiZbV1ONky2LMHz13d6266JXjzTRF2XYlTNuVWEXBe3oQrax+HYbe/35OpJlYLcrfn4WK5eJ/UnHCuEJKueoAAAAASUVORK5CYII="

/***/ }),

/***/ "Vzho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.listData),function(item,key){return _c('div',{key:key,staticClass:"item"},[_c('div',{},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("工作单号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ladingId || '/'))])]),_vm._v(" "),_c('div',{},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("运单号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.mblNo || '/'))])]),_vm._v(" "),_c('div',{},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("柜号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.contNo || '/'))])]),_vm._v(" "),_c('div',{},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("封号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.sealNo || '/'))])]),_vm._v(" "),_c('div',{},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("柜型：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.contId || '/'))])]),_vm._v(" "),_c('div',{},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("货名：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.goods || '/'))])]),_vm._v(" "),_c('div',{},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("提柜码头：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.carryPort || '/'))])]),_vm._v(" "),_c('div',{},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("船到日期：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.firstEta || '/'))])]),_vm._v(" "),_c('div',{},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("免滞日期：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.remark2 || '/'))])]),_vm._v(" "),_c('div',{},[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("滞期天数：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.demurrageDays || '0'))])])])}),_vm._v(" "),_c('MyBtnReturn')],2)}
var staticRenderFns = []


/***/ }),

/***/ "W9EI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

exports.default = MapLoader;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 异步加载高德地图
function MapLoader() {
    return new _promise2.default(function (resolve, reject) {
        if (window.AMap) {
            resolve(window.AMap);
        } else {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = 'https://webapi.amap.com/maps?v=1.3&callback=initAMap&key=55ce8518a39bacd9d41bb37da7e4e129';
            script.onerror = reject;
            document.head.appendChild(script);
        }
        window.initAMap = function () {
            resolve(window.AMap);
        };
    });
}

/***/ }),

/***/ "WZtS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("p6lR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("qiCt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_72e1168a_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("s7BY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("wBau")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_72e1168a_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_72e1168a_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "X2rc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _asyncLoadJs = __webpack_require__("W9EI");

var _asyncLoadJs2 = _interopRequireDefault(_asyncLoadJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'amapLocation',
    data: function data() {
        return {
            map: null,
            edit: false, // 是否可编辑
            placeSearch: null,
            poiList: [],
            selectIndex: -1, // 选中位置
            show: false,
            currLocation: null
        };
    },

    watch: {
        selectIndex: function selectIndex(newValue, oldValue) {
            if (newValue != oldValue && newValue != -1 && this.poiList.length > newValue) {
                var poi = this.poiList[newValue];
                this.map.setCenter([poi.location.lng, poi.location.lat]);

                this.map.clearMap();
                var marker = new AMap.Marker({
                    position: new AMap.LngLat(poi.location.lng, poi.location.lat)
                });
                this.map.add(marker);
            }
        },
        show: function show(newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                if (this.selectIndex != -1 && this.poiList.length > this.selectIndex) {
                    var poi = this.poiList[this.selectIndex];
                    this.map.setCenter([poi.location.lng, poi.location.lat]);

                    if (this.map.getZoom() < 10) {
                        this.map.setZoom(16);
                    }
                }
            }
        }
    },
    props: {
        value: {
            type: Object,
            default: null
        }
    },
    methods: {
        /**
         * 加载地图
         */
        loadMap: function loadMap() {
            var that = this;
            (0, _asyncLoadJs2.default)().then(function (AMap) {
                that.map = new AMap.Map('amapContainer', {
                    zoom: 17,
                    resizeEnable: true
                });
                that.getLocation();
                that.initAutocomplete();
                that.initPlaceSearch();
            }, function (e) {
                console.error('地图加载失败', e);
            });
        },

        /**
         * 获取去当前位置
         */
        getLocation: function getLocation() {
            var that = this;
            this.map.plugin('AMap.Geolocation', function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 10000, //超过10秒后停止定位，默认：无穷大
                    maximumAge: 0, //定位结果缓存0毫秒，默认：0
                    convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                    showButton: true, //显示定位按钮，默认：true
                    buttonPosition: 'RB', //定位按钮停靠位置，默认：'LB'，左下角
                    buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
                    showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
                    panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
                    zoomToAccuracy: true //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                });

                that.map.addControl(geolocation);
                geolocation.getCurrentPosition();
                AMap.event.addListener(geolocation, 'complete', onComplete);
                AMap.event.addListener(geolocation, 'error', onError);

                function onComplete(data) {
                    // data是具体的定位信息
                    that.edit = true;
                    that.selectIndex = -1;
                    that.placeSearch.search(data.formattedAddress);
                }

                function onError(data) {
                    // 定位出错
                    console.error(data);
                }
            });
        },

        /**
         * 初始化自动匹配输入
         */
        initAutocomplete: function initAutocomplete() {
            var that = this;
            AMap.plugin('AMap.Autocomplete', function () {

                // 实例化Autocomplete
                var autoComplete = new AMap.Autocomplete({
                    city: '全国',
                    input: 'Autocomplete'
                });

                AMap.event.addListener(autoComplete, 'complete', onComplete);
                AMap.event.addListener(autoComplete, 'error', onError);
                AMap.event.addListener(autoComplete, 'select', onSelect);

                function onComplete(data) {}

                function onError(data) {}

                function onSelect(data) {
                    // 选择输入
                    that.selectIndex = -1;
                    that.placeSearch.search(data.poi.name);
                }
            });
        },

        /**
         * 初始化搜索服务
         */
        initPlaceSearch: function initPlaceSearch() {
            var that = this;
            AMap.plugin('AMap.PlaceSearch', function () {

                that.placeSearch = new AMap.PlaceSearch({
                    pageSize: 30,
                    renderStyle: 'default',
                    extensions: 'all'
                });

                AMap.event.addListener(that.placeSearch, 'complete', onComplete);
                AMap.event.addListener(that.placeSearch, 'error', onError);

                function onComplete(data) {
                    that.selectIndex = 0;
                    that.poiList = data.poiList.pois;

                    if (!that.value || !that.value.address) {
                        // 第一次获取到位置，回传回去，能减少打开页面频率
                        var poi = that.poiList[that.selectIndex];
                        var address = {
                            address: (poi.pname || '') + (poi.cityname || '') + (poi.adname || '') + (poi.address || '') + (poi.name || ''),
                            lng: poi.location.lng,
                            lat: poi.location.lat
                        };
                        that.$emit('input', address);
                    }
                }

                function onError(err) {
                    console.error(err);
                }
            });
        },

        /**
         * 确定选择
         */
        enter: function enter() {
            var poi = this.poiList[this.selectIndex];
            var address = {
                address: (poi.pname || '') + (poi.cityname || '') + (poi.adname || '') + (poi.address || '') + (poi.name || ''),
                lng: poi.location.lng,
                lat: poi.location.lat
            };
            this.$emit('input', address);
            this.show = false;
        }
    },
    created: function created() {
        this.loadMap();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "X4+V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

var _util = __webpack_require__("LOkV");

var _uploadImg = __webpack_require__("vwcn");

var _uploadImg2 = _interopRequireDefault(_uploadImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'DeliveImgUpload',
    components: {
        MyBtnReturn: _MyBtnReturn2.default,
        uploadImg: _uploadImg2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src2: __webpack_require__("fy9M"), // 送货的icon图片
            uploadOpenSrc: __webpack_require__("itOs"), // 开箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: __webpack_require__("ujfB"), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadDelivedocSrc: __webpack_require__("CPjU"), // 送货单证图片，上传图片的那个图标，如果用户上传了，就替代下
            imgSrc: '', // 一开始为uploadLoadSrc或uploadSealSrc，之后为用户上传的图片
            // base64Img: '', // 用户上传的图片转换为base64；废弃吧，直接用imgSrc也一样
            //iconClose: require('@/assets/images/wx_sc_oringe.png'), // 关闭图标
            iconClose2: __webpack_require__("VrRN"), // 关闭图标
            isShowLoading: false,
            canUpload: true,
            isUploaded: false, // 是否已经上传成功，true代表已经上传成了
            goBackQuery: {}, // 回退时要带的参数
            uploadUrl: '',
            file: '', // 保存e.target.files[0]
            fileUrl: '', // 上传成功后返回的图片路径
            fileUrl2: '', // 上传成功后返回的图片路径
            step: -1,
            inputFiles: []
        };
    },
    created: function created() {
        document.title = '送货图片';
        var query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype || '';
        this.id = query.id;
        this.referenceno = query.referenceno || '';
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常，原因：页面先被刷新一次，再进入该组件，导致数据丢失，而且用go回退时要两次！
        if (!_const.apiParams.companyId) {
            // 如果apiParams.companyId变回空字符串了，证明页面被刷新了
            _const.apiParams.companyId = query.companyId2;
            _const.apiParams.openId = query.openId2;
            this.step = -2;
        }
        // 判断是开箱的，还是封箱的
        if (query.type === 'delive') {
            var imgSrc = {
                imgSrc: this.uploadSealSrc, //封箱图片
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(imgSrc);
            this.uploadUrl = _const.apiUrl.uploadDelive;
        } else if (query.type === 'open') {
            //this.imgSrc = this.uploadOpenSrc

            var _imgSrc = {
                imgSrc: this.uploadOpenSrc, //开箱图片
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(_imgSrc);
            this.uploadUrl = _const.apiUrl.uploadOpenController;
        } else {

            var _imgSrc2 = {
                imgSrc: this.uploadDelivedocSrc, //送货单证图片
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(_imgSrc2);
            this.uploadUrl = _const.apiUrl.uploadDelivedoc;
        }
    },

    methods: {
        uploadImg: function uploadImg() {
            var _this = this;

            // 如果已经上传成功了，不给继续上传
            //一次可以传多张，但只能传一次
            if (this.isUploaded) {
                this.showToast('已上传图片了，请返回上一页面继续操作！');
                return;
            }
            var imgs = [];
            var loadComplete = true;
            this.inputFiles.forEach(function (item, index) {
                if (item.flag === '1') {
                    if (item.progress === 100) {
                        imgs.push({ img: item.imgSrc });
                    } else {
                        loadComplete = false;
                    }
                }
            });
            if (!loadComplete) {
                this.showToast('请等待照片上传完成！');
                return;
            }
            if (imgs.length === 0) {
                this.showToast('请选择照片再上传！');
                return;
            }

            this.$vux.loading.show({
                text: 'Loading'
            });
            var param = {
                base64Imgs: (0, _stringify2.default)(imgs), //多张图片
                companyId: _const.apiParams.companyId,
                openId: _const.apiParams.openId,
                bookingId: this.bookingId,
                ladingId: this.ladingId,
                id: this.id,
                referenceno: this.referenceno,
                cont_no: this.contNo
            };
            var url = this.uploadUrl;
            this.requestApi({
                url: url,
                data: param
            }, function (res) {
                //let resultData = res.data // 后台返回结果
                var code = res.code;
                var info = res.data.info;

                if (code === 412) {
                    //let info = resultData.info // 412或500的提示语
                    _this.showToast(info, 1500, 'warn');
                } else if (code === 500) {
                    //let info = resultData.info // 412或500的提示语
                    _this.showToast(info, 1500, 'warn');
                } else {
                    _this.isUploaded = true; //上传后改标识
                    if (info === "上传成功") {
                        var mes = "上传成功" + res.data.num.toString() + "张图片";
                        _this.showToast(mes, 2000, 'success', {
                            onHide: function onHide() {
                                _this.showToast('请返回上一页面继续操作。', 2000);
                            }
                        });
                    } else {

                        if (res.data.num > 0) {

                            var _mes = "只上传成功" + res.data.num.toString() + "张(受总共最多上传30张的限制)";
                            _this.showToast(_mes, 5000, 'success', {
                                onHide: function onHide() {
                                    _this.showToast('请返回上一页面继续操作。', 2000);
                                }
                            });
                        } else {
                            _this.showToast(info, 1500, 'warn');
                        }
                    }
                }
                _this.canUpload = true;
                _this.$vux.loading.hide();
            }, function (error) {
                _this.canUpload = true;
                _this.$vux.loading.hide();
                if (error) {
                    console.error(error);
                    _this.showToast('上传失败！', 2000, 'cancel');
                }
            });
        }
    }
};

/***/ }),

/***/ "XCoW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAeCAMAAADn2eWTAAAAflBMVEUAAACUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvmUzvk120ryAAAAKXRSTlMALQf4uqucfCIV8ubhXyj66tfMjIN1WlRGO8OUT0lAEA3TsJKPZx4aF0xVmZAAAADKSURBVCjP7dJHDoMwEEDRMdj03kso6Zn7XzAYA7Ew2WSdv0HoSZbHGpB7pN7VguNqFuIUq1XSigTXkkIDOdt0Uc7Lx82IoeM+52YJNPEwvRBsZZ5invnkdAJex0KJQlaBMHQza75YHi8W5y9xoovA/2mpzQMbDuqsnwcsKQfAuSgNYGosbf4J0ghR6Frja+Jd/AbXQJ6xHWBoHURFRQQI4l9/04p+1fi+Lp2qtNsWNtqpbhB52f2zpK5pw66KLprwNVALjADIpYdPb9vUWUUSN0RJAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Xtae":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YK4T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'DeliveImgLading',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src2: __webpack_require__("fy9M"), // 送货的icon图片
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'zzzz',
                //   deliveimgisload: 0,
                //   openimgisupload: 1,
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'aaaaa',
                //   deliveimgisload: 1,
                //   openimgisupload: 0,
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            isNoData: false
        };
    },
    created: function created() {
        document.title = '送货图片';
        this.bookingId = this.$route.query.bookingId;
        this.ladingId = this.$route.query.ladingId;
        this.servicetype = this.$route.query.servicetype;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            // 获取工作单下要上传图片的柜，一个工作单可能有多个柜号id
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                servicetype: this.servicetype
            };
            this.isShowLoading = true;
            // 调用接口获取数据
            this.requestApi({
                url: _const.apiUrl.deliveImgLading,
                data: data
            }, function (resultData) {
                _this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况
                _this.tableData = resultData.data.sonos || [];
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        goNextPage: function goNextPage(routerName, id, referenceno, contNo, contId, type) {
            // 按钮的方法，跳转查看页面，并且带些参数过去
            this.$router.push({
                name: routerName,
                query: {
                    bookingId: this.bookingId,
                    ladingId: this.ladingId,
                    servicetype: this.servicetype,
                    id: id,
                    referenceno: referenceno,
                    contNo: contNo,
                    contId: contId,
                    type: type, // 为了区分装箱与封箱，load为装箱，seal为封箱,delivedoc为送货单证图片
                    companyId2: _const.apiParams.companyId,
                    openId2: _const.apiParams.openId
                }
            });
        }
    }
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Home = __webpack_require__("lO7g");

var _Home2 = _interopRequireDefault(_Home);

var _test = __webpack_require__("EXDq");

var _test2 = _interopRequireDefault(_test);

var _Voyage = __webpack_require__("qeVO");

var _Voyage2 = _interopRequireDefault(_Voyage);

var _VoyageResult = __webpack_require__("+RXR");

var _VoyageResult2 = _interopRequireDefault(_VoyageResult);

var _FreightPrice = __webpack_require__("skjD");

var _FreightPrice2 = _interopRequireDefault(_FreightPrice);

var _FreightPriceResult = __webpack_require__("aTau");

var _FreightPriceResult2 = _interopRequireDefault(_FreightPriceResult);

var _Business = __webpack_require__("Ji7B");

var _Business2 = _interopRequireDefault(_Business);

var _BusinessResult = __webpack_require__("nkgz");

var _BusinessResult2 = _interopRequireDefault(_BusinessResult);

var _ShipperOrder = __webpack_require__("e5c6");

var _ShipperOrder2 = _interopRequireDefault(_ShipperOrder);

var _Vehicletracking = __webpack_require__("UbqI");

var _Vehicletracking2 = _interopRequireDefault(_Vehicletracking);

var _VehicletrackingResult = __webpack_require__("4lrv");

var _VehicletrackingResult2 = _interopRequireDefault(_VehicletrackingResult);

var _quote = __webpack_require__("uvie");

var _quote2 = _interopRequireDefault(_quote);

var _QuoteResult = __webpack_require__("IoGp");

var _QuoteResult2 = _interopRequireDefault(_QuoteResult);

var _Order = __webpack_require__("Ml40");

var _Order2 = _interopRequireDefault(_Order);

var _Plan = __webpack_require__("ewTV");

var _Plan2 = _interopRequireDefault(_Plan);

var _ReportNoList = __webpack_require__("a14U");

var _ReportNoList2 = _interopRequireDefault(_ReportNoList);

var _ReportContNo = __webpack_require__("ipeC");

var _ReportContNo2 = _interopRequireDefault(_ReportContNo);

var _LoadImgList = __webpack_require__("9mub");

var _LoadImgList2 = _interopRequireDefault(_LoadImgList);

var _LoadImgLading = __webpack_require__("LkYy");

var _LoadImgLading2 = _interopRequireDefault(_LoadImgLading);

var _LoadImgUpload = __webpack_require__("smcu");

var _LoadImgUpload2 = _interopRequireDefault(_LoadImgUpload);

var _LoadImgUploadZJDLD = __webpack_require__("HaVW");

var _LoadImgUploadZJDLD2 = _interopRequireDefault(_LoadImgUploadZJDLD);

var _LoadImgLook = __webpack_require__("PqHc");

var _LoadImgLook2 = _interopRequireDefault(_LoadImgLook);

var _DeliveImgList = __webpack_require__("KdaI");

var _DeliveImgList2 = _interopRequireDefault(_DeliveImgList);

var _DeliveImgLading = __webpack_require__("dVzj");

var _DeliveImgLading2 = _interopRequireDefault(_DeliveImgLading);

var _DeliveImgUpload = __webpack_require__("VIaE");

var _DeliveImgUpload2 = _interopRequireDefault(_DeliveImgUpload);

var _DeliveImgLook = __webpack_require__("D0fX");

var _DeliveImgLook2 = _interopRequireDefault(_DeliveImgLook);

var _FeeMaintainList = __webpack_require__("aUPK");

var _FeeMaintainList2 = _interopRequireDefault(_FeeMaintainList);

var _FeeMaintain = __webpack_require__("P8n1");

var _FeeMaintain2 = _interopRequireDefault(_FeeMaintain);

var _ViewPictureList = __webpack_require__("+EOM");

var _ViewPictureList2 = _interopRequireDefault(_ViewPictureList);

var _ViewPicture = __webpack_require__("TcVl");

var _ViewPicture2 = _interopRequireDefault(_ViewPicture);

var _LocationUploadList = __webpack_require__("4lZo");

var _LocationUploadList2 = _interopRequireDefault(_LocationUploadList);

var _LocationUpload = __webpack_require__("GKgO");

var _LocationUpload2 = _interopRequireDefault(_LocationUpload);

var _demurrageQueryList = __webpack_require__("w2e1");

var _demurrageQueryList2 = _interopRequireDefault(_demurrageQueryList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import LoadUploadResult from '@/components/siji/loadImg/LoadUploadResult'
// import DeliveUploadResult from '@/components/siji/deliveImg/DeliveUploadResult'

// 业务应用的
_vue2.default.use(_vueRouter2.default);
// 司机应用

// 客户应用的
exports.default = new _vueRouter2.default({
    routes: [{
        path: '/test',
        name: 'test',
        component: _test2.default
    }, {
        path: '/',
        name: 'index',
        component: _Home2.default
    }, {
        path: '/home',
        name: 'Home',
        component: _Home2.default
    }, {
        path: '/voyage-kehu',
        name: 'VoyageKehu', // 客户的船期查询
        component: _Voyage2.default
    }, {
        path: '/voyage-yewu',
        name: 'VoyageYewu', // 业务的船期查询
        component: _Voyage2.default
    }, {
        path: '/voyage-result',
        name: 'VoyageResult', // 船期查询的结果界面
        component: _VoyageResult2.default
    }, {
        path: '/freight-price',
        name: 'FreightPrice',
        component: _FreightPrice2.default
    }, {
        path: '/freight-price-result',
        name: 'FreightPriceResult',
        component: _FreightPriceResult2.default
    }, {
        path: '/business',
        name: 'Business',
        component: _Business2.default
    }, {
        path: '/business-result',
        name: 'BusinessResult',
        component: _BusinessResult2.default
    }, {
        path: '/shipper-order',
        name: 'ShipperOrder',
        component: _ShipperOrder2.default
    }, {
        path: '/vehicletracking',
        name: 'Vehicletracking',
        component: _Vehicletracking2.default
    }, {
        path: '/vehicletracking-result',
        name: 'VehicletrackingResult',
        component: _VehicletrackingResult2.default
    }, {
        path: '/quote',
        name: 'Quote',
        component: _quote2.default
    }, {
        path: '/quote-result',
        name: 'QuoteResult',
        component: _QuoteResult2.default
    }, {
        path: '/order',
        name: 'Order',
        component: _Order2.default
    }, {
        path: '/today-plan',
        name: 'TodayPlan',
        component: _Plan2.default
    }, {
        path: '/tomorrow-plan',
        name: 'TomorrowPlan',
        component: _Plan2.default
    }, {
        path: '/report-no-list',
        name: 'ReportNoList',
        component: _ReportNoList2.default
    }, {
        path: '/report-cont-no',
        name: 'ReportContNo',
        component: _ReportContNo2.default
    }, {
        path: '/load-img-list',
        name: 'LoadImgList',
        component: _LoadImgList2.default
    }, {
        path: '/load-img-lading',
        name: 'LoadImgLading',
        component: _LoadImgLading2.default
    }, {
        path: '/load-img-upload',
        name: 'LoadImgUpload',
        component: _LoadImgUpload2.default
    }, {
        path: '/load-img-uploadZJDLD',
        name: 'LoadImgUploadZJDLD',
        component: _LoadImgUploadZJDLD2.default
    }, {
        path: '/load-img-look',
        name: 'LoadImgLook',
        component: _LoadImgLook2.default
    }, {
        path: '/delive-img-list',
        name: 'DeliveImgList',
        component: _DeliveImgList2.default
    }, {
        path: '/delive-img-lading',
        name: 'DeliveImgLading',
        component: _DeliveImgLading2.default
    }, {
        path: '/delive-img-upload',
        name: 'DeliveImgUpload',
        component: _DeliveImgUpload2.default
    }, {
        path: '/delive-img-look',
        name: 'DeliveImgLook',
        component: _DeliveImgLook2.default
    }, {
        path: '/fee-maintain-list',
        name: 'FeeMaintainList',
        component: _FeeMaintainList2.default
    }, {
        path: '/fee-maintain',
        name: 'FeeMaintain',
        component: _FeeMaintain2.default
    }, {
        path: '/view-picture-list',
        name: 'ViewPictureList',
        component: _ViewPictureList2.default
    }, {
        path: '/view-picture',
        name: 'ViewPicture',
        component: _ViewPicture2.default
    }, {
        path: '/location-upload-list',
        name: 'LocationUploadList',
        component: _LocationUploadList2.default
    }, {
        path: '/location-upload',
        name: 'LocationUpload',
        component: _LocationUpload2.default
    }, {
        path: '/demurrage-query-list',
        name: 'demurrageQueryList',
        component: _demurrageQueryList2.default
        // {
        //   path: '/load-upload-result',
        //   name: 'LoadUploadResult',
        //   component: LoadUploadResult
        // },
        // {
        //   path: '/delive-upload-result',
        //   name: 'DeliveUploadResult',
        //   component: DeliveUploadResult
        // },
    }]
});

/***/ }),

/***/ "YeBf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YeHI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DeliveImgList',
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {

      src2: __webpack_require__("fy9M"), // 送货的icon图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      isNoData: false
    };
  },
  created: function created() {
    document.title = '送货图片';
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code
      };
      this.isShowLoading = true;

      this.requestApi({
        url: _const.apiUrl.deliveImgListController,
        data: data
      }, function (resultData) {
        var list = resultData.data.list || [];
        if (list.length === 0) {

          _this.isNoData = true;
          _this.isShowLoading = false;
          _this.isShowTable = false;
          return;
        }
        _this.tableData = list;
      }, function (error) {
        _this.isShowLoading = false;
        if (error) {
          console.error(error);
        }
      });
    },
    goNextPage: function goNextPage(bookingId, ladingId, servicetype) {

      this.$router.push({
        name: 'DeliveImgLading',
        query: {
          bookingId: bookingId,
          ladingId: ladingId,
          servicetype: servicetype
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "YhgZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YmXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-check-icon",on:{"click":_vm.updateValue}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'default' && _vm.value),expression:"type === 'default' && value"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'plain' && _vm.value),expression:"type === 'plain' && value"}],attrs:{"type":"success_circle"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],attrs:{"type":"circle"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []


/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__ = __webpack_require__("RJTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__ = __webpack_require__("+kMp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_5d806436_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_flexbox_vue__ = __webpack_require__("QSTa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("jsSu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_5d806436_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_flexbox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_5d806436_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_flexbox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Z06H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z5JB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
};

/***/ }),

/***/ "ZLd3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

// 区分是开发环境还是生产环境
// if (process.env.NODE_ENV === 'production') {
// openId = '';
// companyId = '';
//ipName = 'https://t.aohaisoft.com' // 废弃，毕竟url要变成自适应
// openId, companyId,
//     ipName = '';
// } else {
//     // openId = 'o9slduOkB2HbLQ_ZvkLHqoWVr5Ko'; // 开发时先写死
//     // companyId = 'aohyTest'; // 开发时先写死
//     openId = 'wx7aea50fda6f841e7'; // 开发时先写死
//     companyId = 'gzjdwl'; // 开发时先写死
//     //ipName = 'http://192.168.1.202:8090' // 有时t.aohaisoft.com会被重置而用不了，就换成这个
//     //ipName = 'https://t.aohaisoft.com'
//     ipName = '' // http://web.gnway.cc:' + (process.env.PORT || 8070)
// }

// apiParams存放接口几个共用的参数
var apiParams = exports.apiParams = {
    companyId: '',
    openId: '',
    code: ''
    // ladingId: '',
    // servicetype: '',
};

// ipName是后台接口域名
var ipName = '';

var apiUrl = exports.apiUrl = {

    getAuthUrl: ipName + '/AohyWebchatS/getAuthUrl.do', // 微信授权登录
    menuPermission: ipName + '/AohyWebchatS/menuPermission.do', // 判断操作权限
    voyageSearch: ipName + '/AohyWebchatS/voyageSearch.do', // 获取船期查询所有起运港和目的港
    changePlace: ipName + '/AohyWebchatS/changePlace.do', // 起始地下拉框改变时，获取对应的目的地
    voyageTemplate: ipName + '/AohyWebchatS/voyageTemplate.do', // 获取船期查询的分页数据
    freightPrice: ipName + '/AohyWebchatS/freightPrice.do', // 获取报价查询的地点与shipper、group等数据
    freightPriceTemplate: ipName + '/AohyWebchatS/freightPriceTemplate.do', // 获取报价查询的分页数据
    businessTemplate: ipName + '/AohyWebchatS/businessTemplate.do', // 获取客户应用的business业务查询的分页数据
    shipperOrder: ipName + '/AohyWebchatS/shipperOrder.do', // 获取客户应用下单的多个下拉列表数据
    shipperAddOrder: ipName + '/AohyWebchatS/shipperAddOrder.do', // 增加客户应用的下单数据
    // 业务应用的接口
    voyageSearchYeWu: ipName + '/AohyWebchatS/voyageSearchYeWu.do', // 获取船期查询所有起运港和目的港
    changePort: ipName + '/AohyWebchatS/changePort.do', // 选择起始港后获取对应的目的港
    voyageTemplateYw: ipName + '/AohyWebchatS/voyageTemplateYw.do', // 获取船期查询的分页数据
    vehicleTemplate: ipName + '/AohyWebchatS/vehicleTemplate.do', // 获取调度应用的分页数据
    updateVehicle: ipName + '/AohyWebchatS/updateVehicle.do', // 更新调度应用的车辆状态数据
    quoteSearchCondition: ipName + '/AohyWebchatS/quoteSearchCondition.do', // 获取业务应用的报价查询的地址与柜量等数据
    quoteTemplate: ipName + '/AohyWebchatS/quoteTemplate.do', // 获取业务应用的报价查询的分页数据（即列表或表格数据）
    getConsignee: ipName + '/AohyWebchatS/getConsignee.do', // 下单--选择托运人-拉取他的货主
    getStartArea: ipName + '/AohyWebchatS/getStartArea.do', // 下单--选择托运人-拉取起始的地区（起运地）
    getShippersAndConts: ipName + '/AohyWebchatS/getShippersAndConts.do', // 获取业务应用托运人列表shippers与柜型柜量conts
    addOrder: ipName + '/AohyWebchatS/addOrder.do', // 获取业务应用托运人列表shippers与柜型柜量conts

    // 客户与业务应用共用的接口
    getKehuTel: ipName + '/AohyWebchatS/getKehuTel.do', // 获取“联系我们”的号码
    getArea: ipName + '/AohyWebchatS/getArea.do', // 选择托运人-货主--获取收货地区（目的地）
    getPlace: ipName + '/AohyWebchatS/getPlace.do', // 获取卸货地址，装货地址也是这个
    getLinkman: ipName + '/AohyWebchatS/getLinkman.do', // 获取装货/卸货联系人
    getOtherloadInfo: ipName + '/AohyWebchatS/getOtherloadInfo.do', // 获取装货/卸货联系人手机电话

    // 司机应用的接口
    todayPlan: ipName + '/AohyWebchatS/todayPlan.do', // 查询今日拖车计划
    tomorrowPlan: ipName + '/AohyWebchatS/tomorrowPlan.do', // 查询今日拖车计划
    reportNoSearch: ipName + '/AohyWebchatS/reportNoSearch.do', // 获取还没报柜号的计划，即ui图报柜号第一个页面
    getReportContNoSono: ipName + '/AohyWebchatS/getReportContNoSono.do', // 获取工作单下要报柜号的柜，一个工作单可能有多个柜号id，对应第二个页面
    reportContNo: ipName + '/AohyWebchatS/reportContNo.do', // 更新对应 的柜号、封号，对应第二个页面的报柜号/封号按钮，且一次只能更新一个柜号ID
    reportSealNoGet: ipName + '/AohyWebchatS/reportSealNoGet.do', // 只更新对应封号，暂时只用reportContNo接口去更新就好了，先不用这个接口
    //装货图片
    loadImgListController: ipName + '/AohyWebchatS/loadImgListController.do', // 获取《装货图片》，还未上传图片的列表数据
    loadImgLading: ipName + '/AohyWebchatS/loadImgLading.do', // 《装货图片》，获取是要上传还是查看的loadimgisupload（装箱）与sealimgisupload（封箱）
    loadImgUpload: ipName + '/AohyWebchatS/loadImgUpload.do', // 《装货图片》，上传装箱图片
    uploadSealController: ipName + '/AohyWebchatS/uploadSealController.do', // 《装货图片》，上传封箱图片
    loaddocUpload: ipName + '/AohyWebchatS/loaddocUpload.do', // 《装货图片》，上传装箱单证图片
    loadImgDisplay: ipName + '/AohyWebchatS/loadImgDisplay.do', // 《装货图片》，查看（获取）装箱图片
    lookSealImg: ipName + '/AohyWebchatS/lookSealImg.do', // 《装货图片》，查看（获取）封箱图片
    lookloaddoc: ipName + '/AohyWebchatS/lookloaddoc.do', // 《装货图片》，查看（获取）装箱单证图片
    //送货图片
    deliveImgListController: ipName + '/AohyWebchatS/deliveImgListController.do', // 获取《送货图片》，还未上传图片的列表数据
    deliveImgLading: ipName + '/AohyWebchatS/deliveImgLading.do', // 《送货图片》，获取是要上传还是查看的deliveimgisload（送货）与openimgisupload（开箱）
    uploadDelive: ipName + '/AohyWebchatS/uploadDelive.do', // 《送货图片》，上传送货图片(好像是送货的封箱图片另起名称为送货图片)
    uploadOpenController: ipName + '/AohyWebchatS/uploadOpenController.do', // 《送货图片》，上传开箱图片
    uploadDelivedoc: ipName + '/AohyWebchatS/uploadDelivedoc.do', // 《送货图片》，上传送货单证图片
    deliveImgDisplay: ipName + '/AohyWebchatS/deliveImgDisplay.do', // 《送货图片》，获取送货图片
    lookopenimg: ipName + '/AohyWebchatS/lookopenimg.do', // 《送货图片》，获取开箱图片
    lookDelivedoc: ipName + '/AohyWebchatS/lookdelivedoc.do', // 《送货图片》，查看（获取）送货单证图片

    feeMaintainPageList: ipName + '/AohyWebchatS/feeMaintainPageList.do', // 《费用维护》获取列表
    getFeeDetail: ipName + '/AohyWebchatS/getFeeDetail.do', // 《费用维护》，获取费用明细
    getFeeIdList: ipName + '/AohyWebchatS/getFeeIdList.do', // 《费用维护》， 获取司机可维护费用项目
    saveFee: ipName + '/AohyWebchatS/saveFee.do', // 《费用维护》，保存费用
    viewPicturesOrderList: ipName + '/AohyWebchatS/viewPicturesOrderList.do', // 《客户应用》，查看图片
    locationNoticeList: ipName + '/AohyWebchatS/locationNoticeList.do', // 《司机应用》 位置上传
    getLocationNoticeDetail: ipName + '/AohyWebchatS/getLocationNoticeDetail.do', // 《司机应用》位置上传详情
    locationNoticeSave: ipName + '/AohyWebchatS/locationNoticeSave.do', // 《司机应用》 位置上传
    getContainerDemurrageDaysList: ipName + '/AohyWebchatS/getContainerDemurrageDaysList.do', // 《客户应用》 滞期天数查询
    getAvailableMenu: ipName + '/AohyWebchatS/getAvailableMenu.do' // 获取首页菜单
};

var homeMenu = exports.homeMenu = {
    kehu: { // 客户菜单
        title: '客户应用',
        iconTitleUrl: __webpack_require__("yjv+"),
        contentData: [{
            label: '船期查询',
            iconUrl: __webpack_require__("RIvw"),
            path: '/voyage-kehu',
            menuType: 'V1_VOYAGE'
        }, {
            label: '报价查询',
            iconUrl: __webpack_require__("V3cc"),
            path: '/freight-price',
            menuType: 'V1_PRICE'
        }, {
            label: '业务查询',
            iconUrl: __webpack_require__("+qj0"),
            path: '/business',
            menuType: 'V1_BUSINESS'
        }, {
            label: '客户下单',
            iconUrl: __webpack_require__("NxxP"),
            path: '/shipper-order',
            menuType: 'V1_ORDER'
        }, {
            label: '查看图片',
            iconUrl: __webpack_require__("KZl4"),
            path: '/view-picture-list',
            menuType: 'V1_ORDER'
        }]
    },
    yewu: { // 业务菜单
        title: '业务员应用',
        iconTitleUrl: __webpack_require__("1pHq"),
        contentData: [{
            label: '船期查询',
            iconUrl: __webpack_require__("RIvw"),
            path: '/voyage-yewu',
            menuType: 'V2_VOYAGE'
        }, {
            label: '调度应用',
            iconUrl: __webpack_require__("ByWV"),
            path: '/vehicletracking',
            menuType: 'V2_DIAODU'
        }, {
            label: '报价查询',
            iconUrl: __webpack_require__("V3cc"),
            path: '/quote',
            menuType: 'V2_QUOTE'
        }, {
            label: '业务下单',
            iconUrl: __webpack_require__("0wEq"),
            path: '/order',
            menuType: 'V2_ORDER'
        }]
    },
    siji: { // 司机菜单
        title: '司机应用',
        iconTitleUrl: __webpack_require__("V8Pl"),
        contentData: [{
            label: '今日计划',
            iconUrl: __webpack_require__("Bse7"),
            path: '/today-plan',
            menuType: 'V3_PLAN'
        }, {
            label: '明日计划',
            iconUrl: __webpack_require__("61LD"),
            path: '/tomorrow-plan',
            menuType: 'V3_PLAN' // todo:今日与明日共用一个menuType可以吧？
        }, {
            label: '报柜号',
            iconUrl: __webpack_require__("+qj0"),
            path: '/report-no-list',
            menuType: 'V3_REPORT'
        }, {
            label: '装货图片',
            iconUrl: __webpack_require__("rOEi"),
            path: '/load-img-list',
            menuType: 'V3_REPORT'
        }, {
            label: '送货图片',
            iconUrl: __webpack_require__("nicx"),
            path: '/delive-img-list',
            menuType: 'V3_DELIVERY'
        }, {
            label: '费用维护',
            iconUrl: __webpack_require__("oION"),
            path: '/fee-maintain-list',
            menuType: 'V3_DELIVERY'
        }, {
            label: '位置上传',
            iconUrl: __webpack_require__("gBGf"),
            path: '/location-upload-list',
            menuType: 'V3_DELIVERY'
        }]
    }
};

exports.default = {
    apiParams: apiParams,
    apiUrl: apiUrl,
    homeMenu: homeMenu
};

/***/ }),

/***/ "ZWVd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_GoHome_vue__ = __webpack_require__("UMYo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_GoHome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_GoHome_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_GoHome_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_GoHome_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_GoHome_vue__ = __webpack_require__("qN9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_GoHome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_GoHome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2154874e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_GoHome_vue__ = __webpack_require__("8OYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("j1+K")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2154874e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_GoHome_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2154874e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_GoHome_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2154874e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_GoHome_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZWmw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = __webpack_require__("f6Hi");

var _base2 = _interopRequireDefault(_base);

var _objectFilter = __webpack_require__("q5lo");

var _props = __webpack_require__("Zor0");

var _props2 = _interopRequireDefault(_props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'radio',
  mixins: [_base2.default],
  filters: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey
  },
  props: (0, _props2.default)(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey,
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, (0, _objectFilter.getLabel)(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}

/***/ }),

/***/ "ZfQA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkFBNkRCNzYwQkYzQzExRTlCODdBOUZDMDZCMEE2NDNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkFBNkRCNzYxQkYzQzExRTlCODdBOUZDMDZCMEE2NDNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QUE2REI3NUVCRjNDMTFFOUI4N0E5RkMwNkIwQTY0M0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QUE2REI3NUZCRjNDMTFFOUI4N0E5RkMwNkIwQTY0M0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4TCFbdAAAAoUlEQVR42uzXsQkCQRBG4blTjOUqMBThsCINDc9IIxtQM0sQ27CDBUVQDK1AucxE8C1MC6PJP/Bt+mCinSKl1DOzDSaoLHaeOGDR5VljjhuOweERGrxzeIorxvgEhzs4Y1b6eh8/iJo3LuiX9qdRWGGFFVZYYYUVVljhmPALA/9sR09u1GjzJbH3E+aEe3B46OFtDi9R+ClTB4db7LD6CjAAuZwZ+8M5lIwAAAAASUVORK5CYII="

/***/ }),

/***/ "Zspb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'VehicletrackingResult',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            tableData: [],
            // newData: [
            //   {
            //     c_drive_num_hk: '090',
            //     truck_no: '粤Ajk232',
            //     truck_company: '远集拖车',
            //     c_phone: '13515646848',
            //     zxhdz: '',
            //     time: '0',
            //     truck_status: 0,
            //     c_truck_tracing_status: 0, // 车辆状态
            //     // isShowBtn: false, // 这个不是后台传的，而是前端添加
            //   },
            // ],// 假数据，后续要注释
            tracingStatusList: [{
                key: 0,
                value: '营运'
            }, {
                key: 1,
                value: '待安排'
            }, {
                key: 2,
                value: '维修'
            }, {
                key: 3,
                value: '交通事故'
            }, {
                key: 4,
                value: '违章'
            }],
            isShowTable: true,
            isShowLoading: false,
            originSelectedStatus: [],
            canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
            canUpdate: true, // true代表能继续发送请求，控制updateState方法的
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false, // false代表有数据
            url: _const.apiUrl.vehicleTemplate,
            updateUrl: _const.apiUrl.updateVehicle
        };
    },
    created: function created() {
        document.title = '车辆跟踪';
        this.onScrollBottom();
    },

    methods: {
        getMoreData: function getMoreData(url, data) {
            var _this = this;

            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle',
                    type: 'text'
                });
                return;
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data.page;
                var resultArr = dataObj.result || []; // 防止后台返回null
                if (_this.pageNo === 1 && resultArr.length === 0) {
                    // 如果根本没有数据
                    _this.isShowTable = false;
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    return;
                }
                resultArr.forEach(function (item) {
                    // 为了控制保存按钮，要先给返回的数据添加一个属性isShowBtn
                    item.isShowBtn = false;
                    _this.tableData.push(item);
                    // 为了让selector的value恢复到初始值，要先保存刚请求回来的
                    _this.originSelectedStatus.push(item.c_truck_tracing_status);
                }); // 表格数据是放在result中
                _this.totalCount = dataObj.totalCount;
                _this.totalPages = dataObj.totalPages;
                _this.pageNo++;
                _this.$nextTick(function () {
                    _this.$refs.scrollerBottom.reset();
                }); // 要重置scroller组件
            }, function (error) {
                _this.isShowLoading = false;
                _this.canFetch = true;
                if (error) {
                    console.error(error);
                }
            });
        },
        onScrollBottom: function onScrollBottom() {
            this.isShowLoading = true;
            var query = this.$route.query;
            var data = {
                begin: query.loadDate,
                end: query.unloadingDate,
                truck_no: query.truck_no,
                is_self: query.is_self,
                pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                pageNo: this.pageNo, // 当前为第几页数据，要累加
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            if (!this.canFetch) {} else {
                this.canFetch = false;
                this.getMoreData(this.url, data);
            }
        },
        changeNative: function changeNative(e, index) {
            // 不用vux的on-change，使用原生的change事件就不会首次渲染触发，而且后台可能会传默认选项，因此也无法判断用户有没选择；
            // 不过原生的change事件中无法正常获取到v-model绑定的值，因此只能使用e.target.value获取了
            // 现在要控制对应的保存按钮，两种方式：
            // 1、为tableData加一个控制按钮属性，每次修改都找到对应数据，修改这个控制的属性；
            // 2、直接获取到该按钮的dom，然后控制显示状态
            this.tableData[index].isShowBtn = true;
        },
        updateState: function updateState(index) {
            var _this2 = this;

            // 点击保存按钮后，调用接口保存，参数有：c_drive_num_hk、truck_no、被选中的c_truck_tracing_status
            var data = {
                c_drive_num_hk: this.tableData[index].c_drive_num_hk,
                truck_no: this.tableData[index].truck_no,
                state: this.tableData[index].c_truck_tracing_status,
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            // 调用接口进行修改
            this.canUpdate = false;
            this.requestApi({
                url: this.updateUrl,
                data: data
            }, function (resultData) {
                // 没看懂后台会返回什么，先当做到这一步就是更新成功吧
                // 接口调用成功后，要隐藏按钮，还可以给个成功toast
                _this2.$vux.toast.show({
                    text: '更新成功',
                    type: 'success'
                });
                _this2.tableData[index].isShowBtn = false;
                // this.$set(this.tableData[index],'isShowBtn',false)
                // 保存成功的话，要重置下originSelectedStatus里的数据
                _this2.originSelectedStatus[index] = _this2.tableData[index].c_truck_tracing_status;
            }, function (error) {
                _this2.canUpdate = true;
                console.error(error);
            });
        },
        handleCancel: function handleCancel(index) {
            // 点击取消按钮后，要重置selector的默认值
            this.tableData[index].c_truck_tracing_status = this.originSelectedStatus[index];
            this.tableData[index].isShowBtn = false; // 隐藏按钮
        }
    }
};

/***/ }),

/***/ "a14U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportNoList_vue__ = __webpack_require__("pzVr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportNoList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportNoList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportNoList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportNoList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportNoList_vue__ = __webpack_require__("sEDc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportNoList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportNoList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f31bcb4a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ReportNoList_vue__ = __webpack_require__("+PSE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("uHX6")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f31bcb4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportNoList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f31bcb4a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ReportNoList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f31bcb4a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ReportNoList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aTau":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPriceResult_vue__ = __webpack_require__("G8OR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPriceResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPriceResult_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPriceResult_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPriceResult_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPriceResult_vue__ = __webpack_require__("fGBG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPriceResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPriceResult_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_095e3d64_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FreightPriceResult_vue__ = __webpack_require__("m8iH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("tEYZ")
  __webpack_require__("YhgZ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-095e3d64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPriceResult_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_095e3d64_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FreightPriceResult_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_095e3d64_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FreightPriceResult_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aUPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintainList_vue__ = __webpack_require__("H3Xw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintainList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintainList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintainList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintainList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintainList_vue__ = __webpack_require__("KJbd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintainList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintainList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6631609f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FeeMaintainList_vue__ = __webpack_require__("I+8Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Sf51")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6631609f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FeeMaintainList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6631609f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FeeMaintainList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6631609f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FeeMaintainList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bCvt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cleanStyle = __webpack_require__("wmxo");

var _cleanStyle2 = _interopRequireDefault(_cleanStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'group',
  methods: {
    cleanStyle: _cleanStyle2.default
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "bMC4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"quoteResult"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_c('scroller',{ref:"scrollerBottom",attrs:{"lock-x":"","scroll-bottom-offset":50},on:{"on-scroll-bottom":_vm.onScrollBottom}},[_c('div',{staticClass:"box2"},[_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"vehicletracking-table-box"},[_c('table',{staticClass:"vehicletracking-table"},[_c('tr',[_c('td',{staticStyle:{"width":"40%"}},[_vm._v("起运地")]),_vm._v(" "),_c('td',{staticStyle:{"width":"60%"}},[_vm._v(_vm._s(item.sPlace))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("起运港")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.sPort))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("目的地")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.ePlace))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("目的港")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.ePort))])]),_vm._v(" "),(item.ship_company)?_c('tr',[_c('td',[_vm._v("船公司")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.ship_company))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("目的拖车公司")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.truck_delivery))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("始驳费(单拖)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tf_loading1_t))])]),_vm._v(" "),(item.tf_loading2_t)?_c('tr',[_c('td',[_vm._v("始驳费(双拖)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tf_loading2_t))])]):_vm._e(),_vm._v(" "),(item.oceanfee)?_c('tr',[_c('td',[_vm._v("海运费")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.oceanfee))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("装箱费")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.cont_fee))])]),_vm._v(" "),(item.order_fee)?_c('tr',[_c('td',[_vm._v("办单费")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.order_fee))])]):_vm._e(),_vm._v(" "),(item.baf)?_c('tr',[_c('td',[_vm._v("燃油附加费")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.baf))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("码头包干费")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.port_fee))])]),_vm._v(" "),(item.tf_delivery1)?_c('tr',[_c('td',[_vm._v("达驳费(单拖)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tf_delivery1))])]):_vm._e(),_vm._v(" "),(item.tf_delivery2_t)?_c('tr',[_c('td',[_vm._v("达驳费(双拖)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tf_delivery2_t))])]):_vm._e(),_vm._v(" "),(item.totalup1)?_c('tr',[_c('td',[_vm._v("合计(单拖)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.totalup1))])]):_vm._e(),_vm._v(" "),(item.totalup2)?_c('tr',[_c('td',[_vm._v("合计(双拖)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.totalup2))])]):_vm._e()])])}),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],2)])],1),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "bwrR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'app'
};

/***/ }),

/***/ "cW8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])],{"icon":one.icon,"label":_vm.getValue(one),"index":index,"selected":_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){return _vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var staticRenderFns = []


/***/ }),

/***/ "cbhP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "ShipperOrder",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            // todo:逻辑应该是：上层中某个选项变化了，下面所有select与受影响的input都要变为null
            load_date: '',
            consignee_id: null, // 囧，selector组件要设置默认值为null时，placeholder才有效果！
            consigneeOps: [
                // {
                //   key: 'lsh',
                //   value: '李四'
                // },
                // {
                //   key: 'zhs',
                //   value: '张三'
                // }
            ],
            goods_name: '',
            dockOfLoading: null,
            dockOfLoadingOps: [
                // '广东',
                // '上海',
            ],
            finalDestination: null,
            finalDestinationOps: [],
            jhr: null,
            jhrOps: [],
            company_lxr: null,
            company_lxrOps: [],
            shipper_tel: '',
            shipper_mp: '',
            remark3: '', // 装货说明
            consignee_place: null,
            consignee_placeOps: [],
            consignee_linkman: null,
            consignee_linkmanOps: [],
            consignee_tel: '',
            consignee_mp: '',
            remark9: '', // 卸货说明
            carriage: null,
            carriageOps: [{
                key: 'DR-DR',
                value: '门/门'
            }, {
                key: 'DR-CY',
                value: '门/堆场'
            }, {
                key: 'CY-DR',
                value: '堆场/门'
            }, {
                key: 'CY-CY',
                value: '堆场/堆场'
            }],
            contQty: '', // todo:柜量还要进行处理？
            contType: null,
            contTypeOps: [
                // {
                //   key: '20',
                //   value: '20GP'
                // },
                // {
                //   key: '40',
                //   value: '20GP'
                // },
            ], // todo:后台传递来
            insurance_status: null,
            insurance_statusOps: [{
                key: '1',
                value: '是'
            }, {
                key: '0',
                value: '否'
            }],
            fees_remark2: '',
            group: '', // 这个由shipperOrder接口获得，不知道是否要传回去
            shipper: '', // 这个由shipperOrder接口获得，托运人，在获取目的地时也要传递
            employeeId: '',
            isDisabledList: {
                consigSelector: false,
                dockOfLoadingSelector: false,
                finalDestinationSelector: false,
                jhrSelector: false,
                companyLxrSelector: false,
                consigneePlaceSelector: false,
                consigneeLinkmanSelector: false
            }, // 这个对象存放控制各个selector组件的readonly属性的值
            canSubmit: true // true代表能继续发送请求，控制submit方法的
        };
    },
    created: function created() {
        document.title = '客户下单';
        this.getInitialSelectData();
    },

    methods: {
        getInitialSelectData: function getInitialSelectData() {
            var _this = this;

            // 可获取到shipper(托运人)、employeeId(对应业务员？)、conts(柜型柜量)、consignees(货主？)、startAreas(起运地)
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: _const.apiUrl.shipperOrder,
                data: data
            }, function (resultData) {
                _this.$vux.loading.hide();
                var dataObj = resultData.data;
                _this.consigneeOps = dataObj.consignees;
                _this.group = dataObj.group;
                _this.shipper = dataObj.shipper;
                // this.shipperOps = dataObj.shippers
                _this.employeeId = dataObj.employeeId;
                _this.consigneeOps = dataObj.consignees;
                _this.contTypeOps = dataObj.conts;
                _this.dockOfLoadingOps = dataObj.startAreas; // 起运地
            }, function (error) {
                _this.$vux.loading.hide();
                if (error) {
                    // todo:如果请求失败，2秒后可重新获取，或者提示用户刷新页面？
                    setTimeout(function () {
                        _this.getInitialSelectData();
                    }, 2000);
                    console.error(error);
                }
            });
        },

        // 由于on-change会立即调用一次，因此如果value为null，要中止函数
        // 如果用户在第一次请求还未完成时，就又触发了change事件，然后第二次请求完成速度比第一次还快，怎么办？？
        // 处理上述bug：一旦改变了选项，那就禁用selector组件，等请求完毕后再启用
        getArea: function getArea(value, ref) {
            var _this2 = this;

            // 获取目的地：通过托运人与货主去查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取目的地：通过托运人与货主去查询
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id
            };
            this.requestApi({
                url: _const.apiUrl.getArea,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this2.finalDestinationOps = dataObj.area;
                _this2.finalDestination = null; // 要重置为null，避免默认选中值没改
            }, function (error) {
                _this2.isDisabled(ref);
                if (error) {
                    // todo:除了getInitialSelectData可以自动重新请求外，其他change事件触发的接口不可自动重新获取，不然万一用户修改选项，请求数据会混乱了！
                    // 处理上述bug：因此如果请求失败了，那就重置select的默认值为null
                    _this2.consignee_id = null;
                    console.error(error);
                }
            });
        },
        getLoadJhr: function getLoadJhr(value, ref) {
            var _this3 = this;

            // 获取装货地址：根据起运地查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.dockOfLoading || '' // 也可以直接使用参数value
            };
            this.requestApi({
                url: _const.apiUrl.getPlace,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this3.jhrOps = dataObj.places;
                _this3.jhr = null;
            }, function (error) {
                _this3.isDisabled(ref);
                if (error) {
                    _this3.dockOfLoading = null;
                    console.error(error);
                }
            });
        },
        getConsigPlace: function getConsigPlace(value, ref) {
            var _this4 = this;

            // 获取卸货地址：根据目的地去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.finalDestination || ''
            };
            this.requestApi({
                url: _const.apiUrl.getPlace,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this4.consignee_placeOps = dataObj.places;
                _this4.consignee_place = null;
            }, function (error) {
                _this4.isDisabled(ref);
                if (error) {
                    _this4.finalDestination = null;
                    console.error(error);
                }
            });
        },
        getLoadLink: function getLoadLink(value, ref) {
            var _this5 = this;

            // 获取装货联系人：根据起运地+装货地址去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.dockOfLoading || '',
                place: this.jhr || ''
            };
            this.requestApi({
                url: _const.apiUrl.getLinkman,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this5.company_lxrOps = dataObj.linkmans;
                _this5.company_lxr = null;
            }, function (error) {
                _this5.isDisabled(ref);
                if (error) {
                    _this5.jhr = null;
                    console.error(error);
                }
            });
        },
        getLoadTelMp: function getLoadTelMp(value, ref) {
            var _this6 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取装货人手机电话：根据起运地+装货地址+装货联系人获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.dockOfLoading || '',
                place: this.jhr || '',
                linkman: this.company_lxr || ''
            };
            this.requestApi({
                url: _const.apiUrl.getOtherloadInfo,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                // todo:手机与电话好像是放在loadInfo数组里面
                _this6.shipper_tel = dataObj.loadInfo[1];
                _this6.shipper_mp = dataObj.loadInfo[0];
            }, function (error) {
                _this6.isDisabled(ref);
                if (error) {
                    _this6.company_lxr = null;
                    console.error(error);
                }
            });
        },
        getXHLink: function getXHLink(value, ref) {
            var _this7 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货联系人：根据目的地+卸货地址获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.finalDestination || '',
                place: this.consignee_place || ''
            };
            this.requestApi({
                url: _const.apiUrl.getLinkman,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this7.consignee_linkmanOps = dataObj.linkmans;
                _this7.consignee_linkman = null;
            }, function (error) {
                _this7.isDisabled(ref);
                if (error) {
                    _this7.consignee_place = null;
                    console.error(error);
                }
            });
        },
        getXhTelMp: function getXhTelMp(value, ref) {
            var _this8 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货人手机电话：根据目的地+卸货地址+卸货联系人获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.finalDestination || '',
                place: this.consignee_place || '',
                linkman: this.consignee_linkman || ''
            };
            this.requestApi({
                url: _const.apiUrl.getOtherloadInfo,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                // 手机与电话好像是放在loadInfo数组里面，loadInfo:["13678978756", null]
                _this8.consignee_tel = dataObj.loadInfo[1];
                _this8.consignee_mp = dataObj.loadInfo[0];
            }, function (error) {
                _this8.isDisabled(ref);
                if (error) {
                    _this8.consignee_linkman = null;
                    console.error(error);
                }
            });
        },
        submit: function submit(e) {
            var _this9 = this;

            // 对表单各项进行检测
            if (!this.load_date) {
                this.showToastWarn('请选择装货时间');
                return;
            }
            if (!this.consignee_id) {
                this.showToastWarn('请输入货主');
                return;
            }
            if (!this.goods_name) {
                this.showToastWarn('请输入货名');
                return;
            }
            if (!this.dockOfLoading) {
                this.showToastWarn('请输入起运地');
                return;
            }
            if (!this.finalDestination) {
                this.showToastWarn('请输入目的地');
                return;
            }
            if (!this.jhr) {
                this.showToastWarn('请输入装货地址');
                return;
            }
            if (!this.company_lxr) {
                this.showToastWarn('请输入装货联系人');
                return;
            }
            if (!(this.shipper_mp || this.shipper_tel)) {
                this.showToastWarn('装货联系人手机,电话至少输入一个');
                return;
            }
            if (!this.consignee_place) {
                this.showToastWarn('请输入卸货地址');
                return;
            }
            if (!this.consignee_linkman) {
                this.showToastWarn('请输入卸货联系人');
                return;
            }
            if (!(this.consignee_tel || this.consignee_mp)) {
                this.showToastWarn('卸货联系人手机,电话至少输入一个');
                return;
            }
            if (!this.contQty) {
                this.showToastWarn('请输入柜量');
                return;
            } else if (isNaN(Number(this.contQty))) {
                // 柜量必须是数字，而且是整数
                this.showToastWarn('柜量必须为数字');
                return;
            }
            if (!this.fees_remark2) {
                this.showToastWarn('请输入费用说明');
                return;
            }
            // 防止连续调用接口：也可直接给loading
            if (!this.canSubmit) return;
            this.canSubmit = false;
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 提交下单信息
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                employeeId: this.employeeId || '',
                load_date: this.load_date,
                consignee_id: this.consignee_id,
                goods_name: this.goods_name,
                dockOfLoading: this.dockOfLoading,
                finalDestination: this.finalDestination,
                jhr: this.jhr,
                company_lxr: this.company_lxr,
                shipper_tel: this.shipper_tel || '',
                shipper_mp: this.shipper_mp || '',
                remark3: this.remark3,
                consignee_place: this.consignee_place,
                consignee_linkman: this.consignee_linkman,
                consignee_tel: this.consignee_tel || '',
                consignee_mp: this.consignee_mp || '',
                remark9: this.remark9,
                carriage_item: this.carriage,
                contQty: parseInt(this.contQty),
                contType: this.contType,
                insurance_status: this.insurance_status || 0,
                fees_remark2: this.fees_remark2,
                group: this.group
            };
            this.requestApi({
                url: _const.apiUrl.shipperAddOrder,
                data: data
            }, function (resultData) {
                _this9.$vux.loading.hide();
                // 最后判断下单是否成功，给toast，状态码为200就是成功
                var dataObj = resultData.data;
                _this9.showToast(dataObj.info, 1500, 'success', {
                    onHide: function onHide() {
                        _this9.$router.push('/home');
                    }
                });
            }, function (error) {
                _this9.canSubmit = true;
                _this9.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            });
        },
        showToastWarn: function showToastWarn(text) {
            var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

            // 专门给submit函数里的验证使用
            this.showToast(text, time, 'warn');
        },
        isDisabled: function isDisabled(ref) {
            // 在触发select的change事件后，要先禁用select，等到请求完毕后，再重启select功能
            // 两种实现方式：1、第一种是通过ref获取到对应dom元素，然后禁用：
            // this.$refs[ref].$el.querySelector('select').disabled = !this.$refs[ref].$el.querySelector('select').disabled

            // 2、第二种是控制对应数据去设置selector组件的readonly属性
            this.isDisabledList[ref] = !this.isDisabledList[ref];
        }
    }
};

/***/ }),

/***/ "cvA0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preventBodyScroll = __webpack_require__("JkZY");

var _preventBodyScroll2 = _interopRequireDefault(_preventBodyScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_preventBodyScroll2.default],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "d1G5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []


/***/ }),

/***/ "d6cP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _icon = __webpack_require__("oWtu");

var _icon2 = _interopRequireDefault(_icon);

var _datetimepicker = __webpack_require__("zV4+");

var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

var _group = __webpack_require__("rHil");

var _group2 = _interopRequireDefault(_group);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _uuid = __webpack_require__("KRg4");

var _uuid2 = _interopRequireDefault(_uuid);

var _format2 = __webpack_require__("ODCk");

var _format3 = _interopRequireDefault(_format2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'datetime',
  mixins: [_uuid2.default],
  components: {
    Group: _group2.default,
    InlineDesc: _inlineDesc2.default,
    Icon: _icon2.default
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = (0, _keys2.default)(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new _datetimepicker2.default(_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = (0, _format3.default)(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
};

/***/ }),

/***/ "dQrX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"xs-container"},[_vm._t("default"),_vm._v(" "),_vm._t("pulldown"),_vm._v(" "),_vm._t("pullup")],2)])}
var staticRenderFns = []


/***/ }),

/***/ "dVzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLading_vue__ = __webpack_require__("YK4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLading_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLading_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLading_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLading_vue__ = __webpack_require__("Kl/K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615f5044_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgLading_vue__ = __webpack_require__("QQnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("133T")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-615f5044"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveImgLading_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615f5044_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgLading_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615f5044_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveImgLading_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "e5c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ShipperOrder_vue__ = __webpack_require__("rAd9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ShipperOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ShipperOrder_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ShipperOrder_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ShipperOrder_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ShipperOrder_vue__ = __webpack_require__("cbhP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ShipperOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ShipperOrder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e74d6974_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ShipperOrder_vue__ = __webpack_require__("vxH5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("h9fF")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e74d6974"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ShipperOrder_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e74d6974_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ShipperOrder_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e74d6974_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ShipperOrder_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eSwO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "LoadImgLook",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: __webpack_require__("w2ig"), // 装箱的图片，右上角的icon
            iconClose: __webpack_require__("VrRN"), // 关闭图标
            goBackQuery: {}, // 回退时要带的参数
            displayUrl: '',
            imgSrcList: [
                // require('@/assets/images/plan/wx_zhuang_blue.png'),
                // require('@/assets/images/wx_sc_oringe.png')
            ], // 图片路径列表
            isNoData: false,
            isShowLoading: false,
            step: -1
        };
    },
    created: function created() {
        document.title = '装货图片';
        var query = this.$route.query;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常，原因：页面先被刷新一次，再进入该组件，导致数据丢失，而且用go回退时要两次！
        if (!_const.apiParams.companyId) {
            _const.apiParams.companyId = query.companyId2;
            _const.apiParams.openId = query.openId2;
            this.step = -2;
        }
        if (query.type === 'load') {
            this.displayUrl = _const.apiUrl.loadImgDisplay; // 装箱图片的接口
        } else if (query.type === 'seal') {
            this.displayUrl = _const.apiUrl.lookSealImg; // 封箱图片的接口
        } else {
            this.displayUrl = _const.apiUrl.lookloaddoc; // 装箱单证图片的接口
        }
        this.getDisplayImg();
    },

    methods: {
        getDisplayImg: function getDisplayImg() {
            var _this = this;

            // 获取可展示的图片
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                id: this.id,
                servicetype: this.servicetype,
                referenceno: this.referenceno
            };
            this.isShowLoading = true;
            this.requestApi({
                url: this.displayUrl,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                var imgSrcList = dataObj.paths || [];
                if (imgSrcList.length === 0) {
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    _this.imgSrcList = imgSrcList;
                    return;
                }
                _this.imgSrcList = imgSrcList;
                _this.$previewRefresh();
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error);
                }
            });
        }
    }
};

/***/ }),

/***/ "elS0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DeliveImgList',
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {

      src2: __webpack_require__("fy9M"), // 送货的icon图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      isNoData: false
    };
  },
  created: function created() {
    document.title = '送货图片';
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code
      };
      this.isShowLoading = true;

      this.requestApi({
        url: _const.apiUrl.deliveImgListController,
        data: data
      }, function (resultData) {
        var list = resultData.data.list || [];
        if (list.length === 0) {

          _this.isNoData = true;
          _this.isShowLoading = false;
          _this.isShowTable = false;
          return;
        }
        _this.tableData = list;
      }, function (error) {
        _this.isShowLoading = false;
        if (error) {
          console.error(error);
        }
      });
    },
    goNextPage: function goNextPage(bookingId, ladingId, servicetype) {

      this.$router.push({
        name: 'DeliveImgLading',
        query: {
          bookingId: bookingId,
          ladingId: ladingId,
          servicetype: servicetype
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "etVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("zhp2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("mYjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_328eacef_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("y6Wx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("SSHx")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_328eacef_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_328eacef_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ewTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__ = __webpack_require__("ng3N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__ = __webpack_require__("g9ob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7f8efe6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__ = __webpack_require__("VQkV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("qnZv")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7f8efe6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7f8efe6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7f8efe6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "f2xR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loadImgUpload"}},[_c('div',[_c('div',{staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src1,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-item__first"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(_vm.ladingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.bookingId))])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contNo))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v("柜型：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contId))])])]),_vm._v(" "),_c('p',{staticStyle:{"color":"#333"}},[_vm._v(_vm._s(_vm.type === 'load' ? '装箱图片：' : _vm.type === 'seal' ? '封箱图片：' : '单证图片：'))]),_vm._v(" "),_c('uploadImg',{model:{value:(_vm.inputFiles),callback:function ($$v) {_vm.inputFiles=$$v},expression:"inputFiles"}})],1)]),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}}),_vm._v(" "),_c('div',{staticClass:"btn-box",staticStyle:{"margin-top":"0.2rem","padding":"0 0.16rem"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.uploadImg}},[_vm._v("确认上传")])])],1),_vm._v(" "),_c('MyBtnReturn',{attrs:{"step":_vm.step}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "fA0m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DeliveImgList',
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      src1: __webpack_require__("w2ig"), // 装箱的icon图片
      src2: __webpack_require__("fy9M"), // 送货的icon图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      isNoData: false
    };
  },
  created: function created() {
    document.title = '查看图片';
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code
      };
      this.isShowLoading = true;

      this.requestApi({
        url: _const.apiUrl.viewPicturesOrderList,
        data: data
      }, function (resultData) {
        var list = resultData.data.list || [];
        if (list.length === 0) {

          _this.isNoData = true;
          _this.isShowLoading = false;
          _this.isShowTable = false;
          return;
        }
        _this.tableData = list;
      }, function (error) {
        _this.isShowLoading = false;
        if (error) {
          console.error(error);
        }
      });
    },
    goNextPage: function goNextPage(bookingId, ladingId, servicetype) {

      this.$router.push({
        name: 'ViewPicture',
        query: {
          bookingId: bookingId,
          ladingId: ladingId,
          servicetype: servicetype
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "fGBG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "FreightPriceResult",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            tableData: [
                // {
                //   priceType: '20GP',
                //   pricePortLoading: '广州',
                //   priceDockLoading: '上海',
                //   totalup: '￥3000.23',
                //   priceGoodsName: '石油',
                //   priceCarriageItem: 'DR-DR(门-门)',
                //   priceConsigneeJhr: '广州市海珠区建南1',
                //   priceConsigneePlace: '广州市海珠区江南西',
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false,
            tableDataUrl: '' // 查询表单数据API，freightPriceTemplate
        };
    },
    created: function created() {
        document.title = '全程运输报价查询';
        this.tableDataUrl = _const.apiUrl.freightPriceTemplate;
    },
    mounted: function mounted() {
        // 要在这个钩子函数中才能一开始操作到scrollBottom标签
        this.onScrollBottom();
    },

    methods: {
        getMoreData: function getMoreData(url, data) {
            var _this = this;

            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle',
                    type: 'text'
                });
                return;
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data.page;
                var resultArr = dataObj.result || []; // 防止后台返回null
                if (resultArr.length === 0) {
                    // 如果没有数据，要告知用户（不在第一个if加上this.pageNo === 1，是怕后台莫名其妙传完[]）
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    // 如果是第一页就没有数据，那隐藏scroller吧
                    if (_this.pageNo === 1) {
                        _this.isShowTable = false;
                    }
                    return;
                }
                resultArr.forEach(function (item) {
                    _this.tableData.push(item);
                }); // 表格数据是放在result中
                _this.totalCount = dataObj.totalCount;
                _this.totalPages = dataObj.totalPages;
                _this.pageNo++;
                _this.$nextTick(function () {
                    _this.$refs.scrollerBottom.reset(); // 一开始不能v-if隐藏scrollBottom标签，否则这里获取不到scrollBottom标签
                }); // 要重置scroller组件
            }, function (error) {
                _this.isShowLoading = false;
                _this.canFetch = true;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        onScrollBottom: function onScrollBottom() {
            if (!this.canFetch) {} else {
                this.isShowLoading = true;
                this.canFetch = false;
                var query = this.$route.query;
                var data = {
                    place_loading: query.place_loading,
                    place_delivery: query.place_delivery,
                    group: query.group,
                    shipper: query.shipper,
                    pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                    pageNo: this.pageNo, // 当前为第几页数据，要累加
                    openId: _const.apiParams.openId,
                    companyId: _const.apiParams.companyId,
                    code: _const.apiParams.code
                };
                this.getMoreData(this.tableDataUrl, data);
            }
        }
    }
};

/***/ }),

/***/ "fZUZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fqc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){return _vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var staticRenderFns = []


/***/ }),

/***/ "frZV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'LoadImgLading',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: __webpack_require__("w2ig"), // 装箱的图片，右上角的icon
            // src2: require('@/assets/images/plan/wx_chai_oringe.png'), // 拆箱的图片
            uploadLoadSrc: __webpack_require__("wVEz"), // 装箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: __webpack_require__("ujfB"), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            iconClose: __webpack_require__("VrRN"), // 关闭图标
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'zzzz',
                //   loadimgisupload: 0,
                //   sealimgisupload: 1,
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'aaaaa',
                //   loadimgisupload: 1,
                //   sealimgisupload: 0,
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            isNoData: false
        };
    },
    created: function created() {
        document.title = '装货图片';
        var query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            // 获取工作单下要上传图片的柜，一个工作单可能有多个柜号id
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                servicetype: this.servicetype
            };
            this.isShowLoading = true;
            // 调用接口获取数据
            this.requestApi({
                url: _const.apiUrl.loadImgLading,
                data: data
            }, function (resultData) {
                _this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况
                _this.tableData = resultData.data.sonos || [];
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        goNextPage: function goNextPage(routerName, id, referenceno, contNo, contId, type) {
            // 按钮的方法，跳转上传或查看页面，并且带些参数过去
            // todo 有个bug，在这层跳转到下一个页面时，会感觉到先关闭当前窗口，然后重新打开一个窗口？导致数据丢失，而且用go回退时要两次！
            // 但有时候又是直接一次跳转成功，奇怪！

            this.$router.push({
                name: routerName,
                // path: '/load-img-upload',
                query: {
                    bookingId: this.bookingId,
                    ladingId: this.ladingId,
                    servicetype: this.servicetype,
                    id: id,
                    referenceno: referenceno,
                    contNo: contNo,
                    contId: contId,
                    type: type, // 为了区分装箱与封箱，load为装箱，seal为封箱,loaddoc为单证图片
                    companyId2: _const.apiParams.companyId,
                    openId2: _const.apiParams.openId
                }
            });
        }
    }
};

/***/ }),

/***/ "fy9M":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABaCAMAAAB5TAO7AAAAYFBMVEUAAAAyxp0yxp0yxp0yxp0yxp0yxp0yxp0yxp0yxp0yxp0yxp0yxp0yxp0yxp0yxp0yxp3////1+/lJyqVt0rPg9O2/6dum4s6Z3sjW8ed91rpczqzr+POM2sGz5dXK7eGXYirwAAAAEHRSTlMA8+jczKWNc1tGMyQXDbq5t8q2lAAAAnZJREFUaN601cluKyEQhWHufDOKU8zQHb//W8ZdhKAsolIhcRa2d596+LH5Z/fPmP8/7NYxYh62K+a+x59278y1p1926wzv+bfdOdP38mo3zoz9sftmPvfXjm1EZpYbkZnlRmRmuRGZWe5E1rN0OTUFspZlA7ICWcyS8KZAFrMsKApkMcuCoEX0WRZAgaizrP2zWgWizTIifyGpeAHRZ+kCPt8r7+4IUCVEn6W7AfHDC84mwMmIPssDSNf3CZCPICsi+izzuBLrCXQ6LyL6LDOuQlxXwjhdWqwCosnSE4KzLozHwpflI3C4bxB9lo1Avl+OGw+oHLgvioic5XyB/bhpnr95ITXhmSiyLBgpngTybCXgYFhE5CxRYroBaT4cIPJdqwSq3yKaLBt48eutA/nLO4AsI3KWvpSSynUh52BvAG7DExBFlicO24CS7ivgFcfKkEVEztIRUsVcSkBoQvHqLCPI50gXQPFAsLl3IyC6LBtx2a7WZvkA7ueXgGizTD11XgXOfn41AdFmGTHT478vPscERJ1l5Dh4AUX+j9dmOZU6fsmINsup9PYS4EVkNcuM/jQqUEVkOctMQGQkich6lp74VU65ych6lu29tjpGQSCGoihqk6QUHARt3P8ybQZO/Yv7NnAg5PLf99UaIPMsr6+vPEDmWb5+U2Se5ecaPNc0Sxsggyw7RJYhYitEbIeInRSRZYnIskRkWSKyLBFZhogsnyFiK0Rsh4idFJFliciyRGRZIrIsEVmWiCxDxFaI2A4ROykiyxKRZYnIskRkWSKyjBFZQqqtELEdInZSRJYlIssSkWWJyLJEZNkisnz0W5Bw+w+EBR+T1k/lxwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "g9ob":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Plan",
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      src1: __webpack_require__("w2ig"), // 装箱的图片
      src2: __webpack_require__("qDaJ"), // 拆箱的图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
      isNoData: false,
      noDataText: '' // 无数据时的文本
    };
  },
  created: function created() {
    document.title = '计划查询';

    if (this.$route.name === 'TodayPlan') {
      this.tableDataUrl = _const.apiUrl.todayPlan;
      this.noDataText = '今日暂无计划';
    } else {
      this.tableDataUrl = _const.apiUrl.tomorrowPlan;
      this.noDataText = '明日暂无计划';
    }
    var data = {
      openId: _const.apiParams.openId,
      companyId: _const.apiParams.companyId,
      code: _const.apiParams.code
    };
    this.getData(this.tableDataUrl, data);
  },

  methods: {
    getData: function getData(url, data) {
      var _this = this;

      this.isShowLoading = true;

      this.$http({
        method: 'post',
        url: url,
        data: data
      }).then(function (res) {
        var resultData = res.data;
        var code = resultData.code;
        var info = resultData.info;
        if (code === 412) {
          _this.showToast(info, 2000, 'warn');

          _this.isNoData = true;
          _this.noDataText = info;
        } else if (code === 500) {
          _this.showToast(info, 2000, 'warn');
        } else {
          var list = resultData.data.list || [];
          _this.tableData = list;
        }
        _this.isShowLoading = false;
      }, function (error) {
        _this.isShowLoading = false;
        console.error(error);
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "gBGf":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gIQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []


/***/ }),

/***/ "h9fF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h9vq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("oyyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("wSNw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_49fe4aca_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("1Q5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("9O+z")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_49fe4aca_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_49fe4aca_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hGvq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_item_vue__ = __webpack_require__("Dk6r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_item_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_item_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_item_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_item_vue__ = __webpack_require__("1jKx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6ac06bd6_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_checker_item_vue__ = __webpack_require__("SFNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("wV0P")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_checker_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6ac06bd6_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_checker_item_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6ac06bd6_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_checker_item_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ik+1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__("oWtu");

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'check-icon',
  components: {
    Icon: _icon2.default
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),

/***/ "ipeC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContNo_vue__ = __webpack_require__("GK7v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContNo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContNo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContNo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContNo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContNo_vue__ = __webpack_require__("BG2Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContNo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContNo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c228556a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ReportContNo_vue__ = __webpack_require__("Sd/X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("lVk6")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c228556a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContNo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c228556a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ReportContNo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c228556a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ReportContNo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "itOs":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAT4AAADACAMAAACqCf/fAAAAeFBMVEUAAADz9fnz9fnz9fnz9fnz9fnz9fn///+IiIiZmZna297Gx8moqavn6Ozt7e3t7/Py8vOhoaLg4uW3uLqurq+RkZHAwMKxsrOenp7Nz9Hh4eHT1dj8/PzQ0dLExca9vb66urujo6SioqL09PTp6+7Kysq2tretra2HEi8yAAAABnRSTlMA875NhEzEWFrSAAAFoElEQVR42uzb227iMBSF4UBbW2tEQhAWMVFOnN//DYdOpBGUUgz7Zkld3yXc/SIksb2zLHubTpw8bTL9yM7enbzoPcs+nLzsLZs6edk00/+ewSRzYqB8ypdM+bgon/IlUz4uyqd8yZSPi/IpXzLl46J8ypdM+bgon/IlUz4uyqd8yZSPi/IpXzLl46J8ypdM+bgon/IlUz4uyqd8yZSPi/IpXzLl46J8ypdM+bjQ5svXfVhEIC5Cv84dKc58ebfBlU3HWZAxX13hUwx9dzh0fYj4VNWOD1++/RFnp7bw/xXtCWfHvWNDl6+NAFaF/6JYAYitI0OWbz4AGEr/jfLfV3NHhSvfPADb2t9Rb4HA1Y8q33wGVDt/164CZlT9mPLNA7Bs/A+aJdnvjynfACz9A0tgcDyI8rVA1fgHmgoguv/y5NtHbHf+od0Wkef5jyffEah9gho4OhY0+Wpg8EkGgOb9jSZfBZQ+SQlUjgRLvhxY+RvNbOP8jRXAsv7Ckq8DCn+j/PbTAugcB5Z8G5x8aj5/wsZxIMmXA216vpbm6iXJtwaK9HwFsHYUSPL1iD49n4/oHQWSfAHhmXwBwVEgybdA/0y+HgtHgSRfROcvNMWoBv4Uo8Zf6BAdBZJ8wMFfmOHG9rLfAXAUlM+AJt/Xi7cc5UBdjnTx3qVbh4keXEz02GyilzYTLRnYPLlgFbRgdUXLpSZarLfRVpGJNipttE1uokMaNjoiZKMDaiY6Hmmjw7k2Ohpuo8EEI43FWI1DWeF6KCtoKCuRRgKNNJBqpXHoX+Evu3a32zgIhGE4265Gw58sg3Bkcf/3ueCpgp21K5oDizrfewJpRCU/simNAj7wNQe+vgIf+JoDX1+BD3zNga+vwAe+5sDXV+ADX3Pg6yvwga858PUV+MDXHPj6Cnzga+66fNpv5r+kXvhc5OnxQnGgmte7PYwNW1pNT+xMPt7NkHRnDmapIPDdSI6ILO8nUuDLGX5EnmuawCfp0shBSxmsDI5Kc8YwQW46H1kZEznWu0+M3eyoZt6MLycUkmYmadEbB6LA0VPWY0/kmcPTmrCyAV/l03HRo0HxlAV4ppyRn9U1mh8Rga/ykZ8GGR0RJU9LabvGRfDt80nyd2LQ6+qaYfx6mr2ccDZ8O53C2B+f5nWPNV6xYr4P5OVBB9+P+GxGS5GViRyL3pZv3DtTn1AnfF7nmI0MmiSz4qM5o3mVRZXo7ex953canzOSYmukwCwTtzkYH/DlXF5cUiYDvhmf5sOy1mStzTZjHvb5fJpGzt1TiHmwRr8Xn7dSMZIyh0w8LY3f7X2ac6Nx+dVgFkj3VnxSwXF1+vQOhzJWYFX5yEwpL5zUVLC9Gc0Kze7cz+d0Np+pZk98gXMz0eHel3OcU5Oj3Fvy3etztuVzvKSP+CRnxseRrvIpDnrVdfmG+JB44rMcmEeO7hs+O6UiqBKVKt+T13X55rr1bfkSs2NOiseDY7Ms5hgSSYWvrqVHV+bLPCRt+VzkUC47sT3moxRiPfZVvokV1S7MJ59FSWu+oTy1y2XfDx9eKd0zYNREK77IE9Wuy+divfmEr06NXPZAx3ySM3HMQ+WbmT3VLss3jJsLEz7JBPq67H2+oFeleRmC8MmGULsqX9EzVPvJJy67CV82TrTqonxeMQeqHfPV/zoa+LwMtYvyha3eMd/x3rdN9r45RkfrLspH05OBt5Y2yYcHvgySNkZW2pn+b7YT5by89/R7TqqfL2n80sAHvubA11fgA19z4Osr8IGvOfD1FfjA1xz4+gp84GsOfH0FPvA1B76+Ah/4mgNfX4EPfM2Br6/AB77mwNdX4ANfc+DrK/CBrznw9RX4wNcc+PoKfOBrDnx9dftD6OX+3D4IvdzH7ZPQy33ebn8Jvdi/sTAAATPTaPlHBmBkAqY9AOYz0xooyUZIAAAAAElFTkSuQmCC"

/***/ }),

/***/ "j/5W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j0Pk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "j1+K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j15Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"vux-divider"},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "jBoD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyFooter = __webpack_require__("m+mo");

var _MyFooter2 = _interopRequireDefault(_MyFooter);

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Voyage',
    components: {
        MyFooter: _MyFooter2.default,
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            place_loading: null,
            place_loadingOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            place_delivery: null,
            place_deliveryOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            title: [],
            canCall: true, // true代表能继续发送请求，控制search方法的
            startAreaUrl: '', // 查询起运地API，voyageSearch或voyageSearchYeWu
            endAreaUrl: '', // 查询目的地API，changePlace目的地或changePort目的港
            routeName: ''
        };
    },
    created: function created() {
        document.title = '船期查询';
        // this.test()
        // 判断是哪个路由路径，然后获取相应数据
        this.routeName = this.$route.name;
        if (this.routeName === 'VoyageKehu') {
            // 如果是客户应用的
            this.title = ['起始地', '目的地'];
            this.startAreaUrl = _const.apiUrl.voyageSearch;
            this.endAreaUrl = _const.apiUrl.changePlace;
            this.tableDataUrl = _const.apiUrl.voyageTemplate;
        } else {
            // 如果是业务应用的
            this.title = ['起始港', '目的港'];
            this.startAreaUrl = _const.apiUrl.voyageSearchYeWu;
            this.endAreaUrl = _const.apiUrl.changePort;
            this.tableDataUrl = _const.apiUrl.voyageTemplateYw;
        }

        this.searchArea();
    },

    methods: {
        searchArea: function searchArea() {
            var _this = this;

            // 获取起始与目的等地点:如果没获取到，要提示用户重新打开页面吗？
            // 这里获取的目的地应该是总数量，可随用户选
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.requestApi({
                url: this.startAreaUrl,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                // todo:囧，结果后台返回了数组里一个null，[null]，selector组件直接崩溃
                if (_this.routeName === 'VoyageKehu') {
                    _this.place_loadingOps = dataObj.startPlaces || []; // 防止后台返回null
                    _this.place_deliveryOps = dataObj.endPlaces || []; // 防止后台返回null
                } else {
                    _this.place_loadingOps = dataObj.startPorts || []; // 防止后台返回null
                    _this.place_deliveryOps = dataObj.endPorts || []; // 防止后台返回null
                }
            }, function (error) {
                if (error) {
                    console.error(error);
                }
            });
        },
        startChange: function startChange(value) {
            var _this2 = this;

            if (!value) return;
            // 去获取目的地的数据：这是根据起运地获取的，数量应该没startAreaUrl接口的多吧？
            // 加一个loading吧，顺便可以不让用户又去选择另一个起运地
            this.$vux.loading.show({
                text: 'Loading'
            });
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                start: this.place_loading || ''
            };
            this.requestApi({
                url: this.endAreaUrl,
                data: data
            }, function (resultData) {
                _this2.$vux.loading.hide();
                var dataObj = resultData.data;
                // 囧，结果后台返回了数组里一个null，[null]，selector组件直接崩溃
                if (_this2.routeName === 'VoyageKehu') {
                    _this2.place_deliveryOps = dataObj.findEndPlace || []; // 防止后台返回null
                } else {
                    _this2.place_deliveryOps = dataObj.findEndPort || []; // 防止后台返回null
                }
                _this2.place_delivery = null; // 目的地被选中项变为null，不然查询时会记忆回来选择的
            }, function (error) {
                _this2.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            });
        },
        search: function search() {
            this.$router.push({
                name: 'VoyageResult',
                query: {
                    place_loading: this.place_loading || '',
                    place_delivery: this.place_delivery || '',
                    routeName: this.routeName // 传递路由name给结果页面，可以判断是客户还是业务应用
                }
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "jK9e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "QuoteResult",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            tableData: [],
            newData: [{
                sPlace: '广州',
                sPort: '黄埔港',
                ePlace: '天津',
                ePort: '天津港',
                // ship_company: '',
                truck_delivery: '远集拖车',
                tf_loading1_t: 10,
                // tf_loading2_t: 0,
                // oceanfee: 0,
                cont_fee: 10,
                // order_fee: 0,
                // baf: 0,
                port_fee: 20
                // tf_delivery1: 0,
                // tf_delivery2_t: 0,
                // totalup1: 0,
                // totalup2: 0,
            }], // 假数据，后续要注释
            canFetch: true, // false为阻止继续获取数据
            isShowLoading: false,
            isShowTable: true,
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回
            totalPages: 2, // 总页数，初始化必须比pageNo大；发现后台也有返回
            isNoData: false // false代表还有数据
        };
    },
    created: function created() {
        document.title = '报价查询';
        this.onScrollBottom(); // 组件被创建时，就先获取一次数据
    },

    methods: {
        getData: function getData(url, data) {
            var _this = this;

            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.isShowLoading = false;
                this.canFetch = true;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle'
                });
                return;
            }
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 调用接口获取数据
            this.$http({
                method: 'post',
                url: url,
                data: data
            }).then(function (res) {
                var resultData = res.data; // 后台返回结果
                var code = resultData.code;
                var info = resultData.info; // 412或500的提示语
                if (code === 412) {
                    _this.$vux.toast.show({
                        // text: '状态出错，请重新操作！',
                        text: info,
                        time: 1000,
                        type: 'warn'
                    });
                    _this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                    _this.isShowLoading = false;
                    _this.$vux.loading.hide();
                    return;
                }
                if (code === 500) {
                    _this.$vux.toast.show({
                        // text: '系统繁忙！',
                        text: info,
                        time: 1000,
                        type: 'warn'
                    });
                    _this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                    _this.isShowLoading = false;
                    _this.$vux.loading.hide();
                    return;
                }
                // 如果一切正常，那就渲染数据
                _this.$vux.loading.hide();
                var dataObj = resultData.data.page;
                if (dataObj.result.length === 0) {
                    // 如果没有数据了，要告知用户
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    // 如果第一页就没数据，那隐藏scroller
                    if (_this.pageNo === 1) {
                        _this.isShowTable = false;
                    }
                    return;
                }
                dataObj.result.forEach(function (item) {
                    _this.tableData.push(item);
                }); // 表格数据是放在result中
                _this.totalCount = dataObj.totalCount;
                _this.totalPages = Math.ceil(_this.totalCount / _this.pageSize);
                _this.pageNo++;
                _this.$nextTick(function () {
                    _this.$refs.scrollerBottom.reset();
                }); // 要重置scroller组件
                _this.isShowLoading = false;
                _this.canFetch = true;
            }).catch(function (error) {
                _this.canFetch = true;
                _this.$vux.loading.hide();
                console.error(error.response);
            });
        },
        onScrollBottom: function onScrollBottom() {
            this.isShowLoading = true;
            var query = this.$route.query;
            var data = {
                splace: query.splace,
                sport: query.sport,
                eport: query.eport,
                eplace: query.eplace,
                cont: query.cont,
                pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                pageNo: this.pageNo, // 当前为第几页数据，要累加
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            if (!this.canFetch) {} else {
                this.canFetch = false;
                this.getData(_const.apiUrl.quoteTemplate, data);
            }
        }
    }
};

/***/ }),

/***/ "jOOX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'DeliveImgLading',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src2: __webpack_require__("fy9M"), // 送货的icon图片
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'zzzz',
                //   deliveimgisload: 0,
                //   openimgisupload: 1,
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'aaaaa',
                //   deliveimgisload: 1,
                //   openimgisupload: 0,
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            isNoData: false
        };
    },
    created: function created() {
        document.title = '送货图片';
        this.bookingId = this.$route.query.bookingId;
        this.ladingId = this.$route.query.ladingId;
        this.servicetype = this.$route.query.servicetype;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            // 获取工作单下要上传图片的柜，一个工作单可能有多个柜号id
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                servicetype: this.servicetype
            };
            this.isShowLoading = true;
            // 调用接口获取数据
            this.requestApi({
                url: _const.apiUrl.deliveImgLading,
                data: data
            }, function (resultData) {
                _this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况
                _this.tableData = resultData.data.sonos || [];
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        goNextPage: function goNextPage(routerName, id, referenceno, contNo, contId, type) {
            // 按钮的方法，跳转查看页面，并且带些参数过去
            this.$router.push({
                name: routerName,
                query: {
                    bookingId: this.bookingId,
                    ladingId: this.ladingId,
                    servicetype: this.servicetype,
                    id: id,
                    referenceno: referenceno,
                    contNo: contNo,
                    contId: contId,
                    type: type, // 为了区分装箱与封箱，load为装箱，seal为封箱,delivedoc为送货单证图片
                    companyId2: _const.apiParams.companyId,
                    openId2: _const.apiParams.openId
                }
            });
        }
    }
};

/***/ }),

/***/ "jWrU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkM5NkEyQjkzQkYzQzExRTlCNEJBQzU2QzYyOERFNzk0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkM5NkEyQjk0QkYzQzExRTlCNEJBQzU2QzYyOERFNzk0Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Qzk2QTJCOTFCRjNDMTFFOUI0QkFDNTZDNjI4REU3OTQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Qzk2QTJCOTJCRjNDMTFFOUI0QkFDNTZDNjI4REU3OTQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7GUFl2AAABjklEQVR42uyXUSsEURTH74zJqwjLB2CJkCivxIeg8MSLPHhTJGpLkvDg0Ruy30CEb+BJ2MiyiVZePNu1/qf+6iYzZme7dyOnftOc5ja/PTtzz73jFCaUxAiYBy3AUWaiAK5AAux5OAyDXWU+pKBWuhwHFZ/jpE3ZjUsXh7iyH00i9sog9lxVpviT4iw4Bu82xRegAwyCBVtiaRID4Jn5qw1xitIs8z52KqPia0qfmPeCA1BlUnxD6SPzHnDkJw0Syw1GwSqbe1Dcgn7wwLwbHAZJVUDX2gQ72o9Y9xmX/iLtYqXVUeexTIMKnm+A2W/G3PPvzTDvpLSmlAYyBLa16ytgUbueYaV3zNsprQ3drAOujYM3MMnnvAQqwRgrTXOcLKknoK6oxRnr8U8vzxaY1l4yqeqF57Kwn4KYiV49Bda0/FMaZ6WxKPMv7DyeActa3kxpQ+QFuYix8mbXgzMwBxpL2oCFeMb/G4HfL86VwZtzuWOwHSnXb4dgOBIiTvL7SSrPG5Tl6ZAPxP0PAQYAV4ZPfrvNcfMAAAAASUVORK5CYII="

/***/ }),

/***/ "jp8c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _amapLocation = __webpack_require__("3lov");

var _amapLocation2 = _interopRequireDefault(_amapLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "test",
  components: {
    amapLocation: _amapLocation2.default
  },
  data: function data() {
    return {
      location: {
        address: null
      }
    };
  },

  watch: {
    address: function address(newValue, oldValue) {}
  },
  methods: {}
}; //
//
//
//
//
//
//
//

/***/ }),

/***/ "jsSu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k48M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _base = __webpack_require__("f6Hi");

var _base2 = _interopRequireDefault(_base);

var _icon = __webpack_require__("oWtu");

var _icon2 = _interopRequireDefault(_icon);

var _toast = __webpack_require__("rLAy");

var _toast2 = _interopRequireDefault(_toast);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _isEmail = __webpack_require__("2LX0");

var _isEmail2 = _interopRequireDefault(_isEmail);

var _isMobilePhone = __webpack_require__("Ewe+");

var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);

var _debounce = __webpack_require__("nror");

var _debounce2 = _interopRequireDefault(_debounce);

var _vanillaMasker = __webpack_require__("lFEC");

var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var validators = {
  'email': {
    fn: _isEmail2.default,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return (0, _isMobilePhone2.default)(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
exports.default = {
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = (0, _debounce2.default)(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [_base2.default],
  components: {
    Icon: _icon2.default,
    InlineDesc: _inlineDesc2.default,
    Toast: _toast2.default
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return (0, _keys2.default)(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? _vanillaMasker2.default.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = (0, _keys2.default)(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
};

/***/ }),

/***/ "kW1H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _cell = __webpack_require__("1DHf");

var _cell2 = _interopRequireDefault(_cell);

var _popup = __webpack_require__("HD9R");

var _popup2 = _interopRequireDefault(_popup);

var _radio = __webpack_require__("QHDY");

var _radio2 = _interopRequireDefault(_radio);

var _props = __webpack_require__("Zor0");

var _props2 = _interopRequireDefault(_props);

var _props3 = __webpack_require__("2IIR");

var _props4 = _interopRequireDefault(_props3);

var _transferDom = __webpack_require__("63CM");

var _transferDom2 = _interopRequireDefault(_transferDom);

var _arrayFind = __webpack_require__("NXHL");

var _arrayFind2 = _interopRequireDefault(_arrayFind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _cellProps = (0, _props4.default)(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

delete _cellProps.value;

exports.default = {
  name: 'popup-radio',
  components: {
    Popup: _popup2.default,
    Radio: _radio2.default,
    Cell: _cell2.default
  },
  directives: {
    TransferDom: _transferDom2.default
  },
  props: (0, _extends3.default)({
    placeholder: String,
    readonly: Boolean
  }, _cellProps, (0, _props2.default)()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if ((0, _typeof3.default)(this.options[0]) === 'object') {
        var match = (0, _arrayFind2.default)(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
};

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("zaRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("zprm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_02febef1_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("OrxC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("H0qR")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_02febef1_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_02febef1_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("9ADW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("xpjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7621b982_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("O4d1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("4jQ+")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7621b982_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7621b982_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lVk6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lfAX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _const = __webpack_require__("ZLd3");

var _imageConversion = __webpack_require__("WFjR");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'uploadImg',
    data: function data() {
        return {
            itemWidth: 0,
            iconClose2: __webpack_require__("VrRN") // 关闭图标
        };
    },

    props: {
        value: {
            type: Array,
            default: null
        }
    },
    watch: {
        value: {
            handler: function handler(newValue, oldValue) {
                this.$previewRefresh();
            },

            immediate: true
        }
    },
    methods: {
        /**
         * 选择图片回调, 压缩图片
         * @param {Object} e
         */
        getImg: function getImg(e) {
            if (!e.target.files[0]) return;
            var files = e.target.files;
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                // let file = new File([files[i]], files[i].name, {type: files[i].type})
                var imgItem = {
                    imgSrc: URL.createObjectURL(file),
                    iconClose: this.iconClose2,
                    flag: '1',
                    progress: 0, // 进度
                    error: false, // 是否上传失败
                    file: file,
                    compress: true, // 是否正在压缩
                    compressTag: false // 压缩标志，压缩成功的图片不再压缩 会遇到压缩完成图片大于512的
                };
                this.value.splice(this.value.length - 1, 0, imgItem);
                this.uploadImg(imgItem);
            }
            // document.getElementById('inputFile').value = '';
        },

        /**
         * 异步压缩图片
         * @param {Object} imgItem
         */
        compress: function compress(imgItem) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var res, newFile;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                imgItem.compress = true;
                                _context.next = 3;
                                return (0, _imageConversion.compressAccurately)(imgItem.file, 512);

                            case 3:
                                res = _context.sent;
                                newFile = new File([res], imgItem.file.name, { type: res.type });

                                imgItem.file = newFile;
                                imgItem.compress = false;
                                imgItem.compressTag = true;
                                _this.uploadImg(imgItem);

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        /**
         * 上传图片
         * @param {Object} file
         */
        uploadImg: function uploadImg(imgItem) {
            var _this2 = this;

            if (imgItem.file.size / 1024 > 512 && !imgItem.compressTag) {
                this.compress(imgItem);
                return;
            }
            imgItem.compress = false;
            imgItem.imgSrc = URL.createObjectURL(imgItem.file);
            imgItem.error = false;
            imgItem.progress = 0;
            this.getToken(imgItem, function (token) {
                var axiosInstance = _axios2.default.create({
                    withCredentials: false
                }); //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
                var data = new FormData();
                data.append('token', token); //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
                data.append('file', imgItem.file);
                var companyId = _const.apiParams.companyId || _this2.getUrlParams('companyId') || 'Unknown';
                var dateStr = new Date().Format('yyyyMMdd');
                var randStr = Math.random(5).toString(36).substr(2) || 'Unknown';
                var extName = imgItem.file.name.substring(imgItem.file.name.lastIndexOf('.') + 1) || '.jpg'; //后缀名
                var key = companyId + '_' + dateStr + '_' + randStr + '.' + extName;
                data.append('key', key);
                axiosInstance({
                    method: 'POST',
                    url: 'https://up-z2.qbox.me', //上传地址
                    data: data,
                    timeout: 30000, //超时时间，因为图片上传有可能需要很久
                    onUploadProgress: function onUploadProgress(progressEvent) {
                        // 是上传进度，可以用来添加进度条
                        var imgLoadPercent = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                        // 由于上传进度满足100但是key还没返回，在返回url那里将进度赋值100，这里100改为99
                        imgItem.progress = imgLoadPercent < 100 ? imgLoadPercent : 99;
                    }
                }).then(function (data) {
                    var key = data.data.key;
                    imgItem.progress = 100;
                    imgItem.imgSrc = 'http://img.aohaisoft.com/' + key;
                    imgItem.error = false;
                }).catch(function (err) {
                    //上传失败
                    imgItem.error = true;
                });
            });
        },

        /**
         * 获取上传token
         */
        getToken: function getToken(imgItem, success, fail) {
            var _this3 = this;

            success = success || function () {};
            fail = fail || function () {};

            var storage = window.localStorage;
            var qnToken = storage['qToken'];
            if (qnToken) {
                qnToken = JSON.parse(qnToken);
                var date = new Date().getTime();
                if (parseInt((date - qnToken.endDate) / 1000 / 60) <= 50) {
                    success(qnToken.token);
                    return;
                }
            }

            this.requestApi({
                url: '/AohyWebchatS/qiniu/getSimpleToken/wxtrace.do'
            }, function (res) {
                if (res.code === 200) {
                    var token = res.data;
                    storage['qToken'] = (0, _stringify2.default)({
                        token: token,
                        endDate: new Date().getTime()
                    });
                    success(token);
                } else {
                    _this3.showToast('获取token失败！', 2000, 'cancel');
                    fail();
                }
            }, function (error) {
                if (error) {
                    _this3.showToast('获取token失败！', 2000, 'cancel');
                    fail();
                    imgItem.error = true;
                }
            });
        },

        /**
         * 上传失败，重新上传
         * @param {Object} index
         */
        reUpload: function reUpload(index) {
            this.uploadImg(this.value[index]);
        },

        /**
         * 删除图片
         * @param {Object} index
         */
        resetImg: function resetImg(index) {
            this.value.splice(index, 1);
            document.getElementById('inputFile').value = '';
        }
    },
    mounted: function mounted() {
        var o = document.getElementById('upload-img');
        if (o) {
            this.itemWidth = parseInt((o.clientWidth || o.offsetWidth) / 3);
        }
        this.getToken();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "lz1h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m+mo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue__ = __webpack_require__("3c9e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue__ = __webpack_require__("P+D6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50073856_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_MyFooter_vue__ = __webpack_require__("2nGA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("lz1h")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50073856"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50073856_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_MyFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50073856_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_MyFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "m8iH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"freightPriceResult"}},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"place_loading"},[_vm._v(_vm._s(_vm.$route.query.place_loading || '起运地'))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Nf+F"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"place_delivery"},[_vm._v(_vm._s(_vm.$route.query.place_delivery || '目的地'))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_c('scroller',{ref:"scrollerBottom",attrs:{"height":"6rem","lock-x":"","scroll-bottom-offset":50},on:{"on-scroll-bottom":_vm.onScrollBottom}},[_c('div',{staticClass:"box2"},[_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-left"},[_c('img',{attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"price-type"},[_vm._v(_vm._s(item.priceType))])]),_vm._v(" "),_c('b',{staticClass:"list-item-right"},[_vm._v(_vm._s(item.totalup))])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-left"},[_c('img',{staticStyle:{"width":"0.2rem"},attrs:{"src":__webpack_require__("XCoW"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"price-goods-name"},[_vm._v(_vm._s(item.priceGoodsName))]),_vm._v(" "),_c('i',[_vm._v("|")]),_vm._v(" "),_c('b',{staticClass:"price-carriage-item"},[_vm._v(_vm._s(item.priceCarriageItem))])])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-left"},[_c('img',{staticStyle:{"width":"0.2rem"},attrs:{"src":__webpack_require__("A+vQ"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.priceConsigneeJhr))])])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-left"},[_c('img',{staticStyle:{"width":"0.2rem"},attrs:{"src":__webpack_require__("I3VT"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.priceConsigneePlace))])])])])}),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],2)])],1),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "m9C4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mHiu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-img",attrs:{"id":"upload-img"}},_vm._l((_vm.value),function(item,index){return _c('div',{key:index,staticClass:"item",style:({ width: _vm.itemWidth + 'px', height: _vm.itemWidth + 'px' })},[(!item.iconClose)?_c('img',{attrs:{"src":item.imgSrc}}):_c('img',{attrs:{"src":item.imgSrc,"preview":"0"}}),_vm._v(" "),(item.flag === '1')?_c('img',{staticClass:"close-img",attrs:{"src":item.iconClose},on:{"click":function($event){return _vm.resetImg(index)}}}):_c('input',{staticClass:"input-file",attrs:{"name":"file","type":"file","accept":"image/*","multiple":"multiple","id":"inputFile"},on:{"change":_vm.getImg}}),_vm._v(" "),(item.compress)?_c('div',{staticClass:"progress",staticStyle:{"font-size":"16px"}},[_vm._v("正在压缩")]):(item.progress < 100 && !item.error)?_c('div',{staticClass:"progress"},[_vm._v(_vm._s(item.progress)+"%")]):_vm._e(),_vm._v(" "),(item.iconClose && item.error)?_c('button',{staticClass:"load-err",on:{"click":function($event){return _vm.reUpload(index)}}},[_vm._v("上传失败"),_c('br'),_vm._v("点击重试")]):_vm._e()])}),0)}
var staticRenderFns = []


/***/ }),

/***/ "mYjQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _base = __webpack_require__("f6Hi");

var _base2 = _interopRequireDefault(_base);

var _tip = __webpack_require__("h9vq");

var _tip2 = _interopRequireDefault(_tip);

var _icon = __webpack_require__("oWtu");

var _icon2 = _interopRequireDefault(_icon);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _objectFilter = __webpack_require__("q5lo");

var _arrayShuffle = __webpack_require__("HHx2");

var _arrayShuffle2 = _interopRequireDefault(_arrayShuffle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'checklist',
  components: {
    Tip: _tip2.default,
    Icon: _icon2.default,
    InlineDesc: _inlineDesc2.default
  },
  filters: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey
  },
  mixins: [_base2.default],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = (0, _arrayShuffle2.default)(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey,
    getInlineDesc: _objectFilter.getInlineDesc,
    getFullValue: function getFullValue() {
      var labels = (0, _objectFilter.getLabels)(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, (0, _objectFilter.getLabels)(this.options, _val));
    },
    value: function value(newVal) {
      if ((0, _stringify2.default)(newVal) !== (0, _stringify2.default)(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, (0, _objectFilter.getLabels)(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && (0, _keys2.default)(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
};

function pure(obj) {
  return JSON.parse((0, _stringify2.default)(obj));
}

/***/ }),

/***/ "mmg8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'BusinessResult',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            tableData: [],
            // newData: [
            //   {
            //     contNo: 'asfasf',
            //     mblNo: 'aaaaaa',
            //     truckStatus: 0,
            //     loadOverStatus: 1,
            //     inVesselStatus: 0,
            //     isArrived: 0,
            //     goodsReliveStatus: 1,
            //     isGoodskeep: 0,
            //   },
            // ], // todo:虚假数据，模拟滚动加载新数据功能，后续注释
            radioIconGrey: __webpack_require__("2DUM"),
            radioIconGreen: __webpack_require__("7GQS"),
            goodsKeepIcon1: __webpack_require__("/hKF"),
            goodsKeepIcon0: __webpack_require__("IYP8"),
            canFetch: true, // false为阻止继续获取数据
            isShowLoading: false,
            isShowTable: true,
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false, // false代表还有数据
            tableDataUrl: _const.apiUrl.businessTemplate // 查询表单数据API，businessTemplate
        };
    },
    created: function created() {
        document.title = '货物跟踪';
    },
    mounted: function mounted() {
        // 要在这个钩子函数中才能一开始操作到scrollBottom标签
        this.onScrollBottom(); // 组件被创建时，就先获取一次数据
    },

    methods: {
        getMoreData: function getMoreData(url, data) {
            var _this = this;

            // 获取表格数据（分页数据）
            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle'
                });
                return;
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data.page;
                var resultArr = dataObj.result || []; // 防止后台返回null
                if (resultArr.length === 0) {
                    // 如果没有数据，要告知用户
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    // 如果是第一页就没有数据，那隐藏scroller吧
                    if (_this.pageNo === 1) {
                        _this.isShowTable = false;
                    }
                    return;
                }
                resultArr.forEach(function (item) {
                    _this.tableData.push(item);
                }); // 表格数据是放在result中
                _this.totalCount = dataObj.totalCount;
                _this.totalPages = dataObj.totalPages;
                _this.pageNo++;
                _this.$nextTick(function () {
                    _this.$refs.scrollerBottom.reset();
                }); // 要重置scroller组件
            }, function (error) {
                _this.isShowLoading = false;
                _this.canFetch = true;
                if (error) {
                    console.error(error);
                }
            });
        },
        onScrollBottom: function onScrollBottom() {
            this.isShowLoading = true;
            var query = this.$route.query;
            var data = {
                cont_no: query.cont_no,
                m_bl_no: query.m_bl_no,
                lading_id: query.lading_id,
                consignee_id: query.consignee_id,
                datediff: query.datediff,
                pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                pageNo: this.pageNo, // 当前为第几页数据，要累加
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            if (!this.canFetch) {} else {
                this.canFetch = false;
                this.getMoreData(this.tableDataUrl, data);
            }
        },
        editDate: function editDate(data) {
            // 将'√18.02.27'这种数据弄成2018.02.27这样的
            if (data !== '×') {
                var reg = /\D*(.*)/;
                var date = '20' + data.match(reg)[1];
                return date;
            } else {
                return null;
            }
        }
    }
};

/***/ }),

/***/ "mqin":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"feeMaintain"}},[_c('div',{staticClass:"lading"},[_c('img',{staticStyle:{"width":"4px","margin-right":"0.1rem"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v("\n    "+_vm._s(_vm.ladingId)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"fee-list"},_vm._l((_vm.feeList),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('popup-picker',{attrs:{"title":"","data":_vm.feeType},model:{value:(item.key),callback:function ($$v) {_vm.$set(item, "key", $$v)},expression:"item.key"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.value),expression:"item.value"}],staticStyle:{"flex":"1"},attrs:{"type":"number"},domProps:{"value":(item.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "value", $event.target.value)}}})],1)}),0),_vm._v(" "),_c('div',{staticClass:"bottom-handel"},[_c('button',{staticClass:"btn btn-add",class:{disabled : _vm.isShowLoading},attrs:{"type":"primary","disabled":_vm.isShowLoading},on:{"click":function($event){return _vm.addFee()}}},[_vm._v("添加费用项目")]),_vm._v(" "),_c('button',{staticClass:"btn",class:{disabled : _vm.isShowLoading},staticStyle:{"margin-top":"10px"},attrs:{"type":"primary","disabled":_vm.isShowLoading},on:{"click":function($event){return _vm.feeSave()}}},[_vm._v("保存")])]),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"正在加载..."}}),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "my6m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'Quote',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            sPlaceOps: [], // 起始地列表
            sPortOps: [], // 起始港列表
            ePortOps: [], // 目的港列表
            ePlaceOps: [], // 目的地列表
            contTypeOps: [], // 柜型列表
            // options: [
            //   {
            //     key: 'gd',
            //     value: '广东'
            //   },
            //   {
            //     key: 'gx',
            //     value: '广西'
            //   }
            // ], // 虚假数据，后续注释
            splace: null,
            sport: null,
            eport: null,
            eplace: null,
            cont: null
        };
    },
    created: function created() {
        document.title = '报价查询';
        this.getInitialSelectData();
    },

    methods: {
        getInitialSelectData: function getInitialSelectData() {
            var _this = this;

            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: _const.apiUrl.quoteSearchCondition,
                data: data
            }, function (resultData) {
                _this.$vux.loading.hide();
                var dataObj = resultData.data;
                _this.sPlaceOps = dataObj.splaces || [];
                _this.sPortOps = dataObj.sports || [];
                _this.ePortOps = dataObj.eports || [];
                _this.ePlaceOps = dataObj.eplaces || [];
                _this.contTypeOps = dataObj.conts || [];
            }, function (error) {
                _this.$vux.loading.hide();
                if (error) {
                    // todo:如果请求失败，2秒后可重新获取，或者提示用户刷新页面？
                    setTimeout(function () {
                        _this.getInitialSelectData();
                    }, 2000);
                    console.error(error);
                }
            });
        },
        goResultPage: function goResultPage() {
            var route = {
                name: 'QuoteResult',
                query: {
                    splace: this.splace || '', // 一开始没选择是null，遇到此情况可以换成空字符串；当然也可以不传递，这个不是必传的参数
                    sport: this.sport || '',
                    eport: this.eport || '',
                    eplace: this.eplace || '',
                    cont: this.cont || ''
                }
            };
            this.$router.push(route);
        },
        sPlaceChange: function sPlaceChange() {},
        sPortChange: function sPortChange() {},
        ePortChange: function ePortChange() {},
        ePlaceChange: function ePlaceChange() {},
        contChange: function contChange() {}
    }
};

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Eta7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("2RPQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_c9144e54_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("t1Qh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("2PkL")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_c9144e54_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_c9144e54_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "n4w8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nQpb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _safariFix = __webpack_require__("xNvf");

var _safariFix2 = _interopRequireDefault(_safariFix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'toast',
  mixins: [_safariFix2.default],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "ng3N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Plan",
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      src1: __webpack_require__("w2ig"), // 装箱的图片
      src2: __webpack_require__("qDaJ"), // 拆箱的图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
      isNoData: false,
      noDataText: '' // 无数据时的文本
    };
  },
  created: function created() {
    document.title = '计划查询';

    if (this.$route.name === 'TodayPlan') {
      this.tableDataUrl = _const.apiUrl.todayPlan;
      this.noDataText = '今日暂无计划';
    } else {
      this.tableDataUrl = _const.apiUrl.tomorrowPlan;
      this.noDataText = '明日暂无计划';
    }
    var data = {
      openId: _const.apiParams.openId,
      companyId: _const.apiParams.companyId,
      code: _const.apiParams.code
    };
    this.getData(this.tableDataUrl, data);
  },

  methods: {
    getData: function getData(url, data) {
      var _this = this;

      this.isShowLoading = true;

      this.$http({
        method: 'post',
        url: url,
        data: data
      }).then(function (res) {
        var resultData = res.data;
        var code = resultData.code;
        var info = resultData.info;
        if (code === 412) {
          _this.showToast(info, 2000, 'warn');

          _this.isNoData = true;
          _this.noDataText = info;
        } else if (code === 500) {
          _this.showToast(info, 2000, 'warn');
        } else {
          var list = resultData.data.list || [];
          _this.tableData = list;
        }
        _this.isShowLoading = false;
      }, function (error) {
        _this.isShowLoading = false;
        console.error(error);
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "nicx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABLCAMAAAD6bgFoAAAAllBMVEUAAADxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0LxW0KXmQMfAAAAMXRSTlMAkOGwb08gBfb6MBkJ8ebdihTqDtGBwXo+7Z1zZFk4xmnXy6qiQ7xetplTSSsmlUcjGsgglgAAA55JREFUWMPtl8mCojAQhpEt7KugguK+22re/+WGrMYm3TLkMJf5L4KEL6lKVaXQNDDR4UDFNdCowAEqyGCYGippRTGxGmZDMfjGKY2/1mmG3xQw4Zc2QMEGthIwO22Q5t8wo2EY6z/m32L8pkmVMRYOqnKvhAFnSJWoYEaQqx6O8eBLrj0YU0FByWBMLGKWgzGOiIkHYyIRMx6MMURMNRhzETHT4XFTvihbhfBL13yfcpWcyu8uLvgJUMzw9FgUi06KH6siVao3PNfiXBVjkWRVxPgZxqwVMSdI1ChhVjyuVTA3nrBOPhwDxkI3MxyTiEk/GDOFIsYXH+3bf7J+mFznDHfndc0t+mG2nGJ0e6lgj8GfMQsGCRfyAb0wdsg6RZvaMS2MdRRG4+2k+RXjJ2c+ALAqdgros0gs+ZNchuHp4z7ozYS5BWBPFA58V1gDCYYXdZ1M7rm0EAJ8F8vaYluK2QsHZkALapTiWHPYm1VRFzsW2rNGhqFPXdSX7MQT4kL9sUqZ9RPiJ2faxfD9dbcJIvKHDanQJhCjpnBfvbmIARLzZ2g7UjxzfPueKBnOEPANM4dd1bzTiP3WlHfOF+ZM3jFA71LCnLU94RNFwIkeHx5Wio11/DeMCbs688Q6tvNkMDSRnnSoSUIrETFBJMHs0dQu7XaOkOrAMMSCDHCMfDEOYLXYahez1DPdgVCPzXbsYoEw5K0rx8gXUzKbspaXovJiwJBMadsIQ5aaMAzByl2js08uc3SzDzC07fyF0ZZoNoKRbhPby4Dte57xYJq8MCOULxyzkkDIOB9dXJCrQ+4yAVOjoGcYoP+IsdHFA+fRZe+VMPQ8nxnFYpZh5lCqgq3GIt33LDCgY1mib0wRs5FjKuYbkx5MNi5IO/PdNxnDuHLMku+UgNHjuYApxZ2ayTEuoBUx4hgeNw3G5A4CMEwB5Xow6x8vjGd9mS24fX9OnWrxDb8kI5ks5uMDqWqVjuOmhhDt/lMDa5T8Qf82ydKe3IGxCeHZ2F3pSu9aL0yDBmX+Df+U99U0QL7hvY9ryzHyk3ycH829T8unqwNkrk7KTU+MP8McW/gnQGvBlBhd9vs8uJKMfOsHgOng/MJdBT1rPogly2YRsMZnviaRdcW39GTUf9bB04QC6pyS1XGVHBx6e2Xn5EetiVcj2SOPr/aziCHpuZMqSaAxVR8pET/dKkc8T0f2W2N2iPXftBQ2ILjcl6gDisrkCgTGH0Kah3vHbILXAAAAAElFTkSuQmCC"

/***/ }),

/***/ "nkgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessResult_vue__ = __webpack_require__("tv7B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessResult_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessResult_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessResult_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessResult_vue__ = __webpack_require__("mmg8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessResult_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c95fcb4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessResult_vue__ = __webpack_require__("KuUT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("r9aq")
  __webpack_require__("pHA2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c95fcb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessResult_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c95fcb4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessResult_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c95fcb4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessResult_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "o2Xe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _arrayFind = __webpack_require__("NXHL");

var _arrayFind2 = _interopRequireDefault(_arrayFind);

var _uuid = __webpack_require__("KRg4");

var _uuid2 = _interopRequireDefault(_uuid);

var _cleanStyle = __webpack_require__("wmxo");

var _cleanStyle2 = _interopRequireDefault(_cleanStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findByKey = function findByKey(key, options) {
  var _rs = (0, _arrayFind2.default)(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'selector',
  mixins: [_uuid2.default],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = (0, _typeof3.default)(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: _cleanStyle2.default,
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if ((0, _typeof3.default)(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
};

/***/ }),

/***/ "oION":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "oSJp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"amapLocation"}},[_c('div',{on:{"click":function($event){_vm.show = true}}},[_vm._t("default")],2),_vm._v(" "),_c('popup',{attrs:{"height":"100%"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","height":"100%"}},[_c('div',{staticClass:"seatch-view"},[_c('input',{attrs:{"placeholder":"搜索地点","id":"Autocomplete","disabled":!_vm.edit}}),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":function($event){_vm.show = false}}},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"amapContainer"}}),_vm._v(" "),_c('div',{staticClass:"list",style:({'background-color' : _vm.poiList.length != 0 ? '#FFFFFF' : 'none'})},_vm._l((_vm.poiList),function(value,index){return _c('div',{key:index,staticClass:"list_item",on:{"click":function($event){_vm.selectIndex = index}}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","flex":"1"}},[_c('span',{staticClass:"list_item_title"},[_vm._v(_vm._s(value.name))]),_vm._v(" "),_c('span',{staticClass:"list_item_content"},[_vm._v(_vm._s(value.pname + value.cityname + value.adname + value.address))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectIndex == index),expression:"selectIndex == index"}],staticClass:"iconfont"},[_vm._v("")])])}),0),_vm._v(" "),_c('div',{staticClass:"bottom-view"},[_c('x-button',{staticClass:"enter-btn",class:{'enter-btn-visible' : _vm.selectIndex != -1},attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.enter($event)}}},[_vm._v("\n                    确定\n                ")])],1)])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "oWtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0pea");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("vAbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_13ee6e34_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("q3v4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("6td+")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_13ee6e34_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_13ee6e34_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oWvR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _picker = __webpack_require__("taJy");

var _picker2 = _interopRequireDefault(_picker);

var _cell = __webpack_require__("1DHf");

var _cell2 = _interopRequireDefault(_cell);

var _popup = __webpack_require__("HD9R");

var _popup2 = _interopRequireDefault(_popup);

var _popupHeader = __webpack_require__("WZtS");

var _popupHeader2 = _interopRequireDefault(_popupHeader);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _flexbox = __webpack_require__("F3HL");

var _array2String = __webpack_require__("LsKW");

var _array2String2 = _interopRequireDefault(_array2String);

var _value2name = __webpack_require__("NE4E");

var _value2name2 = _interopRequireDefault(_value2name);

var _mixin_uuid = __webpack_require__("OFgA");

var _mixin_uuid2 = _interopRequireDefault(_mixin_uuid);

var _transferDom = __webpack_require__("63CM");

var _transferDom2 = _interopRequireDefault(_transferDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var getObject = function getObject(obj) {
  return JSON.parse((0, _stringify2.default)(obj));
};

exports.default = {
  name: 'popup-picker',
  directives: {
    TransferDom: _transferDom2.default
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [_mixin_uuid2.default],
  components: {
    Picker: _picker2.default,
    Cell: _cell2.default,
    Popup: _popup2.default,
    PopupHeader: _popupHeader2.default,
    Flexbox: _flexbox.Flexbox,
    FlexboxItem: _flexbox.FlexboxItem,
    InlineDesc: _inlineDesc2.default
  },
  filters: {
    array2string: _array2String2.default,
    value2name: _value2name2.default
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: _value2name2.default,
    getNameValues: function getNameValues() {
      return (0, _value2name2.default)(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if ((0, _stringify2.default)(this.currentValue) !== (0, _stringify2.default)(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = (0, _stringify2.default)(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = getObject(val);
      this.$emit('on-shadow-change', _val, (0, _value2name2.default)(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.tempValue)) {
        this.tempValue = getObject(val);
        this.currentValue = getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', getObject(val));
      this.$emit('on-change', getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: getObject(this.value),
      closeType: false,
      currentData: (0, _stringify2.default)(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
};

/***/ }),

/***/ "oory":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

var _util = __webpack_require__("LOkV");

var _uploadImg = __webpack_require__("vwcn");

var _uploadImg2 = _interopRequireDefault(_uploadImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'LoadImgUploadZJDLD',
    components: {
        MyBtnReturn: _MyBtnReturn2.default,
        uploadImg: _uploadImg2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: __webpack_require__("w2ig"), // 装箱的图片，右上角的icon
            uploadLoadSrc: __webpack_require__("wVEz"), // 装箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: __webpack_require__("ujfB"), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadLoaddocSrc: __webpack_require__("CPjU"), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            imgSrc: '', // 一开始为uploadLoadSrc或uploadSealSrc，之后为用户上传的图片
            fileUrl: '', // 上传成功后返回的图片路径
            //iconClose: require('@/assets/images/wx_sc_oringe.png'), // 关闭图标
            iconClose2: __webpack_require__("VrRN"), // 关闭图标
            isShowLoading: false,
            canUpload: true,
            isUploaded: false, // 是否已经上传成功，true代表已经上传成了
            goBackQuery: {}, // 回退时要带的参数
            uploadUrl: '',
            step: -1,
            inputFiles: []
        };
    },
    created: function created() {
        document.title = '装货图片';
        var query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常
        // 出现上述bug的原因：页面的url被拼接了一个问号，变成/?#/这种情况，然后刷新一次页面，再进入这个组件，导致数据丢失，而且用go回退时要两次！
        // 上述Bug后，如果使用go回退，那apiParams里的属性在这里设置也没用，还是初始化为空字符串了，可能要保存在sessionStorage了，
        // 或者后台去将companyId与openId保存在session里
        // =>最新进展：后台保存在session里了
        if (!_const.apiParams.companyId) {
            // 如果apiParams.companyId变回空字符串了，证明页面被刷新了
            console.error('companyId被弄没了');
            _const.apiParams.companyId = query.companyId2;
            _const.apiParams.openId = query.openId2;
            this.step = -2;
        }
        // 判断是装箱的，还是封箱的
        if (query.type === 'load') {
            var imgSrc = {
                imgSrc: this.uploadLoadSrc,
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(imgSrc);
            this.uploadUrl = _const.apiUrl.loadImgUpload;
        } else if (query.type === 'seal') {
            var _imgSrc = {
                imgSrc: this.uploadSealSrc,
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(_imgSrc);
            this.uploadUrl = _const.apiUrl.uploadSealController;
        } else {
            var _imgSrc2 = {
                imgSrc: this.uploadLoaddocSrc,
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(_imgSrc2);
            this.uploadUrl = _const.apiUrl.loaddocUpload;
        }
    },

    methods: {
        uploadImg: function uploadImg() {
            var _this = this;

            // 如果已经上传成功了，不给继续上传
            if (this.isUploaded) {
                this.showToast('已上传图片了，请返回上一页面继续操作！');
                return;
            }
            var imgs = [];
            var loadComplete = true;
            this.inputFiles.forEach(function (item, index) {
                if (item.flag === '1') {
                    if (item.progress === 100) {
                        imgs.push({ img: item.imgSrc });
                    } else {
                        loadComplete = false;
                    }
                }
            });
            if (!loadComplete) {
                this.showToast('请等待照片上传完成！');
                return;
            }
            if (imgs.length === 0) {
                this.showToast('请选择照片再上传！');
                return;
            }
            this.$vux.loading.show({
                text: 'Loading'
            });
            var param = {
                base64Imgs: (0, _stringify2.default)(imgs), //多张图片
                companyId: _const.apiParams.companyId,
                openId: _const.apiParams.openId,
                bookingId: this.bookingId,
                ladingId: this.ladingId,
                id: this.id,
                referenceno: this.referenceno,
                cont_no: this.contNo
            };
            var url = this.uploadUrl;
            this.requestApi({
                url: url,
                data: param
            }, function (res) {
                var code = res.code;
                var info = res.data.info;

                if (code === 412) {
                    // 412或500的提示语
                    _this.showToast(info, 1500, 'warn');
                } else if (code === 500) {
                    _this.showToast(info, 1500, 'warn');
                } else {
                    _this.isUploaded = true;
                    if (info === '上传成功') {
                        var mes = '上传成功' + res.data.num.toString() + '张图片';
                        _this.showToast(mes, 2000, 'success', {
                            onHide: function onHide() {
                                _this.showToast('请返回上一页面继续操作。', 2000);
                            }
                        });
                    } else {
                        if (res.data.num > 0) {
                            var _mes = '只上传成功' + res.data.num.toString() + '张(受总共最多上传30张的限制)';
                            _this.showToast(_mes, 5000, 'success', {
                                onHide: function onHide() {
                                    _this.showToast('请返回上一页面继续操作。', 2000);
                                }
                            });
                        } else {
                            _this.showToast(info, 1500, 'warn');
                        }
                    }
                }
                _this.canUpload = true;
                _this.$vux.loading.hide();
            }, function (error) {
                _this.canUpload = true;
                _this.$vux.loading.hide();
                if (error) {
                    console.error(error);
                    _this.showToast('上传失败！', 2000, 'cancel');
                }
            });
        }
    }
};

/***/ }),

/***/ "orOp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oyyU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
};

/***/ }),

/***/ "p6lR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
};

/***/ }),

/***/ "pDNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("psuN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("k48M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_16e1f5e8_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("fqc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Oe89")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_16e1f5e8_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_16e1f5e8_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pHA2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pPRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []


/***/ }),

/***/ "pmSg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
};

/***/ }),

/***/ "psuN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _base = __webpack_require__("f6Hi");

var _base2 = _interopRequireDefault(_base);

var _icon = __webpack_require__("oWtu");

var _icon2 = _interopRequireDefault(_icon);

var _toast = __webpack_require__("rLAy");

var _toast2 = _interopRequireDefault(_toast);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _isEmail = __webpack_require__("2LX0");

var _isEmail2 = _interopRequireDefault(_isEmail);

var _isMobilePhone = __webpack_require__("Ewe+");

var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);

var _debounce = __webpack_require__("nror");

var _debounce2 = _interopRequireDefault(_debounce);

var _vanillaMasker = __webpack_require__("lFEC");

var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var validators = {
  'email': {
    fn: _isEmail2.default,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return (0, _isMobilePhone2.default)(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
exports.default = {
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = (0, _debounce2.default)(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [_base2.default],
  components: {
    Icon: _icon2.default,
    InlineDesc: _inlineDesc2.default,
    Toast: _toast2.default
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return (0, _keys2.default)(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? _vanillaMasker2.default.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = (0, _keys2.default)(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
};

/***/ }),

/***/ "pzVr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ReportNoList",
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      src1: __webpack_require__("w2ig"), // 装箱的图片
      src2: __webpack_require__("qDaJ"), // 拆箱的图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      isNoData: false
    };
  },
  created: function created() {
    document.title = '报柜号';
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code
      };
      this.isShowLoading = true;

      this.requestApi({
        url: _const.apiUrl.reportNoSearch,
        data: data
      }, function (resultData) {
        var list = resultData.data.list || [];
        if (list.length === 0) {

          _this.isNoData = true;
          _this.isShowLoading = false;
          _this.isShowTable = false;
          return;
        }
        _this.tableData = list;
      }, function (error) {
        _this.isShowLoading = false;
        if (error) {
          console.error(error);
        }
      });
    },
    goReportContNo: function goReportContNo(ladingId, otherservice) {

      this.$router.push({
        name: 'ReportContNo',
        query: {
          ladingId: ladingId,
          otherservice: otherservice
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "q3v4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []


/***/ }),

/***/ "qDaJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABaCAMAAAB5TAO7AAAAYFBMVEUAAAD/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/eSH/////+PX/hDz/6N//tpT/mWX/v6L/0Lz/rYb/j1L/4NT/o3b/8Or/2Mj/yK9hC0ZQAAAAEHRSTlMA8+jczKWNc1tGMyQXDbq5t8q2lAAAAnVJREFUaN60lcmO9CAMBvn3dUb+bPZs7/+W09CTcHQ7EnVAOaXkQAX3i+bj3O8vNBvn3J/pFvfg71eai2v8+0ZTcZ3/32km7snbO03EnfygebiLnzSYJhlZTpSMLCdKRpYTJSPLiZKR5UTJyHK65H6Wq0Fiz7LEtmYcBok1y8j8sAQgGyTWLCMDoQBeDBJzluIBHg5FcjdL2QFEMkhGlqZRsLRJiiiS+1kuQAZ8pYItKpK7WWYgUWCUyACSIrFmmUJfn4c3hspgD+yiSGxZMvioAViunYmSAS6KxJJlZHS8nDvTJgvchlEklizL3iScy7kzjdqySYrEkqV4dDZKI5X+vFVNomc5HEHCzimgEehJXYBVkbycZT7fu7ZMPMb5XdVJ9Cwlt/UA8nkEuJK0KJXiLVkmHP3vvp9fjePnZIsoktezzMCRAC/Xzlw/GF91iZ7lOFXcHSsDQfat9NkAjork5Sxl/3xbbYkHog2ZCuBXVoo3ZRmSkIQFgG+yBF4Zm1D0QFQklixX4Iq7Xl9KfCZdomc5JFsSeuIxAlQktixTHM/LSNEgsd2WGUAxSey3ZcKDwyKx35YB8Au8RWK+LSPDywGILrFnORwc2zTFILHelr4HsgJJldzPMiD0zQ8ftdQhDoBAEATBNZtTBMf/n4psSUJS84FSPc838j/Ljvcb+Z8lQMoSIWUpkbKESFuLlKVH5lCkLCVSlhIpS4mUJUXK0iNz3RBpa5Gy9MgcipSlRMpSImUpkbKUSFlKpCwh0tYiZemRORQpS4mUpUTKUiJlKZGyxEhZhqitRcrSI3MoUpYSKUuJlKVEylIiZWmRshy/lUhZvkKLH5axdvT3AAAAAElFTkSuQmCC"

/***/ }),

/***/ "qN9R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "GoHome",
    data: function data() {
        return {};
    },

    methods: {
        handleGoHome: function handleGoHome() {
            this.$router.push({
                name: 'Home'
            });
        }
    }
};

/***/ }),

/***/ "qeVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Voyage_vue__ = __webpack_require__("jBoD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Voyage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Voyage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Voyage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Voyage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Voyage_vue__ = __webpack_require__("ROt2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Voyage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Voyage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7b4b488_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Voyage_vue__ = __webpack_require__("woRs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("5Xmy")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7b4b488"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Voyage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7b4b488_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Voyage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7b4b488_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Voyage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qiCt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
};

/***/ }),

/***/ "qnZv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qwxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loadImgLading"}},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_c('div',{staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src1,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-item__first"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(_vm.ladingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.bookingId))])]),_vm._v(" "),_vm._l((_vm.tableData),function(item,index){return [_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.contNo && item.contNo.toUpperCase()))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v("柜型：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.contId && item.contId.toUpperCase()))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('div',{staticClass:"btn-box"},[(item.loadimgisupload)?_c('x-button',{staticClass:"btn btn-look",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('LoadImgLook', item.id, item.referenceno, item.contNo, item.contId, 'load')}}},[_vm._v("查看\n                                ")]):_c('x-button',{staticClass:"btn btn-upload",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('LoadImgUploadZJDLD', item.id, item.referenceno, item.contNo, item.contId, 'load')}}},[_vm._v("上传\n                                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('div',{staticClass:"btn-box"},[(item.sealimgisupload)?_c('x-button',{staticClass:"btn btn-look",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('LoadImgLook', item.id, item.referenceno, item.contNo, item.contId, 'seal')}}},[_vm._v("查看\n                                ")]):_c('x-button',{staticClass:"btn btn-upload",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('LoadImgUploadZJDLD', item.id, item.referenceno, item.contNo, item.contId, 'seal')}}},[_vm._v("上传\n                                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('div',{staticClass:"btn-box"},[(item.loaddocisupload)?_c('x-button',{staticClass:"btn btn-look",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('LoadImgLook', item.id, item.referenceno, item.contNo, item.contId, 'loaddoc')}}},[_vm._v("查看\n                                ")]):_c('x-button',{staticClass:"btn btn-upload",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage('LoadImgUploadZJDLD', item.id, item.referenceno, item.contNo, item.contId, 'loaddoc')}}},[_vm._v("上传\n                                ")])],1)])])])]})],2),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],1),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("装箱图片：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("封箱图片：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("单证图片：")])])}]


/***/ }),

/***/ "qyUV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

var _util = __webpack_require__("LOkV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "LoadImgUpload",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: __webpack_require__("w2ig"), // 装箱的图片，右上角的icon
            uploadLoadSrc: __webpack_require__("wVEz"), // 装箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: __webpack_require__("ujfB"), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            imgSrc: '', // 一开始为uploadLoadSrc或uploadSealSrc，之后为用户上传的图片
            fileUrl: '', // 上传成功后返回的图片路径
            iconClose: __webpack_require__("VrRN"), // 关闭图标
            isShowLoading: false,
            canUpload: true,
            isUploaded: false, // 是否已经上传成功，true代表已经上传成了
            goBackQuery: {}, // 回退时要带的参数
            uploadUrl: '',
            step: -2,
            inputFiles: [{ imgSrc: null }]
        };
    },
    created: function created() {
        document.title = '装货图片';
        var query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常
        // 出现上述bug的原因：页面的url被拼接了一个问号，变成/?#/这种情况，然后刷新一次页面，再进入这个组件，导致数据丢失，而且用go回退时要两次！
        // 上述Bug后，如果使用go回退，那apiParams里的属性在这里设置也没用，还是初始化为空字符串了，可能要保存在sessionStorage了，
        // 或者后台去将companyId与openId保存在session里
        // =>最新进展：后台保存在session里了
        if (!_const.apiParams.companyId) {
            // 如果apiParams.companyId变回空字符串了，证明页面被刷新了
            console.error('companyId被弄没了');
            _const.apiParams.companyId = query.companyId2;
            _const.apiParams.openId = query.openId2;
            this.step = -2;
        }
        // 判断是装箱的，还是封箱的
        // 可以异步上传图片了，不用麻烦后台重定向了
        // let resultUrl = `#/load-upload-result?companyId=${apiParams.companyId}&openId=${apiParams.openId}&ladingId=${query.ladingId}&id=${query.id}&referenceno=${query.referenceno}&cont_no=${query.contNo}&type=${query.type}`
        if (query.type === 'load') {
            this.imgSrc = this.uploadLoadSrc;

            // this.uploadUrl = `${apiUrl.loadImgUpload}?companyId=${apiParams.companyId}&openId=${apiParams.openId}&ladingId=${query.ladingId}&id=${query.id}&referenceno=${query.referenceno}&cont_no=${query.contNo}&resultUrl=${resultUrl}`
            this.uploadUrl = _const.apiUrl.loadImgUpload;
        } else {
            this.imgSrc = this.uploadSealSrc;
            // this.uploadUrl = `${apiUrl.uploadSealController}?companyId=${apiParams.companyId}&openId=${apiParams.openId}&ladingId=${query.ladingId}&id=${query.id}&referenceno=${query.referenceno}&cont_no=${query.contNo}&resultUrl=${resultUrl}`
            this.uploadUrl = _const.apiUrl.uploadSealController;
        }
    },

    methods: {
        getImg: function getImg(e) {
            var _this = this;

            // 如果用户选择图片时，按了取消/撤销，那e.target.files[0]会变为undefined，此时要阻止后续操作
            if (!e.target.files[0]) return;
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.file = e.target.files[0];
            // 如果图片超过2M，才进行压缩：因为现在限制10M内，但还是尽量别上传太大图片，所以大于2M还是压缩一次吧
            // 新需求：大于512K的，都进行压缩
            if (this.file.size / 1024 > 513) {
                // 压缩图片
                (0, _util.photoCompress)(this.file, {
                    quality: 0.5,
                    minSize: 513
                }, function (base64Img) {
                    _this.$vux.loading.hide();
                    _this.imgSrc = base64Img;
                }, function () {
                    // 图片经过多次压缩，还是太大了，提示用户
                    _this.$vux.loading.hide();
                    _this.showToast('抱歉，图片太大', 2000);
                });
            } else {
                // 小于512K的，直接用，不压缩了
                (0, _util.directTurnIntoBase64)(this.file, function (base64Img) {
                    _this.$vux.loading.hide();
                    _this.imgSrc = base64Img;
                });
            }
        },
        resetImg: function resetImg() {
            // 这个方法是.icon-close的方法，只是删除下已加载的图片
            if (this.type === 'load') {
                this.imgSrc = this.uploadLoadSrc;
            } else {
                this.imgSrc = this.uploadSealSrc;
            }
            // bug:如果resetImg了，在resetImg中没有将input获取到的file清空的话，那用户紧接着又选同一张图片，是无法触发change事件的！
            // 处理上述bug：因此要将其value变为空字符串
            this.$refs.inputFile.value = '';
            this.file = '';
        },
        uploadImg: function uploadImg() {
            var _this2 = this;

            // 如果已经上传成功了，不给继续上传
            if (this.isUploaded) {
                this.showToast('已上传图片了，请返回上一页面继续操作！');
                return;
            }
            // 提交前先验证下有没选择图片了
            if (!this.canUpload) return;
            this.canUpload = false;
            if (this.file) {} else {
                this.showToast('请先选择图片');
                this.canUpload = true;
                return;
            }
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 上传图片：该接口需要'Content-Type': 'multipart/form-data'；因此要将图片文件与其他参数都放进FormData实例中
            var param = {
                base64Img: this.imgSrc, // 现在上传图片的格式为base64的
                companyId: _const.apiParams.companyId,
                openId: _const.apiParams.openId,
                bookingId: this.bookingId,
                ladingId: this.ladingId,
                id: this.id,
                referenceno: this.referenceno,
                cont_no: this.contNo
            };
            var config = { // 如果已经使用FormData对象作为参数了，那不用设置这个请求头了，会自动修改为这个content-type的
                headers: { 'Content-Type': 'multipart/form-data' }
            }; //添加请求头
            var url = this.uploadUrl;
            // this.$http.post(apiUrl.uploadDelive, param, config) // 用已序列化数据的方式会直接报500
            this.requestApi({
                url: url,
                data: param
            }, function (res) {
                //{"code":200,"data":{"fileUrl":"/api/upload/aohy/a4266e1e31f942ba89246656dd3ffce7.png"}}
                var resultData = res.data; // 后台返回结果data数据
                var code = res.code;
                var info = resultData.info; // 412或500的提示语
                if (code === 412) {
                    _this2.showToast(info, 1500, 'warn');
                } else if (code === 500) {
                    _this2.showToast(info, 1500, 'warn');
                } else {
                    _this2.isUploaded = true;
                    _this2.showToast('上传成功！', 2000, 'success', {
                        onHide: function onHide() {
                            _this2.showToast('请返回上一页面继续操作。', 2000);
                        }
                    });
                }
                _this2.canUpload = true;
                _this2.$vux.loading.hide();
            }, function (error) {
                _this2.canUpload = true;
                _this2.$vux.loading.hide();
                // if (error.response) {
                //   // 请求已发出，但服务器响应的状态码不在 2xx 范围内
                //   if (error.response.status === 413) {
                //     this.showToast('图片太大，上传失败！', 2000,'cancel')
                //   } else {
                //     this.showToast('上传失败！', 2000,'cancel')
                //   }
                // } else {
                if (error) {
                    console.error(error);
                    _this2.showToast('上传失败！', 2000, 'cancel');
                }
                // }
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "r9aq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rAd9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "ShipperOrder",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            // todo:逻辑应该是：上层中某个选项变化了，下面所有select与受影响的input都要变为null
            load_date: '',
            consignee_id: null, // 囧，selector组件要设置默认值为null时，placeholder才有效果！
            consigneeOps: [
                // {
                //   key: 'lsh',
                //   value: '李四'
                // },
                // {
                //   key: 'zhs',
                //   value: '张三'
                // }
            ],
            goods_name: '',
            dockOfLoading: null,
            dockOfLoadingOps: [
                // '广东',
                // '上海',
            ],
            finalDestination: null,
            finalDestinationOps: [],
            jhr: null,
            jhrOps: [],
            company_lxr: null,
            company_lxrOps: [],
            shipper_tel: '',
            shipper_mp: '',
            remark3: '', // 装货说明
            consignee_place: null,
            consignee_placeOps: [],
            consignee_linkman: null,
            consignee_linkmanOps: [],
            consignee_tel: '',
            consignee_mp: '',
            remark9: '', // 卸货说明
            carriage: null,
            carriageOps: [{
                key: 'DR-DR',
                value: '门/门'
            }, {
                key: 'DR-CY',
                value: '门/堆场'
            }, {
                key: 'CY-DR',
                value: '堆场/门'
            }, {
                key: 'CY-CY',
                value: '堆场/堆场'
            }],
            contQty: '', // todo:柜量还要进行处理？
            contType: null,
            contTypeOps: [
                // {
                //   key: '20',
                //   value: '20GP'
                // },
                // {
                //   key: '40',
                //   value: '20GP'
                // },
            ], // todo:后台传递来
            insurance_status: null,
            insurance_statusOps: [{
                key: '1',
                value: '是'
            }, {
                key: '0',
                value: '否'
            }],
            fees_remark2: '',
            group: '', // 这个由shipperOrder接口获得，不知道是否要传回去
            shipper: '', // 这个由shipperOrder接口获得，托运人，在获取目的地时也要传递
            employeeId: '',
            isDisabledList: {
                consigSelector: false,
                dockOfLoadingSelector: false,
                finalDestinationSelector: false,
                jhrSelector: false,
                companyLxrSelector: false,
                consigneePlaceSelector: false,
                consigneeLinkmanSelector: false
            }, // 这个对象存放控制各个selector组件的readonly属性的值
            canSubmit: true // true代表能继续发送请求，控制submit方法的
        };
    },
    created: function created() {
        document.title = '客户下单';
        this.getInitialSelectData();
    },

    methods: {
        getInitialSelectData: function getInitialSelectData() {
            var _this = this;

            // 可获取到shipper(托运人)、employeeId(对应业务员？)、conts(柜型柜量)、consignees(货主？)、startAreas(起运地)
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: _const.apiUrl.shipperOrder,
                data: data
            }, function (resultData) {
                _this.$vux.loading.hide();
                var dataObj = resultData.data;
                _this.consigneeOps = dataObj.consignees;
                _this.group = dataObj.group;
                _this.shipper = dataObj.shipper;
                // this.shipperOps = dataObj.shippers
                _this.employeeId = dataObj.employeeId;
                _this.consigneeOps = dataObj.consignees;
                _this.contTypeOps = dataObj.conts;
                _this.dockOfLoadingOps = dataObj.startAreas; // 起运地
            }, function (error) {
                _this.$vux.loading.hide();
                if (error) {
                    // todo:如果请求失败，2秒后可重新获取，或者提示用户刷新页面？
                    setTimeout(function () {
                        _this.getInitialSelectData();
                    }, 2000);
                    console.error(error);
                }
            });
        },

        // 由于on-change会立即调用一次，因此如果value为null，要中止函数
        // 如果用户在第一次请求还未完成时，就又触发了change事件，然后第二次请求完成速度比第一次还快，怎么办？？
        // 处理上述bug：一旦改变了选项，那就禁用selector组件，等请求完毕后再启用
        getArea: function getArea(value, ref) {
            var _this2 = this;

            // 获取目的地：通过托运人与货主去查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取目的地：通过托运人与货主去查询
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id
            };
            this.requestApi({
                url: _const.apiUrl.getArea,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this2.finalDestinationOps = dataObj.area;
                _this2.finalDestination = null; // 要重置为null，避免默认选中值没改
            }, function (error) {
                _this2.isDisabled(ref);
                if (error) {
                    // todo:除了getInitialSelectData可以自动重新请求外，其他change事件触发的接口不可自动重新获取，不然万一用户修改选项，请求数据会混乱了！
                    // 处理上述bug：因此如果请求失败了，那就重置select的默认值为null
                    _this2.consignee_id = null;
                    console.error(error);
                }
            });
        },
        getLoadJhr: function getLoadJhr(value, ref) {
            var _this3 = this;

            // 获取装货地址：根据起运地查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.dockOfLoading || '' // 也可以直接使用参数value
            };
            this.requestApi({
                url: _const.apiUrl.getPlace,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this3.jhrOps = dataObj.places;
                _this3.jhr = null;
            }, function (error) {
                _this3.isDisabled(ref);
                if (error) {
                    _this3.dockOfLoading = null;
                    console.error(error);
                }
            });
        },
        getConsigPlace: function getConsigPlace(value, ref) {
            var _this4 = this;

            // 获取卸货地址：根据目的地去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.finalDestination || ''
            };
            this.requestApi({
                url: _const.apiUrl.getPlace,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this4.consignee_placeOps = dataObj.places;
                _this4.consignee_place = null;
            }, function (error) {
                _this4.isDisabled(ref);
                if (error) {
                    _this4.finalDestination = null;
                    console.error(error);
                }
            });
        },
        getLoadLink: function getLoadLink(value, ref) {
            var _this5 = this;

            // 获取装货联系人：根据起运地+装货地址去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.dockOfLoading || '',
                place: this.jhr || ''
            };
            this.requestApi({
                url: _const.apiUrl.getLinkman,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this5.company_lxrOps = dataObj.linkmans;
                _this5.company_lxr = null;
            }, function (error) {
                _this5.isDisabled(ref);
                if (error) {
                    _this5.jhr = null;
                    console.error(error);
                }
            });
        },
        getLoadTelMp: function getLoadTelMp(value, ref) {
            var _this6 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取装货人手机电话：根据起运地+装货地址+装货联系人获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.dockOfLoading || '',
                place: this.jhr || '',
                linkman: this.company_lxr || ''
            };
            this.requestApi({
                url: _const.apiUrl.getOtherloadInfo,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                // todo:手机与电话好像是放在loadInfo数组里面
                _this6.shipper_tel = dataObj.loadInfo[1];
                _this6.shipper_mp = dataObj.loadInfo[0];
            }, function (error) {
                _this6.isDisabled(ref);
                if (error) {
                    _this6.company_lxr = null;
                    console.error(error);
                }
            });
        },
        getXHLink: function getXHLink(value, ref) {
            var _this7 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货联系人：根据目的地+卸货地址获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.finalDestination || '',
                place: this.consignee_place || ''
            };
            this.requestApi({
                url: _const.apiUrl.getLinkman,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this7.consignee_linkmanOps = dataObj.linkmans;
                _this7.consignee_linkman = null;
            }, function (error) {
                _this7.isDisabled(ref);
                if (error) {
                    _this7.consignee_place = null;
                    console.error(error);
                }
            });
        },
        getXhTelMp: function getXhTelMp(value, ref) {
            var _this8 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货人手机电话：根据目的地+卸货地址+卸货联系人获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id,
                area: this.finalDestination || '',
                place: this.consignee_place || '',
                linkman: this.consignee_linkman || ''
            };
            this.requestApi({
                url: _const.apiUrl.getOtherloadInfo,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                // 手机与电话好像是放在loadInfo数组里面，loadInfo:["13678978756", null]
                _this8.consignee_tel = dataObj.loadInfo[1];
                _this8.consignee_mp = dataObj.loadInfo[0];
            }, function (error) {
                _this8.isDisabled(ref);
                if (error) {
                    _this8.consignee_linkman = null;
                    console.error(error);
                }
            });
        },
        submit: function submit(e) {
            var _this9 = this;

            // 对表单各项进行检测
            if (!this.load_date) {
                this.showToastWarn('请选择装货时间');
                return;
            }
            if (!this.consignee_id) {
                this.showToastWarn('请输入货主');
                return;
            }
            if (!this.goods_name) {
                this.showToastWarn('请输入货名');
                return;
            }
            if (!this.dockOfLoading) {
                this.showToastWarn('请输入起运地');
                return;
            }
            if (!this.finalDestination) {
                this.showToastWarn('请输入目的地');
                return;
            }
            if (!this.jhr) {
                this.showToastWarn('请输入装货地址');
                return;
            }
            if (!this.company_lxr) {
                this.showToastWarn('请输入装货联系人');
                return;
            }
            if (!(this.shipper_mp || this.shipper_tel)) {
                this.showToastWarn('装货联系人手机,电话至少输入一个');
                return;
            }
            if (!this.consignee_place) {
                this.showToastWarn('请输入卸货地址');
                return;
            }
            if (!this.consignee_linkman) {
                this.showToastWarn('请输入卸货联系人');
                return;
            }
            if (!(this.consignee_tel || this.consignee_mp)) {
                this.showToastWarn('卸货联系人手机,电话至少输入一个');
                return;
            }
            if (!this.contQty) {
                this.showToastWarn('请输入柜量');
                return;
            } else if (isNaN(Number(this.contQty))) {
                // 柜量必须是数字，而且是整数
                this.showToastWarn('柜量必须为数字');
                return;
            }
            if (!this.fees_remark2) {
                this.showToastWarn('请输入费用说明');
                return;
            }
            // 防止连续调用接口：也可直接给loading
            if (!this.canSubmit) return;
            this.canSubmit = false;
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 提交下单信息
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                employeeId: this.employeeId || '',
                load_date: this.load_date,
                consignee_id: this.consignee_id,
                goods_name: this.goods_name,
                dockOfLoading: this.dockOfLoading,
                finalDestination: this.finalDestination,
                jhr: this.jhr,
                company_lxr: this.company_lxr,
                shipper_tel: this.shipper_tel || '',
                shipper_mp: this.shipper_mp || '',
                remark3: this.remark3,
                consignee_place: this.consignee_place,
                consignee_linkman: this.consignee_linkman,
                consignee_tel: this.consignee_tel || '',
                consignee_mp: this.consignee_mp || '',
                remark9: this.remark9,
                carriage_item: this.carriage,
                contQty: parseInt(this.contQty),
                contType: this.contType,
                insurance_status: this.insurance_status || 0,
                fees_remark2: this.fees_remark2,
                group: this.group
            };
            this.requestApi({
                url: _const.apiUrl.shipperAddOrder,
                data: data
            }, function (resultData) {
                _this9.$vux.loading.hide();
                // 最后判断下单是否成功，给toast，状态码为200就是成功
                var dataObj = resultData.data;
                _this9.showToast(dataObj.info, 1500, 'success', {
                    onHide: function onHide() {
                        _this9.$router.push('/home');
                    }
                });
            }, function (error) {
                _this9.canSubmit = true;
                _this9.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            });
        },
        showToastWarn: function showToastWarn(text) {
            var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

            // 专门给submit函数里的验证使用
            this.showToast(text, time, 'warn');
        },
        isDisabled: function isDisabled(ref) {
            // 在触发select的change事件后，要先禁用select，等到请求完毕后，再重启select功能
            // 两种实现方式：1、第一种是通过ref获取到对应dom元素，然后禁用：
            // this.$refs[ref].$el.querySelector('select').disabled = !this.$refs[ref].$el.querySelector('select').disabled

            // 2、第二种是控制对应数据去设置selector组件的readonly属性
            this.isDisabledList[ref] = !this.isDisabledList[ref];
        }
    }
};

/***/ }),

/***/ "rGqP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("E2vU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("3d+v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_daf7e004_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("j15Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("3sFM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_daf7e004_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_daf7e004_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("2A0z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("bCvt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_00172c07_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("s+q/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("xY5n")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_00172c07_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_00172c07_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("AD3X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("nQpb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_3f9fa4da_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("j0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Vike")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_3f9fa4da_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_3f9fa4da_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rOEi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABLCAMAAAD6bgFoAAAAllBMVEUAAAD2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCr2nCpSItdtAAAAMXRSTlMAkOGxUARw+fafMj+LYgjr0YZ/ORwYD+fdaUoTy8BaxgvxrJl4Rddz77qnlFQsJiBu7awbMQAAA8lJREFUWMPtltuCmjAQhm0wBBBQQEDAM5511877v1yTIaFZYKuFi970v1GMfJnMKTMa0ZBATy3OdCRFrzBAe8U5wCBlEnMahllKDD6wlfHXuk6By9Iwl89RD22XwKVh7FEveQ3Mj36Y8X/Mv8XEUVQMxowxqVbHQRhaglQwBPMDah36Yxz4LfbsjbFBU9AbQ3TMpjeG6RjSG5PqmFlvjKFj7N6Yh46Z9M+blXZ3DEi/+FTHaTukppI7Rsty/YEVHnthuG6VuGeHxeB+g7W22A7F4AtwHoiJp4g5DcSooSMahPlZ5/UQzIelMFbSH0Nn2jTTH+PqRd8bMwEdEzeXpu9hElIzmO20jxu+h7nVFKM9S/lHBL/GrBXksu7+w1uY505Nik95jklonNJdOtsfnD9i5m4Z1YdXXexaVWUc6M16cUhaGL182LExMxsUR8bAgq/anWkTozd1Um3uMNkIfXxadI3Fz07MEVAu7i4bKikw1yz1ZhmeQ3umXB+1MSrx8VjU1m+Ih/RHVigfHio/WZGGacaX3QK1310sRFWHNqmeNQFDB302MbTj+FMRjoKgKR/NQplihfgNjAdtnetJYxGjXVUeRhjNT+SEXzE+aVN2whhHGp+X84RBLjwDENWHteIvGBPaKuvC4lYsgXwAeGvTdAFs0/ToKMTA6hg/7cAI2wsmp52cwYSfQV+lRPiPVphvjbFEaDLgyjEFozW3xrVtA2Bl2/dENuq8wnxrzEqs7HFDUamB2NurvDXmH8pUV2G6jYFSjXK36kxCXrYgKQcTgsm+wd0UhpIuzEGYWcUd7V+eua9vemvGezmtMRl0ycTgcj3ETg+Hd/h94QTmBIWFwcHAFIaSbzFP5eE4M1EEdiYqS9T+CpNBp0Jlzbjuy83R2dQxy26Mjb6RZh33BtcC26EhtHekb6YKw7oxGxUpW3XHEoBY/DEOLguK46IeqUs3hvmyIxJ8xSkt/k5x5nz+JRW/JQwBEhN2Y9C1pqyKZAPopiohdz+TuiuM64A/3B9dypWPr7ycASwOuN2XTLhyEcQ8widB9N8akwxpxCGI5WUxz8QNZkhL7+9NWxG2wbm6c6xNyGvJvcC9mn3Y/D0M+gJmwhc0Mx3ZkLcOnZOq3byJmVdNd96cwwioQRewfF8p75gHqGlhS3LUzcAmLzmevOvWvhp8vFOVWTk+Aiol3+vqaBywjCDzfrpXJh/zijqDlzpVl1LatfRRW/ta1UGKslUqwXakZL+kEPXXz1IfTS4/vkRuvSJ/1EYLwPZx34gJKF25ua8xfgEiFIfdPh6SuwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "rPN7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []


/***/ }),

/***/ "rQtf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loadImgUpload"}},[_c('div',[_c('div',{staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src1,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-item__first"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(_vm.ladingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.bookingId))])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("柜号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contNo))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v("柜型：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contId))])])]),_vm._v(" "),_c('p',{staticStyle:{"color":"#333"}},[_vm._v(_vm._s(_vm.type === 'load' ? '装箱图片：' : '封箱图片：'))]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left-upload"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}}),_vm._v(" "),_c('input',{ref:"inputFile",staticClass:"input-file",attrs:{"name":"file","type":"file","accept":"image/*","multiple":"multiple"},on:{"change":_vm.getImg}})]),_vm._v(" "),_c('img',{staticClass:"icon-close",attrs:{"src":_vm.iconClose,"alt":""},on:{"click":_vm.resetImg}})])])]),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}}),_vm._v(" "),_c('div',{staticClass:"btn-box",staticStyle:{"margin-top":"0.2rem","padding":"0 0.16rem"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.uploadImg}},[_vm._v("确认上传")])])],1),_vm._v(" "),_c('MyBtnReturn',{attrs:{"step":_vm.step}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "rtyr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []


/***/ }),

/***/ "s+q/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []


/***/ }),

/***/ "s7BY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){return _vm.$emit('on-click-left')}}},[_vm._t("left-text",[_vm._v(_vm._s(_vm.leftText))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){return _vm.$emit('on-click-right')}}},[_vm._t("right-text",[_vm._v(_vm._s(_vm.rightText))])],2)])}
var staticRenderFns = []


/***/ }),

/***/ "sEDc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ReportNoList",
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      src1: __webpack_require__("w2ig"), // 装箱的图片
      src2: __webpack_require__("qDaJ"), // 拆箱的图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      isNoData: false
    };
  },
  created: function created() {
    document.title = '报柜号';
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code
      };
      this.isShowLoading = true;

      this.requestApi({
        url: _const.apiUrl.reportNoSearch,
        data: data
      }, function (resultData) {
        var list = resultData.data.list || [];
        if (list.length === 0) {

          _this.isNoData = true;
          _this.isShowLoading = false;
          _this.isShowTable = false;
          return;
        }
        _this.tableData = list;
      }, function (error) {
        _this.isShowLoading = false;
        if (error) {
          console.error(error);
        }
      });
    },
    goReportContNo: function goReportContNo(ladingId, otherservice) {

      this.$router.push({
        name: 'ReportContNo',
        query: {
          ladingId: ladingId,
          otherservice: otherservice
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "sJY8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"deliveImgList"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('div',{staticClass:"otherservice"},[_c('img',{attrs:{"src":_vm.src2,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"list-binning"},[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("yjv+"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lading-id",staticStyle:{"font-size":"0.22rem"}},[_vm._v(_vm._s(item.ladingId))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(item.bookingId))])]),_vm._v(" "),(item.mBlNo)?_c('div',{staticClass:"list-item-row"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.mBlNo))])])]):_vm._e(),_vm._v(" "),(item.preCarriage)?_c('div',{staticClass:"list-item-row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.preCarriage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"consignee-linkman"},[_vm._v(_vm._s(item.consigneeLinkman))]),_vm._v(" "),(item.consigneeMp)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeMp))]):_vm._e(),_vm._v(" "),(item.consigneeMp && item.consigneeTel)?_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e(),_vm._v(" "),(!item.consigneeMp && item.consigneeTel)?_c('span',{staticClass:"consignee-mp"},[_vm._v(_vm._s(item.consigneeTel))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[(item.servicetype === '拖车')?_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.loadDate)))]):_c('span',[_vm._v(_vm._s(_vm.dateFormat(item.releasePlanDate)))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.consigneePlace))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(5,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark9))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(6,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.shipCompany))])])]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_vm._m(7,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.portDelivery))])])]),_vm._v(" "),(item.remark18)?_c('div',{staticClass:"list-item-row"},[_vm._m(8,true),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.remark18))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('img',{staticStyle:{"width":"4px"},attrs:{"src":__webpack_require__("1pHq"),"alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#333"}},[_vm._v("柜号/封号")])]),_vm._v(" "),_vm._m(9,true)]),_vm._v(" "),_c('div',{staticClass:"list-item-row"},[_c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v(_vm._s(item.contSealNo))])]),_vm._v(" "),_c('div',{staticClass:"list-item-row-right"},[_c('span',[_vm._v(_vm._s(item.cont))])])])])]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search btn-loading-img",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.goNextPage(item.bookingId,item.ladingId, item.servicetype)}}},[_vm._v("上传/查看图片\n                ")])],1)])}),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],2),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("运单号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("车牌号：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货联系人：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货时间：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货地点：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("送货说明：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("船公司：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("目的港：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-left"},[_c('span',[_vm._v("备注18：")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-row-right"},[_c('span',{staticClass:"cont",staticStyle:{"color":"#333"}},[_vm._v("柜型")])])}]


/***/ }),

/***/ "sW9f":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "seJ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _router = __webpack_require__("0FxO");

var _props = __webpack_require__("2IIR");

var _props2 = _interopRequireDefault(_props);

var _cleanStyle = __webpack_require__("wmxo");

var _cleanStyle2 = _interopRequireDefault(_cleanStyle);

var _getParentProp = __webpack_require__("vLYD");

var _getParentProp2 = _interopRequireDefault(_getParentProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'cell',
  components: {
    InlineDesc: _inlineDesc2.default
  },
  props: (0, _props2.default)(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return (0, _cleanStyle2.default)({
        width: (0, _getParentProp2.default)(this, 'labelWidth'),
        textAlign: (0, _getParentProp2.default)(this, 'labelAlign'),
        marginRight: (0, _getParentProp2.default)(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && (0, _router.go)(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "skjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPrice_vue__ = __webpack_require__("LBXa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPrice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPrice_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPrice_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPrice_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPrice_vue__ = __webpack_require__("EyCA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPrice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPrice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8e3e42_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FreightPrice_vue__ = __webpack_require__("Uc0O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("NobU")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c8e3e42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_FreightPrice_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8e3e42_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FreightPrice_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8e3e42_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_FreightPrice_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "slyI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//

exports.default = {
    name: 'MyBtnReturn',
    props: {
        routerName: String,
        query: Object,
        step: Number
        // step: {
        //   type: Number,
        //   default: -1
        // },
    },
    data: function data() {
        return {};
    },

    methods: {
        handleReturn: function handleReturn() {
            // this.$router.push({
            //   name: this.routerName,
            //   query: this.query || {}
            // })

            // 回退按钮要弄成类似浏览器的回退按钮，不然IOS端的微信自带回退按钮会乱
            if (this.step) {
                // history.go(this.step)
                this.$router.go(this.step);
            } else {
                // history.go(-1)
                this.$router.go(-1);
            }
        }
    }
};

/***/ }),

/***/ "smcu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUpload_vue__ = __webpack_require__("qyUV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUpload_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUpload_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUpload_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUpload_vue__ = __webpack_require__("OGWE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f35264_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgUpload_vue__ = __webpack_require__("rQtf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("MCPu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56f35264"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_LoadImgUpload_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f35264_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgUpload_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f35264_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_LoadImgUpload_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "t1Qh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "t5ke":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tEYZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tOCg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "taJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("+AC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("P5Kq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6e436005_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("zfut");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Xtae")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6e436005_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6e436005_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tub4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-box"},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "tv7B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'BusinessResult',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            tableData: [],
            // newData: [
            //   {
            //     contNo: 'asfasf',
            //     mblNo: 'aaaaaa',
            //     truckStatus: 0,
            //     loadOverStatus: 1,
            //     inVesselStatus: 0,
            //     isArrived: 0,
            //     goodsReliveStatus: 1,
            //     isGoodskeep: 0,
            //   },
            // ], // todo:虚假数据，模拟滚动加载新数据功能，后续注释
            radioIconGrey: __webpack_require__("2DUM"),
            radioIconGreen: __webpack_require__("7GQS"),
            goodsKeepIcon1: __webpack_require__("/hKF"),
            goodsKeepIcon0: __webpack_require__("IYP8"),
            canFetch: true, // false为阻止继续获取数据
            isShowLoading: false,
            isShowTable: true,
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false, // false代表还有数据
            tableDataUrl: _const.apiUrl.businessTemplate // 查询表单数据API，businessTemplate
        };
    },
    created: function created() {
        document.title = '货物跟踪';
    },
    mounted: function mounted() {
        // 要在这个钩子函数中才能一开始操作到scrollBottom标签
        this.onScrollBottom(); // 组件被创建时，就先获取一次数据
    },

    methods: {
        getMoreData: function getMoreData(url, data) {
            var _this = this;

            // 获取表格数据（分页数据）
            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle'
                });
                return;
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data.page;
                var resultArr = dataObj.result || []; // 防止后台返回null
                if (resultArr.length === 0) {
                    // 如果没有数据，要告知用户
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    // 如果是第一页就没有数据，那隐藏scroller吧
                    if (_this.pageNo === 1) {
                        _this.isShowTable = false;
                    }
                    return;
                }
                resultArr.forEach(function (item) {
                    _this.tableData.push(item);
                }); // 表格数据是放在result中
                _this.totalCount = dataObj.totalCount;
                _this.totalPages = dataObj.totalPages;
                _this.pageNo++;
                _this.$nextTick(function () {
                    _this.$refs.scrollerBottom.reset();
                }); // 要重置scroller组件
            }, function (error) {
                _this.isShowLoading = false;
                _this.canFetch = true;
                if (error) {
                    console.error(error);
                }
            });
        },
        onScrollBottom: function onScrollBottom() {
            this.isShowLoading = true;
            var query = this.$route.query;
            var data = {
                cont_no: query.cont_no,
                m_bl_no: query.m_bl_no,
                lading_id: query.lading_id,
                consignee_id: query.consignee_id,
                datediff: query.datediff,
                pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                pageNo: this.pageNo, // 当前为第几页数据，要累加
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            if (!this.canFetch) {} else {
                this.canFetch = false;
                this.getMoreData(this.tableDataUrl, data);
            }
        },
        editDate: function editDate(data) {
            // 将'√18.02.27'这种数据弄成2018.02.27这样的
            if (data !== '×') {
                var reg = /\D*(.*)/;
                var date = '20' + data.match(reg)[1];
                return date;
            } else {
                return null;
            }
        }
    }
};

/***/ }),

/***/ "u5dV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _const = __webpack_require__("ZLd3");

var _imageConversion = __webpack_require__("WFjR");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'uploadImg',
    data: function data() {
        return {
            itemWidth: 0,
            iconClose2: __webpack_require__("VrRN") // 关闭图标
        };
    },

    props: {
        value: {
            type: Array,
            default: null
        }
    },
    watch: {
        value: {
            handler: function handler(newValue, oldValue) {
                this.$previewRefresh();
            },

            immediate: true
        }
    },
    methods: {
        /**
         * 选择图片回调, 压缩图片
         * @param {Object} e
         */
        getImg: function getImg(e) {
            if (!e.target.files[0]) return;
            var files = e.target.files;
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                // let file = new File([files[i]], files[i].name, {type: files[i].type})
                var imgItem = {
                    imgSrc: URL.createObjectURL(file),
                    iconClose: this.iconClose2,
                    flag: '1',
                    progress: 0, // 进度
                    error: false, // 是否上传失败
                    file: file,
                    compress: true, // 是否正在压缩
                    compressTag: false // 压缩标志，压缩成功的图片不再压缩 会遇到压缩完成图片大于512的
                };
                this.value.splice(this.value.length - 1, 0, imgItem);
                this.uploadImg(imgItem);
            }
            // document.getElementById('inputFile').value = '';
        },

        /**
         * 异步压缩图片
         * @param {Object} imgItem
         */
        compress: function compress(imgItem) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var res, newFile;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                imgItem.compress = true;
                                _context.next = 3;
                                return (0, _imageConversion.compressAccurately)(imgItem.file, 512);

                            case 3:
                                res = _context.sent;
                                newFile = new File([res], imgItem.file.name, { type: res.type });

                                imgItem.file = newFile;
                                imgItem.compress = false;
                                imgItem.compressTag = true;
                                _this.uploadImg(imgItem);

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        /**
         * 上传图片
         * @param {Object} file
         */
        uploadImg: function uploadImg(imgItem) {
            var _this2 = this;

            if (imgItem.file.size / 1024 > 512 && !imgItem.compressTag) {
                this.compress(imgItem);
                return;
            }
            imgItem.compress = false;
            imgItem.imgSrc = URL.createObjectURL(imgItem.file);
            imgItem.error = false;
            imgItem.progress = 0;
            this.getToken(imgItem, function (token) {
                var axiosInstance = _axios2.default.create({
                    withCredentials: false
                }); //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
                var data = new FormData();
                data.append('token', token); //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
                data.append('file', imgItem.file);
                var companyId = _const.apiParams.companyId || _this2.getUrlParams('companyId') || 'Unknown';
                var dateStr = new Date().Format('yyyyMMdd');
                var randStr = Math.random(5).toString(36).substr(2) || 'Unknown';
                var extName = imgItem.file.name.substring(imgItem.file.name.lastIndexOf('.') + 1) || '.jpg'; //后缀名
                var key = companyId + '_' + dateStr + '_' + randStr + '.' + extName;
                data.append('key', key);
                axiosInstance({
                    method: 'POST',
                    url: 'https://up-z2.qbox.me', //上传地址
                    data: data,
                    timeout: 30000, //超时时间，因为图片上传有可能需要很久
                    onUploadProgress: function onUploadProgress(progressEvent) {
                        // 是上传进度，可以用来添加进度条
                        var imgLoadPercent = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                        // 由于上传进度满足100但是key还没返回，在返回url那里将进度赋值100，这里100改为99
                        imgItem.progress = imgLoadPercent < 100 ? imgLoadPercent : 99;
                    }
                }).then(function (data) {
                    var key = data.data.key;
                    imgItem.progress = 100;
                    imgItem.imgSrc = 'http://img.aohaisoft.com/' + key;
                    imgItem.error = false;
                }).catch(function (err) {
                    //上传失败
                    imgItem.error = true;
                });
            });
        },

        /**
         * 获取上传token
         */
        getToken: function getToken(imgItem, success, fail) {
            var _this3 = this;

            success = success || function () {};
            fail = fail || function () {};

            var storage = window.localStorage;
            var qnToken = storage['qToken'];
            if (qnToken) {
                qnToken = JSON.parse(qnToken);
                var date = new Date().getTime();
                if (parseInt((date - qnToken.endDate) / 1000 / 60) <= 50) {
                    success(qnToken.token);
                    return;
                }
            }

            this.requestApi({
                url: '/AohyWebchatS/qiniu/getSimpleToken/wxtrace.do'
            }, function (res) {
                if (res.code === 200) {
                    var token = res.data;
                    storage['qToken'] = (0, _stringify2.default)({
                        token: token,
                        endDate: new Date().getTime()
                    });
                    success(token);
                } else {
                    _this3.showToast('获取token失败！', 2000, 'cancel');
                    fail();
                }
            }, function (error) {
                if (error) {
                    _this3.showToast('获取token失败！', 2000, 'cancel');
                    fail();
                    imgItem.error = true;
                }
            });
        },

        /**
         * 上传失败，重新上传
         * @param {Object} index
         */
        reUpload: function reUpload(index) {
            this.uploadImg(this.value[index]);
        },

        /**
         * 删除图片
         * @param {Object} index
         */
        resetImg: function resetImg(index) {
            this.value.splice(index, 1);
            document.getElementById('inputFile').value = '';
        }
    },
    mounted: function mounted() {
        var o = document.getElementById('upload-img');
        if (o) {
            this.itemWidth = parseInt((o.clientWidth || o.offsetWidth) / 3);
        }
        this.getToken();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "u9s0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

var _util = __webpack_require__("LOkV");

var _uploadImg = __webpack_require__("vwcn");

var _uploadImg2 = _interopRequireDefault(_uploadImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'LoadImgUploadZJDLD',
    components: {
        MyBtnReturn: _MyBtnReturn2.default,
        uploadImg: _uploadImg2.default
    },
    data: function data() {
        return {
            bookingId: '',
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: __webpack_require__("w2ig"), // 装箱的图片，右上角的icon
            uploadLoadSrc: __webpack_require__("wVEz"), // 装箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: __webpack_require__("ujfB"), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadLoaddocSrc: __webpack_require__("CPjU"), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            imgSrc: '', // 一开始为uploadLoadSrc或uploadSealSrc，之后为用户上传的图片
            fileUrl: '', // 上传成功后返回的图片路径
            //iconClose: require('@/assets/images/wx_sc_oringe.png'), // 关闭图标
            iconClose2: __webpack_require__("VrRN"), // 关闭图标
            isShowLoading: false,
            canUpload: true,
            isUploaded: false, // 是否已经上传成功，true代表已经上传成了
            goBackQuery: {}, // 回退时要带的参数
            uploadUrl: '',
            step: -1,
            inputFiles: []
        };
    },
    created: function created() {
        document.title = '装货图片';
        var query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常
        // 出现上述bug的原因：页面的url被拼接了一个问号，变成/?#/这种情况，然后刷新一次页面，再进入这个组件，导致数据丢失，而且用go回退时要两次！
        // 上述Bug后，如果使用go回退，那apiParams里的属性在这里设置也没用，还是初始化为空字符串了，可能要保存在sessionStorage了，
        // 或者后台去将companyId与openId保存在session里
        // =>最新进展：后台保存在session里了
        if (!_const.apiParams.companyId) {
            // 如果apiParams.companyId变回空字符串了，证明页面被刷新了
            console.error('companyId被弄没了');
            _const.apiParams.companyId = query.companyId2;
            _const.apiParams.openId = query.openId2;
            this.step = -2;
        }
        // 判断是装箱的，还是封箱的
        if (query.type === 'load') {
            var imgSrc = {
                imgSrc: this.uploadLoadSrc,
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(imgSrc);
            this.uploadUrl = _const.apiUrl.loadImgUpload;
        } else if (query.type === 'seal') {
            var _imgSrc = {
                imgSrc: this.uploadSealSrc,
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(_imgSrc);
            this.uploadUrl = _const.apiUrl.uploadSealController;
        } else {
            var _imgSrc2 = {
                imgSrc: this.uploadLoaddocSrc,
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(_imgSrc2);
            this.uploadUrl = _const.apiUrl.loaddocUpload;
        }
    },

    methods: {
        uploadImg: function uploadImg() {
            var _this = this;

            // 如果已经上传成功了，不给继续上传
            if (this.isUploaded) {
                this.showToast('已上传图片了，请返回上一页面继续操作！');
                return;
            }
            var imgs = [];
            var loadComplete = true;
            this.inputFiles.forEach(function (item, index) {
                if (item.flag === '1') {
                    if (item.progress === 100) {
                        imgs.push({ img: item.imgSrc });
                    } else {
                        loadComplete = false;
                    }
                }
            });
            if (!loadComplete) {
                this.showToast('请等待照片上传完成！');
                return;
            }
            if (imgs.length === 0) {
                this.showToast('请选择照片再上传！');
                return;
            }
            this.$vux.loading.show({
                text: 'Loading'
            });
            var param = {
                base64Imgs: (0, _stringify2.default)(imgs), //多张图片
                companyId: _const.apiParams.companyId,
                openId: _const.apiParams.openId,
                bookingId: this.bookingId,
                ladingId: this.ladingId,
                id: this.id,
                referenceno: this.referenceno,
                cont_no: this.contNo
            };
            var url = this.uploadUrl;
            this.requestApi({
                url: url,
                data: param
            }, function (res) {
                var code = res.code;
                var info = res.data.info;

                if (code === 412) {
                    // 412或500的提示语
                    _this.showToast(info, 1500, 'warn');
                } else if (code === 500) {
                    _this.showToast(info, 1500, 'warn');
                } else {
                    _this.isUploaded = true;
                    if (info === '上传成功') {
                        var mes = '上传成功' + res.data.num.toString() + '张图片';
                        _this.showToast(mes, 2000, 'success', {
                            onHide: function onHide() {
                                _this.showToast('请返回上一页面继续操作。', 2000);
                            }
                        });
                    } else {
                        if (res.data.num > 0) {
                            var _mes = '只上传成功' + res.data.num.toString() + '张(受总共最多上传30张的限制)';
                            _this.showToast(_mes, 5000, 'success', {
                                onHide: function onHide() {
                                    _this.showToast('请返回上一页面继续操作。', 2000);
                                }
                            });
                        } else {
                            _this.showToast(info, 1500, 'warn');
                        }
                    }
                }
                _this.canUpload = true;
                _this.$vux.loading.hide();
            }, function (error) {
                _this.canUpload = true;
                _this.$vux.loading.hide();
                if (error) {
                    console.error(error);
                    _this.showToast('上传失败！', 2000, 'cancel');
                }
            });
        }
    }
};

/***/ }),

/***/ "uCgK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
};

/***/ }),

/***/ "uDI8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "uHX6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uhyW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ujfB":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "uvie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue__ = __webpack_require__("xnax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue__ = __webpack_require__("my6m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d2b835_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_quote_vue__ = __webpack_require__("BDJl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("uhyW")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03d2b835"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d2b835_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_quote_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d2b835_hasScoped_true_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_quote_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vAbW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
};

/***/ }),

/***/ "vOLE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "DeliveImgLook",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src2: __webpack_require__("fy9M"), // 送货的icon图片
            iconClose: __webpack_require__("VrRN"), // 关闭图标
            goBackQuery: {}, // 回退时要带的参数
            displayUrl: '',
            imgSrcList: [
                // require('@/assets/images/plan/wx_zhuang_blue.png'),
                // require('@/assets/images/wx_sc_oringe.png')
            ], // 图片路径列表
            isNoData: false,
            isShowLoading: false,
            step: -1
        };
    },
    created: function created() {
        document.title = '送货图片';
        var query = this.$route.query;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常，原因：页面先被刷新一次，再进入该组件，导致数据丢失，而且用go回退时要两次！
        if (!_const.apiParams.companyId) {
            _const.apiParams.companyId = query.companyId2;
            _const.apiParams.openId = query.openId2;
            this.step = -2;
        }
        if (query.type === 'delive') {
            this.displayUrl = _const.apiUrl.deliveImgDisplay; // 送货图片的接口
        } else if (query.type === 'open') {
            this.displayUrl = _const.apiUrl.lookopenimg; // 开箱图片的接口
        } else {
            this.displayUrl = _const.apiUrl.lookDelivedoc; // 送货单证图片的接口
        }
        this.getDisplayImg();
    },

    methods: {
        getDisplayImg: function getDisplayImg() {
            var _this = this;

            // 获取可展示的图片
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                id: this.id,
                servicetype: this.servicetype,
                referenceno: this.referenceno
            };
            this.isShowLoading = true;
            this.requestApi({
                url: this.displayUrl,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                var imgSrcList = dataObj.paths || [];
                if (imgSrcList.length === 0) {
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    _this.imgSrcList = imgSrcList;
                    return;
                }
                _this.imgSrcList = imgSrcList;
                _this.$previewRefresh();
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error);
                }
            });
        }
    }
};

/***/ }),

/***/ "vQGC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vjYW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__("0FxO");

exports.default = {
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && (0, _router.go)(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "vofn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vwcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_uploadImg_vue__ = __webpack_require__("lfAX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_uploadImg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_uploadImg_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_uploadImg_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_uploadImg_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_uploadImg_vue__ = __webpack_require__("u5dV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_uploadImg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_uploadImg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e10d54f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_uploadImg_vue__ = __webpack_require__("mHiu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("n4w8")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_uploadImg_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e10d54f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_uploadImg_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e10d54f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_uploadImg_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vxH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"shipperOrder"}},[_c('group',{attrs:{"gutter":10}},[_c('datetime',{attrs:{"title":"装货日期","value-text-align":"right","placeholder":"请选择日期","required":""},model:{value:(_vm.load_date),callback:function ($$v) {_vm.load_date=$$v},expression:"load_date"}}),_vm._v(" "),_c('selector',{ref:"consigSelector",attrs:{"title":"货主","options":_vm.consigneeOps,"placeholder":"请选择货主","direction":"rtl","readonly":_vm.isDisabledList.consigSelector},on:{"on-change":function (value) {_vm.getArea(value,'consigSelector')}},model:{value:(_vm.consignee_id),callback:function ($$v) {_vm.consignee_id=$$v},expression:"consignee_id"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"货名","text-align":"right","placeholder":"请输入货物名称","required":""},model:{value:(_vm.goods_name),callback:function ($$v) {_vm.goods_name=$$v},expression:"goods_name"}}),_vm._v(" "),_c('selector',{ref:"dockOfLoadingSelector",attrs:{"title":"起运地","options":_vm.dockOfLoadingOps,"placeholder":"请选择起运地","direction":"rtl","readonly":_vm.isDisabledList.dockOfLoadingSelector},on:{"on-change":function (value) {_vm.getLoadJhr(value,'dockOfLoadingSelector')}},model:{value:(_vm.dockOfLoading),callback:function ($$v) {_vm.dockOfLoading=$$v},expression:"dockOfLoading"}}),_vm._v(" "),_c('selector',{ref:"finalDestinationSelector",attrs:{"title":"目的地","options":_vm.finalDestinationOps,"placeholder":"请选择目的地","direction":"rtl","readonly":_vm.isDisabledList.finalDestinationSelector},on:{"on-change":function (value) {_vm.getConsigPlace(value,'finalDestinationSelector')}},model:{value:(_vm.finalDestination),callback:function ($$v) {_vm.finalDestination=$$v},expression:"finalDestination"}}),_vm._v(" "),_c('selector',{ref:"jhrSelector",attrs:{"title":"装货地址","options":_vm.jhrOps,"placeholder":"请选择装货地址","direction":"rtl","readonly":_vm.isDisabledList.jhrSelector},on:{"on-change":function (value) {_vm.getLoadLink(value,'jhrSelector')}},model:{value:(_vm.jhr),callback:function ($$v) {_vm.jhr=$$v},expression:"jhr"}}),_vm._v(" "),_c('selector',{ref:"companyLxrSelector",attrs:{"title":"装货联系人","options":_vm.company_lxrOps,"placeholder":"请选择装货联系人","direction":"rtl","readonly":_vm.isDisabledList.companyLxrSelector},on:{"on-change":function (value) {_vm.getLoadTelMp(value,'companyLxrSelector')}},model:{value:(_vm.company_lxr),callback:function ($$v) {_vm.company_lxr=$$v},expression:"company_lxr"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"装货电话","text-align":"right","max":13,"placeholder":"请输入装货电话"},model:{value:(_vm.shipper_tel),callback:function ($$v) {_vm.shipper_tel=$$v},expression:"shipper_tel"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"装货手机","text-align":"right","max":11,"placeholder":"请输入装货手机"},model:{value:(_vm.shipper_mp),callback:function ($$v) {_vm.shipper_mp=$$v},expression:"shipper_mp"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"装货说明","text-align":"right","placeholder":"请输入装货说明"},model:{value:(_vm.remark3),callback:function ($$v) {_vm.remark3=$$v},expression:"remark3"}}),_vm._v(" "),_c('selector',{ref:"consigneePlaceSelector",attrs:{"title":"卸货地址","options":_vm.consignee_placeOps,"placeholder":"请选择卸货地址","direction":"rtl","readonly":_vm.isDisabledList.consigneePlaceSelector},on:{"on-change":function (value) {_vm.getXHLink(value,'consigneePlaceSelector')}},model:{value:(_vm.consignee_place),callback:function ($$v) {_vm.consignee_place=$$v},expression:"consignee_place"}}),_vm._v(" "),_c('selector',{ref:"consigneeLinkmanSelector",attrs:{"title":"卸货联系人","options":_vm.consignee_linkmanOps,"placeholder":"请选择卸货联系人","direction":"rtl","readonly":_vm.isDisabledList.consigneeLinkmanSelector},on:{"on-change":function (value) {_vm.getXhTelMp(value,'consigneeLinkmanSelector')}},model:{value:(_vm.consignee_linkman),callback:function ($$v) {_vm.consignee_linkman=$$v},expression:"consignee_linkman"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"卸货电话","text-align":"right","max":13,"placeholder":"请输入卸货电话"},model:{value:(_vm.consignee_tel),callback:function ($$v) {_vm.consignee_tel=$$v},expression:"consignee_tel"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"卸货手机","text-align":"right","max":11,"placeholder":"请输入卸货手机"},model:{value:(_vm.consignee_mp),callback:function ($$v) {_vm.consignee_mp=$$v},expression:"consignee_mp"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"卸货说明","text-align":"right","placeholder":"请输入卸货说明"},model:{value:(_vm.remark9),callback:function ($$v) {_vm.remark9=$$v},expression:"remark9"}}),_vm._v(" "),_c('selector',{ref:"carriageSelector",attrs:{"title":"操作条款","options":_vm.carriageOps,"placeholder":"请选择操作条款","direction":"rtl"},model:{value:(_vm.carriage),callback:function ($$v) {_vm.carriage=$$v},expression:"carriage"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"柜量","text-align":"right","placeholder":"请输入柜量"},model:{value:(_vm.contQty),callback:function ($$v) {_vm.contQty=$$v},expression:"contQty"}}),_vm._v(" "),_c('selector',{ref:"contTypeSelector",attrs:{"title":"柜型","options":_vm.contTypeOps,"placeholder":"请选择柜型","direction":"rtl"},model:{value:(_vm.contType),callback:function ($$v) {_vm.contType=$$v},expression:"contType"}}),_vm._v(" "),_c('selector',{ref:"insuranceStatusSelector",attrs:{"title":"是否保险","options":_vm.insurance_statusOps,"placeholder":"请选择","direction":"rtl"},model:{value:(_vm.insurance_status),callback:function ($$v) {_vm.insurance_status=$$v},expression:"insurance_status"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"费用说明","text-align":"right","placeholder":"请输入费用说明"},model:{value:(_vm.fees_remark2),callback:function ($$v) {_vm.fees_remark2=$$v},expression:"fees_remark2"}})],1),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("下单")])],1),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "w1RL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){return _vm.$emit('on-focus')},"blur":function($event){return _vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var staticRenderFns = []


/***/ }),

/***/ "w2e1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_demurrageQueryList_vue__ = __webpack_require__("7/ee");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_demurrageQueryList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_demurrageQueryList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_demurrageQueryList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_demurrageQueryList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_demurrageQueryList_vue__ = __webpack_require__("DW2Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_demurrageQueryList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_demurrageQueryList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5022a30_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_demurrageQueryList_vue__ = __webpack_require__("Vzho");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("/ulZ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_demurrageQueryList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5022a30_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_demurrageQueryList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5022a30_hasScoped_false_optionsId_0_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_demurrageQueryList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "w2ig":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABaCAMAAAB5TAO7AAAAZlBMVEUAAABQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+VQp+X///9hruf2+v3F3vXj7/qw0/F+u+ra6vikzfBwtOm72fOYx+7Q5PeMwezt9PyMh98TAAAAEnRSTlMA+fPo3Mylc1tGMyQXDbqNuYy9fyQwAAACnUlEQVRo3rTT1wmFABQFwX3BnOD0X6yo6P0XdnoYuvig/8QGDN/IAMZfXBymf1Sc5iYmLssaEbc2Hh5bNBSvJcVrSfFaUryWFK8lxWsJ5X3LnXN6uQEQhgEYukPcf0iB/ZdEZYEomcAH6+1hgUiSpcIViORYTtBAJMkSTKS0EojEWS6WyE33IkmWu+uJvE0adXqRJEuDauf6AHWfJFk+C6DbgOGPz7D8R3+clkuSwyAMBe8wLQnxsWPf/5IThYqzlI1XoAVd5tGCsZ0A2J/0DLKgpRWZg/oiki/YBy0J5ImWQ79RSyF4XWnynpSRQJ5oWQt6xKCg8ikoRRrUBPJISynzSPn38I4Cs5RDci1rnxSDLRZ/C9MkCidYEvxtLQ9OH9OTWLTYOIkoevInj7Q8AF490oZSwaWgtSrNYUsgd7WspgDNj64ojD9paAQfWJMEclvLXbm+FgUDHfOQWQK5raWBubWTKwcHm3JKArmrZf+dIwd81rjWzyG5ljuU73ovFOzSMYE80NL5id1whyazC+w5JNfyF7uNCxKNq8RUPNmuR1rKBlidkOOzU1qTVr+g5TCg1YDss3HpnkBWtAzMCEhxd5v9MoGsaDkiggYQONOaQNa13KA1bRHM6nblt6XffaYuabn+TF24Lf9rq0McAGEgCqIoqkggQFIF978ljPpyxWb+BZ7pdO/z7SL1teSRNZAiy3yWs4vU1/Kv/WoidZZzPn2kzjLrI8nSR8jSR8hSR9hwkWTpI2TpI2TpI2TpI2TpI8u2+whZ6gg7dIQNFUmWPkKWPkKWPkKWPkKWPkKWPkKWPkKWOsKGiiRLHyFLHyFLHyFLHyFLHyFLHyFLHyFLHWFDRZKlj5Clj5Clj5Clj5CliyTLxd/qI2T5ATOmQ3JguPvnAAAAAElFTkSuQmCC"

/***/ }),

/***/ "wALF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

var _amapLocation = __webpack_require__("3lov");

var _amapLocation2 = _interopRequireDefault(_amapLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'DeliveImgLading',
    components: {
        MyBtnReturn: _MyBtnReturn2.default,
        amapLocation: _amapLocation2.default
    },
    data: function data() {
        return {
            src1: __webpack_require__("w2ig"), // 装箱的icon图片
            src2: __webpack_require__("fy9M"), // 送货的icon图片

            check: __webpack_require__("jWrU"),
            unCheck: __webpack_require__("ZfQA"),

            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            // src2: require('@/assets/images/wx_song_green.png'), // 送货的icon图片
            tableData: [],
            address: null,

            isShowTable: true,
            isShowLoading: false,
            isNoData: false,

            showBottomHandel: false,
            location: null
        };
    },

    watch: {
        location: function location(newValue, oldValue) {
            this.address = newValue.address;
        }
    },
    created: function created() {
        document.title = '更新位置';
        this.bookingId = this.$route.query.bookingId;
        this.ladingId = this.$route.query.ladingId;
        this.servicetype = this.$route.query.servicetype;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                bookingId: this.bookingId
            };
            this.showBottomHandel = false;
            this.address = null;
            this.isShowLoading = true;
            this.requestApi({
                url: _const.apiUrl.getLocationNoticeDetail,
                data: data
            }, function (resultData) {
                _this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况

                var sonos = resultData.data || [];

                _this.tableData = sonos.map(function (item) {
                    return (0, _extends3.default)({}, item, {
                        check: false
                    });
                });
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            });
        },
        checkItem: function checkItem(index) {
            var _this2 = this;

            this.tableData[index].check = !this.tableData[index].check;
            this.showBottomHandel = false;
            this.tableData.forEach(function (item) {
                if (item.check) {
                    _this2.showBottomHandel = true;
                }
            });
        },
        upload: function upload() {
            var _this3 = this;

            if (!this.address) {
                this.showToast('请输入位置');
                return;
            }
            var ids = this.tableData.map(function (item) {
                if (item.check) {
                    return item.id;
                }
            });
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                ids: ids.join(','),
                location: this.address
            };
            this.$http.post(_const.apiUrl.locationNoticeSave, data).then(function (response) {
                if (response.data.code == 200) {
                    _this3.getData();
                }
            }).catch(function (error) {
                console.error(error);
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "wBau":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wRSE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__("ZLd3");

var _format = __webpack_require__("ODCk");

var _format2 = _interopRequireDefault(_format);

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'LoadImgList',
  components: {
    MyBtnReturn: _MyBtnReturn2.default
  },
  data: function data() {
    return {
      src1: __webpack_require__("w2ig"), // 装箱的图片
      src2: __webpack_require__("qDaJ"), // 拆箱的图片
      tableData: [],
      isShowTable: true,
      isShowLoading: false,
      isNoData: false
    };
  },
  created: function created() {
    document.title = '装货图片';
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        openId: _const.apiParams.openId,
        companyId: _const.apiParams.companyId,
        code: _const.apiParams.code
      };
      this.isShowLoading = true;

      this.requestApi({
        url: _const.apiUrl.loadImgListController,
        data: data
      }, function (resultData) {
        var list = resultData.data.list || [];
        if (list.length === 0) {

          _this.isNoData = true;
          _this.isShowLoading = false;
          _this.isShowTable = false;
          return;
        }
        _this.tableData = list;
      }, function (error) {
        _this.isShowLoading = false;
        if (error) {
          console.error(error);
        }
      });
    },
    goNextPage: function goNextPage(bookingId, ladingId, servicetype) {

      this.$router.push({
        name: 'LoadImgLading',
        query: {
          bookingId: bookingId,
          ladingId: ladingId,
          servicetype: servicetype
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return (0, _format2.default)(time, 'YYYY-MM-DD HH:mm');
    }
  }
};

/***/ }),

/***/ "wSNw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
};

/***/ }),

/***/ "wV0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wVEz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "wkjy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _amapLocation = __webpack_require__("3lov");

var _amapLocation2 = _interopRequireDefault(_amapLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "test",
  components: {
    amapLocation: _amapLocation2.default
  },
  data: function data() {
    return {
      location: {
        address: null
      }
    };
  },

  watch: {
    address: function address(newValue, oldValue) {}
  },
  methods: {}
}; //
//
//
//
//
//
//
//

/***/ }),

/***/ "woRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"voyage"}},[_c('group',{attrs:{"gutter":10}},[_c('selector',{ref:"placeLoadingSelector",attrs:{"title":_vm.title[0],"options":_vm.place_loadingOps,"direction":"rtl","placeholder":'请选择' + _vm.title[0]},on:{"on-change":_vm.startChange},model:{value:(_vm.place_loading),callback:function ($$v) {_vm.place_loading=$$v},expression:"place_loading"}}),_vm._v(" "),_c('selector',{ref:"placeDeliverySelector",attrs:{"title":_vm.title[1],"options":_vm.place_deliveryOps,"direction":"rtl","placeholder":'请选择' + _vm.title[1]},model:{value:(_vm.place_delivery),callback:function ($$v) {_vm.place_delivery=$$v},expression:"place_delivery"}})],1),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"btn-search",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.search($event)}}},[_vm._v("查询")])],1),_vm._v(" "),_c('MyFooter',{staticStyle:{"margin-top":"0.2rem"}}),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "wwIJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("LAxo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("o2Xe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_11ce0e4e_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("/HK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Q0lW")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_3__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_11ce0e4e_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_11ce0e4e_hasScoped_false_optionsId_0_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xLid":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xY5n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xnax":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'Quote',
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            sPlaceOps: [], // 起始地列表
            sPortOps: [], // 起始港列表
            ePortOps: [], // 目的港列表
            ePlaceOps: [], // 目的地列表
            contTypeOps: [], // 柜型列表
            // options: [
            //   {
            //     key: 'gd',
            //     value: '广东'
            //   },
            //   {
            //     key: 'gx',
            //     value: '广西'
            //   }
            // ], // 虚假数据，后续注释
            splace: null,
            sport: null,
            eport: null,
            eplace: null,
            cont: null
        };
    },
    created: function created() {
        document.title = '报价查询';
        this.getInitialSelectData();
    },

    methods: {
        getInitialSelectData: function getInitialSelectData() {
            var _this = this;

            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: _const.apiUrl.quoteSearchCondition,
                data: data
            }, function (resultData) {
                _this.$vux.loading.hide();
                var dataObj = resultData.data;
                _this.sPlaceOps = dataObj.splaces || [];
                _this.sPortOps = dataObj.sports || [];
                _this.ePortOps = dataObj.eports || [];
                _this.ePlaceOps = dataObj.eplaces || [];
                _this.contTypeOps = dataObj.conts || [];
            }, function (error) {
                _this.$vux.loading.hide();
                if (error) {
                    // todo:如果请求失败，2秒后可重新获取，或者提示用户刷新页面？
                    setTimeout(function () {
                        _this.getInitialSelectData();
                    }, 2000);
                    console.error(error);
                }
            });
        },
        goResultPage: function goResultPage() {
            var route = {
                name: 'QuoteResult',
                query: {
                    splace: this.splace || '', // 一开始没选择是null，遇到此情况可以换成空字符串；当然也可以不传递，这个不是必传的参数
                    sport: this.sport || '',
                    eport: this.eport || '',
                    eplace: this.eplace || '',
                    cont: this.cont || ''
                }
            };
            this.$router.push(route);
        },
        sPlaceChange: function sPlaceChange() {},
        sPortChange: function sPortChange() {},
        ePortChange: function ePortChange() {},
        ePlaceChange: function ePlaceChange() {},
        contChange: function contChange() {}
    }
};

/***/ }),

/***/ "xpjs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

exports.default = {
    data: function data() {
        return {
            msg: 'Hello World!',
            isShowLoading: false,
            groupData: [],
            companyId: '',
            isToast: false,
            canFetch: true
        };
    },
    created: function created() {
        document.title = '货物跟踪';
        // 如果参数为undefined，axios不会传该参数到服务器！
        // 现在后台将companyId/openId等存到session，但验证权限接口menuPermission还是需要前端传递companyId参数的，因此保留这里的代码
        _const.apiParams.companyId = this.getUrlParams('companyId') || _const.apiParams.companyId || '';
        _const.apiParams.code = this.getUrlParams('code') || _const.apiParams.code || '';
        this.getMenu();
    },

    methods: {
        getMenu: function getMenu() {
            var _this = this;

            var data = {
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                openId: _const.apiParams.openId
            };
            this.isShowLoading = true;
            this.$http.post(_const.apiUrl.getAvailableMenu, data).then(function (response) {
                _this.isShowLoading = false;
                if (response.data.code !== 200) {
                    _this.showToast(response.data.info);
                    return;
                }
                var availableMenu = response.data.data || [];
                if (availableMenu.length === 0) {
                    _this.groupData = [_const.homeMenu.kehu, _const.homeMenu.yewu, _const.homeMenu.siji];
                    return;
                }
                debugger;
                availableMenu.forEach(function (item) {
                    var menuItem = {};
                    if (item.menuType === '0') {
                        menuItem = _const.homeMenu.kehu;
                    } else if (item.menuType === '1') {
                        menuItem = _const.homeMenu.yewu;
                    } else if (item.menuType === '2') {
                        menuItem = _const.homeMenu.siji;
                    }
                    if (item.menuTitle) {
                        var menuTitle = item.menuTitle.split(',');
                        for (var j = 0; j < menuItem.contentData.length; j++) {
                            var label = menuItem.contentData[j].label;
                            if (!menuTitle.includes(label)) {
                                menuItem.contentData.splice(j, 1);
                                j--;
                            }
                        }
                    }

                    _this.groupData.push(menuItem);
                });
            }).catch(function (error) {
                console.error(error);
                _this.isShowLoading = false;
            });
        },
        goMenu: function goMenu(menuType, path) {
            var _this2 = this;

            if (!this.canFetch) return;
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.canFetch = false;
            var data = {
                companyId: _const.apiParams.companyId,
                menuType: menuType,
                code: _const.apiParams.code,
                openId: _const.apiParams.openId // 第二次调用开始会使用，代替code
            };
            this.$http.post(_const.apiUrl.menuPermission, data).then(function (response) {
                _this2.$vux.loading.hide();
                // 判断响应状态
                var resultData = response.data;
                var code = resultData.code;
                var info = resultData.info; // 412或500的提示语
                if (code === 412) {
                    _this2.showToast(info, 2000, 'warn');
                } else if (code === 500) {
                    _this2.showToast(info, 2000, 'warn');
                } else {
                    // 判断是否有权限
                    var hasPermission = resultData.data.hasPermission || '';
                    var openId = resultData.data.openId || '';
                    var unPermissionInfo = resultData.data.unPermissionInfo;
                    _const.apiParams.openId = _const.apiParams.openId || openId;
                    if (hasPermission) {
                        _this2.$router.push({
                            path: path
                            // query: {
                            //   openId: openId
                            // }
                        });
                    } else {
                        _this2.showToast(unPermissionInfo, 2000, 'warn');
                    }
                }
                _this2.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
            }).catch(function (error) {
                _this2.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                _this2.$vux.loading.hide();
                console.error(error.config);
                console.error('Error', error.message);
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "xxDG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
};

/***/ }),

/***/ "xzd6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'app'
};

/***/ }),

/***/ "y6Wx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.disabled ? 'vux-checklist-disabled' : ''},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}],staticClass:"weui-cells__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("after-title"),_vm._v(" "),_c('div',{staticClass:"weui-cells weui-cells_checkbox"},_vm._l((_vm.currentOptions),function(one,index){return _c('label',{staticClass:"weui-cell weui-check_label",class:{
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },attrs:{"for":("checkbox_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__hd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"checkbox","name":("vux-checkbox-" + _vm.uuid),"id":_vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),"disabled":_vm.isDisabled(_vm.getKey(one))},domProps:{"value":_vm.getKey(one),"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,_vm.getKey(one))>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.getKey(one),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),_c('i',{staticClass:"weui-icon-checked vux-checklist-icon-checked"})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getValue(one))}}),_vm._v(" "),(_vm.getInlineDesc(one))?_c('inline-desc',[_vm._v(_vm._s(_vm.getInlineDesc(one)))]):_vm._e()],1)])}),0),_vm._v(" "),_vm._t("footer")],2)}
var staticRenderFns = []


/***/ }),

/***/ "yj1K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _const = __webpack_require__("ZLd3");

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "LoadImgLook",
    components: {
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: __webpack_require__("w2ig"), // 装箱的图片，右上角的icon
            iconClose: __webpack_require__("VrRN"), // 关闭图标
            goBackQuery: {}, // 回退时要带的参数
            displayUrl: '',
            imgSrcList: [
                // require('@/assets/images/plan/wx_zhuang_blue.png'),
                // require('@/assets/images/wx_sc_oringe.png')
            ], // 图片路径列表
            isNoData: false,
            isShowLoading: false,
            step: -1
        };
    },
    created: function created() {
        document.title = '装货图片';
        var query = this.$route.query;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常，原因：页面先被刷新一次，再进入该组件，导致数据丢失，而且用go回退时要两次！
        if (!_const.apiParams.companyId) {
            _const.apiParams.companyId = query.companyId2;
            _const.apiParams.openId = query.openId2;
            this.step = -2;
        }
        if (query.type === 'load') {
            this.displayUrl = _const.apiUrl.loadImgDisplay; // 装箱图片的接口
        } else if (query.type === 'seal') {
            this.displayUrl = _const.apiUrl.lookSealImg; // 封箱图片的接口
        } else {
            this.displayUrl = _const.apiUrl.lookloaddoc; // 装箱单证图片的接口
        }
        this.getDisplayImg();
    },

    methods: {
        getDisplayImg: function getDisplayImg() {
            var _this = this;

            // 获取可展示的图片
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                ladingId: this.ladingId,
                id: this.id,
                servicetype: this.servicetype,
                referenceno: this.referenceno
            };
            this.isShowLoading = true;
            this.requestApi({
                url: this.displayUrl,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                var imgSrcList = dataObj.paths || [];
                if (imgSrcList.length === 0) {
                    _this.isNoData = true;
                    _this.isShowLoading = false;
                    _this.imgSrcList = imgSrcList;
                    return;
                }
                _this.imgSrcList = imgSrcList;
                _this.$previewRefresh();
            }, function (error) {
                _this.isShowLoading = false;
                if (error) {
                    console.error(error);
                }
            });
        }
    }
};

/***/ }),

/***/ "yjv+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAWBAMAAAD6A0vjAAAAGFBMVEX/gS3/gS3/gS3/gS3/gS3/gS3/gS3/gS0Z4JLoAAAAB3RSTlO79B6/uvMfGYQZbwAAAB9JREFUCNdjUAlRYGAvN2AQLy9gKKcMg8wAm6UgkAAAiZQaYThFypwAAAAASUVORK5CYII="

/***/ }),

/***/ "ykmb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

exports.default = {
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
};

/***/ }),

/***/ "ym7X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vehicletrackingResult"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTable),expression:"isShowTable"}]},[_c('scroller',{ref:"scrollerBottom",attrs:{"lock-x":"","scroll-bottom-offset":50},on:{"on-scroll-bottom":_vm.onScrollBottom}},[_c('div',{staticClass:"box2"},[_vm._l((_vm.tableData),function(item,index){return _c('div',{key:index,staticClass:"vehicletracking-table-box"},[_c('table',{staticClass:"vehicletracking-table"},[_c('tr',[_c('td',{staticStyle:{"width":"30%"}},[_vm._v("车辆编号")]),_vm._v(" "),_c('td',{staticStyle:{"width":"70%"}},[_vm._v(_vm._s(item.c_drive_num_hk))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("车牌号")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.truck_no))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("拖车公司")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.truck_company))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("司机电话")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.c_phone))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("装卸地址")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.zxhdz))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("出车次数")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.time))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("运营状态")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.truck_status == 0 ? "未派车" : "已派车"))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("车辆状态")]),_vm._v(" "),_c('td',[_c('selector',{ref:'tracingStatusSelector' + index,refInFor:true,staticClass:"select-box",attrs:{"options":_vm.tracingStatusList},nativeOn:{"change":function($event){return (function (e) {_vm.changeNative(e,index)})($event)}},model:{value:(item.c_truck_tracing_status),callback:function ($$v) {_vm.$set(item, "c_truck_tracing_status", $$v)},expression:"item.c_truck_tracing_status"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isShowBtn),expression:"item.isShowBtn"}],staticClass:"btn-box2",attrs:{"id":'btn' + index}},[_c('button',{staticClass:"btn-save",on:{"click":function($event){return _vm.updateState(index)}}},[_vm._v("保存")]),_vm._v(" "),_c('button',{staticClass:"btn-cancel",on:{"click":function($event){return _vm.handleCancel(index)}}},[_vm._v("取消")])])],1)])])])}),_vm._v(" "),_c('load-more',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"tip":"loading"}})],2)])],1),_vm._v(" "),(_vm.isNoData)?_c('div',[_c('divider',[_vm._v("暂无数据")])],1):_vm._e(),_vm._v(" "),_c('MyBtnReturn')],1)}
var staticRenderFns = []


/***/ }),

/***/ "yzPM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _const = __webpack_require__("ZLd3");

var _GoHome = __webpack_require__("ZWVd");

var _GoHome2 = _interopRequireDefault(_GoHome);

var _MyBtnReturn = __webpack_require__("TNdP");

var _MyBtnReturn2 = _interopRequireDefault(_MyBtnReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "Order",
    components: {
        GoHome: _GoHome2.default,
        MyBtnReturn: _MyBtnReturn2.default
    },
    data: function data() {
        return {
            // todo:逻辑应该是：上层中某个选项变化了，下面所有select与受影响的input都要变为null
            shipper: null,
            shipperOps: [],
            employeeId: '',
            load_date: '',
            consignee_id: null, // 囧，selector组件要设置默认值为null时，placeholder才有效果！
            consigneeOps: [
                // {
                //   key: 'lsh',
                //   value: '李四'
                // },
                // {
                //   key: 'zhs',
                //   value: '张三'
                // }
            ],
            goods_name: '',
            dockOfLoading: null,
            dockOfLoadingOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            finalDestination: null,
            finalDestinationOps: [],
            jhr: null,
            jhrOps: [],
            company_lxr: null,
            company_lxrOps: [],
            shipper_tel: '',
            shipper_mp: '',
            remark3: '', // 装货说明
            consignee_place: null,
            consignee_placeOps: [],
            consignee_linkman: null,
            consignee_linkmanOps: [],
            consignee_tel: '',
            consignee_mp: '',
            remark9: '', // 卸货说明
            carriage: null,
            carriageOps: [{
                key: 'DR-DR',
                value: '门/门'
            }, {
                key: 'DR-CY',
                value: '门/堆场'
            }, {
                key: 'CY-DR',
                value: '堆场/门'
            }, {
                key: 'CY-CY',
                value: '堆场/堆场'
            }],
            contQty: '', // todo:柜量还要进行处理？
            contType: null,
            contTypeOps: [
                // {
                //   key: '20',
                //   value: '20GP'
                // },
                // {
                //   key: '40',
                //   value: '20GP'
                // },
                // {
                //   key: '4',
                //   value: '4GP'
                // },
            ], // todo:后台传递来
            insurance_status: null,
            insurance_statusOps: [{
                key: '1',
                value: '是'
            }, {
                key: '0',
                value: '否'
            }],
            fees_remark2: '',
            isDisabledList: {
                shipperSelector: false,
                consigSelector: false,
                dockOfLoadingSelector: false,
                finalDestinationSelector: false,
                jhrSelector: false,
                companyLxrSelector: false,
                consigneePlaceSelector: false,
                consigneeLinkmanSelector: false
            }, // 这个对象存放控制各个selector组件的readonly属性的值
            canSubmit: true
        };
    },
    created: function created() {
        document.title = '业务下单';
        this.getInitialSelectData();
    },

    methods: {
        getInitialSelectData: function getInitialSelectData() {
            var _this = this;

            // 可获取到shippers(托运人列表)、employeeId(对应业务员？)、conts(柜型柜量)
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code
            };
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: _const.apiUrl.getShippersAndConts,
                data: data
            }, function (resultData) {
                _this.$vux.loading.hide();
                var dataObj = resultData.data;
                _this.shipperOps = dataObj.shippers;
                _this.employeeId = dataObj.employeeId;
                _this.contTypeOps = dataObj.conts;
            }, function (error) {
                _this.$vux.loading.hide();
                if (error) {
                    // todo:如果请求失败，2秒后可重新获取，或者提示用户刷新页面？
                    setTimeout(function () {
                        _this.getInitialSelectData();
                    }, 2000);
                    console.error(error);
                }
            });
        },

        // 所有selector的on-change方法都换成原生的change,记得要.native；（这是为了避免初始化selector时自动运行一次on-change）
        changeShipper: function changeShipper(value, ref) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (value) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                // 由于on-change会立即调用一次，因此如果value为null，要中止函数
                                _this2.isDisabled(ref);
                                // 与getStartArea获取起运地
                                _context.next = 5;
                                return _this2.getConsignee();

                            case 5:
                                _context.next = 7;
                                return _this2.getStartArea();

                            case 7:
                                _this2.isDisabled(ref);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        getConsignee: function getConsignee(value, ref) {
            var _this3 = this;

            // 获取货主：根据托运人查询
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper
            };
            this.requestApi({
                url: _const.apiUrl.getConsignee,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this3.consigneeOps = dataObj.consignee;
            }, function (error) {
                if (error) {
                    // todo:除了getInitialSelectData可以自动重新请求外，其他change事件触发的接口不可自动重新获取，不然万一用户修改选项，请求数据会混乱了！
                    // 处理上述bug：因此如果请求失败了，那就重置select的默认值为null
                    _this3.shipper = null;
                    console.error(error);
                }
            });
        },
        getStartArea: function getStartArea(value, ref) {
            var _this4 = this;

            // 获取起运地：根据托运人查询
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || ''
            };
            this.requestApi({
                url: _const.apiUrl.getStartArea,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this4.dockOfLoadingOps = dataObj.startArea;
            }, function (error) {
                if (error) {
                    _this4.shipper = null;
                    console.error(error);
                }
            });
        },
        getArea: function getArea(value, ref) {
            var _this5 = this;

            // 获取目的地：通过托运人与货主去查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取目的地：通过托运人与货主去查询
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id || ''
            };
            this.requestApi({
                url: _const.apiUrl.getArea,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this5.finalDestinationOps = dataObj.area;
            }, function (error) {
                _this5.isDisabled(ref);
                if (error) {
                    _this5.consignee_id = null;
                    console.error(error);
                }
            });
        },
        getLoadJhr: function getLoadJhr(value, ref) {
            var _this6 = this;

            // 获取装货地址：根据起运地查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.dockOfLoading || '' // 也可以直接使用参数value
            };
            this.requestApi({
                url: _const.apiUrl.getPlace,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this6.jhrOps = dataObj.places;
            }, function (error) {
                _this6.isDisabled(ref);
                if (error) {
                    _this6.dockOfLoading = null;
                    console.error(error);
                }
            });
        },
        getConsigPlace: function getConsigPlace(value, ref) {
            var _this7 = this;

            // 获取卸货地址：根据目的地去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.finalDestination || ''
            };
            this.requestApi({
                url: _const.apiUrl.getPlace,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this7.consignee_placeOps = dataObj.places;
            }, function (error) {
                _this7.isDisabled(ref);
                if (error) {
                    _this7.finalDestination = null;
                    console.error(error);
                }
            });
        },
        getLoadLink: function getLoadLink(value, ref) {
            var _this8 = this;

            // 获取装货联系人：根据起运地+装货地址去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.dockOfLoading || '',
                place: this.jhr || ''
            };
            this.requestApi({
                url: _const.apiUrl.getLinkman,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this8.company_lxrOps = dataObj.linkmans;
            }, function (error) {
                _this8.isDisabled(ref);
                if (error) {
                    _this8.jhr = null;
                    console.error(error);
                }
            });
        },
        getLoadTelMp: function getLoadTelMp(value, ref) {
            var _this9 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取装货人手机电话：根据起运地+装货地址+装货联系人获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.dockOfLoading || '',
                place: this.jhr || '',
                linkman: this.company_lxr || ''
            };
            this.requestApi({
                url: _const.apiUrl.getOtherloadInfo,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                // 手机与电话好像是放在loadInfo数组里面
                _this9.shipper_tel = dataObj.loadInfo[1];
                _this9.shipper_mp = dataObj.loadInfo[0];
            }, function (error) {
                _this9.isDisabled(ref);
                if (error) {
                    _this9.company_lxr = null;
                    console.error(error);
                }
            });
        },
        getXHLink: function getXHLink(value, ref) {
            var _this10 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货联系人：根据目的地+卸货地址获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.finalDestination || '',
                place: this.consignee_place || ''
            };
            this.requestApi({
                url: _const.apiUrl.getLinkman,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this10.consignee_linkmanOps = dataObj.linkmans;
            }, function (error) {
                _this10.isDisabled(ref);
                if (error) {
                    _this10.consignee_place = null;
                    console.error(error);
                }
            });
        },
        getXhTelMp: function getXhTelMp(value, ref) {
            var _this11 = this;

            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货人手机电话：根据目的地+卸货地址+卸货联系人获取
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.finalDestination || '',
                place: this.consignee_place || '',
                linkman: this.consignee_linkman || ''
            };
            this.requestApi({
                url: _const.apiUrl.getOtherloadInfo,
                data: data
            }, function (resultData) {
                var dataObj = resultData.data;
                _this11.consignee_tel = dataObj.loadInfo[0];
                _this11.consignee_mp = dataObj.loadInfo[1];
            }, function (error) {
                _this11.isDisabled(ref);
                if (error) {
                    _this11.consignee_linkman = null;
                    console.error(error);
                }
            });
        },
        submit: function submit(e) {
            var _this12 = this;

            // 对表单各项进行检测
            if (!this.shipper) {
                this.showToastWarn('请输入托运人');
                return;
            }
            if (!this.load_date) {
                this.showToastWarn('请选择装货时间');
                return;
            }
            if (!this.consignee_id) {
                this.showToastWarn('请输入货主');
                return;
            }
            if (!this.goods_name) {
                this.showToastWarn('请输入货名');
                return;
            }
            if (!this.dockOfLoading) {
                this.showToastWarn('请输入起运地');
                return;
            }
            if (!this.finalDestination) {
                this.showToastWarn('请输入目的地');
                return;
            }
            if (!this.jhr) {
                this.showToastWarn('请输入装货地址');
                return;
            }
            if (!this.company_lxr) {
                this.showToastWarn('请输入装货联系人');
                return;
            }
            if (!(this.shipper_mp || this.shipper_tel)) {
                this.showToastWarn('装货联系人手机,电话至少输入一个');
                return;
            }
            if (!this.consignee_place) {
                this.showToastWarn('请输入卸货地址');
                return;
            }
            if (!this.consignee_linkman) {
                this.showToastWarn('请输入卸货联系人');
                return;
            }
            if (!(this.consignee_tel || this.consignee_mp)) {
                this.showToastWarn('卸货联系人手机,电话至少输入一个');
                return;
            }
            if (!this.contQty) {
                this.showToastWarn('请输入柜量');
                return;
            } else if (isNaN(Number(this.contQty))) {
                // 柜量必须是数字，而且是整数
                this.showToastWarn('柜量必须为数字');
                return;
            }
            if (!this.fees_remark2) {
                this.showToastWarn('请输入费用说明');
                return;
            }
            // 防止连续调用接口
            if (!this.canSubmit) {
                console.error('不可点击');
                return;
            }
            this.canSubmit = false;
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 提交下单信息
            var data = {
                openId: _const.apiParams.openId,
                companyId: _const.apiParams.companyId,
                code: _const.apiParams.code,
                shipper: this.shipper || '',
                employeeId: this.employeeId || '',
                load_date: this.load_date,
                consignee_id: this.consignee_id,
                goods_name: this.goods_name,
                dockOfLoading: this.dockOfLoading,
                finalDestination: this.finalDestination,
                jhr: this.jhr,
                company_lxr: this.company_lxr,
                shipper_tel: this.shipper_tel || '',
                shipper_mp: this.shipper_mp || '',
                remark3: this.remark3,
                consignee_place: this.consignee_place,
                consignee_linkman: this.consignee_linkman,
                consignee_tel: this.consignee_tel || '',
                consignee_mp: this.consignee_mp || '',
                remark9: this.remark9,
                carriage_item: this.carriage,
                contQty: parseInt(this.contQty), // 柜量必须为整数
                contType: this.contType,
                insurance_status: this.insurance_status || 0,
                fees_remark2: this.fees_remark2,
                group: this.group
            };
            this.requestApi({
                url: _const.apiUrl.addOrder,
                data: data
            }, function (resultData) {
                _this12.$vux.loading.hide();
                // 最后判断下单是否成功，给toast，状态码为200就是成功
                var dataObj = resultData.data;
                _this12.showToast(dataObj.info, 1500, 'success', {
                    onHide: function onHide() {
                        _this12.$router.push('/home');
                    }
                });
            }, function (error) {
                _this12.canSubmit = true;
                _this12.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            });
        },
        showToastWarn: function showToastWarn(text) {
            var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

            // 专门给submit函数里的验证使用
            this.showToast(text, time, 'warn');
        },
        isDisabled: function isDisabled(ref) {
            // 在触发select的change事件后，要先禁用select，等到请求完毕后，再重启select功能
            // 两种实现方式：1、第一种是通过ref获取到对应dom元素，然后禁用：
            // this.$refs[ref].$el.querySelector('select').disabled = !this.$refs[ref].$el.querySelector('select').disabled

            // 2、第二种是控制对应数据去设置selector组件的readonly属性
            this.isDisabledList[ref] = !this.isDisabledList[ref];
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "z9ug":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zaRr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'inline-desc'
};

/***/ }),

/***/ "zfut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}),1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "zhp2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _base = __webpack_require__("f6Hi");

var _base2 = _interopRequireDefault(_base);

var _tip = __webpack_require__("h9vq");

var _tip2 = _interopRequireDefault(_tip);

var _icon = __webpack_require__("oWtu");

var _icon2 = _interopRequireDefault(_icon);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _objectFilter = __webpack_require__("q5lo");

var _arrayShuffle = __webpack_require__("HHx2");

var _arrayShuffle2 = _interopRequireDefault(_arrayShuffle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'checklist',
  components: {
    Tip: _tip2.default,
    Icon: _icon2.default,
    InlineDesc: _inlineDesc2.default
  },
  filters: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey
  },
  mixins: [_base2.default],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = (0, _arrayShuffle2.default)(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey,
    getInlineDesc: _objectFilter.getInlineDesc,
    getFullValue: function getFullValue() {
      var labels = (0, _objectFilter.getLabels)(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, (0, _objectFilter.getLabels)(this.options, _val));
    },
    value: function value(newVal) {
      if ((0, _stringify2.default)(newVal) !== (0, _stringify2.default)(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, (0, _objectFilter.getLabels)(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && (0, _keys2.default)(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
};

function pure(obj) {
  return JSON.parse((0, _stringify2.default)(obj));
}

/***/ }),

/***/ "zprm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'inline-desc'
};

/***/ }),

/***/ "zxca":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d2f82baa4f8efebaa602.js